import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetchData } from '../graphqlFetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  bytea: { input: any; output: any; }
  citext: { input: any; output: any; }
  date: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  __typename?: 'authProviderRequests';
  id: Scalars['uuid']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  __typename?: 'authProviderRequests_aggregate';
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>;
  nodes: Array<AuthProviderRequests>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  __typename?: 'authProviderRequests_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviderRequests_Max_Fields>;
  min?: Maybe<AuthProviderRequests_Min_Fields>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  __typename?: 'authProviderRequests_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  __typename?: 'authProviderRequests_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  __typename?: 'authProviderRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint;
  update_columns?: Array<AuthProviderRequests_Update_Column>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  __typename?: 'authProviders';
  id: Scalars['String']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  __typename?: 'authProviders_aggregate';
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>;
  nodes: Array<AuthProviders>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  __typename?: 'authProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviders_Max_Fields>;
  min?: Maybe<AuthProviders_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  __typename?: 'authProviders_max_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  __typename?: 'authProviders_min_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  __typename?: 'authProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint;
  update_columns?: Array<AuthProviders_Update_Column>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id'
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp;
};

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes = {
  __typename?: 'authRefreshTokenTypes';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate = {
  __typename?: 'authRefreshTokenTypes_aggregate';
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokenTypes>;
};

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields>;
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields>;
};


/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey = 'refresh_token_types_pkey'
}

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular'
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
};

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields = {
  __typename?: 'authRefreshTokenTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields = {
  __typename?: 'authRefreshTokenTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response = {
  __typename?: 'authRefreshTokenTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes>;
};

/** input type for inserting object relation for remote table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Obj_Rel_Insert_Input = {
  data: AuthRefreshTokenTypes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict = {
  constraint: AuthRefreshTokenTypes_Constraint;
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type AuthRefreshTokenTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  refresh_token_type: AuthRefreshTokenTypes;
  type: AuthRefreshTokenTypes_Enum;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  __typename?: 'authRefreshTokens_aggregate';
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokens>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  __typename?: 'authRefreshTokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokens_Max_Fields>;
  min?: Maybe<AuthRefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  refreshTokenHash?: InputMaybe<String_Comparison_Exp>;
  refresh_token_type?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  refresh_token_type?: InputMaybe<AuthRefreshTokenTypes_Obj_Rel_Insert_Input>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  __typename?: 'authRefreshTokens_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  __typename?: 'authRefreshTokens_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint;
  update_columns?: Array<AuthRefreshTokens_Update_Column>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  refresh_token_type?: InputMaybe<AuthRefreshTokenTypes_Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type AuthRefreshTokens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  __typename?: 'authRoles';
  role: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  usersByDefaultRole: Array<Users>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  __typename?: 'authRoles_aggregate';
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>;
  nodes: Array<AuthRoles>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  __typename?: 'authRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRoles_Max_Fields>;
  min?: Maybe<AuthRoles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  __typename?: 'authRoles_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  __typename?: 'authRoles_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  __typename?: 'authRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint;
  update_columns?: Array<AuthRoles_Update_Column>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role'
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  __typename?: 'authUserProviders';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: AuthProviders;
  providerId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  __typename?: 'authUserProviders_aggregate';
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>;
  nodes: Array<AuthUserProviders>;
};

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  __typename?: 'authUserProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserProviders_Max_Fields>;
  min?: Maybe<AuthUserProviders_Min_Fields>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserProviders_Max_Order_By>;
  min?: InputMaybe<AuthUserProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthUserProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<AuthProviders_Bool_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providerUserId?: InputMaybe<String_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key',
  /** unique or primary key constraint on columns "user_id", "provider_id" */
  UserProvidersUserIdProviderIdKey = 'user_providers_user_id_provider_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  __typename?: 'authUserProviders_max_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  __typename?: 'authUserProviders_min_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  __typename?: 'authUserProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint;
  update_columns?: Array<AuthUserProviders_Update_Column>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<AuthProviders_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  __typename?: 'authUserRoles';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  roleByRole: AuthRoles;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  __typename?: 'authUserRoles_aggregate';
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>;
  nodes: Array<AuthUserRoles>;
};

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  __typename?: 'authUserRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserRoles_Max_Fields>;
  min?: Maybe<AuthUserRoles_Min_Fields>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserRoles_Max_Order_By>;
  min?: InputMaybe<AuthUserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthUserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  __typename?: 'authUserRoles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  __typename?: 'authUserRoles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  __typename?: 'authUserRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint;
  update_columns?: Array<AuthUserRoles_Update_Column>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<AuthRoles_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  __typename?: 'authUserSecurityKeys';
  counter: Scalars['bigint']['output'];
  credentialId: Scalars['String']['output'];
  credentialPublicKey?: Maybe<Scalars['bytea']['output']>;
  id: Scalars['uuid']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  transports: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  __typename?: 'authUserSecurityKeys_aggregate';
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>;
  nodes: Array<AuthUserSecurityKeys>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  __typename?: 'authUserSecurityKeys_aggregate_fields';
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By>;
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By>;
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By>;
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By>;
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  __typename?: 'authUserSecurityKeys_avg_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  counter?: InputMaybe<Bigint_Comparison_Exp>;
  credentialId?: InputMaybe<String_Comparison_Exp>;
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  transports?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  __typename?: 'authUserSecurityKeys_max_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  __typename?: 'authUserSecurityKeys_min_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  __typename?: 'authUserSecurityKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  credentialPublicKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  __typename?: 'authUserSecurityKeys_sum_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_var_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_var_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  __typename?: 'authUserSecurityKeys_variance_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "bss_baseline_view" */
export type Bss_Baseline_View = {
  __typename?: 'bss_baseline_view';
  /** An array relationship */
  data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  data_aggregate: Project_Interview_Data_Aggregate;
  /** An object relationship */
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  term?: Maybe<Term>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "bss_baseline_view" */
export type Bss_Baseline_ViewDataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "bss_baseline_view" */
export type Bss_Baseline_ViewData_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};

/** aggregated selection of "bss_baseline_view" */
export type Bss_Baseline_View_Aggregate = {
  __typename?: 'bss_baseline_view_aggregate';
  aggregate?: Maybe<Bss_Baseline_View_Aggregate_Fields>;
  nodes: Array<Bss_Baseline_View>;
};

/** aggregate fields of "bss_baseline_view" */
export type Bss_Baseline_View_Aggregate_Fields = {
  __typename?: 'bss_baseline_view_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bss_Baseline_View_Max_Fields>;
  min?: Maybe<Bss_Baseline_View_Min_Fields>;
};


/** aggregate fields of "bss_baseline_view" */
export type Bss_Baseline_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bss_Baseline_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bss_baseline_view". All fields are combined with a logical 'AND'. */
export type Bss_Baseline_View_Bool_Exp = {
  _and?: InputMaybe<Array<Bss_Baseline_View_Bool_Exp>>;
  _not?: InputMaybe<Bss_Baseline_View_Bool_Exp>;
  _or?: InputMaybe<Array<Bss_Baseline_View_Bool_Exp>>;
  data?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Bss_Baseline_View_Max_Fields = {
  __typename?: 'bss_baseline_view_max_fields';
  project_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bss_Baseline_View_Min_Fields = {
  __typename?: 'bss_baseline_view_min_fields';
  project_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "bss_baseline_view". */
export type Bss_Baseline_View_Order_By = {
  data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "bss_baseline_view" */
export enum Bss_Baseline_View_Select_Column {
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "bss_baseline_view" */
export type Bss_Baseline_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bss_Baseline_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bss_Baseline_View_Stream_Cursor_Value_Input = {
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  /** An array relationship */
  country_regions: Array<Country_Region>;
  /** An aggregate relationship */
  country_regions_aggregate: Country_Region_Aggregate;
  /** An array relationship */
  crop_seasons: Array<Crop_Season>;
  /** An aggregate relationship */
  crop_seasons_aggregate: Crop_Season_Aggregate;
  en: Scalars['String']['output'];
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  /** An array relationship */
  measure_units: Array<Measure_Unit>;
  /** An aggregate relationship */
  measure_units_aggregate: Measure_Unit_Aggregate;
  pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  zones: Array<Zone>;
  /** An aggregate relationship */
  zones_aggregate: Zone_Aggregate;
};


/** columns and relationships of "country" */
export type CountryCountry_RegionsArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryCountry_Regions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryCrop_SeasonsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Order_By>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryCrop_Seasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Order_By>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryMeasure_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryMeasure_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryZonesArgs = {
  distinct_on?: InputMaybe<Array<Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Order_By>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryZones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Order_By>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  country_regions?: InputMaybe<Country_Region_Bool_Exp>;
  country_regions_aggregate?: InputMaybe<Country_Region_Aggregate_Bool_Exp>;
  crop_seasons?: InputMaybe<Crop_Season_Bool_Exp>;
  crop_seasons_aggregate?: InputMaybe<Crop_Season_Aggregate_Bool_Exp>;
  en?: InputMaybe<String_Comparison_Exp>;
  es?: InputMaybe<String_Comparison_Exp>;
  fr?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  measure_units?: InputMaybe<Measure_Unit_Bool_Exp>;
  measure_units_aggregate?: InputMaybe<Measure_Unit_Aggregate_Bool_Exp>;
  pt?: InputMaybe<String_Comparison_Exp>;
  zones?: InputMaybe<Zone_Bool_Exp>;
  zones_aggregate?: InputMaybe<Zone_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "country" */
export enum Country_Constraint {
  /** unique or primary key constraint on columns "key" */
  CountryCountriesIdKey = 'country_countries_id_key',
  /** unique or primary key constraint on columns "en" */
  CountryDefaultKey = 'country_default_key',
  /** unique or primary key constraint on columns "id" */
  CountryPkey = 'country_pkey'
}

/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  country_regions?: InputMaybe<Country_Region_Arr_Rel_Insert_Input>;
  crop_seasons?: InputMaybe<Crop_Season_Arr_Rel_Insert_Input>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  measure_units?: InputMaybe<Measure_Unit_Arr_Rel_Insert_Input>;
  pt?: InputMaybe<Scalars['String']['input']>;
  zones?: InputMaybe<Zone_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** input type for inserting object relation for remote table "country" */
export type Country_Obj_Rel_Insert_Input = {
  data: Country_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Country_On_Conflict>;
};

/** on_conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns?: Array<Country_Update_Column>;
  where?: InputMaybe<Country_Bool_Exp>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  country_regions_aggregate?: InputMaybe<Country_Region_Aggregate_Order_By>;
  crop_seasons_aggregate?: InputMaybe<Crop_Season_Aggregate_Order_By>;
  en?: InputMaybe<Order_By>;
  es?: InputMaybe<Order_By>;
  fr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  measure_units_aggregate?: InputMaybe<Measure_Unit_Aggregate_Order_By>;
  pt?: InputMaybe<Order_By>;
  zones_aggregate?: InputMaybe<Zone_Aggregate_Order_By>;
};

/** primary key columns input for table: country */
export type Country_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "country_region" */
export type Country_Region = {
  __typename?: 'country_region';
  /** An object relationship */
  country: Country;
  country_id: Scalars['uuid']['output'];
  /** An object relationship */
  country_region?: Maybe<Country_Region>;
  /** An array relationship */
  country_regions: Array<Country_Region>;
  /** An aggregate relationship */
  country_regions_aggregate: Country_Region_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  locations: Array<Location>;
  /** An aggregate relationship */
  locations_aggregate: Location_Aggregate;
  name: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "country_region" */
export type Country_RegionCountry_RegionsArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


/** columns and relationships of "country_region" */
export type Country_RegionCountry_Regions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


/** columns and relationships of "country_region" */
export type Country_RegionLocationsArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "country_region" */
export type Country_RegionLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** aggregated selection of "country_region" */
export type Country_Region_Aggregate = {
  __typename?: 'country_region_aggregate';
  aggregate?: Maybe<Country_Region_Aggregate_Fields>;
  nodes: Array<Country_Region>;
};

export type Country_Region_Aggregate_Bool_Exp = {
  count?: InputMaybe<Country_Region_Aggregate_Bool_Exp_Count>;
};

export type Country_Region_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Country_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Country_Region_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "country_region" */
export type Country_Region_Aggregate_Fields = {
  __typename?: 'country_region_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Country_Region_Max_Fields>;
  min?: Maybe<Country_Region_Min_Fields>;
};


/** aggregate fields of "country_region" */
export type Country_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "country_region" */
export type Country_Region_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Country_Region_Max_Order_By>;
  min?: InputMaybe<Country_Region_Min_Order_By>;
};

/** input type for inserting array relation for remote table "country_region" */
export type Country_Region_Arr_Rel_Insert_Input = {
  data: Array<Country_Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Country_Region_On_Conflict>;
};

/** Boolean expression to filter rows from the table "country_region". All fields are combined with a logical 'AND'. */
export type Country_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Region_Bool_Exp>>;
  _not?: InputMaybe<Country_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Region_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  country_region?: InputMaybe<Country_Region_Bool_Exp>;
  country_regions?: InputMaybe<Country_Region_Bool_Exp>;
  country_regions_aggregate?: InputMaybe<Country_Region_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locations?: InputMaybe<Location_Bool_Exp>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "country_region" */
export enum Country_Region_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountryDistrictLevelPkey = 'country_district_level_pkey',
  /** unique or primary key constraint on columns "parent_id", "name", "country_id" */
  CountryRegionNameCountryIdParentIdKey = 'country_region_name_country_id_parent_id_key'
}

/** input type for inserting data into table "country_region" */
export type Country_Region_Insert_Input = {
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  country_region?: InputMaybe<Country_Region_Obj_Rel_Insert_Input>;
  country_regions?: InputMaybe<Country_Region_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locations?: InputMaybe<Location_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Country_Region_Max_Fields = {
  __typename?: 'country_region_max_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "country_region" */
export type Country_Region_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Country_Region_Min_Fields = {
  __typename?: 'country_region_min_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "country_region" */
export type Country_Region_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "country_region" */
export type Country_Region_Mutation_Response = {
  __typename?: 'country_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country_Region>;
};

/** input type for inserting object relation for remote table "country_region" */
export type Country_Region_Obj_Rel_Insert_Input = {
  data: Country_Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Country_Region_On_Conflict>;
};

/** on_conflict condition type for table "country_region" */
export type Country_Region_On_Conflict = {
  constraint: Country_Region_Constraint;
  update_columns?: Array<Country_Region_Update_Column>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "country_region". */
export type Country_Region_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  country_region?: InputMaybe<Country_Region_Order_By>;
  country_regions_aggregate?: InputMaybe<Country_Region_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country_region */
export type Country_Region_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "country_region" */
export enum Country_Region_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id'
}

/** input type for updating data in table "country_region" */
export type Country_Region_Set_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "country_region" */
export type Country_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Region_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "country_region" */
export enum Country_Region_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id'
}

export type Country_Region_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Region_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Region_Bool_Exp;
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Pt = 'pt'
}

/** input type for updating data in table "country" */
export type Country_Set_Input = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "country" */
export enum Country_Update_Column {
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Pt = 'pt'
}

export type Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp;
};

/** columns and relationships of "crop_season" */
export type Crop_Season = {
  __typename?: 'crop_season';
  /** An object relationship */
  country: Country;
  country_id: Scalars['uuid']['output'];
  /** An array relationship */
  crop_season_month_mns: Array<Crop_Season_Month_Mn>;
  /** An aggregate relationship */
  crop_season_month_mns_aggregate: Crop_Season_Month_Mn_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** An array relationship */
  project_bss_notes: Array<Project_Bss_Note>;
  /** An aggregate relationship */
  project_bss_notes_aggregate: Project_Bss_Note_Aggregate;
  /** An array relationship */
  project_interview_crops_seasons: Array<Project_Interview_Crops_Season>;
  /** An aggregate relationship */
  project_interview_crops_seasons_aggregate: Project_Interview_Crops_Season_Aggregate;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonCrop_Season_Month_MnsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonCrop_Season_Month_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonProject_Bss_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonProject_Bss_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonProject_Interview_Crops_SeasonsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


/** columns and relationships of "crop_season" */
export type Crop_SeasonProject_Interview_Crops_Seasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};

/** aggregated selection of "crop_season" */
export type Crop_Season_Aggregate = {
  __typename?: 'crop_season_aggregate';
  aggregate?: Maybe<Crop_Season_Aggregate_Fields>;
  nodes: Array<Crop_Season>;
};

export type Crop_Season_Aggregate_Bool_Exp = {
  count?: InputMaybe<Crop_Season_Aggregate_Bool_Exp_Count>;
};

export type Crop_Season_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Crop_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crop_Season_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "crop_season" */
export type Crop_Season_Aggregate_Fields = {
  __typename?: 'crop_season_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Crop_Season_Max_Fields>;
  min?: Maybe<Crop_Season_Min_Fields>;
};


/** aggregate fields of "crop_season" */
export type Crop_Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "crop_season" */
export type Crop_Season_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Season_Max_Order_By>;
  min?: InputMaybe<Crop_Season_Min_Order_By>;
};

/** input type for inserting array relation for remote table "crop_season" */
export type Crop_Season_Arr_Rel_Insert_Input = {
  data: Array<Crop_Season_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Season_On_Conflict>;
};

/** Boolean expression to filter rows from the table "crop_season". All fields are combined with a logical 'AND'. */
export type Crop_Season_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Season_Bool_Exp>>;
  _not?: InputMaybe<Crop_Season_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Season_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  crop_season_month_mns?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
  crop_season_month_mns_aggregate?: InputMaybe<Crop_Season_Month_Mn_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp>;
  project_interview_crops_seasons?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  project_interview_crops_seasons_aggregate?: InputMaybe<Project_Interview_Crops_Season_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "crop_season" */
export enum Crop_Season_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropSeasonPkey = 'crop_season_pkey'
}

/** input type for inserting data into table "crop_season" */
export type Crop_Season_Insert_Input = {
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  crop_season_month_mns?: InputMaybe<Crop_Season_Month_Mn_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Arr_Rel_Insert_Input>;
  project_interview_crops_seasons?: InputMaybe<Project_Interview_Crops_Season_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Season_Max_Fields = {
  __typename?: 'crop_season_max_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "crop_season" */
export type Crop_Season_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Season_Min_Fields = {
  __typename?: 'crop_season_min_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "crop_season" */
export type Crop_Season_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** columns and relationships of "crop_season_month_mn" */
export type Crop_Season_Month_Mn = {
  __typename?: 'crop_season_month_mn';
  /** An object relationship */
  crop_season: Crop_Season;
  crop_season_id: Scalars['uuid']['output'];
  month: Month_Enum;
  /** An object relationship */
  monthByMonth: Month;
};

/** aggregated selection of "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Aggregate = {
  __typename?: 'crop_season_month_mn_aggregate';
  aggregate?: Maybe<Crop_Season_Month_Mn_Aggregate_Fields>;
  nodes: Array<Crop_Season_Month_Mn>;
};

export type Crop_Season_Month_Mn_Aggregate_Bool_Exp = {
  count?: InputMaybe<Crop_Season_Month_Mn_Aggregate_Bool_Exp_Count>;
};

export type Crop_Season_Month_Mn_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Aggregate_Fields = {
  __typename?: 'crop_season_month_mn_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Crop_Season_Month_Mn_Max_Fields>;
  min?: Maybe<Crop_Season_Month_Mn_Min_Fields>;
};


/** aggregate fields of "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Season_Month_Mn_Max_Order_By>;
  min?: InputMaybe<Crop_Season_Month_Mn_Min_Order_By>;
};

/** input type for inserting array relation for remote table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Arr_Rel_Insert_Input = {
  data: Array<Crop_Season_Month_Mn_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Season_Month_Mn_On_Conflict>;
};

/** Boolean expression to filter rows from the table "crop_season_month_mn". All fields are combined with a logical 'AND'. */
export type Crop_Season_Month_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Season_Month_Mn_Bool_Exp>>;
  _not?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Season_Month_Mn_Bool_Exp>>;
  crop_season?: InputMaybe<Crop_Season_Bool_Exp>;
  crop_season_id?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<Month_Enum_Comparison_Exp>;
  monthByMonth?: InputMaybe<Month_Bool_Exp>;
};

/** unique or primary key constraints on table "crop_season_month_mn" */
export enum Crop_Season_Month_Mn_Constraint {
  /** unique or primary key constraint on columns "month", "crop_season_id" */
  CropSeasonMonthMnCropSeasonIdMonthKey = 'crop_season_month_mn_crop_season_id_month_key',
  /** unique or primary key constraint on columns "month", "crop_season_id" */
  CropSeasonMonthMnPkey = 'crop_season_month_mn_pkey'
}

/** input type for inserting data into table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Insert_Input = {
  crop_season?: InputMaybe<Crop_Season_Obj_Rel_Insert_Input>;
  crop_season_id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Month_Enum>;
  monthByMonth?: InputMaybe<Month_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Season_Month_Mn_Max_Fields = {
  __typename?: 'crop_season_month_mn_max_fields';
  crop_season_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Max_Order_By = {
  crop_season_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Season_Month_Mn_Min_Fields = {
  __typename?: 'crop_season_month_mn_min_fields';
  crop_season_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Min_Order_By = {
  crop_season_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Mutation_Response = {
  __typename?: 'crop_season_month_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Season_Month_Mn>;
};

/** on_conflict condition type for table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_On_Conflict = {
  constraint: Crop_Season_Month_Mn_Constraint;
  update_columns?: Array<Crop_Season_Month_Mn_Update_Column>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_season_month_mn". */
export type Crop_Season_Month_Mn_Order_By = {
  crop_season?: InputMaybe<Crop_Season_Order_By>;
  crop_season_id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  monthByMonth?: InputMaybe<Month_Order_By>;
};

/** primary key columns input for table: crop_season_month_mn */
export type Crop_Season_Month_Mn_Pk_Columns_Input = {
  crop_season_id: Scalars['uuid']['input'];
  month: Month_Enum;
};

/** select columns of table "crop_season_month_mn" */
export enum Crop_Season_Month_Mn_Select_Column {
  /** column name */
  CropSeasonId = 'crop_season_id',
  /** column name */
  Month = 'month'
}

/** input type for updating data in table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Set_Input = {
  crop_season_id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Month_Enum>;
};

/** Streaming cursor of the table "crop_season_month_mn" */
export type Crop_Season_Month_Mn_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Season_Month_Mn_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Season_Month_Mn_Stream_Cursor_Value_Input = {
  crop_season_id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Month_Enum>;
};

/** update columns of table "crop_season_month_mn" */
export enum Crop_Season_Month_Mn_Update_Column {
  /** column name */
  CropSeasonId = 'crop_season_id',
  /** column name */
  Month = 'month'
}

export type Crop_Season_Month_Mn_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Season_Month_Mn_Set_Input>;
  /** filter the rows which have to be updated */
  where: Crop_Season_Month_Mn_Bool_Exp;
};

/** response of any mutation on the table "crop_season" */
export type Crop_Season_Mutation_Response = {
  __typename?: 'crop_season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Season>;
};

/** input type for inserting object relation for remote table "crop_season" */
export type Crop_Season_Obj_Rel_Insert_Input = {
  data: Crop_Season_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Season_On_Conflict>;
};

/** on_conflict condition type for table "crop_season" */
export type Crop_Season_On_Conflict = {
  constraint: Crop_Season_Constraint;
  update_columns?: Array<Crop_Season_Update_Column>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_season". */
export type Crop_Season_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  crop_season_month_mns_aggregate?: InputMaybe<Crop_Season_Month_Mn_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Order_By>;
  project_interview_crops_seasons_aggregate?: InputMaybe<Project_Interview_Crops_Season_Aggregate_Order_By>;
};

/** primary key columns input for table: crop_season */
export type Crop_Season_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "crop_season" */
export enum Crop_Season_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "crop_season" */
export type Crop_Season_Set_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crop_season" */
export type Crop_Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Season_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crop_season" */
export enum Crop_Season_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Crop_Season_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Season_Set_Input>;
  /** filter the rows which have to be updated */
  where: Crop_Season_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  project_files: Array<Project_File>;
  /** An aggregate relationship */
  project_files_aggregate: Project_File_Aggregate;
  /** An array relationship */
  project_interview_files: Array<Project_Interview_File>;
  /** An aggregate relationship */
  project_interview_files_aggregate: Project_Interview_File_Aggregate;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "storage.files" */
export type FilesProject_FilesArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesProject_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesProject_Interview_FilesArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesProject_Interview_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_files?: InputMaybe<Project_File_Bool_Exp>;
  project_files_aggregate?: InputMaybe<Project_File_Aggregate_Bool_Exp>;
  project_interview_files?: InputMaybe<Project_Interview_File_Bool_Exp>;
  project_interview_files_aggregate?: InputMaybe<Project_Interview_File_Aggregate_Bool_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_files?: InputMaybe<Project_File_Arr_Rel_Insert_Input>;
  project_interview_files?: InputMaybe<Project_Interview_File_Arr_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_files_aggregate?: InputMaybe<Project_File_Aggregate_Order_By>;
  project_interview_files_aggregate?: InputMaybe<Project_Interview_File_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "livestock_milking_season" */
export type Livestock_Milking_Season = {
  __typename?: 'livestock_milking_season';
  name: Scalars['String']['output'];
};

/** aggregated selection of "livestock_milking_season" */
export type Livestock_Milking_Season_Aggregate = {
  __typename?: 'livestock_milking_season_aggregate';
  aggregate?: Maybe<Livestock_Milking_Season_Aggregate_Fields>;
  nodes: Array<Livestock_Milking_Season>;
};

/** aggregate fields of "livestock_milking_season" */
export type Livestock_Milking_Season_Aggregate_Fields = {
  __typename?: 'livestock_milking_season_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Livestock_Milking_Season_Max_Fields>;
  min?: Maybe<Livestock_Milking_Season_Min_Fields>;
};


/** aggregate fields of "livestock_milking_season" */
export type Livestock_Milking_Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Livestock_Milking_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "livestock_milking_season". All fields are combined with a logical 'AND'. */
export type Livestock_Milking_Season_Bool_Exp = {
  _and?: InputMaybe<Array<Livestock_Milking_Season_Bool_Exp>>;
  _not?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
  _or?: InputMaybe<Array<Livestock_Milking_Season_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "livestock_milking_season" */
export enum Livestock_Milking_Season_Constraint {
  /** unique or primary key constraint on columns "name" */
  LivestockMilkingSeasonPkey = 'livestock_milking_season_pkey'
}

/** input type for inserting data into table "livestock_milking_season" */
export type Livestock_Milking_Season_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Livestock_Milking_Season_Max_Fields = {
  __typename?: 'livestock_milking_season_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Livestock_Milking_Season_Min_Fields = {
  __typename?: 'livestock_milking_season_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "livestock_milking_season" */
export type Livestock_Milking_Season_Mutation_Response = {
  __typename?: 'livestock_milking_season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Livestock_Milking_Season>;
};

/** on_conflict condition type for table "livestock_milking_season" */
export type Livestock_Milking_Season_On_Conflict = {
  constraint: Livestock_Milking_Season_Constraint;
  update_columns?: Array<Livestock_Milking_Season_Update_Column>;
  where?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
};

/** Ordering options when selecting data from "livestock_milking_season". */
export type Livestock_Milking_Season_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: livestock_milking_season */
export type Livestock_Milking_Season_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "livestock_milking_season" */
export enum Livestock_Milking_Season_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "livestock_milking_season" */
export type Livestock_Milking_Season_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "livestock_milking_season" */
export type Livestock_Milking_Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Livestock_Milking_Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Livestock_Milking_Season_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "livestock_milking_season" */
export enum Livestock_Milking_Season_Update_Column {
  /** column name */
  Name = 'name'
}

export type Livestock_Milking_Season_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Livestock_Milking_Season_Set_Input>;
  /** filter the rows which have to be updated */
  where: Livestock_Milking_Season_Bool_Exp;
};

/** columns and relationships of "livestock_type" */
export type Livestock_Type = {
  __typename?: 'livestock_type';
  name: Scalars['String']['output'];
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** An array relationship */
  project_bss_notes: Array<Project_Bss_Note>;
  /** An aggregate relationship */
  project_bss_notes_aggregate: Project_Bss_Note_Aggregate;
  /** An array relationship */
  project_interview_livestocks: Array<Project_Interview_Livestock>;
  /** An aggregate relationship */
  project_interview_livestocks_aggregate: Project_Interview_Livestock_Aggregate;
};


/** columns and relationships of "livestock_type" */
export type Livestock_TypeProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "livestock_type" */
export type Livestock_TypeProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "livestock_type" */
export type Livestock_TypeProject_Bss_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "livestock_type" */
export type Livestock_TypeProject_Bss_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "livestock_type" */
export type Livestock_TypeProject_Interview_LivestocksArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


/** columns and relationships of "livestock_type" */
export type Livestock_TypeProject_Interview_Livestocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};

/** aggregated selection of "livestock_type" */
export type Livestock_Type_Aggregate = {
  __typename?: 'livestock_type_aggregate';
  aggregate?: Maybe<Livestock_Type_Aggregate_Fields>;
  nodes: Array<Livestock_Type>;
};

/** aggregate fields of "livestock_type" */
export type Livestock_Type_Aggregate_Fields = {
  __typename?: 'livestock_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Livestock_Type_Max_Fields>;
  min?: Maybe<Livestock_Type_Min_Fields>;
};


/** aggregate fields of "livestock_type" */
export type Livestock_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Livestock_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "livestock_type". All fields are combined with a logical 'AND'. */
export type Livestock_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Livestock_Type_Bool_Exp>>;
  _not?: InputMaybe<Livestock_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Livestock_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp>;
  project_interview_livestocks?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  project_interview_livestocks_aggregate?: InputMaybe<Project_Interview_Livestock_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "livestock_type" */
export enum Livestock_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  LivestockTypePkey = 'livestock_type_pkey'
}

export enum Livestock_Type_Enum {
  Buffalo = 'BUFFALO',
  Camel = 'CAMEL',
  Cattle = 'CATTLE',
  Chicken = 'CHICKEN',
  Donkey = 'DONKEY',
  Goat = 'GOAT',
  Horse = 'HORSE',
  OtherPoultry = 'OTHER_POULTRY',
  Oxen = 'OXEN',
  Pig = 'PIG',
  Sheep = 'SHEEP',
  Yak = 'YAK'
}

/** Boolean expression to compare columns of type "livestock_type_enum". All fields are combined with logical 'AND'. */
export type Livestock_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Livestock_Type_Enum>;
  _in?: InputMaybe<Array<Livestock_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Livestock_Type_Enum>;
  _nin?: InputMaybe<Array<Livestock_Type_Enum>>;
};

/** input type for inserting data into table "livestock_type" */
export type Livestock_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Arr_Rel_Insert_Input>;
  project_interview_livestocks?: InputMaybe<Project_Interview_Livestock_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Livestock_Type_Max_Fields = {
  __typename?: 'livestock_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Livestock_Type_Min_Fields = {
  __typename?: 'livestock_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "livestock_type" */
export type Livestock_Type_Mutation_Response = {
  __typename?: 'livestock_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Livestock_Type>;
};

/** input type for inserting object relation for remote table "livestock_type" */
export type Livestock_Type_Obj_Rel_Insert_Input = {
  data: Livestock_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Livestock_Type_On_Conflict>;
};

/** on_conflict condition type for table "livestock_type" */
export type Livestock_Type_On_Conflict = {
  constraint: Livestock_Type_Constraint;
  update_columns?: Array<Livestock_Type_Update_Column>;
  where?: InputMaybe<Livestock_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "livestock_type". */
export type Livestock_Type_Order_By = {
  name?: InputMaybe<Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Order_By>;
  project_interview_livestocks_aggregate?: InputMaybe<Project_Interview_Livestock_Aggregate_Order_By>;
};

/** primary key columns input for table: livestock_type */
export type Livestock_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "livestock_type" */
export enum Livestock_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "livestock_type" */
export type Livestock_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "livestock_type" */
export type Livestock_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Livestock_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Livestock_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "livestock_type" */
export enum Livestock_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Livestock_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Livestock_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Livestock_Type_Bool_Exp;
};

/** columns and relationships of "location" */
export type Location = {
  __typename?: 'location';
  /** An object relationship */
  country_region: Country_Region;
  country_region_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  project_files: Array<Project_File>;
  /** An aggregate relationship */
  project_files_aggregate: Project_File_Aggregate;
  /** An array relationship */
  project_interviews: Array<Project_Interview>;
  /** An aggregate relationship */
  project_interviews_aggregate: Project_Interview_Aggregate;
  /** An object relationship */
  zone: Zone;
  zone_id: Scalars['uuid']['output'];
};


/** columns and relationships of "location" */
export type LocationProject_FilesArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProject_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProject_InterviewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProject_Interviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};

/** aggregated selection of "location" */
export type Location_Aggregate = {
  __typename?: 'location_aggregate';
  aggregate?: Maybe<Location_Aggregate_Fields>;
  nodes: Array<Location>;
};

export type Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Location_Aggregate_Bool_Exp_Count>;
};

export type Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location" */
export type Location_Aggregate_Fields = {
  __typename?: 'location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Location_Max_Fields>;
  min?: Maybe<Location_Min_Fields>;
};


/** aggregate fields of "location" */
export type Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "location" */
export type Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Max_Order_By>;
  min?: InputMaybe<Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "location" */
export type Location_Arr_Rel_Insert_Input = {
  data: Array<Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "location". All fields are combined with a logical 'AND'. */
export type Location_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Bool_Exp>>;
  _not?: InputMaybe<Location_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Bool_Exp>>;
  country_region?: InputMaybe<Country_Region_Bool_Exp>;
  country_region_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_files?: InputMaybe<Project_File_Bool_Exp>;
  project_files_aggregate?: InputMaybe<Project_File_Aggregate_Bool_Exp>;
  project_interviews?: InputMaybe<Project_Interview_Bool_Exp>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Bool_Exp>;
  zone?: InputMaybe<Zone_Bool_Exp>;
  zone_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "location" */
export enum Location_Constraint {
  /** unique or primary key constraint on columns "country_region_id", "zone_id", "name" */
  LocationNameCountryRegionIdZoneIdKey = 'location_name_country_region_id_zone_id_key',
  /** unique or primary key constraint on columns "id" */
  LocationPkey = 'location_pkey'
}

/** input type for inserting data into table "location" */
export type Location_Insert_Input = {
  country_region?: InputMaybe<Country_Region_Obj_Rel_Insert_Input>;
  country_region_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_files?: InputMaybe<Project_File_Arr_Rel_Insert_Input>;
  project_interviews?: InputMaybe<Project_Interview_Arr_Rel_Insert_Input>;
  zone?: InputMaybe<Zone_Obj_Rel_Insert_Input>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Location_Max_Fields = {
  __typename?: 'location_max_fields';
  country_region_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  zone_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "location" */
export type Location_Max_Order_By = {
  country_region_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Min_Fields = {
  __typename?: 'location_min_fields';
  country_region_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  zone_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "location" */
export type Location_Min_Order_By = {
  country_region_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location" */
export type Location_Mutation_Response = {
  __typename?: 'location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Location>;
};

/** input type for inserting object relation for remote table "location" */
export type Location_Obj_Rel_Insert_Input = {
  data: Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** on_conflict condition type for table "location" */
export type Location_On_Conflict = {
  constraint: Location_Constraint;
  update_columns?: Array<Location_Update_Column>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** Ordering options when selecting data from "location". */
export type Location_Order_By = {
  country_region?: InputMaybe<Country_Region_Order_By>;
  country_region_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_files_aggregate?: InputMaybe<Project_File_Aggregate_Order_By>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Order_By>;
  zone?: InputMaybe<Zone_Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location */
export type Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "location" */
export enum Location_Select_Column {
  /** column name */
  CountryRegionId = 'country_region_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ZoneId = 'zone_id'
}

/** input type for updating data in table "location" */
export type Location_Set_Input = {
  country_region_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "location" */
export type Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Stream_Cursor_Value_Input = {
  country_region_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  zone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "location" */
export enum Location_Update_Column {
  /** column name */
  CountryRegionId = 'country_region_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ZoneId = 'zone_id'
}

export type Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Bool_Exp;
};

/** columns and relationships of "measure_unit" */
export type Measure_Unit = {
  __typename?: 'measure_unit';
  /** An object relationship */
  country?: Maybe<Country>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  measure_unit_type: Measure_Unit_Type;
  multiplier: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  projectInterviewCropsBySoldUnitMeasureId: Array<Project_Interview_Crops>;
  /** An aggregate relationship */
  projectInterviewCropsBySoldUnitMeasureId_aggregate: Project_Interview_Crops_Aggregate;
  /** An array relationship */
  project_interview_bases: Array<Project_Interview_Base>;
  /** An aggregate relationship */
  project_interview_bases_aggregate: Project_Interview_Base_Aggregate;
  /** An array relationship */
  project_interview_crops: Array<Project_Interview_Crops>;
  /** An aggregate relationship */
  project_interview_crops_aggregate: Project_Interview_Crops_Aggregate;
  /** An array relationship */
  project_interview_livestock_milks: Array<Project_Interview_Livestock_Milk>;
  /** An aggregate relationship */
  project_interview_livestock_milks_aggregate: Project_Interview_Livestock_Milk_Aggregate;
  type: Measure_Unit_Type_Enum;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProjectInterviewCropsBySoldUnitMeasureIdArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProjectInterviewCropsBySoldUnitMeasureId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProject_Interview_BasesArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProject_Interview_Bases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProject_Interview_CropsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProject_Interview_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProject_Interview_Livestock_MilksArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


/** columns and relationships of "measure_unit" */
export type Measure_UnitProject_Interview_Livestock_Milks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};

/** aggregated selection of "measure_unit" */
export type Measure_Unit_Aggregate = {
  __typename?: 'measure_unit_aggregate';
  aggregate?: Maybe<Measure_Unit_Aggregate_Fields>;
  nodes: Array<Measure_Unit>;
};

export type Measure_Unit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Measure_Unit_Aggregate_Bool_Exp_Count>;
};

export type Measure_Unit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Measure_Unit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "measure_unit" */
export type Measure_Unit_Aggregate_Fields = {
  __typename?: 'measure_unit_aggregate_fields';
  avg?: Maybe<Measure_Unit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Measure_Unit_Max_Fields>;
  min?: Maybe<Measure_Unit_Min_Fields>;
  stddev?: Maybe<Measure_Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Measure_Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Measure_Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Measure_Unit_Sum_Fields>;
  var_pop?: Maybe<Measure_Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Measure_Unit_Var_Samp_Fields>;
  variance?: Maybe<Measure_Unit_Variance_Fields>;
};


/** aggregate fields of "measure_unit" */
export type Measure_Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "measure_unit" */
export type Measure_Unit_Aggregate_Order_By = {
  avg?: InputMaybe<Measure_Unit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Measure_Unit_Max_Order_By>;
  min?: InputMaybe<Measure_Unit_Min_Order_By>;
  stddev?: InputMaybe<Measure_Unit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Measure_Unit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Measure_Unit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Measure_Unit_Sum_Order_By>;
  var_pop?: InputMaybe<Measure_Unit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Measure_Unit_Var_Samp_Order_By>;
  variance?: InputMaybe<Measure_Unit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "measure_unit" */
export type Measure_Unit_Arr_Rel_Insert_Input = {
  data: Array<Measure_Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Measure_Unit_On_Conflict>;
};

/** aggregate avg on columns */
export type Measure_Unit_Avg_Fields = {
  __typename?: 'measure_unit_avg_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "measure_unit" */
export type Measure_Unit_Avg_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "measure_unit". All fields are combined with a logical 'AND'. */
export type Measure_Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Measure_Unit_Bool_Exp>>;
  _not?: InputMaybe<Measure_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Measure_Unit_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  measure_unit_type?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
  multiplier?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectInterviewCropsBySoldUnitMeasureId?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
  projectInterviewCropsBySoldUnitMeasureId_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Bool_Exp>;
  project_interview_bases?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  project_interview_bases_aggregate?: InputMaybe<Project_Interview_Base_Aggregate_Bool_Exp>;
  project_interview_crops?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
  project_interview_crops_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Bool_Exp>;
  project_interview_livestock_milks?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  project_interview_livestock_milks_aggregate?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Bool_Exp>;
  type?: InputMaybe<Measure_Unit_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "measure_unit" */
export enum Measure_Unit_Constraint {
  /** unique or primary key constraint on columns "multiplier", "country_id" */
  MeasureUnitCountryIdMultiplierKey = 'measure_unit_country_id_multiplier_key',
  /** unique or primary key constraint on columns "id" */
  MeasureUnitPkey = 'measure_unit_pkey'
}

/** input type for incrementing numeric columns in table "measure_unit" */
export type Measure_Unit_Inc_Input = {
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "measure_unit" */
export type Measure_Unit_Insert_Input = {
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  measure_unit_type?: InputMaybe<Measure_Unit_Type_Obj_Rel_Insert_Input>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectInterviewCropsBySoldUnitMeasureId?: InputMaybe<Project_Interview_Crops_Arr_Rel_Insert_Input>;
  project_interview_bases?: InputMaybe<Project_Interview_Base_Arr_Rel_Insert_Input>;
  project_interview_crops?: InputMaybe<Project_Interview_Crops_Arr_Rel_Insert_Input>;
  project_interview_livestock_milks?: InputMaybe<Project_Interview_Livestock_Milk_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Measure_Unit_Type_Enum>;
};

/** aggregate max on columns */
export type Measure_Unit_Max_Fields = {
  __typename?: 'measure_unit_max_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "measure_unit" */
export type Measure_Unit_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Measure_Unit_Min_Fields = {
  __typename?: 'measure_unit_min_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  multiplier?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "measure_unit" */
export type Measure_Unit_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "measure_unit" */
export type Measure_Unit_Mutation_Response = {
  __typename?: 'measure_unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Measure_Unit>;
};

/** input type for inserting object relation for remote table "measure_unit" */
export type Measure_Unit_Obj_Rel_Insert_Input = {
  data: Measure_Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Measure_Unit_On_Conflict>;
};

/** on_conflict condition type for table "measure_unit" */
export type Measure_Unit_On_Conflict = {
  constraint: Measure_Unit_Constraint;
  update_columns?: Array<Measure_Unit_Update_Column>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "measure_unit". */
export type Measure_Unit_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_unit_type?: InputMaybe<Measure_Unit_Type_Order_By>;
  multiplier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectInterviewCropsBySoldUnitMeasureId_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Order_By>;
  project_interview_bases_aggregate?: InputMaybe<Project_Interview_Base_Aggregate_Order_By>;
  project_interview_crops_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Order_By>;
  project_interview_livestock_milks_aggregate?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: measure_unit */
export type Measure_Unit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "measure_unit" */
export enum Measure_Unit_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Multiplier = 'multiplier',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "measure_unit" */
export type Measure_Unit_Set_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Measure_Unit_Type_Enum>;
};

/** aggregate stddev on columns */
export type Measure_Unit_Stddev_Fields = {
  __typename?: 'measure_unit_stddev_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "measure_unit" */
export type Measure_Unit_Stddev_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Measure_Unit_Stddev_Pop_Fields = {
  __typename?: 'measure_unit_stddev_pop_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "measure_unit" */
export type Measure_Unit_Stddev_Pop_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Measure_Unit_Stddev_Samp_Fields = {
  __typename?: 'measure_unit_stddev_samp_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "measure_unit" */
export type Measure_Unit_Stddev_Samp_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "measure_unit" */
export type Measure_Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Measure_Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Measure_Unit_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  multiplier?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Measure_Unit_Type_Enum>;
};

/** aggregate sum on columns */
export type Measure_Unit_Sum_Fields = {
  __typename?: 'measure_unit_sum_fields';
  multiplier?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "measure_unit" */
export type Measure_Unit_Sum_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** columns and relationships of "measure_unit_type" */
export type Measure_Unit_Type = {
  __typename?: 'measure_unit_type';
  /** An array relationship */
  measure_units: Array<Measure_Unit>;
  /** An aggregate relationship */
  measure_units_aggregate: Measure_Unit_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "measure_unit_type" */
export type Measure_Unit_TypeMeasure_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


/** columns and relationships of "measure_unit_type" */
export type Measure_Unit_TypeMeasure_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};

/** aggregated selection of "measure_unit_type" */
export type Measure_Unit_Type_Aggregate = {
  __typename?: 'measure_unit_type_aggregate';
  aggregate?: Maybe<Measure_Unit_Type_Aggregate_Fields>;
  nodes: Array<Measure_Unit_Type>;
};

/** aggregate fields of "measure_unit_type" */
export type Measure_Unit_Type_Aggregate_Fields = {
  __typename?: 'measure_unit_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Measure_Unit_Type_Max_Fields>;
  min?: Maybe<Measure_Unit_Type_Min_Fields>;
};


/** aggregate fields of "measure_unit_type" */
export type Measure_Unit_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Measure_Unit_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "measure_unit_type". All fields are combined with a logical 'AND'. */
export type Measure_Unit_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Measure_Unit_Type_Bool_Exp>>;
  _not?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Measure_Unit_Type_Bool_Exp>>;
  measure_units?: InputMaybe<Measure_Unit_Bool_Exp>;
  measure_units_aggregate?: InputMaybe<Measure_Unit_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "measure_unit_type" */
export enum Measure_Unit_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  MeasureUnitTypePkey = 'measure_unit_type_pkey'
}

export enum Measure_Unit_Type_Enum {
  LandSize = 'LAND_SIZE',
  Mass = 'MASS',
  MassPurchases = 'MASS_PURCHASES',
  Volume = 'VOLUME'
}

/** Boolean expression to compare columns of type "measure_unit_type_enum". All fields are combined with logical 'AND'. */
export type Measure_Unit_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Measure_Unit_Type_Enum>;
  _in?: InputMaybe<Array<Measure_Unit_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Measure_Unit_Type_Enum>;
  _nin?: InputMaybe<Array<Measure_Unit_Type_Enum>>;
};

/** input type for inserting data into table "measure_unit_type" */
export type Measure_Unit_Type_Insert_Input = {
  measure_units?: InputMaybe<Measure_Unit_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Measure_Unit_Type_Max_Fields = {
  __typename?: 'measure_unit_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Measure_Unit_Type_Min_Fields = {
  __typename?: 'measure_unit_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "measure_unit_type" */
export type Measure_Unit_Type_Mutation_Response = {
  __typename?: 'measure_unit_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Measure_Unit_Type>;
};

/** input type for inserting object relation for remote table "measure_unit_type" */
export type Measure_Unit_Type_Obj_Rel_Insert_Input = {
  data: Measure_Unit_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Measure_Unit_Type_On_Conflict>;
};

/** on_conflict condition type for table "measure_unit_type" */
export type Measure_Unit_Type_On_Conflict = {
  constraint: Measure_Unit_Type_Constraint;
  update_columns?: Array<Measure_Unit_Type_Update_Column>;
  where?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "measure_unit_type". */
export type Measure_Unit_Type_Order_By = {
  measure_units_aggregate?: InputMaybe<Measure_Unit_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: measure_unit_type */
export type Measure_Unit_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "measure_unit_type" */
export enum Measure_Unit_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "measure_unit_type" */
export type Measure_Unit_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "measure_unit_type" */
export type Measure_Unit_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Measure_Unit_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Measure_Unit_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "measure_unit_type" */
export enum Measure_Unit_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Measure_Unit_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Measure_Unit_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Measure_Unit_Type_Bool_Exp;
};

/** update columns of table "measure_unit" */
export enum Measure_Unit_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Multiplier = 'multiplier',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

export type Measure_Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Measure_Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Measure_Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Measure_Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Measure_Unit_Var_Pop_Fields = {
  __typename?: 'measure_unit_var_pop_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "measure_unit" */
export type Measure_Unit_Var_Pop_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Measure_Unit_Var_Samp_Fields = {
  __typename?: 'measure_unit_var_samp_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "measure_unit" */
export type Measure_Unit_Var_Samp_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Measure_Unit_Variance_Fields = {
  __typename?: 'measure_unit_variance_fields';
  multiplier?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "measure_unit" */
export type Measure_Unit_Variance_Order_By = {
  multiplier?: InputMaybe<Order_By>;
};

/** columns and relationships of "month" */
export type Month = {
  __typename?: 'month';
  /** An array relationship */
  crop_season_month_mns: Array<Crop_Season_Month_Mn>;
  /** An aggregate relationship */
  crop_season_month_mns_aggregate: Crop_Season_Month_Mn_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  project_interview_livestock_milks: Array<Project_Interview_Livestock_Milk>;
  /** An aggregate relationship */
  project_interview_livestock_milks_aggregate: Project_Interview_Livestock_Milk_Aggregate;
};


/** columns and relationships of "month" */
export type MonthCrop_Season_Month_MnsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


/** columns and relationships of "month" */
export type MonthCrop_Season_Month_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


/** columns and relationships of "month" */
export type MonthProject_Interview_Livestock_MilksArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


/** columns and relationships of "month" */
export type MonthProject_Interview_Livestock_Milks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};

/** aggregated selection of "month" */
export type Month_Aggregate = {
  __typename?: 'month_aggregate';
  aggregate?: Maybe<Month_Aggregate_Fields>;
  nodes: Array<Month>;
};

/** aggregate fields of "month" */
export type Month_Aggregate_Fields = {
  __typename?: 'month_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Month_Max_Fields>;
  min?: Maybe<Month_Min_Fields>;
};


/** aggregate fields of "month" */
export type Month_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Month_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "month". All fields are combined with a logical 'AND'. */
export type Month_Bool_Exp = {
  _and?: InputMaybe<Array<Month_Bool_Exp>>;
  _not?: InputMaybe<Month_Bool_Exp>;
  _or?: InputMaybe<Array<Month_Bool_Exp>>;
  crop_season_month_mns?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
  crop_season_month_mns_aggregate?: InputMaybe<Crop_Season_Month_Mn_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_interview_livestock_milks?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  project_interview_livestock_milks_aggregate?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "month" */
export enum Month_Constraint {
  /** unique or primary key constraint on columns "name" */
  MonthPkey = 'month_pkey'
}

export enum Month_Enum {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

/** Boolean expression to compare columns of type "month_enum". All fields are combined with logical 'AND'. */
export type Month_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Month_Enum>;
  _in?: InputMaybe<Array<Month_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Month_Enum>;
  _nin?: InputMaybe<Array<Month_Enum>>;
};

/** input type for inserting data into table "month" */
export type Month_Insert_Input = {
  crop_season_month_mns?: InputMaybe<Crop_Season_Month_Mn_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_interview_livestock_milks?: InputMaybe<Project_Interview_Livestock_Milk_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Month_Max_Fields = {
  __typename?: 'month_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Month_Min_Fields = {
  __typename?: 'month_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "month" */
export type Month_Mutation_Response = {
  __typename?: 'month_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Month>;
};

/** input type for inserting object relation for remote table "month" */
export type Month_Obj_Rel_Insert_Input = {
  data: Month_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Month_On_Conflict>;
};

/** on_conflict condition type for table "month" */
export type Month_On_Conflict = {
  constraint: Month_Constraint;
  update_columns?: Array<Month_Update_Column>;
  where?: InputMaybe<Month_Bool_Exp>;
};

/** Ordering options when selecting data from "month". */
export type Month_Order_By = {
  crop_season_month_mns_aggregate?: InputMaybe<Crop_Season_Month_Mn_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  project_interview_livestock_milks_aggregate?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Order_By>;
};

/** primary key columns input for table: month */
export type Month_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "month" */
export enum Month_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "month" */
export type Month_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "month" */
export type Month_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Month_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Month_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "month" */
export enum Month_Update_Column {
  /** column name */
  Name = 'name'
}

export type Month_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Month_Set_Input>;
  /** filter the rows which have to be updated */
  where: Month_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "country_region" */
  delete_country_region?: Maybe<Country_Region_Mutation_Response>;
  /** delete single row from the table: "country_region" */
  delete_country_region_by_pk?: Maybe<Country_Region>;
  /** delete data from the table: "crop_season" */
  delete_crop_season?: Maybe<Crop_Season_Mutation_Response>;
  /** delete single row from the table: "crop_season" */
  delete_crop_season_by_pk?: Maybe<Crop_Season>;
  /** delete data from the table: "crop_season_month_mn" */
  delete_crop_season_month_mn?: Maybe<Crop_Season_Month_Mn_Mutation_Response>;
  /** delete single row from the table: "crop_season_month_mn" */
  delete_crop_season_month_mn_by_pk?: Maybe<Crop_Season_Month_Mn>;
  /** delete data from the table: "livestock_milking_season" */
  delete_livestock_milking_season?: Maybe<Livestock_Milking_Season_Mutation_Response>;
  /** delete single row from the table: "livestock_milking_season" */
  delete_livestock_milking_season_by_pk?: Maybe<Livestock_Milking_Season>;
  /** delete data from the table: "livestock_type" */
  delete_livestock_type?: Maybe<Livestock_Type_Mutation_Response>;
  /** delete single row from the table: "livestock_type" */
  delete_livestock_type_by_pk?: Maybe<Livestock_Type>;
  /** delete data from the table: "location" */
  delete_location?: Maybe<Location_Mutation_Response>;
  /** delete single row from the table: "location" */
  delete_location_by_pk?: Maybe<Location>;
  /** delete data from the table: "measure_unit" */
  delete_measure_unit?: Maybe<Measure_Unit_Mutation_Response>;
  /** delete single row from the table: "measure_unit" */
  delete_measure_unit_by_pk?: Maybe<Measure_Unit>;
  /** delete data from the table: "measure_unit_type" */
  delete_measure_unit_type?: Maybe<Measure_Unit_Type_Mutation_Response>;
  /** delete single row from the table: "measure_unit_type" */
  delete_measure_unit_type_by_pk?: Maybe<Measure_Unit_Type>;
  /** delete data from the table: "month" */
  delete_month?: Maybe<Month_Mutation_Response>;
  /** delete single row from the table: "month" */
  delete_month_by_pk?: Maybe<Month>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete data from the table: "project_bss_data" */
  delete_project_bss_data?: Maybe<Project_Bss_Data_Mutation_Response>;
  /** delete data from the table: "project_bss_data_backup" */
  delete_project_bss_data_backup?: Maybe<Project_Bss_Data_Backup_Mutation_Response>;
  /** delete single row from the table: "project_bss_data_backup" */
  delete_project_bss_data_backup_by_pk?: Maybe<Project_Bss_Data_Backup>;
  /** delete single row from the table: "project_bss_data" */
  delete_project_bss_data_by_pk?: Maybe<Project_Bss_Data>;
  /** delete data from the table: "project_bss_data_type" */
  delete_project_bss_data_type?: Maybe<Project_Bss_Data_Type_Mutation_Response>;
  /** delete single row from the table: "project_bss_data_type" */
  delete_project_bss_data_type_by_pk?: Maybe<Project_Bss_Data_Type>;
  /** delete data from the table: "project_bss_note" */
  delete_project_bss_note?: Maybe<Project_Bss_Note_Mutation_Response>;
  /** delete single row from the table: "project_bss_note" */
  delete_project_bss_note_by_pk?: Maybe<Project_Bss_Note>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "project_file" */
  delete_project_file?: Maybe<Project_File_Mutation_Response>;
  /** delete single row from the table: "project_file" */
  delete_project_file_by_pk?: Maybe<Project_File>;
  /** delete data from the table: "project_interview" */
  delete_project_interview?: Maybe<Project_Interview_Mutation_Response>;
  /** delete data from the table: "project_interview_backup" */
  delete_project_interview_backup?: Maybe<Project_Interview_Backup_Mutation_Response>;
  /** delete single row from the table: "project_interview_backup" */
  delete_project_interview_backup_by_pk?: Maybe<Project_Interview_Backup>;
  /** delete data from the table: "project_interview_base" */
  delete_project_interview_base?: Maybe<Project_Interview_Base_Mutation_Response>;
  /** delete single row from the table: "project_interview_base" */
  delete_project_interview_base_by_pk?: Maybe<Project_Interview_Base>;
  /** delete single row from the table: "project_interview" */
  delete_project_interview_by_pk?: Maybe<Project_Interview>;
  /** delete data from the table: "project_interview_crops" */
  delete_project_interview_crops?: Maybe<Project_Interview_Crops_Mutation_Response>;
  /** delete single row from the table: "project_interview_crops" */
  delete_project_interview_crops_by_pk?: Maybe<Project_Interview_Crops>;
  /** delete data from the table: "project_interview_crops_green_root" */
  delete_project_interview_crops_green_root?: Maybe<Project_Interview_Crops_Green_Root_Mutation_Response>;
  /** delete single row from the table: "project_interview_crops_green_root" */
  delete_project_interview_crops_green_root_by_pk?: Maybe<Project_Interview_Crops_Green_Root>;
  /** delete data from the table: "project_interview_crops_season" */
  delete_project_interview_crops_season?: Maybe<Project_Interview_Crops_Season_Mutation_Response>;
  /** delete single row from the table: "project_interview_crops_season" */
  delete_project_interview_crops_season_by_pk?: Maybe<Project_Interview_Crops_Season>;
  /** delete data from the table: "project_interview_data" */
  delete_project_interview_data?: Maybe<Project_Interview_Data_Mutation_Response>;
  /** delete single row from the table: "project_interview_data" */
  delete_project_interview_data_by_pk?: Maybe<Project_Interview_Data>;
  /** delete data from the table: "project_interview_data_type" */
  delete_project_interview_data_type?: Maybe<Project_Interview_Data_Type_Mutation_Response>;
  /** delete single row from the table: "project_interview_data_type" */
  delete_project_interview_data_type_by_pk?: Maybe<Project_Interview_Data_Type>;
  /** delete data from the table: "project_interview_file" */
  delete_project_interview_file?: Maybe<Project_Interview_File_Mutation_Response>;
  /** delete single row from the table: "project_interview_file" */
  delete_project_interview_file_by_pk?: Maybe<Project_Interview_File>;
  /** delete data from the table: "project_interview_livestock" */
  delete_project_interview_livestock?: Maybe<Project_Interview_Livestock_Mutation_Response>;
  /** delete single row from the table: "project_interview_livestock" */
  delete_project_interview_livestock_by_pk?: Maybe<Project_Interview_Livestock>;
  /** delete data from the table: "project_interview_livestock_milk" */
  delete_project_interview_livestock_milk?: Maybe<Project_Interview_Livestock_Milk_Mutation_Response>;
  /** delete single row from the table: "project_interview_livestock_milk" */
  delete_project_interview_livestock_milk_by_pk?: Maybe<Project_Interview_Livestock_Milk>;
  /** delete data from the table: "project_interview_note" */
  delete_project_interview_note?: Maybe<Project_Interview_Note_Mutation_Response>;
  /** delete single row from the table: "project_interview_note" */
  delete_project_interview_note_by_pk?: Maybe<Project_Interview_Note>;
  /** delete data from the table: "project_interview_productive_asset" */
  delete_project_interview_productive_asset?: Maybe<Project_Interview_Productive_Asset_Mutation_Response>;
  /** delete single row from the table: "project_interview_productive_asset" */
  delete_project_interview_productive_asset_by_pk?: Maybe<Project_Interview_Productive_Asset>;
  /** delete data from the table: "project_interview_researcher_mn" */
  delete_project_interview_researcher_mn?: Maybe<Project_Interview_Researcher_Mn_Mutation_Response>;
  /** delete single row from the table: "project_interview_researcher_mn" */
  delete_project_interview_researcher_mn_by_pk?: Maybe<Project_Interview_Researcher_Mn>;
  /** delete data from the table: "project_interview_totals" */
  delete_project_interview_totals?: Maybe<Project_Interview_Totals_Mutation_Response>;
  /** delete single row from the table: "project_interview_totals" */
  delete_project_interview_totals_by_pk?: Maybe<Project_Interview_Totals>;
  /** delete data from the table: "sale_purchase_type" */
  delete_sale_purchase_type?: Maybe<Sale_Purchase_Type_Mutation_Response>;
  /** delete single row from the table: "sale_purchase_type" */
  delete_sale_purchase_type_by_pk?: Maybe<Sale_Purchase_Type>;
  /** delete data from the table: "status" */
  delete_status?: Maybe<Status_Mutation_Response>;
  /** delete single row from the table: "status" */
  delete_status_by_pk?: Maybe<Status>;
  /** delete data from the table: "term" */
  delete_term?: Maybe<Term_Mutation_Response>;
  /** delete single row from the table: "term" */
  delete_term_by_pk?: Maybe<Term>;
  /** delete data from the table: "term_category" */
  delete_term_category?: Maybe<Term_Category_Mutation_Response>;
  /** delete single row from the table: "term_category" */
  delete_term_category_by_pk?: Maybe<Term_Category>;
  /** delete data from the table: "term_category_mn" */
  delete_term_category_mn?: Maybe<Term_Category_Mn_Mutation_Response>;
  /** delete single row from the table: "term_category_mn" */
  delete_term_category_mn_by_pk?: Maybe<Term_Category_Mn>;
  /** delete data from the table: "user_permission" */
  delete_user_permission?: Maybe<User_Permission_Mutation_Response>;
  /** delete single row from the table: "user_permission" */
  delete_user_permission_by_pk?: Maybe<User_Permission>;
  /** delete data from the table: "user_permission_role" */
  delete_user_permission_role?: Maybe<User_Permission_Role_Mutation_Response>;
  /** delete single row from the table: "user_permission_role" */
  delete_user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** delete data from the table: "user_profile" */
  delete_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** delete single row from the table: "user_profile" */
  delete_user_profile_by_pk?: Maybe<User_Profile>;
  /** delete data from the table: "wealth_group" */
  delete_wealth_group?: Maybe<Wealth_Group_Mutation_Response>;
  /** delete single row from the table: "wealth_group" */
  delete_wealth_group_by_pk?: Maybe<Wealth_Group>;
  /** delete data from the table: "zone" */
  delete_zone?: Maybe<Zone_Mutation_Response>;
  /** delete single row from the table: "zone" */
  delete_zone_by_pk?: Maybe<Zone>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "country_region" */
  insert_country_region?: Maybe<Country_Region_Mutation_Response>;
  /** insert a single row into the table: "country_region" */
  insert_country_region_one?: Maybe<Country_Region>;
  /** insert data into the table: "crop_season" */
  insert_crop_season?: Maybe<Crop_Season_Mutation_Response>;
  /** insert data into the table: "crop_season_month_mn" */
  insert_crop_season_month_mn?: Maybe<Crop_Season_Month_Mn_Mutation_Response>;
  /** insert a single row into the table: "crop_season_month_mn" */
  insert_crop_season_month_mn_one?: Maybe<Crop_Season_Month_Mn>;
  /** insert a single row into the table: "crop_season" */
  insert_crop_season_one?: Maybe<Crop_Season>;
  /** insert data into the table: "livestock_milking_season" */
  insert_livestock_milking_season?: Maybe<Livestock_Milking_Season_Mutation_Response>;
  /** insert a single row into the table: "livestock_milking_season" */
  insert_livestock_milking_season_one?: Maybe<Livestock_Milking_Season>;
  /** insert data into the table: "livestock_type" */
  insert_livestock_type?: Maybe<Livestock_Type_Mutation_Response>;
  /** insert a single row into the table: "livestock_type" */
  insert_livestock_type_one?: Maybe<Livestock_Type>;
  /** insert data into the table: "location" */
  insert_location?: Maybe<Location_Mutation_Response>;
  /** insert a single row into the table: "location" */
  insert_location_one?: Maybe<Location>;
  /** insert data into the table: "measure_unit" */
  insert_measure_unit?: Maybe<Measure_Unit_Mutation_Response>;
  /** insert a single row into the table: "measure_unit" */
  insert_measure_unit_one?: Maybe<Measure_Unit>;
  /** insert data into the table: "measure_unit_type" */
  insert_measure_unit_type?: Maybe<Measure_Unit_Type_Mutation_Response>;
  /** insert a single row into the table: "measure_unit_type" */
  insert_measure_unit_type_one?: Maybe<Measure_Unit_Type>;
  /** insert data into the table: "month" */
  insert_month?: Maybe<Month_Mutation_Response>;
  /** insert a single row into the table: "month" */
  insert_month_one?: Maybe<Month>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "project_bss_data" */
  insert_project_bss_data?: Maybe<Project_Bss_Data_Mutation_Response>;
  /** insert data into the table: "project_bss_data_backup" */
  insert_project_bss_data_backup?: Maybe<Project_Bss_Data_Backup_Mutation_Response>;
  /** insert a single row into the table: "project_bss_data_backup" */
  insert_project_bss_data_backup_one?: Maybe<Project_Bss_Data_Backup>;
  /** insert a single row into the table: "project_bss_data" */
  insert_project_bss_data_one?: Maybe<Project_Bss_Data>;
  /** insert data into the table: "project_bss_data_type" */
  insert_project_bss_data_type?: Maybe<Project_Bss_Data_Type_Mutation_Response>;
  /** insert a single row into the table: "project_bss_data_type" */
  insert_project_bss_data_type_one?: Maybe<Project_Bss_Data_Type>;
  /** insert data into the table: "project_bss_note" */
  insert_project_bss_note?: Maybe<Project_Bss_Note_Mutation_Response>;
  /** insert a single row into the table: "project_bss_note" */
  insert_project_bss_note_one?: Maybe<Project_Bss_Note>;
  /** insert data into the table: "project_file" */
  insert_project_file?: Maybe<Project_File_Mutation_Response>;
  /** insert a single row into the table: "project_file" */
  insert_project_file_one?: Maybe<Project_File>;
  /** insert data into the table: "project_interview" */
  insert_project_interview?: Maybe<Project_Interview_Mutation_Response>;
  /** insert data into the table: "project_interview_backup" */
  insert_project_interview_backup?: Maybe<Project_Interview_Backup_Mutation_Response>;
  /** insert a single row into the table: "project_interview_backup" */
  insert_project_interview_backup_one?: Maybe<Project_Interview_Backup>;
  /** insert data into the table: "project_interview_base" */
  insert_project_interview_base?: Maybe<Project_Interview_Base_Mutation_Response>;
  /** insert a single row into the table: "project_interview_base" */
  insert_project_interview_base_one?: Maybe<Project_Interview_Base>;
  /** insert data into the table: "project_interview_crops" */
  insert_project_interview_crops?: Maybe<Project_Interview_Crops_Mutation_Response>;
  /** insert data into the table: "project_interview_crops_green_root" */
  insert_project_interview_crops_green_root?: Maybe<Project_Interview_Crops_Green_Root_Mutation_Response>;
  /** insert a single row into the table: "project_interview_crops_green_root" */
  insert_project_interview_crops_green_root_one?: Maybe<Project_Interview_Crops_Green_Root>;
  /** insert a single row into the table: "project_interview_crops" */
  insert_project_interview_crops_one?: Maybe<Project_Interview_Crops>;
  /** insert data into the table: "project_interview_crops_season" */
  insert_project_interview_crops_season?: Maybe<Project_Interview_Crops_Season_Mutation_Response>;
  /** insert a single row into the table: "project_interview_crops_season" */
  insert_project_interview_crops_season_one?: Maybe<Project_Interview_Crops_Season>;
  /** insert data into the table: "project_interview_data" */
  insert_project_interview_data?: Maybe<Project_Interview_Data_Mutation_Response>;
  /** insert a single row into the table: "project_interview_data" */
  insert_project_interview_data_one?: Maybe<Project_Interview_Data>;
  /** insert data into the table: "project_interview_data_type" */
  insert_project_interview_data_type?: Maybe<Project_Interview_Data_Type_Mutation_Response>;
  /** insert a single row into the table: "project_interview_data_type" */
  insert_project_interview_data_type_one?: Maybe<Project_Interview_Data_Type>;
  /** insert data into the table: "project_interview_file" */
  insert_project_interview_file?: Maybe<Project_Interview_File_Mutation_Response>;
  /** insert a single row into the table: "project_interview_file" */
  insert_project_interview_file_one?: Maybe<Project_Interview_File>;
  /** insert data into the table: "project_interview_livestock" */
  insert_project_interview_livestock?: Maybe<Project_Interview_Livestock_Mutation_Response>;
  /** insert data into the table: "project_interview_livestock_milk" */
  insert_project_interview_livestock_milk?: Maybe<Project_Interview_Livestock_Milk_Mutation_Response>;
  /** insert a single row into the table: "project_interview_livestock_milk" */
  insert_project_interview_livestock_milk_one?: Maybe<Project_Interview_Livestock_Milk>;
  /** insert a single row into the table: "project_interview_livestock" */
  insert_project_interview_livestock_one?: Maybe<Project_Interview_Livestock>;
  /** insert data into the table: "project_interview_note" */
  insert_project_interview_note?: Maybe<Project_Interview_Note_Mutation_Response>;
  /** insert a single row into the table: "project_interview_note" */
  insert_project_interview_note_one?: Maybe<Project_Interview_Note>;
  /** insert a single row into the table: "project_interview" */
  insert_project_interview_one?: Maybe<Project_Interview>;
  /** insert data into the table: "project_interview_productive_asset" */
  insert_project_interview_productive_asset?: Maybe<Project_Interview_Productive_Asset_Mutation_Response>;
  /** insert a single row into the table: "project_interview_productive_asset" */
  insert_project_interview_productive_asset_one?: Maybe<Project_Interview_Productive_Asset>;
  /** insert data into the table: "project_interview_researcher_mn" */
  insert_project_interview_researcher_mn?: Maybe<Project_Interview_Researcher_Mn_Mutation_Response>;
  /** insert a single row into the table: "project_interview_researcher_mn" */
  insert_project_interview_researcher_mn_one?: Maybe<Project_Interview_Researcher_Mn>;
  /** insert data into the table: "project_interview_totals" */
  insert_project_interview_totals?: Maybe<Project_Interview_Totals_Mutation_Response>;
  /** insert a single row into the table: "project_interview_totals" */
  insert_project_interview_totals_one?: Maybe<Project_Interview_Totals>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "sale_purchase_type" */
  insert_sale_purchase_type?: Maybe<Sale_Purchase_Type_Mutation_Response>;
  /** insert a single row into the table: "sale_purchase_type" */
  insert_sale_purchase_type_one?: Maybe<Sale_Purchase_Type>;
  /** insert data into the table: "status" */
  insert_status?: Maybe<Status_Mutation_Response>;
  /** insert a single row into the table: "status" */
  insert_status_one?: Maybe<Status>;
  /** insert data into the table: "term" */
  insert_term?: Maybe<Term_Mutation_Response>;
  /** insert data into the table: "term_category" */
  insert_term_category?: Maybe<Term_Category_Mutation_Response>;
  /** insert data into the table: "term_category_mn" */
  insert_term_category_mn?: Maybe<Term_Category_Mn_Mutation_Response>;
  /** insert a single row into the table: "term_category_mn" */
  insert_term_category_mn_one?: Maybe<Term_Category_Mn>;
  /** insert a single row into the table: "term_category" */
  insert_term_category_one?: Maybe<Term_Category>;
  /** insert a single row into the table: "term" */
  insert_term_one?: Maybe<Term>;
  /** insert data into the table: "user_permission" */
  insert_user_permission?: Maybe<User_Permission_Mutation_Response>;
  /** insert a single row into the table: "user_permission" */
  insert_user_permission_one?: Maybe<User_Permission>;
  /** insert data into the table: "user_permission_role" */
  insert_user_permission_role?: Maybe<User_Permission_Role_Mutation_Response>;
  /** insert a single row into the table: "user_permission_role" */
  insert_user_permission_role_one?: Maybe<User_Permission_Role>;
  /** insert data into the table: "user_profile" */
  insert_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** insert a single row into the table: "user_profile" */
  insert_user_profile_one?: Maybe<User_Profile>;
  /** insert data into the table: "wealth_group" */
  insert_wealth_group?: Maybe<Wealth_Group_Mutation_Response>;
  /** insert a single row into the table: "wealth_group" */
  insert_wealth_group_one?: Maybe<Wealth_Group>;
  /** insert data into the table: "zone" */
  insert_zone?: Maybe<Zone_Mutation_Response>;
  /** insert a single row into the table: "zone" */
  insert_zone_one?: Maybe<Zone>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<Country_Mutation_Response>>>;
  /** update data of the table: "country_region" */
  update_country_region?: Maybe<Country_Region_Mutation_Response>;
  /** update single row of the table: "country_region" */
  update_country_region_by_pk?: Maybe<Country_Region>;
  /** update multiples rows of table: "country_region" */
  update_country_region_many?: Maybe<Array<Maybe<Country_Region_Mutation_Response>>>;
  /** update data of the table: "crop_season" */
  update_crop_season?: Maybe<Crop_Season_Mutation_Response>;
  /** update single row of the table: "crop_season" */
  update_crop_season_by_pk?: Maybe<Crop_Season>;
  /** update multiples rows of table: "crop_season" */
  update_crop_season_many?: Maybe<Array<Maybe<Crop_Season_Mutation_Response>>>;
  /** update data of the table: "crop_season_month_mn" */
  update_crop_season_month_mn?: Maybe<Crop_Season_Month_Mn_Mutation_Response>;
  /** update single row of the table: "crop_season_month_mn" */
  update_crop_season_month_mn_by_pk?: Maybe<Crop_Season_Month_Mn>;
  /** update multiples rows of table: "crop_season_month_mn" */
  update_crop_season_month_mn_many?: Maybe<Array<Maybe<Crop_Season_Month_Mn_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "livestock_milking_season" */
  update_livestock_milking_season?: Maybe<Livestock_Milking_Season_Mutation_Response>;
  /** update single row of the table: "livestock_milking_season" */
  update_livestock_milking_season_by_pk?: Maybe<Livestock_Milking_Season>;
  /** update multiples rows of table: "livestock_milking_season" */
  update_livestock_milking_season_many?: Maybe<Array<Maybe<Livestock_Milking_Season_Mutation_Response>>>;
  /** update data of the table: "livestock_type" */
  update_livestock_type?: Maybe<Livestock_Type_Mutation_Response>;
  /** update single row of the table: "livestock_type" */
  update_livestock_type_by_pk?: Maybe<Livestock_Type>;
  /** update multiples rows of table: "livestock_type" */
  update_livestock_type_many?: Maybe<Array<Maybe<Livestock_Type_Mutation_Response>>>;
  /** update data of the table: "location" */
  update_location?: Maybe<Location_Mutation_Response>;
  /** update single row of the table: "location" */
  update_location_by_pk?: Maybe<Location>;
  /** update multiples rows of table: "location" */
  update_location_many?: Maybe<Array<Maybe<Location_Mutation_Response>>>;
  /** update data of the table: "measure_unit" */
  update_measure_unit?: Maybe<Measure_Unit_Mutation_Response>;
  /** update single row of the table: "measure_unit" */
  update_measure_unit_by_pk?: Maybe<Measure_Unit>;
  /** update multiples rows of table: "measure_unit" */
  update_measure_unit_many?: Maybe<Array<Maybe<Measure_Unit_Mutation_Response>>>;
  /** update data of the table: "measure_unit_type" */
  update_measure_unit_type?: Maybe<Measure_Unit_Type_Mutation_Response>;
  /** update single row of the table: "measure_unit_type" */
  update_measure_unit_type_by_pk?: Maybe<Measure_Unit_Type>;
  /** update multiples rows of table: "measure_unit_type" */
  update_measure_unit_type_many?: Maybe<Array<Maybe<Measure_Unit_Type_Mutation_Response>>>;
  /** update data of the table: "month" */
  update_month?: Maybe<Month_Mutation_Response>;
  /** update single row of the table: "month" */
  update_month_by_pk?: Maybe<Month>;
  /** update multiples rows of table: "month" */
  update_month_many?: Maybe<Array<Maybe<Month_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update data of the table: "project_bss_data" */
  update_project_bss_data?: Maybe<Project_Bss_Data_Mutation_Response>;
  /** update data of the table: "project_bss_data_backup" */
  update_project_bss_data_backup?: Maybe<Project_Bss_Data_Backup_Mutation_Response>;
  /** update single row of the table: "project_bss_data_backup" */
  update_project_bss_data_backup_by_pk?: Maybe<Project_Bss_Data_Backup>;
  /** update multiples rows of table: "project_bss_data_backup" */
  update_project_bss_data_backup_many?: Maybe<Array<Maybe<Project_Bss_Data_Backup_Mutation_Response>>>;
  /** update single row of the table: "project_bss_data" */
  update_project_bss_data_by_pk?: Maybe<Project_Bss_Data>;
  /** update multiples rows of table: "project_bss_data" */
  update_project_bss_data_many?: Maybe<Array<Maybe<Project_Bss_Data_Mutation_Response>>>;
  /** update data of the table: "project_bss_data_type" */
  update_project_bss_data_type?: Maybe<Project_Bss_Data_Type_Mutation_Response>;
  /** update single row of the table: "project_bss_data_type" */
  update_project_bss_data_type_by_pk?: Maybe<Project_Bss_Data_Type>;
  /** update multiples rows of table: "project_bss_data_type" */
  update_project_bss_data_type_many?: Maybe<Array<Maybe<Project_Bss_Data_Type_Mutation_Response>>>;
  /** update data of the table: "project_bss_note" */
  update_project_bss_note?: Maybe<Project_Bss_Note_Mutation_Response>;
  /** update single row of the table: "project_bss_note" */
  update_project_bss_note_by_pk?: Maybe<Project_Bss_Note>;
  /** update multiples rows of table: "project_bss_note" */
  update_project_bss_note_many?: Maybe<Array<Maybe<Project_Bss_Note_Mutation_Response>>>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update data of the table: "project_file" */
  update_project_file?: Maybe<Project_File_Mutation_Response>;
  /** update single row of the table: "project_file" */
  update_project_file_by_pk?: Maybe<Project_File>;
  /** update multiples rows of table: "project_file" */
  update_project_file_many?: Maybe<Array<Maybe<Project_File_Mutation_Response>>>;
  /** update data of the table: "project_interview" */
  update_project_interview?: Maybe<Project_Interview_Mutation_Response>;
  /** update data of the table: "project_interview_backup" */
  update_project_interview_backup?: Maybe<Project_Interview_Backup_Mutation_Response>;
  /** update single row of the table: "project_interview_backup" */
  update_project_interview_backup_by_pk?: Maybe<Project_Interview_Backup>;
  /** update multiples rows of table: "project_interview_backup" */
  update_project_interview_backup_many?: Maybe<Array<Maybe<Project_Interview_Backup_Mutation_Response>>>;
  /** update data of the table: "project_interview_base" */
  update_project_interview_base?: Maybe<Project_Interview_Base_Mutation_Response>;
  /** update single row of the table: "project_interview_base" */
  update_project_interview_base_by_pk?: Maybe<Project_Interview_Base>;
  /** update multiples rows of table: "project_interview_base" */
  update_project_interview_base_many?: Maybe<Array<Maybe<Project_Interview_Base_Mutation_Response>>>;
  /** update single row of the table: "project_interview" */
  update_project_interview_by_pk?: Maybe<Project_Interview>;
  /** update data of the table: "project_interview_crops" */
  update_project_interview_crops?: Maybe<Project_Interview_Crops_Mutation_Response>;
  /** update single row of the table: "project_interview_crops" */
  update_project_interview_crops_by_pk?: Maybe<Project_Interview_Crops>;
  /** update data of the table: "project_interview_crops_green_root" */
  update_project_interview_crops_green_root?: Maybe<Project_Interview_Crops_Green_Root_Mutation_Response>;
  /** update single row of the table: "project_interview_crops_green_root" */
  update_project_interview_crops_green_root_by_pk?: Maybe<Project_Interview_Crops_Green_Root>;
  /** update multiples rows of table: "project_interview_crops_green_root" */
  update_project_interview_crops_green_root_many?: Maybe<Array<Maybe<Project_Interview_Crops_Green_Root_Mutation_Response>>>;
  /** update multiples rows of table: "project_interview_crops" */
  update_project_interview_crops_many?: Maybe<Array<Maybe<Project_Interview_Crops_Mutation_Response>>>;
  /** update data of the table: "project_interview_crops_season" */
  update_project_interview_crops_season?: Maybe<Project_Interview_Crops_Season_Mutation_Response>;
  /** update single row of the table: "project_interview_crops_season" */
  update_project_interview_crops_season_by_pk?: Maybe<Project_Interview_Crops_Season>;
  /** update multiples rows of table: "project_interview_crops_season" */
  update_project_interview_crops_season_many?: Maybe<Array<Maybe<Project_Interview_Crops_Season_Mutation_Response>>>;
  /** update data of the table: "project_interview_data" */
  update_project_interview_data?: Maybe<Project_Interview_Data_Mutation_Response>;
  /** update single row of the table: "project_interview_data" */
  update_project_interview_data_by_pk?: Maybe<Project_Interview_Data>;
  /** update multiples rows of table: "project_interview_data" */
  update_project_interview_data_many?: Maybe<Array<Maybe<Project_Interview_Data_Mutation_Response>>>;
  /** update data of the table: "project_interview_data_type" */
  update_project_interview_data_type?: Maybe<Project_Interview_Data_Type_Mutation_Response>;
  /** update single row of the table: "project_interview_data_type" */
  update_project_interview_data_type_by_pk?: Maybe<Project_Interview_Data_Type>;
  /** update multiples rows of table: "project_interview_data_type" */
  update_project_interview_data_type_many?: Maybe<Array<Maybe<Project_Interview_Data_Type_Mutation_Response>>>;
  /** update data of the table: "project_interview_file" */
  update_project_interview_file?: Maybe<Project_Interview_File_Mutation_Response>;
  /** update single row of the table: "project_interview_file" */
  update_project_interview_file_by_pk?: Maybe<Project_Interview_File>;
  /** update multiples rows of table: "project_interview_file" */
  update_project_interview_file_many?: Maybe<Array<Maybe<Project_Interview_File_Mutation_Response>>>;
  /** update data of the table: "project_interview_livestock" */
  update_project_interview_livestock?: Maybe<Project_Interview_Livestock_Mutation_Response>;
  /** update single row of the table: "project_interview_livestock" */
  update_project_interview_livestock_by_pk?: Maybe<Project_Interview_Livestock>;
  /** update multiples rows of table: "project_interview_livestock" */
  update_project_interview_livestock_many?: Maybe<Array<Maybe<Project_Interview_Livestock_Mutation_Response>>>;
  /** update data of the table: "project_interview_livestock_milk" */
  update_project_interview_livestock_milk?: Maybe<Project_Interview_Livestock_Milk_Mutation_Response>;
  /** update single row of the table: "project_interview_livestock_milk" */
  update_project_interview_livestock_milk_by_pk?: Maybe<Project_Interview_Livestock_Milk>;
  /** update multiples rows of table: "project_interview_livestock_milk" */
  update_project_interview_livestock_milk_many?: Maybe<Array<Maybe<Project_Interview_Livestock_Milk_Mutation_Response>>>;
  /** update multiples rows of table: "project_interview" */
  update_project_interview_many?: Maybe<Array<Maybe<Project_Interview_Mutation_Response>>>;
  /** update data of the table: "project_interview_note" */
  update_project_interview_note?: Maybe<Project_Interview_Note_Mutation_Response>;
  /** update single row of the table: "project_interview_note" */
  update_project_interview_note_by_pk?: Maybe<Project_Interview_Note>;
  /** update multiples rows of table: "project_interview_note" */
  update_project_interview_note_many?: Maybe<Array<Maybe<Project_Interview_Note_Mutation_Response>>>;
  /** update data of the table: "project_interview_productive_asset" */
  update_project_interview_productive_asset?: Maybe<Project_Interview_Productive_Asset_Mutation_Response>;
  /** update single row of the table: "project_interview_productive_asset" */
  update_project_interview_productive_asset_by_pk?: Maybe<Project_Interview_Productive_Asset>;
  /** update multiples rows of table: "project_interview_productive_asset" */
  update_project_interview_productive_asset_many?: Maybe<Array<Maybe<Project_Interview_Productive_Asset_Mutation_Response>>>;
  /** update data of the table: "project_interview_researcher_mn" */
  update_project_interview_researcher_mn?: Maybe<Project_Interview_Researcher_Mn_Mutation_Response>;
  /** update single row of the table: "project_interview_researcher_mn" */
  update_project_interview_researcher_mn_by_pk?: Maybe<Project_Interview_Researcher_Mn>;
  /** update multiples rows of table: "project_interview_researcher_mn" */
  update_project_interview_researcher_mn_many?: Maybe<Array<Maybe<Project_Interview_Researcher_Mn_Mutation_Response>>>;
  /** update data of the table: "project_interview_totals" */
  update_project_interview_totals?: Maybe<Project_Interview_Totals_Mutation_Response>;
  /** update single row of the table: "project_interview_totals" */
  update_project_interview_totals_by_pk?: Maybe<Project_Interview_Totals>;
  /** update multiples rows of table: "project_interview_totals" */
  update_project_interview_totals_many?: Maybe<Array<Maybe<Project_Interview_Totals_Mutation_Response>>>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "sale_purchase_type" */
  update_sale_purchase_type?: Maybe<Sale_Purchase_Type_Mutation_Response>;
  /** update single row of the table: "sale_purchase_type" */
  update_sale_purchase_type_by_pk?: Maybe<Sale_Purchase_Type>;
  /** update multiples rows of table: "sale_purchase_type" */
  update_sale_purchase_type_many?: Maybe<Array<Maybe<Sale_Purchase_Type_Mutation_Response>>>;
  /** update data of the table: "status" */
  update_status?: Maybe<Status_Mutation_Response>;
  /** update single row of the table: "status" */
  update_status_by_pk?: Maybe<Status>;
  /** update multiples rows of table: "status" */
  update_status_many?: Maybe<Array<Maybe<Status_Mutation_Response>>>;
  /** update data of the table: "term" */
  update_term?: Maybe<Term_Mutation_Response>;
  /** update single row of the table: "term" */
  update_term_by_pk?: Maybe<Term>;
  /** update data of the table: "term_category" */
  update_term_category?: Maybe<Term_Category_Mutation_Response>;
  /** update single row of the table: "term_category" */
  update_term_category_by_pk?: Maybe<Term_Category>;
  /** update multiples rows of table: "term_category" */
  update_term_category_many?: Maybe<Array<Maybe<Term_Category_Mutation_Response>>>;
  /** update data of the table: "term_category_mn" */
  update_term_category_mn?: Maybe<Term_Category_Mn_Mutation_Response>;
  /** update single row of the table: "term_category_mn" */
  update_term_category_mn_by_pk?: Maybe<Term_Category_Mn>;
  /** update multiples rows of table: "term_category_mn" */
  update_term_category_mn_many?: Maybe<Array<Maybe<Term_Category_Mn_Mutation_Response>>>;
  /** update multiples rows of table: "term" */
  update_term_many?: Maybe<Array<Maybe<Term_Mutation_Response>>>;
  /** update data of the table: "user_permission" */
  update_user_permission?: Maybe<User_Permission_Mutation_Response>;
  /** update single row of the table: "user_permission" */
  update_user_permission_by_pk?: Maybe<User_Permission>;
  /** update multiples rows of table: "user_permission" */
  update_user_permission_many?: Maybe<Array<Maybe<User_Permission_Mutation_Response>>>;
  /** update data of the table: "user_permission_role" */
  update_user_permission_role?: Maybe<User_Permission_Role_Mutation_Response>;
  /** update single row of the table: "user_permission_role" */
  update_user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** update multiples rows of table: "user_permission_role" */
  update_user_permission_role_many?: Maybe<Array<Maybe<User_Permission_Role_Mutation_Response>>>;
  /** update data of the table: "user_profile" */
  update_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** update single row of the table: "user_profile" */
  update_user_profile_by_pk?: Maybe<User_Profile>;
  /** update multiples rows of table: "user_profile" */
  update_user_profile_many?: Maybe<Array<Maybe<User_Profile_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
  /** update data of the table: "wealth_group" */
  update_wealth_group?: Maybe<Wealth_Group_Mutation_Response>;
  /** update single row of the table: "wealth_group" */
  update_wealth_group_by_pk?: Maybe<Wealth_Group>;
  /** update multiples rows of table: "wealth_group" */
  update_wealth_group_many?: Maybe<Array<Maybe<Wealth_Group_Mutation_Response>>>;
  /** update data of the table: "zone" */
  update_zone?: Maybe<Zone_Mutation_Response>;
  /** update single row of the table: "zone" */
  update_zone_by_pk?: Maybe<Zone>;
  /** update multiples rows of table: "zone" */
  update_zone_many?: Maybe<Array<Maybe<Zone_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs = {
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Country_RegionArgs = {
  where: Country_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_Region_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_SeasonArgs = {
  where: Crop_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Season_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_Season_Month_MnArgs = {
  where: Crop_Season_Month_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Season_Month_Mn_By_PkArgs = {
  crop_season_id: Scalars['uuid']['input'];
  month: Month_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Livestock_Milking_SeasonArgs = {
  where: Livestock_Milking_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Livestock_Milking_Season_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Livestock_TypeArgs = {
  where: Livestock_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Livestock_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocationArgs = {
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Measure_UnitArgs = {
  where: Measure_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Measure_Unit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Measure_Unit_TypeArgs = {
  where: Measure_Unit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Measure_Unit_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MonthArgs = {
  where: Month_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Month_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_DataArgs = {
  where: Project_Bss_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_Data_BackupArgs = {
  where: Project_Bss_Data_Backup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_Data_Backup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_Data_TypeArgs = {
  where: Project_Bss_Data_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_Data_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_NoteArgs = {
  where: Project_Bss_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Bss_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_FileArgs = {
  where: Project_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_File_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  project_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_InterviewArgs = {
  where: Project_Interview_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_BackupArgs = {
  where: Project_Interview_Backup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Backup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_BaseArgs = {
  where: Project_Interview_Base_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Base_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_CropsArgs = {
  where: Project_Interview_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Crops_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Crops_Green_RootArgs = {
  where: Project_Interview_Crops_Green_Root_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Crops_Green_Root_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Crops_SeasonArgs = {
  where: Project_Interview_Crops_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Crops_Season_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_DataArgs = {
  where: Project_Interview_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Data_TypeArgs = {
  where: Project_Interview_Data_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Data_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_FileArgs = {
  where: Project_Interview_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_File_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  interview_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_LivestockArgs = {
  where: Project_Interview_Livestock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Livestock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Livestock_MilkArgs = {
  where: Project_Interview_Livestock_Milk_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Livestock_Milk_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_NoteArgs = {
  where: Project_Interview_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Productive_AssetArgs = {
  where: Project_Interview_Productive_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Productive_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Researcher_MnArgs = {
  where: Project_Interview_Researcher_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Researcher_Mn_By_PkArgs = {
  project_interview_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_TotalsArgs = {
  where: Project_Interview_Totals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Interview_Totals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sale_Purchase_TypeArgs = {
  where: Sale_Purchase_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sale_Purchase_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StatusArgs = {
  where: Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TermArgs = {
  where: Term_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Term_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Term_CategoryArgs = {
  where: Term_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Term_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Term_Category_MnArgs = {
  where: Term_Category_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Term_Category_Mn_By_PkArgs = {
  category_id: Scalars['uuid']['input'];
  term_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_PermissionArgs = {
  where: User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Permission_RoleArgs = {
  where: User_Permission_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Permission_Role_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfileArgs = {
  where: User_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Wealth_GroupArgs = {
  where: Wealth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wealth_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ZoneArgs = {
  where: Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Zone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs = {
  object: AuthRefreshTokenTypes_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_RegionArgs = {
  objects: Array<Country_Region_Insert_Input>;
  on_conflict?: InputMaybe<Country_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_Region_OneArgs = {
  object: Country_Region_Insert_Input;
  on_conflict?: InputMaybe<Country_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_SeasonArgs = {
  objects: Array<Crop_Season_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Season_Month_MnArgs = {
  objects: Array<Crop_Season_Month_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Season_Month_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Season_Month_Mn_OneArgs = {
  object: Crop_Season_Month_Mn_Insert_Input;
  on_conflict?: InputMaybe<Crop_Season_Month_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Season_OneArgs = {
  object: Crop_Season_Insert_Input;
  on_conflict?: InputMaybe<Crop_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Livestock_Milking_SeasonArgs = {
  objects: Array<Livestock_Milking_Season_Insert_Input>;
  on_conflict?: InputMaybe<Livestock_Milking_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Livestock_Milking_Season_OneArgs = {
  object: Livestock_Milking_Season_Insert_Input;
  on_conflict?: InputMaybe<Livestock_Milking_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Livestock_TypeArgs = {
  objects: Array<Livestock_Type_Insert_Input>;
  on_conflict?: InputMaybe<Livestock_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Livestock_Type_OneArgs = {
  object: Livestock_Type_Insert_Input;
  on_conflict?: InputMaybe<Livestock_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationArgs = {
  objects: Array<Location_Insert_Input>;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_OneArgs = {
  object: Location_Insert_Input;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Measure_UnitArgs = {
  objects: Array<Measure_Unit_Insert_Input>;
  on_conflict?: InputMaybe<Measure_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Measure_Unit_OneArgs = {
  object: Measure_Unit_Insert_Input;
  on_conflict?: InputMaybe<Measure_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Measure_Unit_TypeArgs = {
  objects: Array<Measure_Unit_Type_Insert_Input>;
  on_conflict?: InputMaybe<Measure_Unit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Measure_Unit_Type_OneArgs = {
  object: Measure_Unit_Type_Insert_Input;
  on_conflict?: InputMaybe<Measure_Unit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonthArgs = {
  objects: Array<Month_Insert_Input>;
  on_conflict?: InputMaybe<Month_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Month_OneArgs = {
  object: Month_Insert_Input;
  on_conflict?: InputMaybe<Month_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_DataArgs = {
  objects: Array<Project_Bss_Data_Insert_Input>;
  on_conflict?: InputMaybe<Project_Bss_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_Data_BackupArgs = {
  objects: Array<Project_Bss_Data_Backup_Insert_Input>;
  on_conflict?: InputMaybe<Project_Bss_Data_Backup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_Data_Backup_OneArgs = {
  object: Project_Bss_Data_Backup_Insert_Input;
  on_conflict?: InputMaybe<Project_Bss_Data_Backup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_Data_OneArgs = {
  object: Project_Bss_Data_Insert_Input;
  on_conflict?: InputMaybe<Project_Bss_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_Data_TypeArgs = {
  objects: Array<Project_Bss_Data_Type_Insert_Input>;
  on_conflict?: InputMaybe<Project_Bss_Data_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_Data_Type_OneArgs = {
  object: Project_Bss_Data_Type_Insert_Input;
  on_conflict?: InputMaybe<Project_Bss_Data_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_NoteArgs = {
  objects: Array<Project_Bss_Note_Insert_Input>;
  on_conflict?: InputMaybe<Project_Bss_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Bss_Note_OneArgs = {
  object: Project_Bss_Note_Insert_Input;
  on_conflict?: InputMaybe<Project_Bss_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_FileArgs = {
  objects: Array<Project_File_Insert_Input>;
  on_conflict?: InputMaybe<Project_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_File_OneArgs = {
  object: Project_File_Insert_Input;
  on_conflict?: InputMaybe<Project_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_InterviewArgs = {
  objects: Array<Project_Interview_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_BackupArgs = {
  objects: Array<Project_Interview_Backup_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Backup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Backup_OneArgs = {
  object: Project_Interview_Backup_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Backup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_BaseArgs = {
  objects: Array<Project_Interview_Base_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Base_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Base_OneArgs = {
  object: Project_Interview_Base_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Base_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_CropsArgs = {
  objects: Array<Project_Interview_Crops_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Crops_Green_RootArgs = {
  objects: Array<Project_Interview_Crops_Green_Root_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Crops_Green_Root_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Crops_Green_Root_OneArgs = {
  object: Project_Interview_Crops_Green_Root_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Crops_Green_Root_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Crops_OneArgs = {
  object: Project_Interview_Crops_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Crops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Crops_SeasonArgs = {
  objects: Array<Project_Interview_Crops_Season_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Crops_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Crops_Season_OneArgs = {
  object: Project_Interview_Crops_Season_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Crops_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_DataArgs = {
  objects: Array<Project_Interview_Data_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Data_OneArgs = {
  object: Project_Interview_Data_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Data_TypeArgs = {
  objects: Array<Project_Interview_Data_Type_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Data_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Data_Type_OneArgs = {
  object: Project_Interview_Data_Type_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Data_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_FileArgs = {
  objects: Array<Project_Interview_File_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_File_OneArgs = {
  object: Project_Interview_File_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_LivestockArgs = {
  objects: Array<Project_Interview_Livestock_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Livestock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Livestock_MilkArgs = {
  objects: Array<Project_Interview_Livestock_Milk_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Livestock_Milk_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Livestock_Milk_OneArgs = {
  object: Project_Interview_Livestock_Milk_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Livestock_Milk_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Livestock_OneArgs = {
  object: Project_Interview_Livestock_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Livestock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_NoteArgs = {
  objects: Array<Project_Interview_Note_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Note_OneArgs = {
  object: Project_Interview_Note_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_OneArgs = {
  object: Project_Interview_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Productive_AssetArgs = {
  objects: Array<Project_Interview_Productive_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Productive_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Productive_Asset_OneArgs = {
  object: Project_Interview_Productive_Asset_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Productive_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Researcher_MnArgs = {
  objects: Array<Project_Interview_Researcher_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Researcher_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Researcher_Mn_OneArgs = {
  object: Project_Interview_Researcher_Mn_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Researcher_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_TotalsArgs = {
  objects: Array<Project_Interview_Totals_Insert_Input>;
  on_conflict?: InputMaybe<Project_Interview_Totals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Interview_Totals_OneArgs = {
  object: Project_Interview_Totals_Insert_Input;
  on_conflict?: InputMaybe<Project_Interview_Totals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Purchase_TypeArgs = {
  objects: Array<Sale_Purchase_Type_Insert_Input>;
  on_conflict?: InputMaybe<Sale_Purchase_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sale_Purchase_Type_OneArgs = {
  object: Sale_Purchase_Type_Insert_Input;
  on_conflict?: InputMaybe<Sale_Purchase_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StatusArgs = {
  objects: Array<Status_Insert_Input>;
  on_conflict?: InputMaybe<Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Status_OneArgs = {
  object: Status_Insert_Input;
  on_conflict?: InputMaybe<Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TermArgs = {
  objects: Array<Term_Insert_Input>;
  on_conflict?: InputMaybe<Term_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_CategoryArgs = {
  objects: Array<Term_Category_Insert_Input>;
  on_conflict?: InputMaybe<Term_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_Category_MnArgs = {
  objects: Array<Term_Category_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Term_Category_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_Category_Mn_OneArgs = {
  object: Term_Category_Mn_Insert_Input;
  on_conflict?: InputMaybe<Term_Category_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_Category_OneArgs = {
  object: Term_Category_Insert_Input;
  on_conflict?: InputMaybe<Term_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_OneArgs = {
  object: Term_Insert_Input;
  on_conflict?: InputMaybe<Term_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PermissionArgs = {
  objects: Array<User_Permission_Insert_Input>;
  on_conflict?: InputMaybe<User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permission_OneArgs = {
  object: User_Permission_Insert_Input;
  on_conflict?: InputMaybe<User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permission_RoleArgs = {
  objects: Array<User_Permission_Role_Insert_Input>;
  on_conflict?: InputMaybe<User_Permission_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permission_Role_OneArgs = {
  object: User_Permission_Role_Insert_Input;
  on_conflict?: InputMaybe<User_Permission_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfileArgs = {
  objects: Array<User_Profile_Insert_Input>;
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_OneArgs = {
  object: User_Profile_Insert_Input;
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wealth_GroupArgs = {
  objects: Array<Wealth_Group_Insert_Input>;
  on_conflict?: InputMaybe<Wealth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wealth_Group_OneArgs = {
  object: Wealth_Group_Insert_Input;
  on_conflict?: InputMaybe<Wealth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ZoneArgs = {
  objects: Array<Zone_Insert_Input>;
  on_conflict?: InputMaybe<Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zone_OneArgs = {
  object: Zone_Insert_Input;
  on_conflict?: InputMaybe<Zone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  pk_columns: AuthProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  pk_columns: AuthRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  pk_columns: AuthUserProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  pk_columns: AuthUserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs = {
  updates: Array<AuthRefreshTokenTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Country_RegionArgs = {
  _set?: InputMaybe<Country_Region_Set_Input>;
  where: Country_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_Region_By_PkArgs = {
  _set?: InputMaybe<Country_Region_Set_Input>;
  pk_columns: Country_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_Region_ManyArgs = {
  updates: Array<Country_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_SeasonArgs = {
  _set?: InputMaybe<Crop_Season_Set_Input>;
  where: Crop_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Season_By_PkArgs = {
  _set?: InputMaybe<Crop_Season_Set_Input>;
  pk_columns: Crop_Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Season_ManyArgs = {
  updates: Array<Crop_Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Season_Month_MnArgs = {
  _set?: InputMaybe<Crop_Season_Month_Mn_Set_Input>;
  where: Crop_Season_Month_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Season_Month_Mn_By_PkArgs = {
  _set?: InputMaybe<Crop_Season_Month_Mn_Set_Input>;
  pk_columns: Crop_Season_Month_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Season_Month_Mn_ManyArgs = {
  updates: Array<Crop_Season_Month_Mn_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Livestock_Milking_SeasonArgs = {
  _set?: InputMaybe<Livestock_Milking_Season_Set_Input>;
  where: Livestock_Milking_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Livestock_Milking_Season_By_PkArgs = {
  _set?: InputMaybe<Livestock_Milking_Season_Set_Input>;
  pk_columns: Livestock_Milking_Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Livestock_Milking_Season_ManyArgs = {
  updates: Array<Livestock_Milking_Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Livestock_TypeArgs = {
  _set?: InputMaybe<Livestock_Type_Set_Input>;
  where: Livestock_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Livestock_Type_By_PkArgs = {
  _set?: InputMaybe<Livestock_Type_Set_Input>;
  pk_columns: Livestock_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Livestock_Type_ManyArgs = {
  updates: Array<Livestock_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationArgs = {
  _set?: InputMaybe<Location_Set_Input>;
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_By_PkArgs = {
  _set?: InputMaybe<Location_Set_Input>;
  pk_columns: Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ManyArgs = {
  updates: Array<Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_UnitArgs = {
  _inc?: InputMaybe<Measure_Unit_Inc_Input>;
  _set?: InputMaybe<Measure_Unit_Set_Input>;
  where: Measure_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Unit_By_PkArgs = {
  _inc?: InputMaybe<Measure_Unit_Inc_Input>;
  _set?: InputMaybe<Measure_Unit_Set_Input>;
  pk_columns: Measure_Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Unit_ManyArgs = {
  updates: Array<Measure_Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Unit_TypeArgs = {
  _set?: InputMaybe<Measure_Unit_Type_Set_Input>;
  where: Measure_Unit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Unit_Type_By_PkArgs = {
  _set?: InputMaybe<Measure_Unit_Type_Set_Input>;
  pk_columns: Measure_Unit_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Measure_Unit_Type_ManyArgs = {
  updates: Array<Measure_Unit_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MonthArgs = {
  _set?: InputMaybe<Month_Set_Input>;
  where: Month_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Month_By_PkArgs = {
  _set?: InputMaybe<Month_Set_Input>;
  pk_columns: Month_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Month_ManyArgs = {
  updates: Array<Month_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _inc?: InputMaybe<Project_Inc_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_DataArgs = {
  _append?: InputMaybe<Project_Bss_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Bss_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Bss_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Bss_Data_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Bss_Data_Inc_Input>;
  _prepend?: InputMaybe<Project_Bss_Data_Prepend_Input>;
  _set?: InputMaybe<Project_Bss_Data_Set_Input>;
  where: Project_Bss_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_BackupArgs = {
  _append?: InputMaybe<Project_Bss_Data_Backup_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Bss_Data_Backup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Bss_Data_Backup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Bss_Data_Backup_Delete_Key_Input>;
  _prepend?: InputMaybe<Project_Bss_Data_Backup_Prepend_Input>;
  _set?: InputMaybe<Project_Bss_Data_Backup_Set_Input>;
  where: Project_Bss_Data_Backup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_Backup_By_PkArgs = {
  _append?: InputMaybe<Project_Bss_Data_Backup_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Bss_Data_Backup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Bss_Data_Backup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Bss_Data_Backup_Delete_Key_Input>;
  _prepend?: InputMaybe<Project_Bss_Data_Backup_Prepend_Input>;
  _set?: InputMaybe<Project_Bss_Data_Backup_Set_Input>;
  pk_columns: Project_Bss_Data_Backup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_Backup_ManyArgs = {
  updates: Array<Project_Bss_Data_Backup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_By_PkArgs = {
  _append?: InputMaybe<Project_Bss_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Bss_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Bss_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Bss_Data_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Bss_Data_Inc_Input>;
  _prepend?: InputMaybe<Project_Bss_Data_Prepend_Input>;
  _set?: InputMaybe<Project_Bss_Data_Set_Input>;
  pk_columns: Project_Bss_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_ManyArgs = {
  updates: Array<Project_Bss_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_TypeArgs = {
  _set?: InputMaybe<Project_Bss_Data_Type_Set_Input>;
  where: Project_Bss_Data_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_Type_By_PkArgs = {
  _set?: InputMaybe<Project_Bss_Data_Type_Set_Input>;
  pk_columns: Project_Bss_Data_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Data_Type_ManyArgs = {
  updates: Array<Project_Bss_Data_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_NoteArgs = {
  _set?: InputMaybe<Project_Bss_Note_Set_Input>;
  where: Project_Bss_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Note_By_PkArgs = {
  _set?: InputMaybe<Project_Bss_Note_Set_Input>;
  pk_columns: Project_Bss_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Bss_Note_ManyArgs = {
  updates: Array<Project_Bss_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _inc?: InputMaybe<Project_Inc_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_FileArgs = {
  _set?: InputMaybe<Project_File_Set_Input>;
  where: Project_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_File_By_PkArgs = {
  _set?: InputMaybe<Project_File_Set_Input>;
  pk_columns: Project_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_File_ManyArgs = {
  updates: Array<Project_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_InterviewArgs = {
  _set?: InputMaybe<Project_Interview_Set_Input>;
  where: Project_Interview_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_BackupArgs = {
  _append?: InputMaybe<Project_Interview_Backup_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Backup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Backup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Backup_Delete_Key_Input>;
  _prepend?: InputMaybe<Project_Interview_Backup_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Backup_Set_Input>;
  where: Project_Interview_Backup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Backup_By_PkArgs = {
  _append?: InputMaybe<Project_Interview_Backup_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Backup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Backup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Backup_Delete_Key_Input>;
  _prepend?: InputMaybe<Project_Interview_Backup_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Backup_Set_Input>;
  pk_columns: Project_Interview_Backup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Backup_ManyArgs = {
  updates: Array<Project_Interview_Backup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_BaseArgs = {
  _append?: InputMaybe<Project_Interview_Base_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Base_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Base_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Base_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Base_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Base_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Base_Set_Input>;
  where: Project_Interview_Base_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Base_By_PkArgs = {
  _append?: InputMaybe<Project_Interview_Base_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Base_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Base_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Base_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Base_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Base_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Base_Set_Input>;
  pk_columns: Project_Interview_Base_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Base_ManyArgs = {
  updates: Array<Project_Interview_Base_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_By_PkArgs = {
  _set?: InputMaybe<Project_Interview_Set_Input>;
  pk_columns: Project_Interview_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_CropsArgs = {
  _append?: InputMaybe<Project_Interview_Crops_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Crops_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Crops_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Crops_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Crops_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Crops_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Crops_Set_Input>;
  where: Project_Interview_Crops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_By_PkArgs = {
  _append?: InputMaybe<Project_Interview_Crops_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Crops_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Crops_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Crops_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Crops_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Crops_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Crops_Set_Input>;
  pk_columns: Project_Interview_Crops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_Green_RootArgs = {
  _append?: InputMaybe<Project_Interview_Crops_Green_Root_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Crops_Green_Root_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Crops_Green_Root_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Crops_Green_Root_Set_Input>;
  where: Project_Interview_Crops_Green_Root_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_Green_Root_By_PkArgs = {
  _append?: InputMaybe<Project_Interview_Crops_Green_Root_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Crops_Green_Root_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Crops_Green_Root_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Crops_Green_Root_Set_Input>;
  pk_columns: Project_Interview_Crops_Green_Root_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_Green_Root_ManyArgs = {
  updates: Array<Project_Interview_Crops_Green_Root_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_ManyArgs = {
  updates: Array<Project_Interview_Crops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_SeasonArgs = {
  _inc?: InputMaybe<Project_Interview_Crops_Season_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Crops_Season_Set_Input>;
  where: Project_Interview_Crops_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_Season_By_PkArgs = {
  _inc?: InputMaybe<Project_Interview_Crops_Season_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Crops_Season_Set_Input>;
  pk_columns: Project_Interview_Crops_Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Crops_Season_ManyArgs = {
  updates: Array<Project_Interview_Crops_Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_DataArgs = {
  _append?: InputMaybe<Project_Interview_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Data_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Data_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Data_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Data_Set_Input>;
  where: Project_Interview_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Data_By_PkArgs = {
  _append?: InputMaybe<Project_Interview_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Interview_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Interview_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Interview_Data_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Interview_Data_Inc_Input>;
  _prepend?: InputMaybe<Project_Interview_Data_Prepend_Input>;
  _set?: InputMaybe<Project_Interview_Data_Set_Input>;
  pk_columns: Project_Interview_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Data_ManyArgs = {
  updates: Array<Project_Interview_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Data_TypeArgs = {
  _set?: InputMaybe<Project_Interview_Data_Type_Set_Input>;
  where: Project_Interview_Data_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Data_Type_By_PkArgs = {
  _set?: InputMaybe<Project_Interview_Data_Type_Set_Input>;
  pk_columns: Project_Interview_Data_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Data_Type_ManyArgs = {
  updates: Array<Project_Interview_Data_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_FileArgs = {
  _set?: InputMaybe<Project_Interview_File_Set_Input>;
  where: Project_Interview_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_File_By_PkArgs = {
  _set?: InputMaybe<Project_Interview_File_Set_Input>;
  pk_columns: Project_Interview_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_File_ManyArgs = {
  updates: Array<Project_Interview_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_LivestockArgs = {
  _inc?: InputMaybe<Project_Interview_Livestock_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Livestock_Set_Input>;
  where: Project_Interview_Livestock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Livestock_By_PkArgs = {
  _inc?: InputMaybe<Project_Interview_Livestock_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Livestock_Set_Input>;
  pk_columns: Project_Interview_Livestock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Livestock_ManyArgs = {
  updates: Array<Project_Interview_Livestock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Livestock_MilkArgs = {
  _inc?: InputMaybe<Project_Interview_Livestock_Milk_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Livestock_Milk_Set_Input>;
  where: Project_Interview_Livestock_Milk_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Livestock_Milk_By_PkArgs = {
  _inc?: InputMaybe<Project_Interview_Livestock_Milk_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Livestock_Milk_Set_Input>;
  pk_columns: Project_Interview_Livestock_Milk_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Livestock_Milk_ManyArgs = {
  updates: Array<Project_Interview_Livestock_Milk_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_ManyArgs = {
  updates: Array<Project_Interview_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_NoteArgs = {
  _set?: InputMaybe<Project_Interview_Note_Set_Input>;
  where: Project_Interview_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Note_By_PkArgs = {
  _set?: InputMaybe<Project_Interview_Note_Set_Input>;
  pk_columns: Project_Interview_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Note_ManyArgs = {
  updates: Array<Project_Interview_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Productive_AssetArgs = {
  _inc?: InputMaybe<Project_Interview_Productive_Asset_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Productive_Asset_Set_Input>;
  where: Project_Interview_Productive_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Productive_Asset_By_PkArgs = {
  _inc?: InputMaybe<Project_Interview_Productive_Asset_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Productive_Asset_Set_Input>;
  pk_columns: Project_Interview_Productive_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Productive_Asset_ManyArgs = {
  updates: Array<Project_Interview_Productive_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Researcher_MnArgs = {
  _set?: InputMaybe<Project_Interview_Researcher_Mn_Set_Input>;
  where: Project_Interview_Researcher_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Researcher_Mn_By_PkArgs = {
  _set?: InputMaybe<Project_Interview_Researcher_Mn_Set_Input>;
  pk_columns: Project_Interview_Researcher_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Researcher_Mn_ManyArgs = {
  updates: Array<Project_Interview_Researcher_Mn_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_TotalsArgs = {
  _inc?: InputMaybe<Project_Interview_Totals_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Totals_Set_Input>;
  where: Project_Interview_Totals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Totals_By_PkArgs = {
  _inc?: InputMaybe<Project_Interview_Totals_Inc_Input>;
  _set?: InputMaybe<Project_Interview_Totals_Set_Input>;
  pk_columns: Project_Interview_Totals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Interview_Totals_ManyArgs = {
  updates: Array<Project_Interview_Totals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Purchase_TypeArgs = {
  _set?: InputMaybe<Sale_Purchase_Type_Set_Input>;
  where: Sale_Purchase_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Purchase_Type_By_PkArgs = {
  _set?: InputMaybe<Sale_Purchase_Type_Set_Input>;
  pk_columns: Sale_Purchase_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sale_Purchase_Type_ManyArgs = {
  updates: Array<Sale_Purchase_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StatusArgs = {
  _set?: InputMaybe<Status_Set_Input>;
  where: Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Status_By_PkArgs = {
  _set?: InputMaybe<Status_Set_Input>;
  pk_columns: Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Status_ManyArgs = {
  updates: Array<Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TermArgs = {
  _inc?: InputMaybe<Term_Inc_Input>;
  _set?: InputMaybe<Term_Set_Input>;
  where: Term_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Term_By_PkArgs = {
  _inc?: InputMaybe<Term_Inc_Input>;
  _set?: InputMaybe<Term_Set_Input>;
  pk_columns: Term_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Term_CategoryArgs = {
  _set?: InputMaybe<Term_Category_Set_Input>;
  where: Term_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Term_Category_By_PkArgs = {
  _set?: InputMaybe<Term_Category_Set_Input>;
  pk_columns: Term_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Term_Category_ManyArgs = {
  updates: Array<Term_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Term_Category_MnArgs = {
  _set?: InputMaybe<Term_Category_Mn_Set_Input>;
  where: Term_Category_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Term_Category_Mn_By_PkArgs = {
  _set?: InputMaybe<Term_Category_Mn_Set_Input>;
  pk_columns: Term_Category_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Term_Category_Mn_ManyArgs = {
  updates: Array<Term_Category_Mn_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Term_ManyArgs = {
  updates: Array<Term_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PermissionArgs = {
  _set?: InputMaybe<User_Permission_Set_Input>;
  where: User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_By_PkArgs = {
  _set?: InputMaybe<User_Permission_Set_Input>;
  pk_columns: User_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_ManyArgs = {
  updates: Array<User_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_RoleArgs = {
  _set?: InputMaybe<User_Permission_Role_Set_Input>;
  where: User_Permission_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_Role_By_PkArgs = {
  _set?: InputMaybe<User_Permission_Role_Set_Input>;
  pk_columns: User_Permission_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_Role_ManyArgs = {
  updates: Array<User_Permission_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfileArgs = {
  _set?: InputMaybe<User_Profile_Set_Input>;
  where: User_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_By_PkArgs = {
  _set?: InputMaybe<User_Profile_Set_Input>;
  pk_columns: User_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_ManyArgs = {
  updates: Array<User_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wealth_GroupArgs = {
  _inc?: InputMaybe<Wealth_Group_Inc_Input>;
  _set?: InputMaybe<Wealth_Group_Set_Input>;
  where: Wealth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wealth_Group_By_PkArgs = {
  _inc?: InputMaybe<Wealth_Group_Inc_Input>;
  _set?: InputMaybe<Wealth_Group_Set_Input>;
  pk_columns: Wealth_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wealth_Group_ManyArgs = {
  updates: Array<Wealth_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ZoneArgs = {
  _set?: InputMaybe<Zone_Set_Input>;
  where: Zone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_By_PkArgs = {
  _set?: InputMaybe<Zone_Set_Input>;
  pk_columns: Zone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Zone_ManyArgs = {
  updates: Array<Zone_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  avg_price_main_staple_kg?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currency_exchange_usd?: Maybe<Scalars['numeric']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  finished?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  kcal_pppd?: Maybe<Scalars['numeric']['output']>;
  main_staple_id?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** An array relationship */
  project_bss_data_backups: Array<Project_Bss_Data_Backup>;
  /** An aggregate relationship */
  project_bss_data_backups_aggregate: Project_Bss_Data_Backup_Aggregate;
  /** An array relationship */
  project_bss_notes: Array<Project_Bss_Note>;
  /** An aggregate relationship */
  project_bss_notes_aggregate: Project_Bss_Note_Aggregate;
  /** An array relationship */
  project_files: Array<Project_File>;
  /** An aggregate relationship */
  project_files_aggregate: Project_File_Aggregate;
  /** An array relationship */
  project_interviews: Array<Project_Interview>;
  /** An aggregate relationship */
  project_interviews_aggregate: Project_Interview_Aggregate;
  reference_period_description?: Maybe<Scalars['String']['output']>;
  reference_period_duration?: Maybe<Scalars['Int']['output']>;
  reference_period_end?: Maybe<Scalars['date']['output']>;
  reference_period_start?: Maybe<Scalars['date']['output']>;
  school_food_kcal?: Maybe<Scalars['numeric']['output']>;
  schooldays_year?: Maybe<Scalars['Int']['output']>;
  supervisor_user_id?: Maybe<Scalars['uuid']['output']>;
  teamleader_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  term?: Maybe<Term>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userTeamleader?: Maybe<Users>;
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
};


/** columns and relationships of "project" */
export type ProjectProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Bss_Data_BackupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Bss_Data_Backups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Bss_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Bss_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_FilesArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_InterviewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Interviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

export type Project_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Aggregate_Bool_Exp_Count>;
};

export type Project_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  avg?: Maybe<Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
  stddev?: Maybe<Project_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Sum_Fields>;
  var_pop?: Maybe<Project_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Var_Samp_Fields>;
  variance?: Maybe<Project_Variance_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project" */
export type Project_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Max_Order_By>;
  min?: InputMaybe<Project_Min_Order_By>;
  stddev?: InputMaybe<Project_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project" */
export type Project_Arr_Rel_Insert_Input = {
  data: Array<Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Avg_Fields = {
  __typename?: 'project_avg_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project" */
export type Project_Avg_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
  avg_price_main_staple_kg?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  currency_exchange_usd?: InputMaybe<Numeric_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  finished?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kcal_pppd?: InputMaybe<Numeric_Comparison_Exp>;
  main_staple_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
  project_bss_data_backups?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
  project_bss_data_backups_aggregate?: InputMaybe<Project_Bss_Data_Backup_Aggregate_Bool_Exp>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp>;
  project_files?: InputMaybe<Project_File_Bool_Exp>;
  project_files_aggregate?: InputMaybe<Project_File_Aggregate_Bool_Exp>;
  project_interviews?: InputMaybe<Project_Interview_Bool_Exp>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Bool_Exp>;
  reference_period_description?: InputMaybe<String_Comparison_Exp>;
  reference_period_duration?: InputMaybe<Int_Comparison_Exp>;
  reference_period_end?: InputMaybe<Date_Comparison_Exp>;
  reference_period_start?: InputMaybe<Date_Comparison_Exp>;
  school_food_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  schooldays_year?: InputMaybe<Int_Comparison_Exp>;
  supervisor_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  teamleader_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userTeamleader?: InputMaybe<Users_Bool_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Bool_Exp>;
};

/** columns and relationships of "project_bss_data" */
export type Project_Bss_Data = {
  __typename?: 'project_bss_data';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  crop_season?: Maybe<Crop_Season>;
  data?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  is_resolved?: Maybe<Scalars['Boolean']['output']>;
  kcal?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  livestockTypeByLivestockType?: Maybe<Livestock_Type>;
  livestock_type?: Maybe<Livestock_Type_Enum>;
  non_significant?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  project: Project;
  /** An object relationship */
  project_bss_data_type: Project_Bss_Data_Type;
  project_id: Scalars['uuid']['output'];
  season_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  term?: Maybe<Term>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  type: Project_Bss_Data_Type_Enum;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  wealth_group: Wealth_Group;
  wealth_group_id: Scalars['uuid']['output'];
};


/** columns and relationships of "project_bss_data" */
export type Project_Bss_DataDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_bss_data" */
export type Project_Bss_Data_Aggregate = {
  __typename?: 'project_bss_data_aggregate';
  aggregate?: Maybe<Project_Bss_Data_Aggregate_Fields>;
  nodes: Array<Project_Bss_Data>;
};

export type Project_Bss_Data_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp_Count>;
};

export type Project_Bss_Data_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Bss_Data_Select_Column_Project_Bss_Data_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Bss_Data_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Bss_Data_Select_Column_Project_Bss_Data_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Bss_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_bss_data" */
export type Project_Bss_Data_Aggregate_Fields = {
  __typename?: 'project_bss_data_aggregate_fields';
  avg?: Maybe<Project_Bss_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Bss_Data_Max_Fields>;
  min?: Maybe<Project_Bss_Data_Min_Fields>;
  stddev?: Maybe<Project_Bss_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Bss_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Bss_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Bss_Data_Sum_Fields>;
  var_pop?: Maybe<Project_Bss_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Bss_Data_Var_Samp_Fields>;
  variance?: Maybe<Project_Bss_Data_Variance_Fields>;
};


/** aggregate fields of "project_bss_data" */
export type Project_Bss_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_bss_data" */
export type Project_Bss_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Bss_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Bss_Data_Max_Order_By>;
  min?: InputMaybe<Project_Bss_Data_Min_Order_By>;
  stddev?: InputMaybe<Project_Bss_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Bss_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Bss_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Bss_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Bss_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Bss_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Bss_Data_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Bss_Data_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_bss_data" */
export type Project_Bss_Data_Arr_Rel_Insert_Input = {
  data: Array<Project_Bss_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Bss_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Bss_Data_Avg_Fields = {
  __typename?: 'project_bss_data_avg_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_bss_data" */
export type Project_Bss_Data_Avg_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_bss_data_backup" */
export type Project_Bss_Data_Backup = {
  __typename?: 'project_bss_data_backup';
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "project_bss_data_backup" */
export type Project_Bss_Data_BackupDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Aggregate = {
  __typename?: 'project_bss_data_backup_aggregate';
  aggregate?: Maybe<Project_Bss_Data_Backup_Aggregate_Fields>;
  nodes: Array<Project_Bss_Data_Backup>;
};

export type Project_Bss_Data_Backup_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Bss_Data_Backup_Aggregate_Bool_Exp_Count>;
};

export type Project_Bss_Data_Backup_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Aggregate_Fields = {
  __typename?: 'project_bss_data_backup_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Bss_Data_Backup_Max_Fields>;
  min?: Maybe<Project_Bss_Data_Backup_Min_Fields>;
};


/** aggregate fields of "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Bss_Data_Backup_Max_Order_By>;
  min?: InputMaybe<Project_Bss_Data_Backup_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Bss_Data_Backup_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Arr_Rel_Insert_Input = {
  data: Array<Project_Bss_Data_Backup_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Bss_Data_Backup_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_bss_data_backup". All fields are combined with a logical 'AND'. */
export type Project_Bss_Data_Backup_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bss_Data_Backup_Bool_Exp>>;
  _not?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bss_Data_Backup_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_bss_data_backup" */
export enum Project_Bss_Data_Backup_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectBssDataBackupPkey = 'project_bss_data_backup_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Bss_Data_Backup_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Bss_Data_Backup_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Bss_Data_Backup_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Bss_Data_Backup_Max_Fields = {
  __typename?: 'project_bss_data_backup_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Bss_Data_Backup_Min_Fields = {
  __typename?: 'project_bss_data_backup_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Mutation_Response = {
  __typename?: 'project_bss_data_backup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Bss_Data_Backup>;
};

/** on_conflict condition type for table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_On_Conflict = {
  constraint: Project_Bss_Data_Backup_Constraint;
  update_columns?: Array<Project_Bss_Data_Backup_Update_Column>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};

/** Ordering options when selecting data from "project_bss_data_backup". */
export type Project_Bss_Data_Backup_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_bss_data_backup */
export type Project_Bss_Data_Backup_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Bss_Data_Backup_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_bss_data_backup" */
export enum Project_Bss_Data_Backup_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_bss_data_backup" */
export type Project_Bss_Data_Backup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Bss_Data_Backup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Bss_Data_Backup_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_bss_data_backup" */
export enum Project_Bss_Data_Backup_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserId = 'user_id'
}

export type Project_Bss_Data_Backup_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Bss_Data_Backup_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Bss_Data_Backup_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Bss_Data_Backup_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Bss_Data_Backup_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Bss_Data_Backup_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Bss_Data_Backup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bss_Data_Backup_Bool_Exp;
};

/** Boolean expression to filter rows from the table "project_bss_data". All fields are combined with a logical 'AND'. */
export type Project_Bss_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bss_Data_Bool_Exp>>;
  _not?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bss_Data_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_season?: InputMaybe<Crop_Season_Bool_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_resolved?: InputMaybe<Boolean_Comparison_Exp>;
  kcal?: InputMaybe<Numeric_Comparison_Exp>;
  livestockTypeByLivestockType?: InputMaybe<Livestock_Type_Bool_Exp>;
  livestock_type?: InputMaybe<Livestock_Type_Enum_Comparison_Exp>;
  non_significant?: InputMaybe<Boolean_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_bss_data_type?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  season_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_cash_income?: InputMaybe<Numeric_Comparison_Exp>;
  total_expenses?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Project_Bss_Data_Type_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  wealth_group?: InputMaybe<Wealth_Group_Bool_Exp>;
  wealth_group_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_bss_data" */
export enum Project_Bss_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectBssDataPkey = 'project_bss_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Bss_Data_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Bss_Data_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Bss_Data_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_bss_data" */
export type Project_Bss_Data_Inc_Input = {
  kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_bss_data" */
export type Project_Bss_Data_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_season?: InputMaybe<Crop_Season_Obj_Rel_Insert_Input>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_resolved?: InputMaybe<Scalars['Boolean']['input']>;
  kcal?: InputMaybe<Scalars['numeric']['input']>;
  livestockTypeByLivestockType?: InputMaybe<Livestock_Type_Obj_Rel_Insert_Input>;
  livestock_type?: InputMaybe<Livestock_Type_Enum>;
  non_significant?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_bss_data_type?: InputMaybe<Project_Bss_Data_Type_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  season_id?: InputMaybe<Scalars['uuid']['input']>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Project_Bss_Data_Type_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  wealth_group?: InputMaybe<Wealth_Group_Obj_Rel_Insert_Input>;
  wealth_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Bss_Data_Max_Fields = {
  __typename?: 'project_bss_data_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kcal?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  season_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  wealth_group_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_bss_data" */
export type Project_Bss_Data_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcal?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wealth_group_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Bss_Data_Min_Fields = {
  __typename?: 'project_bss_data_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kcal?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  season_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  wealth_group_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_bss_data" */
export type Project_Bss_Data_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcal?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wealth_group_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_bss_data" */
export type Project_Bss_Data_Mutation_Response = {
  __typename?: 'project_bss_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Bss_Data>;
};

/** on_conflict condition type for table "project_bss_data" */
export type Project_Bss_Data_On_Conflict = {
  constraint: Project_Bss_Data_Constraint;
  update_columns?: Array<Project_Bss_Data_Update_Column>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "project_bss_data". */
export type Project_Bss_Data_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_season?: InputMaybe<Crop_Season_Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_resolved?: InputMaybe<Order_By>;
  kcal?: InputMaybe<Order_By>;
  livestockTypeByLivestockType?: InputMaybe<Livestock_Type_Order_By>;
  livestock_type?: InputMaybe<Order_By>;
  non_significant?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_bss_data_type?: InputMaybe<Project_Bss_Data_Type_Order_By>;
  project_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  wealth_group?: InputMaybe<Wealth_Group_Order_By>;
  wealth_group_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_bss_data */
export type Project_Bss_Data_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Bss_Data_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_bss_data" */
export enum Project_Bss_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IsResolved = 'is_resolved',
  /** column name */
  Kcal = 'kcal',
  /** column name */
  LivestockType = 'livestock_type',
  /** column name */
  NonSignificant = 'non_significant',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SeasonId = 'season_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalExpenses = 'total_expenses',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WealthGroupId = 'wealth_group_id'
}

/** select "project_bss_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_bss_data" */
export enum Project_Bss_Data_Select_Column_Project_Bss_Data_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsResolved = 'is_resolved',
  /** column name */
  NonSignificant = 'non_significant'
}

/** select "project_bss_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_bss_data" */
export enum Project_Bss_Data_Select_Column_Project_Bss_Data_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsResolved = 'is_resolved',
  /** column name */
  NonSignificant = 'non_significant'
}

/** input type for updating data in table "project_bss_data" */
export type Project_Bss_Data_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_resolved?: InputMaybe<Scalars['Boolean']['input']>;
  kcal?: InputMaybe<Scalars['numeric']['input']>;
  livestock_type?: InputMaybe<Livestock_Type_Enum>;
  non_significant?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  season_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Project_Bss_Data_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  wealth_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Project_Bss_Data_Stddev_Fields = {
  __typename?: 'project_bss_data_stddev_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_bss_data" */
export type Project_Bss_Data_Stddev_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Bss_Data_Stddev_Pop_Fields = {
  __typename?: 'project_bss_data_stddev_pop_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_bss_data" */
export type Project_Bss_Data_Stddev_Pop_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Bss_Data_Stddev_Samp_Fields = {
  __typename?: 'project_bss_data_stddev_samp_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_bss_data" */
export type Project_Bss_Data_Stddev_Samp_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_bss_data" */
export type Project_Bss_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Bss_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Bss_Data_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_resolved?: InputMaybe<Scalars['Boolean']['input']>;
  kcal?: InputMaybe<Scalars['numeric']['input']>;
  livestock_type?: InputMaybe<Livestock_Type_Enum>;
  non_significant?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  season_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Project_Bss_Data_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  wealth_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Project_Bss_Data_Sum_Fields = {
  __typename?: 'project_bss_data_sum_fields';
  kcal?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_bss_data" */
export type Project_Bss_Data_Sum_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_bss_data_type" */
export type Project_Bss_Data_Type = {
  __typename?: 'project_bss_data_type';
  name: Scalars['String']['output'];
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
};


/** columns and relationships of "project_bss_data_type" */
export type Project_Bss_Data_TypeProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "project_bss_data_type" */
export type Project_Bss_Data_TypeProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};

/** aggregated selection of "project_bss_data_type" */
export type Project_Bss_Data_Type_Aggregate = {
  __typename?: 'project_bss_data_type_aggregate';
  aggregate?: Maybe<Project_Bss_Data_Type_Aggregate_Fields>;
  nodes: Array<Project_Bss_Data_Type>;
};

/** aggregate fields of "project_bss_data_type" */
export type Project_Bss_Data_Type_Aggregate_Fields = {
  __typename?: 'project_bss_data_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Bss_Data_Type_Max_Fields>;
  min?: Maybe<Project_Bss_Data_Type_Min_Fields>;
};


/** aggregate fields of "project_bss_data_type" */
export type Project_Bss_Data_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Bss_Data_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_bss_data_type". All fields are combined with a logical 'AND'. */
export type Project_Bss_Data_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bss_Data_Type_Bool_Exp>>;
  _not?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bss_Data_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "project_bss_data_type" */
export enum Project_Bss_Data_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProjectBssDataTypePkey = 'project_bss_data_type_pkey'
}

export enum Project_Bss_Data_Type_Enum {
  CombinedData = 'COMBINED_DATA',
  CropsExpenditure = 'CROPS_EXPENDITURE',
  CropsGreen = 'CROPS_GREEN',
  CropsProduction = 'CROPS_PRODUCTION',
  CropsRoot = 'CROPS_ROOT',
  Employment = 'EMPLOYMENT',
  ExpenditureFood = 'EXPENDITURE_FOOD',
  ExpenditureNonFood = 'EXPENDITURE_NON_FOOD',
  FishingWildFood = 'FISHING_WILD_FOOD',
  FishingWildFoodExpenses = 'FISHING_WILD_FOOD_EXPENSES',
  FoodAid = 'FOOD_AID',
  FoodAidSchoolFeeding = 'FOOD_AID_SCHOOL_FEEDING',
  HouseholdCerealReserves = 'HOUSEHOLD_CEREAL_RESERVES',
  HouseholdProfileBase = 'HOUSEHOLD_PROFILE_BASE',
  HouseholdProfileProductiveAssets = 'HOUSEHOLD_PROFILE_PRODUCTIVE_ASSETS',
  LabourExchange = 'LABOUR_EXCHANGE',
  LivestockExchanged = 'LIVESTOCK_EXCHANGED',
  LivestockExpenditure = 'LIVESTOCK_EXPENDITURE',
  LivestockExpenditureOnInput = 'LIVESTOCK_EXPENDITURE_ON_INPUT',
  LivestockGivenAway = 'LIVESTOCK_GIVEN_AWAY',
  LivestockHerd = 'LIVESTOCK_HERD',
  LivestockIncomeOnProducts = 'LIVESTOCK_INCOME_ON_PRODUCTS',
  LivestockSale = 'LIVESTOCK_SALE',
  LivestockSlaughter = 'LIVESTOCK_SLAUGHTER',
  Migration = 'MIGRATION',
  MilkProductionOffPeak = 'MILK_PRODUCTION_OFF_PEAK',
  MilkProductionOffPeakSecondary = 'MILK_PRODUCTION_OFF_PEAK_SECONDARY',
  MilkProductionPeak = 'MILK_PRODUCTION_PEAK',
  MilkProductionPeakSecondary = 'MILK_PRODUCTION_PEAK_SECONDARY',
  RemittancesCreditExpenses = 'REMITTANCES_CREDIT_EXPENSES',
  RemittancesCreditIncome = 'REMITTANCES_CREDIT_INCOME',
  SelfEmployment = 'SELF_EMPLOYMENT'
}

/** Boolean expression to compare columns of type "project_bss_data_type_enum". All fields are combined with logical 'AND'. */
export type Project_Bss_Data_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Bss_Data_Type_Enum>;
  _in?: InputMaybe<Array<Project_Bss_Data_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Bss_Data_Type_Enum>;
  _nin?: InputMaybe<Array<Project_Bss_Data_Type_Enum>>;
};

/** input type for inserting data into table "project_bss_data_type" */
export type Project_Bss_Data_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Bss_Data_Type_Max_Fields = {
  __typename?: 'project_bss_data_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Bss_Data_Type_Min_Fields = {
  __typename?: 'project_bss_data_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_bss_data_type" */
export type Project_Bss_Data_Type_Mutation_Response = {
  __typename?: 'project_bss_data_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Bss_Data_Type>;
};

/** input type for inserting object relation for remote table "project_bss_data_type" */
export type Project_Bss_Data_Type_Obj_Rel_Insert_Input = {
  data: Project_Bss_Data_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Bss_Data_Type_On_Conflict>;
};

/** on_conflict condition type for table "project_bss_data_type" */
export type Project_Bss_Data_Type_On_Conflict = {
  constraint: Project_Bss_Data_Type_Constraint;
  update_columns?: Array<Project_Bss_Data_Type_Update_Column>;
  where?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "project_bss_data_type". */
export type Project_Bss_Data_Type_Order_By = {
  name?: InputMaybe<Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
};

/** primary key columns input for table: project_bss_data_type */
export type Project_Bss_Data_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "project_bss_data_type" */
export enum Project_Bss_Data_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "project_bss_data_type" */
export type Project_Bss_Data_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_bss_data_type" */
export type Project_Bss_Data_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Bss_Data_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Bss_Data_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_bss_data_type" */
export enum Project_Bss_Data_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Project_Bss_Data_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Bss_Data_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bss_Data_Type_Bool_Exp;
};

/** update columns of table "project_bss_data" */
export enum Project_Bss_Data_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IsResolved = 'is_resolved',
  /** column name */
  Kcal = 'kcal',
  /** column name */
  LivestockType = 'livestock_type',
  /** column name */
  NonSignificant = 'non_significant',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SeasonId = 'season_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalExpenses = 'total_expenses',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WealthGroupId = 'wealth_group_id'
}

export type Project_Bss_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Bss_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Bss_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Bss_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Bss_Data_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Bss_Data_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Bss_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Bss_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bss_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Bss_Data_Var_Pop_Fields = {
  __typename?: 'project_bss_data_var_pop_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_bss_data" */
export type Project_Bss_Data_Var_Pop_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Bss_Data_Var_Samp_Fields = {
  __typename?: 'project_bss_data_var_samp_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_bss_data" */
export type Project_Bss_Data_Var_Samp_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Bss_Data_Variance_Fields = {
  __typename?: 'project_bss_data_variance_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_bss_data" */
export type Project_Bss_Data_Variance_Order_By = {
  kcal?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_bss_note" */
export type Project_Bss_Note = {
  __typename?: 'project_bss_note';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  crop_season?: Maybe<Crop_Season>;
  id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_done?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  livestockTypeByLivestockType?: Maybe<Livestock_Type>;
  livestock_type?: Maybe<Livestock_Type_Enum>;
  message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid']['output'];
  season_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  term?: Maybe<Term>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "project_bss_note" */
export type Project_Bss_Note_Aggregate = {
  __typename?: 'project_bss_note_aggregate';
  aggregate?: Maybe<Project_Bss_Note_Aggregate_Fields>;
  nodes: Array<Project_Bss_Note>;
};

export type Project_Bss_Note_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp_Count>;
};

export type Project_Bss_Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Bss_Note_Select_Column_Project_Bss_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Bss_Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Bss_Note_Select_Column_Project_Bss_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Bss_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_bss_note" */
export type Project_Bss_Note_Aggregate_Fields = {
  __typename?: 'project_bss_note_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Bss_Note_Max_Fields>;
  min?: Maybe<Project_Bss_Note_Min_Fields>;
};


/** aggregate fields of "project_bss_note" */
export type Project_Bss_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_bss_note" */
export type Project_Bss_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Bss_Note_Max_Order_By>;
  min?: InputMaybe<Project_Bss_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_bss_note" */
export type Project_Bss_Note_Arr_Rel_Insert_Input = {
  data: Array<Project_Bss_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Bss_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_bss_note". All fields are combined with a logical 'AND'. */
export type Project_Bss_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bss_Note_Bool_Exp>>;
  _not?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bss_Note_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_season?: InputMaybe<Crop_Season_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_done?: InputMaybe<Boolean_Comparison_Exp>;
  livestockTypeByLivestockType?: InputMaybe<Livestock_Type_Bool_Exp>;
  livestock_type?: InputMaybe<Livestock_Type_Enum_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  season_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_bss_note" */
export enum Project_Bss_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectBssNotePkey = 'project_bss_note_pkey'
}

/** input type for inserting data into table "project_bss_note" */
export type Project_Bss_Note_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop_season?: InputMaybe<Crop_Season_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  livestockTypeByLivestockType?: InputMaybe<Livestock_Type_Obj_Rel_Insert_Input>;
  livestock_type?: InputMaybe<Livestock_Type_Enum>;
  message?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  season_id?: InputMaybe<Scalars['uuid']['input']>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Bss_Note_Max_Fields = {
  __typename?: 'project_bss_note_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  season_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_bss_note" */
export type Project_Bss_Note_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Bss_Note_Min_Fields = {
  __typename?: 'project_bss_note_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  season_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_bss_note" */
export type Project_Bss_Note_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_bss_note" */
export type Project_Bss_Note_Mutation_Response = {
  __typename?: 'project_bss_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Bss_Note>;
};

/** on_conflict condition type for table "project_bss_note" */
export type Project_Bss_Note_On_Conflict = {
  constraint: Project_Bss_Note_Constraint;
  update_columns?: Array<Project_Bss_Note_Update_Column>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "project_bss_note". */
export type Project_Bss_Note_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crop_season?: InputMaybe<Crop_Season_Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_done?: InputMaybe<Order_By>;
  livestockTypeByLivestockType?: InputMaybe<Livestock_Type_Order_By>;
  livestock_type?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_bss_note */
export type Project_Bss_Note_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_bss_note" */
export enum Project_Bss_Note_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done',
  /** column name */
  LivestockType = 'livestock_type',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SeasonId = 'season_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "project_bss_note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_bss_note" */
export enum Project_Bss_Note_Select_Column_Project_Bss_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done'
}

/** select "project_bss_note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_bss_note" */
export enum Project_Bss_Note_Select_Column_Project_Bss_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done'
}

/** input type for updating data in table "project_bss_note" */
export type Project_Bss_Note_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  livestock_type?: InputMaybe<Livestock_Type_Enum>;
  message?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  season_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_bss_note" */
export type Project_Bss_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Bss_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Bss_Note_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  livestock_type?: InputMaybe<Livestock_Type_Enum>;
  message?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  season_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_bss_note" */
export enum Project_Bss_Note_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done',
  /** column name */
  LivestockType = 'livestock_type',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SeasonId = 'season_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Project_Bss_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Bss_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bss_Note_Bool_Exp;
};

/** unique or primary key constraints on table "project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProjectNameKey = 'project_name_key',
  /** unique or primary key constraint on columns "id" */
  ProjectPkey = 'project_pkey'
}

/** columns and relationships of "project_file" */
export type Project_File = {
  __typename?: 'project_file';
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  /** An object relationship */
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid']['output'];
};

/** aggregated selection of "project_file" */
export type Project_File_Aggregate = {
  __typename?: 'project_file_aggregate';
  aggregate?: Maybe<Project_File_Aggregate_Fields>;
  nodes: Array<Project_File>;
};

export type Project_File_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_File_Aggregate_Bool_Exp_Count>;
};

export type Project_File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_file" */
export type Project_File_Aggregate_Fields = {
  __typename?: 'project_file_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_File_Max_Fields>;
  min?: Maybe<Project_File_Min_Fields>;
};


/** aggregate fields of "project_file" */
export type Project_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_file" */
export type Project_File_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_File_Max_Order_By>;
  min?: InputMaybe<Project_File_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_file" */
export type Project_File_Arr_Rel_Insert_Input = {
  data: Array<Project_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_File_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_file". All fields are combined with a logical 'AND'. */
export type Project_File_Bool_Exp = {
  _and?: InputMaybe<Array<Project_File_Bool_Exp>>;
  _not?: InputMaybe<Project_File_Bool_Exp>;
  _or?: InputMaybe<Array<Project_File_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_file" */
export enum Project_File_Constraint {
  /** unique or primary key constraint on columns "project_id", "file_id" */
  ProjectFilePkey = 'project_file_pkey'
}

/** input type for inserting data into table "project_file" */
export type Project_File_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_File_Max_Fields = {
  __typename?: 'project_file_max_fields';
  file_id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_file" */
export type Project_File_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_File_Min_Fields = {
  __typename?: 'project_file_min_fields';
  file_id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_file" */
export type Project_File_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_file" */
export type Project_File_Mutation_Response = {
  __typename?: 'project_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_File>;
};

/** on_conflict condition type for table "project_file" */
export type Project_File_On_Conflict = {
  constraint: Project_File_Constraint;
  update_columns?: Array<Project_File_Update_Column>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};

/** Ordering options when selecting data from "project_file". */
export type Project_File_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_file */
export type Project_File_Pk_Columns_Input = {
  file_id: Scalars['uuid']['input'];
  project_id: Scalars['uuid']['input'];
};

/** select columns of table "project_file" */
export enum Project_File_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "project_file" */
export type Project_File_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_file" */
export type Project_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_File_Stream_Cursor_Value_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_file" */
export enum Project_File_Update_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProjectId = 'project_id'
}

export type Project_File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_File_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_File_Bool_Exp;
};

/** input type for incrementing numeric columns in table "project" */
export type Project_Inc_Input = {
  avg_price_main_staple_kg?: InputMaybe<Scalars['numeric']['input']>;
  currency_exchange_usd?: InputMaybe<Scalars['numeric']['input']>;
  kcal_pppd?: InputMaybe<Scalars['numeric']['input']>;
  reference_period_duration?: InputMaybe<Scalars['Int']['input']>;
  school_food_kcal?: InputMaybe<Scalars['numeric']['input']>;
  schooldays_year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  avg_price_main_staple_kg?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_exchange_usd?: InputMaybe<Scalars['numeric']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcal_pppd?: InputMaybe<Scalars['numeric']['input']>;
  main_staple_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
  project_bss_data_backups?: InputMaybe<Project_Bss_Data_Backup_Arr_Rel_Insert_Input>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Arr_Rel_Insert_Input>;
  project_files?: InputMaybe<Project_File_Arr_Rel_Insert_Input>;
  project_interviews?: InputMaybe<Project_Interview_Arr_Rel_Insert_Input>;
  reference_period_description?: InputMaybe<Scalars['String']['input']>;
  reference_period_duration?: InputMaybe<Scalars['Int']['input']>;
  reference_period_end?: InputMaybe<Scalars['date']['input']>;
  reference_period_start?: InputMaybe<Scalars['date']['input']>;
  school_food_kcal?: InputMaybe<Scalars['numeric']['input']>;
  schooldays_year?: InputMaybe<Scalars['Int']['input']>;
  supervisor_user_id?: InputMaybe<Scalars['uuid']['input']>;
  teamleader_user_id?: InputMaybe<Scalars['uuid']['input']>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userTeamleader?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "project_interview" */
export type Project_Interview = {
  __typename?: 'project_interview';
  created_at: Scalars['timestamptz']['output'];
  date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location: Location;
  location_id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid']['output'];
  /** An array relationship */
  project_interview_backups: Array<Project_Interview_Backup>;
  /** An aggregate relationship */
  project_interview_backups_aggregate: Project_Interview_Backup_Aggregate;
  /** An object relationship */
  project_interview_base?: Maybe<Project_Interview_Base>;
  /** An array relationship */
  project_interview_files: Array<Project_Interview_File>;
  /** An aggregate relationship */
  project_interview_files_aggregate: Project_Interview_File_Aggregate;
  /** An array relationship */
  project_interview_notes: Array<Project_Interview_Note>;
  /** An aggregate relationship */
  project_interview_notes_aggregate: Project_Interview_Note_Aggregate;
  /** An array relationship */
  project_interview_researcher_mns: Array<Project_Interview_Researcher_Mn>;
  /** An aggregate relationship */
  project_interview_researcher_mns_aggregate: Project_Interview_Researcher_Mn_Aggregate;
  status?: Maybe<Status_Enum>;
  /** An object relationship */
  statusByStatus?: Maybe<Status>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  wealth_group: Wealth_Group;
  wealth_group_id: Scalars['uuid']['output'];
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_BackupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_Backups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_FilesArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_Researcher_MnsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


/** columns and relationships of "project_interview" */
export type Project_InterviewProject_Interview_Researcher_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};

/** aggregated selection of "project_interview" */
export type Project_Interview_Aggregate = {
  __typename?: 'project_interview_aggregate';
  aggregate?: Maybe<Project_Interview_Aggregate_Fields>;
  nodes: Array<Project_Interview>;
};

export type Project_Interview_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview" */
export type Project_Interview_Aggregate_Fields = {
  __typename?: 'project_interview_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Max_Fields>;
  min?: Maybe<Project_Interview_Min_Fields>;
};


/** aggregate fields of "project_interview" */
export type Project_Interview_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview" */
export type Project_Interview_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview" */
export type Project_Interview_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_On_Conflict>;
};

/** columns and relationships of "project_interview_backup" */
export type Project_Interview_Backup = {
  __typename?: 'project_interview_backup';
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_interview: Project_Interview;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "project_interview_backup" */
export type Project_Interview_BackupDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_interview_backup" */
export type Project_Interview_Backup_Aggregate = {
  __typename?: 'project_interview_backup_aggregate';
  aggregate?: Maybe<Project_Interview_Backup_Aggregate_Fields>;
  nodes: Array<Project_Interview_Backup>;
};

export type Project_Interview_Backup_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_Backup_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Backup_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_backup" */
export type Project_Interview_Backup_Aggregate_Fields = {
  __typename?: 'project_interview_backup_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Backup_Max_Fields>;
  min?: Maybe<Project_Interview_Backup_Min_Fields>;
};


/** aggregate fields of "project_interview_backup" */
export type Project_Interview_Backup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_backup" */
export type Project_Interview_Backup_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Backup_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Backup_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Backup_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_interview_backup" */
export type Project_Interview_Backup_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Backup_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Backup_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_interview_backup". All fields are combined with a logical 'AND'. */
export type Project_Interview_Backup_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Backup_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Backup_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview?: InputMaybe<Project_Interview_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_backup" */
export enum Project_Interview_Backup_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewBackupPkey = 'project_interview_backup_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Interview_Backup_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Interview_Backup_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Interview_Backup_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "project_interview_backup" */
export type Project_Interview_Backup_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview?: InputMaybe<Project_Interview_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Backup_Max_Fields = {
  __typename?: 'project_interview_backup_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_interview_backup" */
export type Project_Interview_Backup_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Backup_Min_Fields = {
  __typename?: 'project_interview_backup_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_interview_backup" */
export type Project_Interview_Backup_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_backup" */
export type Project_Interview_Backup_Mutation_Response = {
  __typename?: 'project_interview_backup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Backup>;
};

/** on_conflict condition type for table "project_interview_backup" */
export type Project_Interview_Backup_On_Conflict = {
  constraint: Project_Interview_Backup_Constraint;
  update_columns?: Array<Project_Interview_Backup_Update_Column>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_backup". */
export type Project_Interview_Backup_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  project_interview?: InputMaybe<Project_Interview_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_backup */
export type Project_Interview_Backup_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Backup_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_interview_backup" */
export enum Project_Interview_Backup_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "project_interview_backup" */
export type Project_Interview_Backup_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_interview_backup" */
export type Project_Interview_Backup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Backup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Backup_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_interview_backup" */
export enum Project_Interview_Backup_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  UserId = 'user_id'
}

export type Project_Interview_Backup_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Interview_Backup_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Interview_Backup_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Interview_Backup_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Interview_Backup_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Interview_Backup_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Backup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Backup_Bool_Exp;
};

/** columns and relationships of "project_interview_base" */
export type Project_Interview_Base = {
  __typename?: 'project_interview_base';
  children_primary_school?: Maybe<Scalars['numeric']['output']>;
  children_secondary_school?: Maybe<Scalars['numeric']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  interviewees_female?: Maybe<Scalars['numeric']['output']>;
  interviewees_male?: Maybe<Scalars['numeric']['output']>;
  is_done?: Maybe<Scalars['Boolean']['output']>;
  land_cultivated_cash?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_food?: Maybe<Scalars['numeric']['output']>;
  land_outsourced?: Maybe<Scalars['numeric']['output']>;
  land_owned?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion_id?: Maybe<Scalars['uuid']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['numeric']['output']>;
  leftover_cereal_months?: Maybe<Scalars['jsonb']['output']>;
  leftover_cereal_term_id?: Maybe<Scalars['uuid']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  measure_unit?: Maybe<Measure_Unit>;
  other_productive_assets?: Maybe<Scalars['jsonb']['output']>;
  people_in_household?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  project_interview: Project_Interview;
  /** An array relationship */
  project_interview_crops_seasons: Array<Project_Interview_Crops_Season>;
  /** An aggregate relationship */
  project_interview_crops_seasons_aggregate: Project_Interview_Crops_Season_Aggregate;
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
  /** An array relationship */
  project_interview_livestocks: Array<Project_Interview_Livestock>;
  /** An aggregate relationship */
  project_interview_livestocks_aggregate: Project_Interview_Livestock_Aggregate;
  /** An array relationship */
  project_interview_productive_assets: Array<Project_Interview_Productive_Asset>;
  /** An aggregate relationship */
  project_interview_productive_assets_aggregate: Project_Interview_Productive_Asset_Aggregate;
  /** An object relationship */
  project_interview_total?: Maybe<Project_Interview_Totals>;
  /** An object relationship */
  term?: Maybe<Term>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseLeftover_Cereal_MonthsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseOther_Productive_AssetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_Crops_SeasonsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_Crops_Seasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_LivestocksArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_Livestocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_Productive_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


/** columns and relationships of "project_interview_base" */
export type Project_Interview_BaseProject_Interview_Productive_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};

/** aggregated selection of "project_interview_base" */
export type Project_Interview_Base_Aggregate = {
  __typename?: 'project_interview_base_aggregate';
  aggregate?: Maybe<Project_Interview_Base_Aggregate_Fields>;
  nodes: Array<Project_Interview_Base>;
};

export type Project_Interview_Base_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Interview_Base_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Interview_Base_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Interview_Base_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Base_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Interview_Base_Select_Column_Project_Interview_Base_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Base_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Interview_Base_Select_Column_Project_Interview_Base_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Base_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_base" */
export type Project_Interview_Base_Aggregate_Fields = {
  __typename?: 'project_interview_base_aggregate_fields';
  avg?: Maybe<Project_Interview_Base_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Base_Max_Fields>;
  min?: Maybe<Project_Interview_Base_Min_Fields>;
  stddev?: Maybe<Project_Interview_Base_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Base_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Base_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Base_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Base_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Base_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Base_Variance_Fields>;
};


/** aggregate fields of "project_interview_base" */
export type Project_Interview_Base_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_base" */
export type Project_Interview_Base_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Base_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Base_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Base_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Base_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Base_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Base_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Base_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Base_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Base_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Base_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Base_Append_Input = {
  leftover_cereal_months?: InputMaybe<Scalars['jsonb']['input']>;
  other_productive_assets?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_interview_base" */
export type Project_Interview_Base_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Base_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Base_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Base_Avg_Fields = {
  __typename?: 'project_interview_base_avg_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_base" */
export type Project_Interview_Base_Avg_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_base". All fields are combined with a logical 'AND'. */
export type Project_Interview_Base_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Base_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Base_Bool_Exp>>;
  children_primary_school?: InputMaybe<Numeric_Comparison_Exp>;
  children_secondary_school?: InputMaybe<Numeric_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  interviewees_female?: InputMaybe<Numeric_Comparison_Exp>;
  interviewees_male?: InputMaybe<Numeric_Comparison_Exp>;
  is_done?: InputMaybe<Boolean_Comparison_Exp>;
  land_cultivated_cash?: InputMaybe<Numeric_Comparison_Exp>;
  land_cultivated_food?: InputMaybe<Numeric_Comparison_Exp>;
  land_outsourced?: InputMaybe<Numeric_Comparison_Exp>;
  land_owned?: InputMaybe<Numeric_Comparison_Exp>;
  land_unit_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  land_unit_conversion_id?: InputMaybe<Uuid_Comparison_Exp>;
  leftover_cereal_amount?: InputMaybe<Numeric_Comparison_Exp>;
  leftover_cereal_months?: InputMaybe<Jsonb_Comparison_Exp>;
  leftover_cereal_term_id?: InputMaybe<Uuid_Comparison_Exp>;
  leftover_cereal_total_calories?: InputMaybe<Numeric_Comparison_Exp>;
  measure_unit?: InputMaybe<Measure_Unit_Bool_Exp>;
  other_productive_assets?: InputMaybe<Jsonb_Comparison_Exp>;
  people_in_household?: InputMaybe<Numeric_Comparison_Exp>;
  project_interview?: InputMaybe<Project_Interview_Bool_Exp>;
  project_interview_crops_seasons?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  project_interview_crops_seasons_aggregate?: InputMaybe<Project_Interview_Crops_Season_Aggregate_Bool_Exp>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
  project_interview_livestocks?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  project_interview_livestocks_aggregate?: InputMaybe<Project_Interview_Livestock_Aggregate_Bool_Exp>;
  project_interview_productive_assets?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
  project_interview_productive_assets_aggregate?: InputMaybe<Project_Interview_Productive_Asset_Aggregate_Bool_Exp>;
  project_interview_total?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
};

/** unique or primary key constraints on table "project_interview_base" */
export enum Project_Interview_Base_Constraint {
  /** unique or primary key constraint on columns "interview_id" */
  ProjectInterviewBaseInterviewIdKey = 'project_interview_base_interview_id_key',
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewBasePkey = 'project_interview_base_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Interview_Base_Delete_At_Path_Input = {
  leftover_cereal_months?: InputMaybe<Array<Scalars['String']['input']>>;
  other_productive_assets?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Interview_Base_Delete_Elem_Input = {
  leftover_cereal_months?: InputMaybe<Scalars['Int']['input']>;
  other_productive_assets?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Interview_Base_Delete_Key_Input = {
  leftover_cereal_months?: InputMaybe<Scalars['String']['input']>;
  other_productive_assets?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_interview_base" */
export type Project_Interview_Base_Inc_Input = {
  children_primary_school?: InputMaybe<Scalars['numeric']['input']>;
  children_secondary_school?: InputMaybe<Scalars['numeric']['input']>;
  interviewees_female?: InputMaybe<Scalars['numeric']['input']>;
  interviewees_male?: InputMaybe<Scalars['numeric']['input']>;
  land_cultivated_cash?: InputMaybe<Scalars['numeric']['input']>;
  land_cultivated_food?: InputMaybe<Scalars['numeric']['input']>;
  land_outsourced?: InputMaybe<Scalars['numeric']['input']>;
  land_owned?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion?: InputMaybe<Scalars['numeric']['input']>;
  leftover_cereal_amount?: InputMaybe<Scalars['numeric']['input']>;
  leftover_cereal_total_calories?: InputMaybe<Scalars['numeric']['input']>;
  people_in_household?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_base" */
export type Project_Interview_Base_Insert_Input = {
  children_primary_school?: InputMaybe<Scalars['numeric']['input']>;
  children_secondary_school?: InputMaybe<Scalars['numeric']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  interviewees_female?: InputMaybe<Scalars['numeric']['input']>;
  interviewees_male?: InputMaybe<Scalars['numeric']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  land_cultivated_cash?: InputMaybe<Scalars['numeric']['input']>;
  land_cultivated_food?: InputMaybe<Scalars['numeric']['input']>;
  land_outsourced?: InputMaybe<Scalars['numeric']['input']>;
  land_owned?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion_id?: InputMaybe<Scalars['uuid']['input']>;
  leftover_cereal_amount?: InputMaybe<Scalars['numeric']['input']>;
  leftover_cereal_months?: InputMaybe<Scalars['jsonb']['input']>;
  leftover_cereal_term_id?: InputMaybe<Scalars['uuid']['input']>;
  leftover_cereal_total_calories?: InputMaybe<Scalars['numeric']['input']>;
  measure_unit?: InputMaybe<Measure_Unit_Obj_Rel_Insert_Input>;
  other_productive_assets?: InputMaybe<Scalars['jsonb']['input']>;
  people_in_household?: InputMaybe<Scalars['numeric']['input']>;
  project_interview?: InputMaybe<Project_Interview_Obj_Rel_Insert_Input>;
  project_interview_crops_seasons?: InputMaybe<Project_Interview_Crops_Season_Arr_Rel_Insert_Input>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Arr_Rel_Insert_Input>;
  project_interview_livestocks?: InputMaybe<Project_Interview_Livestock_Arr_Rel_Insert_Input>;
  project_interview_productive_assets?: InputMaybe<Project_Interview_Productive_Asset_Arr_Rel_Insert_Input>;
  project_interview_total?: InputMaybe<Project_Interview_Totals_Obj_Rel_Insert_Input>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Interview_Base_Max_Fields = {
  __typename?: 'project_interview_base_max_fields';
  children_primary_school?: Maybe<Scalars['numeric']['output']>;
  children_secondary_school?: Maybe<Scalars['numeric']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  interviewees_female?: Maybe<Scalars['numeric']['output']>;
  interviewees_male?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_cash?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_food?: Maybe<Scalars['numeric']['output']>;
  land_outsourced?: Maybe<Scalars['numeric']['output']>;
  land_owned?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion_id?: Maybe<Scalars['uuid']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['numeric']['output']>;
  leftover_cereal_term_id?: Maybe<Scalars['uuid']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['numeric']['output']>;
  people_in_household?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_interview_base" */
export type Project_Interview_Base_Max_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  land_unit_conversion_id?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_term_id?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Base_Min_Fields = {
  __typename?: 'project_interview_base_min_fields';
  children_primary_school?: Maybe<Scalars['numeric']['output']>;
  children_secondary_school?: Maybe<Scalars['numeric']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  interviewees_female?: Maybe<Scalars['numeric']['output']>;
  interviewees_male?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_cash?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_food?: Maybe<Scalars['numeric']['output']>;
  land_outsourced?: Maybe<Scalars['numeric']['output']>;
  land_owned?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion_id?: Maybe<Scalars['uuid']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['numeric']['output']>;
  leftover_cereal_term_id?: Maybe<Scalars['uuid']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['numeric']['output']>;
  people_in_household?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_interview_base" */
export type Project_Interview_Base_Min_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  land_unit_conversion_id?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_term_id?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_base" */
export type Project_Interview_Base_Mutation_Response = {
  __typename?: 'project_interview_base_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Base>;
};

/** input type for inserting object relation for remote table "project_interview_base" */
export type Project_Interview_Base_Obj_Rel_Insert_Input = {
  data: Project_Interview_Base_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Base_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_base" */
export type Project_Interview_Base_On_Conflict = {
  constraint: Project_Interview_Base_Constraint;
  update_columns?: Array<Project_Interview_Base_Update_Column>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_base". */
export type Project_Interview_Base_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  is_done?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  land_unit_conversion_id?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_months?: InputMaybe<Order_By>;
  leftover_cereal_term_id?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Measure_Unit_Order_By>;
  other_productive_assets?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
  project_interview?: InputMaybe<Project_Interview_Order_By>;
  project_interview_crops_seasons_aggregate?: InputMaybe<Project_Interview_Crops_Season_Aggregate_Order_By>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
  project_interview_livestocks_aggregate?: InputMaybe<Project_Interview_Livestock_Aggregate_Order_By>;
  project_interview_productive_assets_aggregate?: InputMaybe<Project_Interview_Productive_Asset_Aggregate_Order_By>;
  project_interview_total?: InputMaybe<Project_Interview_Totals_Order_By>;
  term?: InputMaybe<Term_Order_By>;
};

/** primary key columns input for table: project_interview_base */
export type Project_Interview_Base_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Base_Prepend_Input = {
  leftover_cereal_months?: InputMaybe<Scalars['jsonb']['input']>;
  other_productive_assets?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_interview_base" */
export enum Project_Interview_Base_Select_Column {
  /** column name */
  ChildrenPrimarySchool = 'children_primary_school',
  /** column name */
  ChildrenSecondarySchool = 'children_secondary_school',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  IntervieweesFemale = 'interviewees_female',
  /** column name */
  IntervieweesMale = 'interviewees_male',
  /** column name */
  IsDone = 'is_done',
  /** column name */
  LandCultivatedCash = 'land_cultivated_cash',
  /** column name */
  LandCultivatedFood = 'land_cultivated_food',
  /** column name */
  LandOutsourced = 'land_outsourced',
  /** column name */
  LandOwned = 'land_owned',
  /** column name */
  LandUnitConversion = 'land_unit_conversion',
  /** column name */
  LandUnitConversionId = 'land_unit_conversion_id',
  /** column name */
  LeftoverCerealAmount = 'leftover_cereal_amount',
  /** column name */
  LeftoverCerealMonths = 'leftover_cereal_months',
  /** column name */
  LeftoverCerealTermId = 'leftover_cereal_term_id',
  /** column name */
  LeftoverCerealTotalCalories = 'leftover_cereal_total_calories',
  /** column name */
  OtherProductiveAssets = 'other_productive_assets',
  /** column name */
  PeopleInHousehold = 'people_in_household'
}

/** select "project_interview_base_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_interview_base" */
export enum Project_Interview_Base_Select_Column_Project_Interview_Base_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDone = 'is_done'
}

/** select "project_interview_base_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_interview_base" */
export enum Project_Interview_Base_Select_Column_Project_Interview_Base_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDone = 'is_done'
}

/** input type for updating data in table "project_interview_base" */
export type Project_Interview_Base_Set_Input = {
  children_primary_school?: InputMaybe<Scalars['numeric']['input']>;
  children_secondary_school?: InputMaybe<Scalars['numeric']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  interviewees_female?: InputMaybe<Scalars['numeric']['input']>;
  interviewees_male?: InputMaybe<Scalars['numeric']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  land_cultivated_cash?: InputMaybe<Scalars['numeric']['input']>;
  land_cultivated_food?: InputMaybe<Scalars['numeric']['input']>;
  land_outsourced?: InputMaybe<Scalars['numeric']['input']>;
  land_owned?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion_id?: InputMaybe<Scalars['uuid']['input']>;
  leftover_cereal_amount?: InputMaybe<Scalars['numeric']['input']>;
  leftover_cereal_months?: InputMaybe<Scalars['jsonb']['input']>;
  leftover_cereal_term_id?: InputMaybe<Scalars['uuid']['input']>;
  leftover_cereal_total_calories?: InputMaybe<Scalars['numeric']['input']>;
  other_productive_assets?: InputMaybe<Scalars['jsonb']['input']>;
  people_in_household?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Base_Stddev_Fields = {
  __typename?: 'project_interview_base_stddev_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_base" */
export type Project_Interview_Base_Stddev_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Base_Stddev_Pop_Fields = {
  __typename?: 'project_interview_base_stddev_pop_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_base" */
export type Project_Interview_Base_Stddev_Pop_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Base_Stddev_Samp_Fields = {
  __typename?: 'project_interview_base_stddev_samp_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_base" */
export type Project_Interview_Base_Stddev_Samp_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_base" */
export type Project_Interview_Base_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Base_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Base_Stream_Cursor_Value_Input = {
  children_primary_school?: InputMaybe<Scalars['numeric']['input']>;
  children_secondary_school?: InputMaybe<Scalars['numeric']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  interviewees_female?: InputMaybe<Scalars['numeric']['input']>;
  interviewees_male?: InputMaybe<Scalars['numeric']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  land_cultivated_cash?: InputMaybe<Scalars['numeric']['input']>;
  land_cultivated_food?: InputMaybe<Scalars['numeric']['input']>;
  land_outsourced?: InputMaybe<Scalars['numeric']['input']>;
  land_owned?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion?: InputMaybe<Scalars['numeric']['input']>;
  land_unit_conversion_id?: InputMaybe<Scalars['uuid']['input']>;
  leftover_cereal_amount?: InputMaybe<Scalars['numeric']['input']>;
  leftover_cereal_months?: InputMaybe<Scalars['jsonb']['input']>;
  leftover_cereal_term_id?: InputMaybe<Scalars['uuid']['input']>;
  leftover_cereal_total_calories?: InputMaybe<Scalars['numeric']['input']>;
  other_productive_assets?: InputMaybe<Scalars['jsonb']['input']>;
  people_in_household?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Base_Sum_Fields = {
  __typename?: 'project_interview_base_sum_fields';
  children_primary_school?: Maybe<Scalars['numeric']['output']>;
  children_secondary_school?: Maybe<Scalars['numeric']['output']>;
  interviewees_female?: Maybe<Scalars['numeric']['output']>;
  interviewees_male?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_cash?: Maybe<Scalars['numeric']['output']>;
  land_cultivated_food?: Maybe<Scalars['numeric']['output']>;
  land_outsourced?: Maybe<Scalars['numeric']['output']>;
  land_owned?: Maybe<Scalars['numeric']['output']>;
  land_unit_conversion?: Maybe<Scalars['numeric']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['numeric']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['numeric']['output']>;
  people_in_household?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_base" */
export type Project_Interview_Base_Sum_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** update columns of table "project_interview_base" */
export enum Project_Interview_Base_Update_Column {
  /** column name */
  ChildrenPrimarySchool = 'children_primary_school',
  /** column name */
  ChildrenSecondarySchool = 'children_secondary_school',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  IntervieweesFemale = 'interviewees_female',
  /** column name */
  IntervieweesMale = 'interviewees_male',
  /** column name */
  IsDone = 'is_done',
  /** column name */
  LandCultivatedCash = 'land_cultivated_cash',
  /** column name */
  LandCultivatedFood = 'land_cultivated_food',
  /** column name */
  LandOutsourced = 'land_outsourced',
  /** column name */
  LandOwned = 'land_owned',
  /** column name */
  LandUnitConversion = 'land_unit_conversion',
  /** column name */
  LandUnitConversionId = 'land_unit_conversion_id',
  /** column name */
  LeftoverCerealAmount = 'leftover_cereal_amount',
  /** column name */
  LeftoverCerealMonths = 'leftover_cereal_months',
  /** column name */
  LeftoverCerealTermId = 'leftover_cereal_term_id',
  /** column name */
  LeftoverCerealTotalCalories = 'leftover_cereal_total_calories',
  /** column name */
  OtherProductiveAssets = 'other_productive_assets',
  /** column name */
  PeopleInHousehold = 'people_in_household'
}

export type Project_Interview_Base_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Interview_Base_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Interview_Base_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Interview_Base_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Interview_Base_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Base_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Interview_Base_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Base_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Base_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Base_Var_Pop_Fields = {
  __typename?: 'project_interview_base_var_pop_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_base" */
export type Project_Interview_Base_Var_Pop_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Base_Var_Samp_Fields = {
  __typename?: 'project_interview_base_var_samp_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_base" */
export type Project_Interview_Base_Var_Samp_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Base_Variance_Fields = {
  __typename?: 'project_interview_base_variance_fields';
  children_primary_school?: Maybe<Scalars['Float']['output']>;
  children_secondary_school?: Maybe<Scalars['Float']['output']>;
  interviewees_female?: Maybe<Scalars['Float']['output']>;
  interviewees_male?: Maybe<Scalars['Float']['output']>;
  land_cultivated_cash?: Maybe<Scalars['Float']['output']>;
  land_cultivated_food?: Maybe<Scalars['Float']['output']>;
  land_outsourced?: Maybe<Scalars['Float']['output']>;
  land_owned?: Maybe<Scalars['Float']['output']>;
  land_unit_conversion?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_amount?: Maybe<Scalars['Float']['output']>;
  leftover_cereal_total_calories?: Maybe<Scalars['Float']['output']>;
  people_in_household?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_base" */
export type Project_Interview_Base_Variance_Order_By = {
  children_primary_school?: InputMaybe<Order_By>;
  children_secondary_school?: InputMaybe<Order_By>;
  interviewees_female?: InputMaybe<Order_By>;
  interviewees_male?: InputMaybe<Order_By>;
  land_cultivated_cash?: InputMaybe<Order_By>;
  land_cultivated_food?: InputMaybe<Order_By>;
  land_outsourced?: InputMaybe<Order_By>;
  land_owned?: InputMaybe<Order_By>;
  land_unit_conversion?: InputMaybe<Order_By>;
  leftover_cereal_amount?: InputMaybe<Order_By>;
  leftover_cereal_total_calories?: InputMaybe<Order_By>;
  people_in_household?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview". All fields are combined with a logical 'AND'. */
export type Project_Interview_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  location_id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview_backups?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
  project_interview_backups_aggregate?: InputMaybe<Project_Interview_Backup_Aggregate_Bool_Exp>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  project_interview_files?: InputMaybe<Project_Interview_File_Bool_Exp>;
  project_interview_files_aggregate?: InputMaybe<Project_Interview_File_Aggregate_Bool_Exp>;
  project_interview_notes?: InputMaybe<Project_Interview_Note_Bool_Exp>;
  project_interview_notes_aggregate?: InputMaybe<Project_Interview_Note_Aggregate_Bool_Exp>;
  project_interview_researcher_mns?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
  project_interview_researcher_mns_aggregate?: InputMaybe<Project_Interview_Researcher_Mn_Aggregate_Bool_Exp>;
  status?: InputMaybe<Status_Enum_Comparison_Exp>;
  statusByStatus?: InputMaybe<Status_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wealth_group?: InputMaybe<Wealth_Group_Bool_Exp>;
  wealth_group_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview" */
export enum Project_Interview_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewPkey = 'project_interview_pkey',
  /** unique or primary key constraint on columns "project_id", "wealth_group_id", "location_id" */
  ProjectInterviewProjectIdWealthGroupIdLocationIdKey = 'project_interview_project_id_wealth_group_id_location_id_key'
}

/** columns and relationships of "project_interview_crops" */
export type Project_Interview_Crops = {
  __typename?: 'project_interview_crops';
  crops_season_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  losses?: Maybe<Scalars['numeric']['output']>;
  months_consumption?: Maybe<Scalars['jsonb']['output']>;
  other_uses?: Maybe<Scalars['jsonb']['output']>;
  produced_quantity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  produced_unit?: Maybe<Measure_Unit>;
  produced_unit_measure?: Maybe<Scalars['numeric']['output']>;
  produced_unit_measure_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  project_interview_crops_season: Project_Interview_Crops_Season;
  sold_price_per_unit?: Maybe<Scalars['numeric']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  sold_unit?: Maybe<Measure_Unit>;
  sold_unit_measure?: Maybe<Scalars['numeric']['output']>;
  sold_unit_measure_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  term?: Maybe<Term>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
  when_sold?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "project_interview_crops" */
export type Project_Interview_CropsMonths_ConsumptionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_interview_crops" */
export type Project_Interview_CropsOther_UsesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_interview_crops" */
export type Project_Interview_CropsWhen_SoldArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_interview_crops" */
export type Project_Interview_Crops_Aggregate = {
  __typename?: 'project_interview_crops_aggregate';
  aggregate?: Maybe<Project_Interview_Crops_Aggregate_Fields>;
  nodes: Array<Project_Interview_Crops>;
};

export type Project_Interview_Crops_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_Crops_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Crops_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_crops" */
export type Project_Interview_Crops_Aggregate_Fields = {
  __typename?: 'project_interview_crops_aggregate_fields';
  avg?: Maybe<Project_Interview_Crops_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Crops_Max_Fields>;
  min?: Maybe<Project_Interview_Crops_Min_Fields>;
  stddev?: Maybe<Project_Interview_Crops_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Crops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Crops_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Crops_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Crops_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Crops_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Crops_Variance_Fields>;
};


/** aggregate fields of "project_interview_crops" */
export type Project_Interview_Crops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_crops" */
export type Project_Interview_Crops_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Crops_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Crops_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Crops_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Crops_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Crops_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Crops_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Crops_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Crops_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Crops_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Crops_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Crops_Append_Input = {
  months_consumption?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  when_sold?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_interview_crops" */
export type Project_Interview_Crops_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Crops_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Crops_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Crops_Avg_Fields = {
  __typename?: 'project_interview_crops_avg_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Avg_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_crops". All fields are combined with a logical 'AND'. */
export type Project_Interview_Crops_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Crops_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Crops_Bool_Exp>>;
  crops_season_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  losses?: InputMaybe<Numeric_Comparison_Exp>;
  months_consumption?: InputMaybe<Jsonb_Comparison_Exp>;
  other_uses?: InputMaybe<Jsonb_Comparison_Exp>;
  produced_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  produced_unit?: InputMaybe<Measure_Unit_Bool_Exp>;
  produced_unit_measure?: InputMaybe<Numeric_Comparison_Exp>;
  produced_unit_measure_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview_crops_season?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  sold_price_per_unit?: InputMaybe<Numeric_Comparison_Exp>;
  sold_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  sold_unit?: InputMaybe<Measure_Unit_Bool_Exp>;
  sold_unit_measure?: InputMaybe<Numeric_Comparison_Exp>;
  sold_unit_measure_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_cash_income?: InputMaybe<Numeric_Comparison_Exp>;
  total_consumed?: InputMaybe<Numeric_Comparison_Exp>;
  total_given_away?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal_consumed?: InputMaybe<Numeric_Comparison_Exp>;
  total_produced?: InputMaybe<Numeric_Comparison_Exp>;
  total_sold?: InputMaybe<Numeric_Comparison_Exp>;
  when_sold?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_crops" */
export enum Project_Interview_Crops_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewCropsPkey = 'project_interview_crops_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Interview_Crops_Delete_At_Path_Input = {
  months_consumption?: InputMaybe<Array<Scalars['String']['input']>>;
  other_uses?: InputMaybe<Array<Scalars['String']['input']>>;
  when_sold?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Interview_Crops_Delete_Elem_Input = {
  months_consumption?: InputMaybe<Scalars['Int']['input']>;
  other_uses?: InputMaybe<Scalars['Int']['input']>;
  when_sold?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Interview_Crops_Delete_Key_Input = {
  months_consumption?: InputMaybe<Scalars['String']['input']>;
  other_uses?: InputMaybe<Scalars['String']['input']>;
  when_sold?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root = {
  __typename?: 'project_interview_crops_green_root';
  days_per_week?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  is_snack?: Maybe<Scalars['Boolean']['output']>;
  meals_day?: Maybe<Scalars['smallint']['output']>;
  months?: Maybe<Scalars['jsonb']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  season_green_crops?: Maybe<Project_Interview_Crops_Season>;
  season_green_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  season_root_crops?: Maybe<Project_Interview_Crops_Season>;
  season_root_id?: Maybe<Scalars['uuid']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  weeks?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_RootMonthsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Aggregate = {
  __typename?: 'project_interview_crops_green_root_aggregate';
  aggregate?: Maybe<Project_Interview_Crops_Green_Root_Aggregate_Fields>;
  nodes: Array<Project_Interview_Crops_Green_Root>;
};

/** aggregate fields of "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Aggregate_Fields = {
  __typename?: 'project_interview_crops_green_root_aggregate_fields';
  avg?: Maybe<Project_Interview_Crops_Green_Root_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Crops_Green_Root_Max_Fields>;
  min?: Maybe<Project_Interview_Crops_Green_Root_Min_Fields>;
  stddev?: Maybe<Project_Interview_Crops_Green_Root_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Crops_Green_Root_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Crops_Green_Root_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Crops_Green_Root_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Crops_Green_Root_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Crops_Green_Root_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Crops_Green_Root_Variance_Fields>;
};


/** aggregate fields of "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Crops_Green_Root_Append_Input = {
  months?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Project_Interview_Crops_Green_Root_Avg_Fields = {
  __typename?: 'project_interview_crops_green_root_avg_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_interview_crops_green_root". All fields are combined with a logical 'AND'. */
export type Project_Interview_Crops_Green_Root_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Bool_Exp>>;
  days_per_week?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_snack?: InputMaybe<Boolean_Comparison_Exp>;
  meals_day?: InputMaybe<Smallint_Comparison_Exp>;
  months?: InputMaybe<Jsonb_Comparison_Exp>;
  people?: InputMaybe<Numeric_Comparison_Exp>;
  season_green_crops?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  season_green_id?: InputMaybe<Uuid_Comparison_Exp>;
  season_root_crops?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  season_root_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  weeks?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_crops_green_root" */
export enum Project_Interview_Crops_Green_Root_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewCropsGreenRootPkey = 'project_interview_crops_green_root_pkey',
  /** unique or primary key constraint on columns "season_green_id" */
  ProjectInterviewCropsGreenRootSeasonGreenIdKey = 'project_interview_crops_green_root_season_green_id_key',
  /** unique or primary key constraint on columns "season_root_id" */
  ProjectInterviewCropsGreenRootSeasonRootIdKey = 'project_interview_crops_green_root_season_root_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Interview_Crops_Green_Root_Delete_At_Path_Input = {
  months?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Interview_Crops_Green_Root_Delete_Elem_Input = {
  months?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Interview_Crops_Green_Root_Delete_Key_Input = {
  months?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Inc_Input = {
  days_per_week?: InputMaybe<Scalars['numeric']['input']>;
  meals_day?: InputMaybe<Scalars['smallint']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  weeks?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Insert_Input = {
  days_per_week?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_snack?: InputMaybe<Scalars['Boolean']['input']>;
  meals_day?: InputMaybe<Scalars['smallint']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  season_green_crops?: InputMaybe<Project_Interview_Crops_Season_Obj_Rel_Insert_Input>;
  season_green_id?: InputMaybe<Scalars['uuid']['input']>;
  season_root_crops?: InputMaybe<Project_Interview_Crops_Season_Obj_Rel_Insert_Input>;
  season_root_id?: InputMaybe<Scalars['uuid']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  weeks?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Crops_Green_Root_Max_Fields = {
  __typename?: 'project_interview_crops_green_root_max_fields';
  days_per_week?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meals_day?: Maybe<Scalars['smallint']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  season_green_id?: Maybe<Scalars['uuid']['output']>;
  season_root_id?: Maybe<Scalars['uuid']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  weeks?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Project_Interview_Crops_Green_Root_Min_Fields = {
  __typename?: 'project_interview_crops_green_root_min_fields';
  days_per_week?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  meals_day?: Maybe<Scalars['smallint']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  season_green_id?: Maybe<Scalars['uuid']['output']>;
  season_root_id?: Maybe<Scalars['uuid']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  weeks?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Mutation_Response = {
  __typename?: 'project_interview_crops_green_root_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Crops_Green_Root>;
};

/** input type for inserting object relation for remote table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Obj_Rel_Insert_Input = {
  data: Project_Interview_Crops_Green_Root_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Crops_Green_Root_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_On_Conflict = {
  constraint: Project_Interview_Crops_Green_Root_Constraint;
  update_columns?: Array<Project_Interview_Crops_Green_Root_Update_Column>;
  where?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_crops_green_root". */
export type Project_Interview_Crops_Green_Root_Order_By = {
  days_per_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_snack?: InputMaybe<Order_By>;
  meals_day?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  season_green_crops?: InputMaybe<Project_Interview_Crops_Season_Order_By>;
  season_green_id?: InputMaybe<Order_By>;
  season_root_crops?: InputMaybe<Project_Interview_Crops_Season_Order_By>;
  season_root_id?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  weeks?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_crops_green_root */
export type Project_Interview_Crops_Green_Root_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Crops_Green_Root_Prepend_Input = {
  months?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_interview_crops_green_root" */
export enum Project_Interview_Crops_Green_Root_Select_Column {
  /** column name */
  DaysPerWeek = 'days_per_week',
  /** column name */
  Id = 'id',
  /** column name */
  IsSnack = 'is_snack',
  /** column name */
  MealsDay = 'meals_day',
  /** column name */
  Months = 'months',
  /** column name */
  People = 'people',
  /** column name */
  SeasonGreenId = 'season_green_id',
  /** column name */
  SeasonRootId = 'season_root_id',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  Weeks = 'weeks'
}

/** input type for updating data in table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Set_Input = {
  days_per_week?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_snack?: InputMaybe<Scalars['Boolean']['input']>;
  meals_day?: InputMaybe<Scalars['smallint']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  season_green_id?: InputMaybe<Scalars['uuid']['input']>;
  season_root_id?: InputMaybe<Scalars['uuid']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  weeks?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Crops_Green_Root_Stddev_Fields = {
  __typename?: 'project_interview_crops_green_root_stddev_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Crops_Green_Root_Stddev_Pop_Fields = {
  __typename?: 'project_interview_crops_green_root_stddev_pop_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Crops_Green_Root_Stddev_Samp_Fields = {
  __typename?: 'project_interview_crops_green_root_stddev_samp_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project_interview_crops_green_root" */
export type Project_Interview_Crops_Green_Root_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Crops_Green_Root_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Crops_Green_Root_Stream_Cursor_Value_Input = {
  days_per_week?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_snack?: InputMaybe<Scalars['Boolean']['input']>;
  meals_day?: InputMaybe<Scalars['smallint']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  season_green_id?: InputMaybe<Scalars['uuid']['input']>;
  season_root_id?: InputMaybe<Scalars['uuid']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  weeks?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Crops_Green_Root_Sum_Fields = {
  __typename?: 'project_interview_crops_green_root_sum_fields';
  days_per_week?: Maybe<Scalars['numeric']['output']>;
  meals_day?: Maybe<Scalars['smallint']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  weeks?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "project_interview_crops_green_root" */
export enum Project_Interview_Crops_Green_Root_Update_Column {
  /** column name */
  DaysPerWeek = 'days_per_week',
  /** column name */
  Id = 'id',
  /** column name */
  IsSnack = 'is_snack',
  /** column name */
  MealsDay = 'meals_day',
  /** column name */
  Months = 'months',
  /** column name */
  People = 'people',
  /** column name */
  SeasonGreenId = 'season_green_id',
  /** column name */
  SeasonRootId = 'season_root_id',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  Weeks = 'weeks'
}

export type Project_Interview_Crops_Green_Root_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Interview_Crops_Green_Root_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Interview_Crops_Green_Root_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Crops_Green_Root_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Interview_Crops_Green_Root_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Crops_Green_Root_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Crops_Green_Root_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Crops_Green_Root_Var_Pop_Fields = {
  __typename?: 'project_interview_crops_green_root_var_pop_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Crops_Green_Root_Var_Samp_Fields = {
  __typename?: 'project_interview_crops_green_root_var_samp_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Interview_Crops_Green_Root_Variance_Fields = {
  __typename?: 'project_interview_crops_green_root_variance_fields';
  days_per_week?: Maybe<Scalars['Float']['output']>;
  meals_day?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "project_interview_crops" */
export type Project_Interview_Crops_Inc_Input = {
  losses?: InputMaybe<Scalars['numeric']['input']>;
  produced_quantity?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  sold_price_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_crops" */
export type Project_Interview_Crops_Insert_Input = {
  crops_season_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  losses?: InputMaybe<Scalars['numeric']['input']>;
  months_consumption?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  produced_quantity?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit?: InputMaybe<Measure_Unit_Obj_Rel_Insert_Input>;
  produced_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit_measure_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview_crops_season?: InputMaybe<Project_Interview_Crops_Season_Obj_Rel_Insert_Input>;
  sold_price_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit?: InputMaybe<Measure_Unit_Obj_Rel_Insert_Input>;
  sold_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit_measure_id?: InputMaybe<Scalars['uuid']['input']>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  when_sold?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Crops_Max_Fields = {
  __typename?: 'project_interview_crops_max_fields';
  crops_season_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  losses?: Maybe<Scalars['numeric']['output']>;
  produced_quantity?: Maybe<Scalars['numeric']['output']>;
  produced_unit_measure?: Maybe<Scalars['numeric']['output']>;
  produced_unit_measure_id?: Maybe<Scalars['uuid']['output']>;
  sold_price_per_unit?: Maybe<Scalars['numeric']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit_measure?: Maybe<Scalars['numeric']['output']>;
  sold_unit_measure_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Max_Order_By = {
  crops_season_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  produced_unit_measure_id?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  sold_unit_measure_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Crops_Min_Fields = {
  __typename?: 'project_interview_crops_min_fields';
  crops_season_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  losses?: Maybe<Scalars['numeric']['output']>;
  produced_quantity?: Maybe<Scalars['numeric']['output']>;
  produced_unit_measure?: Maybe<Scalars['numeric']['output']>;
  produced_unit_measure_id?: Maybe<Scalars['uuid']['output']>;
  sold_price_per_unit?: Maybe<Scalars['numeric']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit_measure?: Maybe<Scalars['numeric']['output']>;
  sold_unit_measure_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Min_Order_By = {
  crops_season_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  produced_unit_measure_id?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  sold_unit_measure_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_crops" */
export type Project_Interview_Crops_Mutation_Response = {
  __typename?: 'project_interview_crops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Crops>;
};

/** on_conflict condition type for table "project_interview_crops" */
export type Project_Interview_Crops_On_Conflict = {
  constraint: Project_Interview_Crops_Constraint;
  update_columns?: Array<Project_Interview_Crops_Update_Column>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_crops". */
export type Project_Interview_Crops_Order_By = {
  crops_season_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  losses?: InputMaybe<Order_By>;
  months_consumption?: InputMaybe<Order_By>;
  other_uses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit?: InputMaybe<Measure_Unit_Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  produced_unit_measure_id?: InputMaybe<Order_By>;
  project_interview_crops_season?: InputMaybe<Project_Interview_Crops_Season_Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Measure_Unit_Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  sold_unit_measure_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  when_sold?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_crops */
export type Project_Interview_Crops_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Crops_Prepend_Input = {
  months_consumption?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  when_sold?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "project_interview_crops_season" */
export type Project_Interview_Crops_Season = {
  __typename?: 'project_interview_crops_season';
  crop_season_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  green_crops?: Maybe<Project_Interview_Crops_Green_Root>;
  harvested_crops?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_interview_base: Project_Interview_Base;
  /** An array relationship */
  project_interview_crops: Array<Project_Interview_Crops>;
  /** An aggregate relationship */
  project_interview_crops_aggregate: Project_Interview_Crops_Aggregate;
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
  /** An object relationship */
  root_crops?: Maybe<Project_Interview_Crops_Green_Root>;
  /** An object relationship */
  season?: Maybe<Crop_Season>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "project_interview_crops_season" */
export type Project_Interview_Crops_SeasonProject_Interview_CropsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "project_interview_crops_season" */
export type Project_Interview_Crops_SeasonProject_Interview_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "project_interview_crops_season" */
export type Project_Interview_Crops_SeasonProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "project_interview_crops_season" */
export type Project_Interview_Crops_SeasonProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};

/** aggregated selection of "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Aggregate = {
  __typename?: 'project_interview_crops_season_aggregate';
  aggregate?: Maybe<Project_Interview_Crops_Season_Aggregate_Fields>;
  nodes: Array<Project_Interview_Crops_Season>;
};

export type Project_Interview_Crops_Season_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_Crops_Season_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Crops_Season_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Aggregate_Fields = {
  __typename?: 'project_interview_crops_season_aggregate_fields';
  avg?: Maybe<Project_Interview_Crops_Season_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Crops_Season_Max_Fields>;
  min?: Maybe<Project_Interview_Crops_Season_Min_Fields>;
  stddev?: Maybe<Project_Interview_Crops_Season_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Crops_Season_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Crops_Season_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Crops_Season_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Crops_Season_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Crops_Season_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Crops_Season_Variance_Fields>;
};


/** aggregate fields of "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Crops_Season_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Crops_Season_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Crops_Season_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Crops_Season_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Crops_Season_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Crops_Season_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Crops_Season_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Crops_Season_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Crops_Season_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Crops_Season_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Crops_Season_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Crops_Season_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Crops_Season_Avg_Fields = {
  __typename?: 'project_interview_crops_season_avg_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Avg_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_crops_season". All fields are combined with a logical 'AND'. */
export type Project_Interview_Crops_Season_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Crops_Season_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Crops_Season_Bool_Exp>>;
  crop_season_id?: InputMaybe<Uuid_Comparison_Exp>;
  green_crops?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
  harvested_crops?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  project_interview_crops?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
  project_interview_crops_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Bool_Exp>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
  root_crops?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
  season?: InputMaybe<Crop_Season_Bool_Exp>;
  total_cash_income?: InputMaybe<Numeric_Comparison_Exp>;
  total_consumed?: InputMaybe<Numeric_Comparison_Exp>;
  total_expenses?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal_consumed?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_crops_season" */
export enum Project_Interview_Crops_Season_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewCropsSeasonPkey = 'project_interview_crops_season_pkey'
}

/** input type for incrementing numeric columns in table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Inc_Input = {
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Insert_Input = {
  crop_season_id?: InputMaybe<Scalars['uuid']['input']>;
  green_crops?: InputMaybe<Project_Interview_Crops_Green_Root_Obj_Rel_Insert_Input>;
  harvested_crops?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Obj_Rel_Insert_Input>;
  project_interview_crops?: InputMaybe<Project_Interview_Crops_Arr_Rel_Insert_Input>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Arr_Rel_Insert_Input>;
  root_crops?: InputMaybe<Project_Interview_Crops_Green_Root_Obj_Rel_Insert_Input>;
  season?: InputMaybe<Crop_Season_Obj_Rel_Insert_Input>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Crops_Season_Max_Fields = {
  __typename?: 'project_interview_crops_season_max_fields';
  crop_season_id?: Maybe<Scalars['uuid']['output']>;
  harvested_crops?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Max_Order_By = {
  crop_season_id?: InputMaybe<Order_By>;
  harvested_crops?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Crops_Season_Min_Fields = {
  __typename?: 'project_interview_crops_season_min_fields';
  crop_season_id?: Maybe<Scalars['uuid']['output']>;
  harvested_crops?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Min_Order_By = {
  crop_season_id?: InputMaybe<Order_By>;
  harvested_crops?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Mutation_Response = {
  __typename?: 'project_interview_crops_season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Crops_Season>;
};

/** input type for inserting object relation for remote table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Obj_Rel_Insert_Input = {
  data: Project_Interview_Crops_Season_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Crops_Season_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_On_Conflict = {
  constraint: Project_Interview_Crops_Season_Constraint;
  update_columns?: Array<Project_Interview_Crops_Season_Update_Column>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_crops_season". */
export type Project_Interview_Crops_Season_Order_By = {
  crop_season_id?: InputMaybe<Order_By>;
  green_crops?: InputMaybe<Project_Interview_Crops_Green_Root_Order_By>;
  harvested_crops?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Order_By>;
  project_interview_crops_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Order_By>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
  root_crops?: InputMaybe<Project_Interview_Crops_Green_Root_Order_By>;
  season?: InputMaybe<Crop_Season_Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_crops_season */
export type Project_Interview_Crops_Season_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_crops_season" */
export enum Project_Interview_Crops_Season_Select_Column {
  /** column name */
  CropSeasonId = 'crop_season_id',
  /** column name */
  HarvestedCrops = 'harvested_crops',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalConsumed = 'total_consumed',
  /** column name */
  TotalExpenses = 'total_expenses',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalKcalConsumed = 'total_kcal_consumed'
}

/** input type for updating data in table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Set_Input = {
  crop_season_id?: InputMaybe<Scalars['uuid']['input']>;
  harvested_crops?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Crops_Season_Stddev_Fields = {
  __typename?: 'project_interview_crops_season_stddev_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Stddev_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Crops_Season_Stddev_Pop_Fields = {
  __typename?: 'project_interview_crops_season_stddev_pop_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Stddev_Pop_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Crops_Season_Stddev_Samp_Fields = {
  __typename?: 'project_interview_crops_season_stddev_samp_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Stddev_Samp_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Crops_Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Crops_Season_Stream_Cursor_Value_Input = {
  crop_season_id?: InputMaybe<Scalars['uuid']['input']>;
  harvested_crops?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Crops_Season_Sum_Fields = {
  __typename?: 'project_interview_crops_season_sum_fields';
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Sum_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** update columns of table "project_interview_crops_season" */
export enum Project_Interview_Crops_Season_Update_Column {
  /** column name */
  CropSeasonId = 'crop_season_id',
  /** column name */
  HarvestedCrops = 'harvested_crops',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalConsumed = 'total_consumed',
  /** column name */
  TotalExpenses = 'total_expenses',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalKcalConsumed = 'total_kcal_consumed'
}

export type Project_Interview_Crops_Season_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Crops_Season_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Crops_Season_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Crops_Season_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Crops_Season_Var_Pop_Fields = {
  __typename?: 'project_interview_crops_season_var_pop_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Var_Pop_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Crops_Season_Var_Samp_Fields = {
  __typename?: 'project_interview_crops_season_var_samp_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Var_Samp_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Crops_Season_Variance_Fields = {
  __typename?: 'project_interview_crops_season_variance_fields';
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_crops_season" */
export type Project_Interview_Crops_Season_Variance_Order_By = {
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
};

/** select columns of table "project_interview_crops" */
export enum Project_Interview_Crops_Select_Column {
  /** column name */
  CropsSeasonId = 'crops_season_id',
  /** column name */
  Id = 'id',
  /** column name */
  Losses = 'losses',
  /** column name */
  MonthsConsumption = 'months_consumption',
  /** column name */
  OtherUses = 'other_uses',
  /** column name */
  ProducedQuantity = 'produced_quantity',
  /** column name */
  ProducedUnitMeasure = 'produced_unit_measure',
  /** column name */
  ProducedUnitMeasureId = 'produced_unit_measure_id',
  /** column name */
  SoldPricePerUnit = 'sold_price_per_unit',
  /** column name */
  SoldQuantity = 'sold_quantity',
  /** column name */
  SoldUnitMeasure = 'sold_unit_measure',
  /** column name */
  SoldUnitMeasureId = 'sold_unit_measure_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalConsumed = 'total_consumed',
  /** column name */
  TotalGivenAway = 'total_given_away',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalKcalConsumed = 'total_kcal_consumed',
  /** column name */
  TotalProduced = 'total_produced',
  /** column name */
  TotalSold = 'total_sold',
  /** column name */
  WhenSold = 'when_sold'
}

/** input type for updating data in table "project_interview_crops" */
export type Project_Interview_Crops_Set_Input = {
  crops_season_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  losses?: InputMaybe<Scalars['numeric']['input']>;
  months_consumption?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  produced_quantity?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit_measure_id?: InputMaybe<Scalars['uuid']['input']>;
  sold_price_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit_measure_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  when_sold?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Crops_Stddev_Fields = {
  __typename?: 'project_interview_crops_stddev_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Stddev_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Crops_Stddev_Pop_Fields = {
  __typename?: 'project_interview_crops_stddev_pop_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Stddev_Pop_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Crops_Stddev_Samp_Fields = {
  __typename?: 'project_interview_crops_stddev_samp_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Stddev_Samp_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_crops" */
export type Project_Interview_Crops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Crops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Crops_Stream_Cursor_Value_Input = {
  crops_season_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  losses?: InputMaybe<Scalars['numeric']['input']>;
  months_consumption?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  produced_quantity?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  produced_unit_measure_id?: InputMaybe<Scalars['uuid']['input']>;
  sold_price_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit_measure?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit_measure_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  when_sold?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Crops_Sum_Fields = {
  __typename?: 'project_interview_crops_sum_fields';
  losses?: Maybe<Scalars['numeric']['output']>;
  produced_quantity?: Maybe<Scalars['numeric']['output']>;
  produced_unit_measure?: Maybe<Scalars['numeric']['output']>;
  sold_price_per_unit?: Maybe<Scalars['numeric']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit_measure?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal_consumed?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Sum_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** update columns of table "project_interview_crops" */
export enum Project_Interview_Crops_Update_Column {
  /** column name */
  CropsSeasonId = 'crops_season_id',
  /** column name */
  Id = 'id',
  /** column name */
  Losses = 'losses',
  /** column name */
  MonthsConsumption = 'months_consumption',
  /** column name */
  OtherUses = 'other_uses',
  /** column name */
  ProducedQuantity = 'produced_quantity',
  /** column name */
  ProducedUnitMeasure = 'produced_unit_measure',
  /** column name */
  ProducedUnitMeasureId = 'produced_unit_measure_id',
  /** column name */
  SoldPricePerUnit = 'sold_price_per_unit',
  /** column name */
  SoldQuantity = 'sold_quantity',
  /** column name */
  SoldUnitMeasure = 'sold_unit_measure',
  /** column name */
  SoldUnitMeasureId = 'sold_unit_measure_id',
  /** column name */
  TermId = 'term_id',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalConsumed = 'total_consumed',
  /** column name */
  TotalGivenAway = 'total_given_away',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalKcalConsumed = 'total_kcal_consumed',
  /** column name */
  TotalProduced = 'total_produced',
  /** column name */
  TotalSold = 'total_sold',
  /** column name */
  WhenSold = 'when_sold'
}

export type Project_Interview_Crops_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Interview_Crops_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Interview_Crops_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Interview_Crops_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Interview_Crops_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Crops_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Interview_Crops_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Crops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Crops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Crops_Var_Pop_Fields = {
  __typename?: 'project_interview_crops_var_pop_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Var_Pop_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Crops_Var_Samp_Fields = {
  __typename?: 'project_interview_crops_var_samp_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Var_Samp_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Crops_Variance_Fields = {
  __typename?: 'project_interview_crops_variance_fields';
  losses?: Maybe<Scalars['Float']['output']>;
  produced_quantity?: Maybe<Scalars['Float']['output']>;
  produced_unit_measure?: Maybe<Scalars['Float']['output']>;
  sold_price_per_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit_measure?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal_consumed?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_crops" */
export type Project_Interview_Crops_Variance_Order_By = {
  losses?: InputMaybe<Order_By>;
  produced_quantity?: InputMaybe<Order_By>;
  produced_unit_measure?: InputMaybe<Order_By>;
  sold_price_per_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit_measure?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_kcal_consumed?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_interview_data" */
export type Project_Interview_Data = {
  __typename?: 'project_interview_data';
  activity?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  crop_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['jsonb']['output']>;
  food_amount?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  food_term?: Maybe<Term>;
  food_term_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_area_based?: Maybe<Scalars['Boolean']['output']>;
  is_expenditure?: Maybe<Scalars['Boolean']['output']>;
  is_food?: Maybe<Scalars['Boolean']['output']>;
  is_payment_person?: Maybe<Scalars['Boolean']['output']>;
  is_resold?: Maybe<Scalars['Boolean']['output']>;
  is_school?: Maybe<Scalars['Boolean']['output']>;
  livestock_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  meals_included?: Maybe<Scalars['Boolean']['output']>;
  months?: Maybe<Scalars['jsonb']['output']>;
  number_children?: Maybe<Scalars['numeric']['output']>;
  other_uses?: Maybe<Scalars['jsonb']['output']>;
  payment?: Maybe<Scalars['numeric']['output']>;
  payment_nr_times?: Maybe<Scalars['numeric']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  profit_by_person?: Maybe<Scalars['numeric']['output']>;
  profit_per_unit?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  project_interview_base?: Maybe<Project_Interview_Base>;
  /** An object relationship */
  project_interview_crop?: Maybe<Project_Interview_Crops_Season>;
  /** An object relationship */
  project_interview_data_type: Project_Interview_Data_Type;
  project_interview_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  project_interview_livestock?: Maybe<Project_Interview_Livestock>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_unit?: Maybe<Scalars['numeric']['output']>;
  quantity_unit_id?: Maybe<Scalars['uuid']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  term?: Maybe<Term>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  times_money_sent?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_quantity?: Maybe<Scalars['numeric']['output']>;
  type: Project_Interview_Data_Type_Enum;
};


/** columns and relationships of "project_interview_data" */
export type Project_Interview_DataDurationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_interview_data" */
export type Project_Interview_DataMonthsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_interview_data" */
export type Project_Interview_DataOther_UsesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_interview_data" */
export type Project_Interview_Data_Aggregate = {
  __typename?: 'project_interview_data_aggregate';
  aggregate?: Maybe<Project_Interview_Data_Aggregate_Fields>;
  nodes: Array<Project_Interview_Data>;
};

export type Project_Interview_Data_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Data_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Interview_Data_Select_Column_Project_Interview_Data_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Data_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Interview_Data_Select_Column_Project_Interview_Data_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_data" */
export type Project_Interview_Data_Aggregate_Fields = {
  __typename?: 'project_interview_data_aggregate_fields';
  avg?: Maybe<Project_Interview_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Data_Max_Fields>;
  min?: Maybe<Project_Interview_Data_Min_Fields>;
  stddev?: Maybe<Project_Interview_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Data_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Data_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Data_Variance_Fields>;
};


/** aggregate fields of "project_interview_data" */
export type Project_Interview_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_data" */
export type Project_Interview_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Data_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Data_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Data_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Data_Append_Input = {
  duration?: InputMaybe<Scalars['jsonb']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "project_interview_data" */
export type Project_Interview_Data_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Data_Avg_Fields = {
  __typename?: 'project_interview_data_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_data" */
export type Project_Interview_Data_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_data". All fields are combined with a logical 'AND'. */
export type Project_Interview_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Data_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Data_Bool_Exp>>;
  activity?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  crop_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Jsonb_Comparison_Exp>;
  food_amount?: InputMaybe<Numeric_Comparison_Exp>;
  food_term?: InputMaybe<Term_Bool_Exp>;
  food_term_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_area_based?: InputMaybe<Boolean_Comparison_Exp>;
  is_expenditure?: InputMaybe<Boolean_Comparison_Exp>;
  is_food?: InputMaybe<Boolean_Comparison_Exp>;
  is_payment_person?: InputMaybe<Boolean_Comparison_Exp>;
  is_resold?: InputMaybe<Boolean_Comparison_Exp>;
  is_school?: InputMaybe<Boolean_Comparison_Exp>;
  livestock_id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  meals_included?: InputMaybe<Boolean_Comparison_Exp>;
  months?: InputMaybe<Jsonb_Comparison_Exp>;
  number_children?: InputMaybe<Numeric_Comparison_Exp>;
  other_uses?: InputMaybe<Jsonb_Comparison_Exp>;
  payment?: InputMaybe<Numeric_Comparison_Exp>;
  payment_nr_times?: InputMaybe<Numeric_Comparison_Exp>;
  people?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  profit_by_person?: InputMaybe<Numeric_Comparison_Exp>;
  profit_per_unit?: InputMaybe<Numeric_Comparison_Exp>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  project_interview_crop?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
  project_interview_data_type?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
  project_interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview_livestock?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_unit?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_unit_id?: InputMaybe<Uuid_Comparison_Exp>;
  sold_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  sold_unit?: InputMaybe<Numeric_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
  times_money_sent?: InputMaybe<Numeric_Comparison_Exp>;
  total_cash_income?: InputMaybe<Numeric_Comparison_Exp>;
  total_expenses?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Project_Interview_Data_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_data" */
export enum Project_Interview_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewDataPkey = 'project_interview_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Interview_Data_Delete_At_Path_Input = {
  duration?: InputMaybe<Array<Scalars['String']['input']>>;
  months?: InputMaybe<Array<Scalars['String']['input']>>;
  other_uses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Interview_Data_Delete_Elem_Input = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  other_uses?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Interview_Data_Delete_Key_Input = {
  duration?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['String']['input']>;
  other_uses?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_interview_data" */
export type Project_Interview_Data_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  food_amount?: InputMaybe<Scalars['numeric']['input']>;
  number_children?: InputMaybe<Scalars['numeric']['input']>;
  payment?: InputMaybe<Scalars['numeric']['input']>;
  payment_nr_times?: InputMaybe<Scalars['numeric']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profit_by_person?: InputMaybe<Scalars['numeric']['input']>;
  profit_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit?: InputMaybe<Scalars['numeric']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit?: InputMaybe<Scalars['numeric']['input']>;
  times_money_sent?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_data" */
export type Project_Interview_Data_Insert_Input = {
  activity?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  crop_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['jsonb']['input']>;
  food_amount?: InputMaybe<Scalars['numeric']['input']>;
  food_term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  food_term_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_area_based?: InputMaybe<Scalars['Boolean']['input']>;
  is_expenditure?: InputMaybe<Scalars['Boolean']['input']>;
  is_food?: InputMaybe<Scalars['Boolean']['input']>;
  is_payment_person?: InputMaybe<Scalars['Boolean']['input']>;
  is_resold?: InputMaybe<Scalars['Boolean']['input']>;
  is_school?: InputMaybe<Scalars['Boolean']['input']>;
  livestock_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meals_included?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  number_children?: InputMaybe<Scalars['numeric']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  payment?: InputMaybe<Scalars['numeric']['input']>;
  payment_nr_times?: InputMaybe<Scalars['numeric']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profit_by_person?: InputMaybe<Scalars['numeric']['input']>;
  profit_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Obj_Rel_Insert_Input>;
  project_interview_crop?: InputMaybe<Project_Interview_Crops_Season_Obj_Rel_Insert_Input>;
  project_interview_data_type?: InputMaybe<Project_Interview_Data_Type_Obj_Rel_Insert_Input>;
  project_interview_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview_livestock?: InputMaybe<Project_Interview_Livestock_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit_id?: InputMaybe<Scalars['uuid']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit?: InputMaybe<Scalars['numeric']['input']>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  times_money_sent?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Project_Interview_Data_Type_Enum>;
};

/** aggregate max on columns */
export type Project_Interview_Data_Max_Fields = {
  __typename?: 'project_interview_data_max_fields';
  activity?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  crop_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  food_amount?: Maybe<Scalars['numeric']['output']>;
  food_term_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  livestock_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  number_children?: Maybe<Scalars['numeric']['output']>;
  payment?: Maybe<Scalars['numeric']['output']>;
  payment_nr_times?: Maybe<Scalars['numeric']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  profit_by_person?: Maybe<Scalars['numeric']['output']>;
  profit_per_unit?: Maybe<Scalars['numeric']['output']>;
  project_interview_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_unit?: Maybe<Scalars['numeric']['output']>;
  quantity_unit_id?: Maybe<Scalars['uuid']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit?: Maybe<Scalars['numeric']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  times_money_sent?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_interview_data" */
export type Project_Interview_Data_Max_Order_By = {
  activity?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  food_term_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livestock_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  project_interview_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Data_Min_Fields = {
  __typename?: 'project_interview_data_min_fields';
  activity?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  crop_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  food_amount?: Maybe<Scalars['numeric']['output']>;
  food_term_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  livestock_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  number_children?: Maybe<Scalars['numeric']['output']>;
  payment?: Maybe<Scalars['numeric']['output']>;
  payment_nr_times?: Maybe<Scalars['numeric']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  profit_by_person?: Maybe<Scalars['numeric']['output']>;
  profit_per_unit?: Maybe<Scalars['numeric']['output']>;
  project_interview_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_unit?: Maybe<Scalars['numeric']['output']>;
  quantity_unit_id?: Maybe<Scalars['uuid']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit?: Maybe<Scalars['numeric']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
  times_money_sent?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_interview_data" */
export type Project_Interview_Data_Min_Order_By = {
  activity?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  food_term_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livestock_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  project_interview_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_data" */
export type Project_Interview_Data_Mutation_Response = {
  __typename?: 'project_interview_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Data>;
};

/** on_conflict condition type for table "project_interview_data" */
export type Project_Interview_Data_On_Conflict = {
  constraint: Project_Interview_Data_Constraint;
  update_columns?: Array<Project_Interview_Data_Update_Column>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_data". */
export type Project_Interview_Data_Order_By = {
  activity?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  food_term?: InputMaybe<Term_Order_By>;
  food_term_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_area_based?: InputMaybe<Order_By>;
  is_expenditure?: InputMaybe<Order_By>;
  is_food?: InputMaybe<Order_By>;
  is_payment_person?: InputMaybe<Order_By>;
  is_resold?: InputMaybe<Order_By>;
  is_school?: InputMaybe<Order_By>;
  livestock_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  meals_included?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  other_uses?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Order_By>;
  project_interview_crop?: InputMaybe<Project_Interview_Crops_Season_Order_By>;
  project_interview_data_type?: InputMaybe<Project_Interview_Data_Type_Order_By>;
  project_interview_id?: InputMaybe<Order_By>;
  project_interview_livestock?: InputMaybe<Project_Interview_Livestock_Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_id?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_data */
export type Project_Interview_Data_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Interview_Data_Prepend_Input = {
  duration?: InputMaybe<Scalars['jsonb']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_interview_data" */
export enum Project_Interview_Data_Select_Column {
  /** column name */
  Activity = 'activity',
  /** column name */
  Amount = 'amount',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  FoodAmount = 'food_amount',
  /** column name */
  FoodTermId = 'food_term_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAreaBased = 'is_area_based',
  /** column name */
  IsExpenditure = 'is_expenditure',
  /** column name */
  IsFood = 'is_food',
  /** column name */
  IsPaymentPerson = 'is_payment_person',
  /** column name */
  IsResold = 'is_resold',
  /** column name */
  IsSchool = 'is_school',
  /** column name */
  LivestockId = 'livestock_id',
  /** column name */
  Location = 'location',
  /** column name */
  MealsIncluded = 'meals_included',
  /** column name */
  Months = 'months',
  /** column name */
  NumberChildren = 'number_children',
  /** column name */
  OtherUses = 'other_uses',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentNrTimes = 'payment_nr_times',
  /** column name */
  People = 'people',
  /** column name */
  Price = 'price',
  /** column name */
  ProfitByPerson = 'profit_by_person',
  /** column name */
  ProfitPerUnit = 'profit_per_unit',
  /** column name */
  ProjectInterviewId = 'project_interview_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnit = 'quantity_unit',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SoldQuantity = 'sold_quantity',
  /** column name */
  SoldUnit = 'sold_unit',
  /** column name */
  TermId = 'term_id',
  /** column name */
  TimesMoneySent = 'times_money_sent',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalExpenses = 'total_expenses',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  Type = 'type'
}

/** select "project_interview_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_interview_data" */
export enum Project_Interview_Data_Select_Column_Project_Interview_Data_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAreaBased = 'is_area_based',
  /** column name */
  IsExpenditure = 'is_expenditure',
  /** column name */
  IsFood = 'is_food',
  /** column name */
  IsPaymentPerson = 'is_payment_person',
  /** column name */
  IsResold = 'is_resold',
  /** column name */
  IsSchool = 'is_school',
  /** column name */
  MealsIncluded = 'meals_included'
}

/** select "project_interview_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_interview_data" */
export enum Project_Interview_Data_Select_Column_Project_Interview_Data_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAreaBased = 'is_area_based',
  /** column name */
  IsExpenditure = 'is_expenditure',
  /** column name */
  IsFood = 'is_food',
  /** column name */
  IsPaymentPerson = 'is_payment_person',
  /** column name */
  IsResold = 'is_resold',
  /** column name */
  IsSchool = 'is_school',
  /** column name */
  MealsIncluded = 'meals_included'
}

/** input type for updating data in table "project_interview_data" */
export type Project_Interview_Data_Set_Input = {
  activity?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  crop_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['jsonb']['input']>;
  food_amount?: InputMaybe<Scalars['numeric']['input']>;
  food_term_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_area_based?: InputMaybe<Scalars['Boolean']['input']>;
  is_expenditure?: InputMaybe<Scalars['Boolean']['input']>;
  is_food?: InputMaybe<Scalars['Boolean']['input']>;
  is_payment_person?: InputMaybe<Scalars['Boolean']['input']>;
  is_resold?: InputMaybe<Scalars['Boolean']['input']>;
  is_school?: InputMaybe<Scalars['Boolean']['input']>;
  livestock_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meals_included?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  number_children?: InputMaybe<Scalars['numeric']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  payment?: InputMaybe<Scalars['numeric']['input']>;
  payment_nr_times?: InputMaybe<Scalars['numeric']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profit_by_person?: InputMaybe<Scalars['numeric']['input']>;
  profit_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  project_interview_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit_id?: InputMaybe<Scalars['uuid']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit?: InputMaybe<Scalars['numeric']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  times_money_sent?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Project_Interview_Data_Type_Enum>;
};

/** aggregate stddev on columns */
export type Project_Interview_Data_Stddev_Fields = {
  __typename?: 'project_interview_data_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_data" */
export type Project_Interview_Data_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Data_Stddev_Pop_Fields = {
  __typename?: 'project_interview_data_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_data" */
export type Project_Interview_Data_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Data_Stddev_Samp_Fields = {
  __typename?: 'project_interview_data_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_data" */
export type Project_Interview_Data_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_data" */
export type Project_Interview_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Data_Stream_Cursor_Value_Input = {
  activity?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  crop_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['jsonb']['input']>;
  food_amount?: InputMaybe<Scalars['numeric']['input']>;
  food_term_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_area_based?: InputMaybe<Scalars['Boolean']['input']>;
  is_expenditure?: InputMaybe<Scalars['Boolean']['input']>;
  is_food?: InputMaybe<Scalars['Boolean']['input']>;
  is_payment_person?: InputMaybe<Scalars['Boolean']['input']>;
  is_resold?: InputMaybe<Scalars['Boolean']['input']>;
  is_school?: InputMaybe<Scalars['Boolean']['input']>;
  livestock_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meals_included?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Scalars['jsonb']['input']>;
  number_children?: InputMaybe<Scalars['numeric']['input']>;
  other_uses?: InputMaybe<Scalars['jsonb']['input']>;
  payment?: InputMaybe<Scalars['numeric']['input']>;
  payment_nr_times?: InputMaybe<Scalars['numeric']['input']>;
  people?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  profit_by_person?: InputMaybe<Scalars['numeric']['input']>;
  profit_per_unit?: InputMaybe<Scalars['numeric']['input']>;
  project_interview_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit?: InputMaybe<Scalars['numeric']['input']>;
  quantity_unit_id?: InputMaybe<Scalars['uuid']['input']>;
  sold_quantity?: InputMaybe<Scalars['numeric']['input']>;
  sold_unit?: InputMaybe<Scalars['numeric']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
  times_money_sent?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Project_Interview_Data_Type_Enum>;
};

/** aggregate sum on columns */
export type Project_Interview_Data_Sum_Fields = {
  __typename?: 'project_interview_data_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  food_amount?: Maybe<Scalars['numeric']['output']>;
  number_children?: Maybe<Scalars['numeric']['output']>;
  payment?: Maybe<Scalars['numeric']['output']>;
  payment_nr_times?: Maybe<Scalars['numeric']['output']>;
  people?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  profit_by_person?: Maybe<Scalars['numeric']['output']>;
  profit_per_unit?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_unit?: Maybe<Scalars['numeric']['output']>;
  sold_quantity?: Maybe<Scalars['numeric']['output']>;
  sold_unit?: Maybe<Scalars['numeric']['output']>;
  times_money_sent?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_expenses?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_data" */
export type Project_Interview_Data_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_interview_data_type" */
export type Project_Interview_Data_Type = {
  __typename?: 'project_interview_data_type';
  name: Scalars['String']['output'];
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
};


/** columns and relationships of "project_interview_data_type" */
export type Project_Interview_Data_TypeProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "project_interview_data_type" */
export type Project_Interview_Data_TypeProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};

/** aggregated selection of "project_interview_data_type" */
export type Project_Interview_Data_Type_Aggregate = {
  __typename?: 'project_interview_data_type_aggregate';
  aggregate?: Maybe<Project_Interview_Data_Type_Aggregate_Fields>;
  nodes: Array<Project_Interview_Data_Type>;
};

/** aggregate fields of "project_interview_data_type" */
export type Project_Interview_Data_Type_Aggregate_Fields = {
  __typename?: 'project_interview_data_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Data_Type_Max_Fields>;
  min?: Maybe<Project_Interview_Data_Type_Min_Fields>;
};


/** aggregate fields of "project_interview_data_type" */
export type Project_Interview_Data_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Data_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_interview_data_type". All fields are combined with a logical 'AND'. */
export type Project_Interview_Data_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Data_Type_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Data_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "project_interview_data_type" */
export enum Project_Interview_Data_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProjectInterviewDataTypePkey = 'project_interview_data_type_pkey'
}

export enum Project_Interview_Data_Type_Enum {
  CropsExpenditure = 'CROPS_EXPENDITURE',
  Employment = 'EMPLOYMENT',
  ExpenditureFood = 'EXPENDITURE_FOOD',
  ExpenditureNonFood = 'EXPENDITURE_NON_FOOD',
  FishingWildFood = 'FISHING_WILD_FOOD',
  FishingWildFoodExpenses = 'FISHING_WILD_FOOD_EXPENSES',
  FoodAid = 'FOOD_AID',
  LabourExchange = 'LABOUR_EXCHANGE',
  LivestockExchanged = 'LIVESTOCK_EXCHANGED',
  LivestockExpenditure = 'LIVESTOCK_EXPENDITURE',
  LivestockGivenAway = 'LIVESTOCK_GIVEN_AWAY',
  LivestockSale = 'LIVESTOCK_SALE',
  Migration = 'MIGRATION',
  RemittancesCredit = 'REMITTANCES_CREDIT',
  SelfEmployment = 'SELF_EMPLOYMENT'
}

/** Boolean expression to compare columns of type "project_interview_data_type_enum". All fields are combined with logical 'AND'. */
export type Project_Interview_Data_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Interview_Data_Type_Enum>;
  _in?: InputMaybe<Array<Project_Interview_Data_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Interview_Data_Type_Enum>;
  _nin?: InputMaybe<Array<Project_Interview_Data_Type_Enum>>;
};

/** input type for inserting data into table "project_interview_data_type" */
export type Project_Interview_Data_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Interview_Data_Type_Max_Fields = {
  __typename?: 'project_interview_data_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Interview_Data_Type_Min_Fields = {
  __typename?: 'project_interview_data_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_interview_data_type" */
export type Project_Interview_Data_Type_Mutation_Response = {
  __typename?: 'project_interview_data_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Data_Type>;
};

/** input type for inserting object relation for remote table "project_interview_data_type" */
export type Project_Interview_Data_Type_Obj_Rel_Insert_Input = {
  data: Project_Interview_Data_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Data_Type_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_data_type" */
export type Project_Interview_Data_Type_On_Conflict = {
  constraint: Project_Interview_Data_Type_Constraint;
  update_columns?: Array<Project_Interview_Data_Type_Update_Column>;
  where?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_data_type". */
export type Project_Interview_Data_Type_Order_By = {
  name?: InputMaybe<Order_By>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
};

/** primary key columns input for table: project_interview_data_type */
export type Project_Interview_Data_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "project_interview_data_type" */
export enum Project_Interview_Data_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "project_interview_data_type" */
export type Project_Interview_Data_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_interview_data_type" */
export type Project_Interview_Data_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Data_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Data_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_interview_data_type" */
export enum Project_Interview_Data_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Project_Interview_Data_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Data_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Data_Type_Bool_Exp;
};

/** update columns of table "project_interview_data" */
export enum Project_Interview_Data_Update_Column {
  /** column name */
  Activity = 'activity',
  /** column name */
  Amount = 'amount',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  FoodAmount = 'food_amount',
  /** column name */
  FoodTermId = 'food_term_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAreaBased = 'is_area_based',
  /** column name */
  IsExpenditure = 'is_expenditure',
  /** column name */
  IsFood = 'is_food',
  /** column name */
  IsPaymentPerson = 'is_payment_person',
  /** column name */
  IsResold = 'is_resold',
  /** column name */
  IsSchool = 'is_school',
  /** column name */
  LivestockId = 'livestock_id',
  /** column name */
  Location = 'location',
  /** column name */
  MealsIncluded = 'meals_included',
  /** column name */
  Months = 'months',
  /** column name */
  NumberChildren = 'number_children',
  /** column name */
  OtherUses = 'other_uses',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentNrTimes = 'payment_nr_times',
  /** column name */
  People = 'people',
  /** column name */
  Price = 'price',
  /** column name */
  ProfitByPerson = 'profit_by_person',
  /** column name */
  ProfitPerUnit = 'profit_per_unit',
  /** column name */
  ProjectInterviewId = 'project_interview_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnit = 'quantity_unit',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  SoldQuantity = 'sold_quantity',
  /** column name */
  SoldUnit = 'sold_unit',
  /** column name */
  TermId = 'term_id',
  /** column name */
  TimesMoneySent = 'times_money_sent',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalExpenses = 'total_expenses',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  Type = 'type'
}

export type Project_Interview_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Interview_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Interview_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Interview_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Interview_Data_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Data_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Interview_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Data_Var_Pop_Fields = {
  __typename?: 'project_interview_data_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_data" */
export type Project_Interview_Data_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Data_Var_Samp_Fields = {
  __typename?: 'project_interview_data_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_data" */
export type Project_Interview_Data_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Data_Variance_Fields = {
  __typename?: 'project_interview_data_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  food_amount?: Maybe<Scalars['Float']['output']>;
  number_children?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_nr_times?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  profit_by_person?: Maybe<Scalars['Float']['output']>;
  profit_per_unit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_unit?: Maybe<Scalars['Float']['output']>;
  sold_quantity?: Maybe<Scalars['Float']['output']>;
  sold_unit?: Maybe<Scalars['Float']['output']>;
  times_money_sent?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_expenses?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_data" */
export type Project_Interview_Data_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  food_amount?: InputMaybe<Order_By>;
  number_children?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  payment_nr_times?: InputMaybe<Order_By>;
  people?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profit_by_person?: InputMaybe<Order_By>;
  profit_per_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Order_By>;
  sold_quantity?: InputMaybe<Order_By>;
  sold_unit?: InputMaybe<Order_By>;
  times_money_sent?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_expenses?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_interview_file" */
export type Project_Interview_File = {
  __typename?: 'project_interview_file';
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_interview: Project_Interview;
};

/** aggregated selection of "project_interview_file" */
export type Project_Interview_File_Aggregate = {
  __typename?: 'project_interview_file_aggregate';
  aggregate?: Maybe<Project_Interview_File_Aggregate_Fields>;
  nodes: Array<Project_Interview_File>;
};

export type Project_Interview_File_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_File_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_file" */
export type Project_Interview_File_Aggregate_Fields = {
  __typename?: 'project_interview_file_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_File_Max_Fields>;
  min?: Maybe<Project_Interview_File_Min_Fields>;
};


/** aggregate fields of "project_interview_file" */
export type Project_Interview_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_file" */
export type Project_Interview_File_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_File_Max_Order_By>;
  min?: InputMaybe<Project_Interview_File_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_file" */
export type Project_Interview_File_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_File_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_interview_file". All fields are combined with a logical 'AND'. */
export type Project_Interview_File_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_File_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_File_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_File_Bool_Exp>>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview?: InputMaybe<Project_Interview_Bool_Exp>;
};

/** unique or primary key constraints on table "project_interview_file" */
export enum Project_Interview_File_Constraint {
  /** unique or primary key constraint on columns "file_id", "interview_id" */
  ProjectInterviewFilePkey = 'project_interview_file_pkey'
}

/** input type for inserting data into table "project_interview_file" */
export type Project_Interview_File_Insert_Input = {
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview?: InputMaybe<Project_Interview_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Interview_File_Max_Fields = {
  __typename?: 'project_interview_file_max_fields';
  file_id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_interview_file" */
export type Project_Interview_File_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_File_Min_Fields = {
  __typename?: 'project_interview_file_min_fields';
  file_id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_interview_file" */
export type Project_Interview_File_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_file" */
export type Project_Interview_File_Mutation_Response = {
  __typename?: 'project_interview_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_File>;
};

/** on_conflict condition type for table "project_interview_file" */
export type Project_Interview_File_On_Conflict = {
  constraint: Project_Interview_File_Constraint;
  update_columns?: Array<Project_Interview_File_Update_Column>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_file". */
export type Project_Interview_File_Order_By = {
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  project_interview?: InputMaybe<Project_Interview_Order_By>;
};

/** primary key columns input for table: project_interview_file */
export type Project_Interview_File_Pk_Columns_Input = {
  file_id: Scalars['uuid']['input'];
  interview_id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_file" */
export enum Project_Interview_File_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  InterviewId = 'interview_id'
}

/** input type for updating data in table "project_interview_file" */
export type Project_Interview_File_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_interview_file" */
export type Project_Interview_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_File_Stream_Cursor_Value_Input = {
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_interview_file" */
export enum Project_Interview_File_Update_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  InterviewId = 'interview_id'
}

export type Project_Interview_File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_File_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_File_Bool_Exp;
};

/** input type for inserting data into table "project_interview" */
export type Project_Interview_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview_backups?: InputMaybe<Project_Interview_Backup_Arr_Rel_Insert_Input>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Obj_Rel_Insert_Input>;
  project_interview_files?: InputMaybe<Project_Interview_File_Arr_Rel_Insert_Input>;
  project_interview_notes?: InputMaybe<Project_Interview_Note_Arr_Rel_Insert_Input>;
  project_interview_researcher_mns?: InputMaybe<Project_Interview_Researcher_Mn_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Status_Enum>;
  statusByStatus?: InputMaybe<Status_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wealth_group?: InputMaybe<Wealth_Group_Obj_Rel_Insert_Input>;
  wealth_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "project_interview_livestock" */
export type Project_Interview_Livestock = {
  __typename?: 'project_interview_livestock';
  animals_other?: Maybe<Scalars['numeric']['output']>;
  balance_consumed?: Maybe<Scalars['numeric']['output']>;
  breeding_female?: Maybe<Scalars['numeric']['output']>;
  given_away_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  is_exchanged_resold?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  livestock_type: Livestock_Type;
  losses_death?: Maybe<Scalars['numeric']['output']>;
  losses_reason?: Maybe<Scalars['String']['output']>;
  meat_per_carcass?: Maybe<Scalars['numeric']['output']>;
  meat_price_per_kg?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_sold?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  new_birth?: Maybe<Scalars['numeric']['output']>;
  new_birth_secondary?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  off_peak_milk?: Maybe<Project_Interview_Livestock_Milk>;
  /** An object relationship */
  off_peak_milk_secondary?: Maybe<Project_Interview_Livestock_Milk>;
  /** An object relationship */
  peak_milk?: Maybe<Project_Interview_Livestock_Milk>;
  /** An object relationship */
  peak_milk_secondary?: Maybe<Project_Interview_Livestock_Milk>;
  /** An object relationship */
  project_interview_base: Project_Interview_Base;
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
  slaughtered?: Maybe<Scalars['numeric']['output']>;
  total_bartered_calories?: Maybe<Scalars['numeric']['output']>;
  total_calories?: Maybe<Scalars['numeric']['output']>;
  total_cash_expenses?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_cash_income_milk?: Maybe<Scalars['numeric']['output']>;
  total_eggs_consumed?: Maybe<Scalars['numeric']['output']>;
  total_end?: Maybe<Scalars['numeric']['output']>;
  total_exchanged?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_purchases?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
  total_start?: Maybe<Scalars['numeric']['output']>;
  type: Livestock_Type_Enum;
};


/** columns and relationships of "project_interview_livestock" */
export type Project_Interview_LivestockProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "project_interview_livestock" */
export type Project_Interview_LivestockProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};

/** aggregated selection of "project_interview_livestock" */
export type Project_Interview_Livestock_Aggregate = {
  __typename?: 'project_interview_livestock_aggregate';
  aggregate?: Maybe<Project_Interview_Livestock_Aggregate_Fields>;
  nodes: Array<Project_Interview_Livestock>;
};

export type Project_Interview_Livestock_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Interview_Livestock_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Interview_Livestock_Select_Column_Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Interview_Livestock_Select_Column_Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Livestock_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_livestock" */
export type Project_Interview_Livestock_Aggregate_Fields = {
  __typename?: 'project_interview_livestock_aggregate_fields';
  avg?: Maybe<Project_Interview_Livestock_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Livestock_Max_Fields>;
  min?: Maybe<Project_Interview_Livestock_Min_Fields>;
  stddev?: Maybe<Project_Interview_Livestock_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Livestock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Livestock_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Livestock_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Livestock_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Livestock_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Livestock_Variance_Fields>;
};


/** aggregate fields of "project_interview_livestock" */
export type Project_Interview_Livestock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_livestock" */
export type Project_Interview_Livestock_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Livestock_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Livestock_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Livestock_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Livestock_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Livestock_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Livestock_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Livestock_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Livestock_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Livestock_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Livestock_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_livestock" */
export type Project_Interview_Livestock_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Livestock_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Livestock_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Livestock_Avg_Fields = {
  __typename?: 'project_interview_livestock_avg_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Avg_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_livestock". All fields are combined with a logical 'AND'. */
export type Project_Interview_Livestock_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Livestock_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Livestock_Bool_Exp>>;
  animals_other?: InputMaybe<Numeric_Comparison_Exp>;
  balance_consumed?: InputMaybe<Numeric_Comparison_Exp>;
  breeding_female?: InputMaybe<Numeric_Comparison_Exp>;
  given_away_reason?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_exchanged_resold?: InputMaybe<Boolean_Comparison_Exp>;
  livestock_type?: InputMaybe<Livestock_Type_Bool_Exp>;
  losses_death?: InputMaybe<Numeric_Comparison_Exp>;
  losses_reason?: InputMaybe<String_Comparison_Exp>;
  meat_per_carcass?: InputMaybe<Numeric_Comparison_Exp>;
  meat_price_per_kg?: InputMaybe<Numeric_Comparison_Exp>;
  meat_quantity_given_away?: InputMaybe<Numeric_Comparison_Exp>;
  meat_quantity_sold?: InputMaybe<Numeric_Comparison_Exp>;
  milked_female?: InputMaybe<Numeric_Comparison_Exp>;
  new_birth?: InputMaybe<Numeric_Comparison_Exp>;
  new_birth_secondary?: InputMaybe<Numeric_Comparison_Exp>;
  off_peak_milk?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  off_peak_milk_secondary?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  peak_milk?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  peak_milk_secondary?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
  slaughtered?: InputMaybe<Numeric_Comparison_Exp>;
  total_bartered_calories?: InputMaybe<Numeric_Comparison_Exp>;
  total_calories?: InputMaybe<Numeric_Comparison_Exp>;
  total_cash_expenses?: InputMaybe<Numeric_Comparison_Exp>;
  total_cash_income?: InputMaybe<Numeric_Comparison_Exp>;
  total_cash_income_milk?: InputMaybe<Numeric_Comparison_Exp>;
  total_eggs_consumed?: InputMaybe<Numeric_Comparison_Exp>;
  total_end?: InputMaybe<Numeric_Comparison_Exp>;
  total_exchanged?: InputMaybe<Numeric_Comparison_Exp>;
  total_given_away?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Numeric_Comparison_Exp>;
  total_off_peak_milk_calories?: InputMaybe<Numeric_Comparison_Exp>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Numeric_Comparison_Exp>;
  total_peak_milk_calories?: InputMaybe<Numeric_Comparison_Exp>;
  total_peak_milk_exchanged_calories?: InputMaybe<Numeric_Comparison_Exp>;
  total_purchases?: InputMaybe<Numeric_Comparison_Exp>;
  total_sold?: InputMaybe<Numeric_Comparison_Exp>;
  total_start?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Livestock_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_livestock" */
export enum Project_Interview_Livestock_Constraint {
  /** unique or primary key constraint on columns "type", "interview_id" */
  ProjectInterviewLivestockInterviewIdTypeKey = 'project_interview_livestock_interview_id_type_key',
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewLivestockPkey = 'project_interview_livestock_pkey'
}

/** input type for incrementing numeric columns in table "project_interview_livestock" */
export type Project_Interview_Livestock_Inc_Input = {
  animals_other?: InputMaybe<Scalars['numeric']['input']>;
  balance_consumed?: InputMaybe<Scalars['numeric']['input']>;
  breeding_female?: InputMaybe<Scalars['numeric']['input']>;
  losses_death?: InputMaybe<Scalars['numeric']['input']>;
  meat_per_carcass?: InputMaybe<Scalars['numeric']['input']>;
  meat_price_per_kg?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_sold?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  new_birth?: InputMaybe<Scalars['numeric']['input']>;
  new_birth_secondary?: InputMaybe<Scalars['numeric']['input']>;
  slaughtered?: InputMaybe<Scalars['numeric']['input']>;
  total_bartered_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income_milk?: InputMaybe<Scalars['numeric']['input']>;
  total_eggs_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_end?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_purchases?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  total_start?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_livestock" */
export type Project_Interview_Livestock_Insert_Input = {
  animals_other?: InputMaybe<Scalars['numeric']['input']>;
  balance_consumed?: InputMaybe<Scalars['numeric']['input']>;
  breeding_female?: InputMaybe<Scalars['numeric']['input']>;
  given_away_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  is_exchanged_resold?: InputMaybe<Scalars['Boolean']['input']>;
  livestock_type?: InputMaybe<Livestock_Type_Obj_Rel_Insert_Input>;
  losses_death?: InputMaybe<Scalars['numeric']['input']>;
  losses_reason?: InputMaybe<Scalars['String']['input']>;
  meat_per_carcass?: InputMaybe<Scalars['numeric']['input']>;
  meat_price_per_kg?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_sold?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  new_birth?: InputMaybe<Scalars['numeric']['input']>;
  new_birth_secondary?: InputMaybe<Scalars['numeric']['input']>;
  off_peak_milk?: InputMaybe<Project_Interview_Livestock_Milk_Obj_Rel_Insert_Input>;
  off_peak_milk_secondary?: InputMaybe<Project_Interview_Livestock_Milk_Obj_Rel_Insert_Input>;
  peak_milk?: InputMaybe<Project_Interview_Livestock_Milk_Obj_Rel_Insert_Input>;
  peak_milk_secondary?: InputMaybe<Project_Interview_Livestock_Milk_Obj_Rel_Insert_Input>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Obj_Rel_Insert_Input>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Arr_Rel_Insert_Input>;
  slaughtered?: InputMaybe<Scalars['numeric']['input']>;
  total_bartered_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income_milk?: InputMaybe<Scalars['numeric']['input']>;
  total_eggs_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_end?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_purchases?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  total_start?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Livestock_Type_Enum>;
};

/** aggregate max on columns */
export type Project_Interview_Livestock_Max_Fields = {
  __typename?: 'project_interview_livestock_max_fields';
  animals_other?: Maybe<Scalars['numeric']['output']>;
  balance_consumed?: Maybe<Scalars['numeric']['output']>;
  breeding_female?: Maybe<Scalars['numeric']['output']>;
  given_away_reason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  losses_death?: Maybe<Scalars['numeric']['output']>;
  losses_reason?: Maybe<Scalars['String']['output']>;
  meat_per_carcass?: Maybe<Scalars['numeric']['output']>;
  meat_price_per_kg?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_sold?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  new_birth?: Maybe<Scalars['numeric']['output']>;
  new_birth_secondary?: Maybe<Scalars['numeric']['output']>;
  slaughtered?: Maybe<Scalars['numeric']['output']>;
  total_bartered_calories?: Maybe<Scalars['numeric']['output']>;
  total_calories?: Maybe<Scalars['numeric']['output']>;
  total_cash_expenses?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_cash_income_milk?: Maybe<Scalars['numeric']['output']>;
  total_eggs_consumed?: Maybe<Scalars['numeric']['output']>;
  total_end?: Maybe<Scalars['numeric']['output']>;
  total_exchanged?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_purchases?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
  total_start?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Max_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  given_away_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  losses_reason?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk = {
  __typename?: 'project_interview_livestock_milk';
  consumes_skim?: Maybe<Scalars['Boolean']['output']>;
  days_milked?: Maybe<Scalars['numeric']['output']>;
  exchanged_cereal?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  livestock_off_peak?: Maybe<Project_Interview_Livestock>;
  livestock_off_peak_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  livestock_off_peak_secondary?: Maybe<Project_Interview_Livestock>;
  livestock_off_peak_secondary_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  livestock_peak?: Maybe<Project_Interview_Livestock>;
  livestock_peak_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  livestock_peak_secondary?: Maybe<Project_Interview_Livestock>;
  livestock_peak_secondary_id?: Maybe<Scalars['uuid']['output']>;
  measure_unit?: Maybe<Scalars['numeric']['output']>;
  measure_unit_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  measure_unit_rel?: Maybe<Measure_Unit>;
  milk_per_animal?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  month?: Maybe<Month>;
  peak_milk_month?: Maybe<Month_Enum>;
  price_per_litre?: Maybe<Scalars['numeric']['output']>;
  quantity_consumed_day?: Maybe<Scalars['numeric']['output']>;
  quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  sold_per_day?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Aggregate = {
  __typename?: 'project_interview_livestock_milk_aggregate';
  aggregate?: Maybe<Project_Interview_Livestock_Milk_Aggregate_Fields>;
  nodes: Array<Project_Interview_Livestock_Milk>;
};

export type Project_Interview_Livestock_Milk_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Interview_Livestock_Milk_Select_Column_Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Interview_Livestock_Milk_Select_Column_Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Aggregate_Fields = {
  __typename?: 'project_interview_livestock_milk_aggregate_fields';
  avg?: Maybe<Project_Interview_Livestock_Milk_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Livestock_Milk_Max_Fields>;
  min?: Maybe<Project_Interview_Livestock_Milk_Min_Fields>;
  stddev?: Maybe<Project_Interview_Livestock_Milk_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Livestock_Milk_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Livestock_Milk_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Livestock_Milk_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Livestock_Milk_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Livestock_Milk_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Livestock_Milk_Variance_Fields>;
};


/** aggregate fields of "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Livestock_Milk_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Livestock_Milk_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Livestock_Milk_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Livestock_Milk_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Livestock_Milk_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Livestock_Milk_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Livestock_Milk_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Livestock_Milk_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Livestock_Milk_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Livestock_Milk_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Livestock_Milk_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Livestock_Milk_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Livestock_Milk_Avg_Fields = {
  __typename?: 'project_interview_livestock_milk_avg_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Avg_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_livestock_milk". All fields are combined with a logical 'AND'. */
export type Project_Interview_Livestock_Milk_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Livestock_Milk_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Livestock_Milk_Bool_Exp>>;
  consumes_skim?: InputMaybe<Boolean_Comparison_Exp>;
  days_milked?: InputMaybe<Numeric_Comparison_Exp>;
  exchanged_cereal?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  livestock_off_peak?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  livestock_off_peak_id?: InputMaybe<Uuid_Comparison_Exp>;
  livestock_off_peak_secondary?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  livestock_off_peak_secondary_id?: InputMaybe<Uuid_Comparison_Exp>;
  livestock_peak?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  livestock_peak_id?: InputMaybe<Uuid_Comparison_Exp>;
  livestock_peak_secondary?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
  livestock_peak_secondary_id?: InputMaybe<Uuid_Comparison_Exp>;
  measure_unit?: InputMaybe<Numeric_Comparison_Exp>;
  measure_unit_id?: InputMaybe<Uuid_Comparison_Exp>;
  measure_unit_rel?: InputMaybe<Measure_Unit_Bool_Exp>;
  milk_per_animal?: InputMaybe<Numeric_Comparison_Exp>;
  milked_female?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<Month_Bool_Exp>;
  peak_milk_month?: InputMaybe<Month_Enum_Comparison_Exp>;
  price_per_litre?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_consumed_day?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_given_away?: InputMaybe<Numeric_Comparison_Exp>;
  sold_per_day?: InputMaybe<Numeric_Comparison_Exp>;
  total_cash_income?: InputMaybe<Numeric_Comparison_Exp>;
  total_consumed?: InputMaybe<Numeric_Comparison_Exp>;
  total_exchanged_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  total_kcal?: InputMaybe<Numeric_Comparison_Exp>;
  total_produced?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_livestock_milk" */
export enum Project_Interview_Livestock_Milk_Constraint {
  /** unique or primary key constraint on columns "livestock_off_peak_secondary_id" */
  ProjectInterviewLivestockMLivestockOffPeakSecondaaryKey = 'project_interview_livestock_m_livestock_off_peak_secondaary_key',
  /** unique or primary key constraint on columns "livestock_peak_secondary_id" */
  ProjectInterviewLivestockMilLivestockPeakSecondaryIdKey = 'project_interview_livestock_mil_livestock_peak_secondary_id_key',
  /** unique or primary key constraint on columns "livestock_off_peak_id" */
  ProjectInterviewLivestockMilkLivestockOffPeakIdKey = 'project_interview_livestock_milk_livestock_off_peak_id_key',
  /** unique or primary key constraint on columns "livestock_peak_id" */
  ProjectInterviewLivestockMilkLivestockPeakIdKey = 'project_interview_livestock_milk_livestock_peak_id_key',
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewLivestockMilkPkey = 'project_interview_livestock_milk_pkey'
}

/** input type for incrementing numeric columns in table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Inc_Input = {
  days_milked?: InputMaybe<Scalars['numeric']['input']>;
  exchanged_cereal?: InputMaybe<Scalars['numeric']['input']>;
  measure_unit?: InputMaybe<Scalars['numeric']['input']>;
  milk_per_animal?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  price_per_litre?: InputMaybe<Scalars['numeric']['input']>;
  quantity_consumed_day?: InputMaybe<Scalars['numeric']['input']>;
  quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  sold_per_day?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Insert_Input = {
  consumes_skim?: InputMaybe<Scalars['Boolean']['input']>;
  days_milked?: InputMaybe<Scalars['numeric']['input']>;
  exchanged_cereal?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_off_peak?: InputMaybe<Project_Interview_Livestock_Obj_Rel_Insert_Input>;
  livestock_off_peak_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_off_peak_secondary?: InputMaybe<Project_Interview_Livestock_Obj_Rel_Insert_Input>;
  livestock_off_peak_secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_peak?: InputMaybe<Project_Interview_Livestock_Obj_Rel_Insert_Input>;
  livestock_peak_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_peak_secondary?: InputMaybe<Project_Interview_Livestock_Obj_Rel_Insert_Input>;
  livestock_peak_secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  measure_unit?: InputMaybe<Scalars['numeric']['input']>;
  measure_unit_id?: InputMaybe<Scalars['uuid']['input']>;
  measure_unit_rel?: InputMaybe<Measure_Unit_Obj_Rel_Insert_Input>;
  milk_per_animal?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  month?: InputMaybe<Month_Obj_Rel_Insert_Input>;
  peak_milk_month?: InputMaybe<Month_Enum>;
  price_per_litre?: InputMaybe<Scalars['numeric']['input']>;
  quantity_consumed_day?: InputMaybe<Scalars['numeric']['input']>;
  quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  sold_per_day?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Livestock_Milk_Max_Fields = {
  __typename?: 'project_interview_livestock_milk_max_fields';
  days_milked?: Maybe<Scalars['numeric']['output']>;
  exchanged_cereal?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  livestock_off_peak_id?: Maybe<Scalars['uuid']['output']>;
  livestock_off_peak_secondary_id?: Maybe<Scalars['uuid']['output']>;
  livestock_peak_id?: Maybe<Scalars['uuid']['output']>;
  livestock_peak_secondary_id?: Maybe<Scalars['uuid']['output']>;
  measure_unit?: Maybe<Scalars['numeric']['output']>;
  measure_unit_id?: Maybe<Scalars['uuid']['output']>;
  milk_per_animal?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  price_per_litre?: Maybe<Scalars['numeric']['output']>;
  quantity_consumed_day?: Maybe<Scalars['numeric']['output']>;
  quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  sold_per_day?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Max_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livestock_off_peak_id?: InputMaybe<Order_By>;
  livestock_off_peak_secondary_id?: InputMaybe<Order_By>;
  livestock_peak_id?: InputMaybe<Order_By>;
  livestock_peak_secondary_id?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  measure_unit_id?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Livestock_Milk_Min_Fields = {
  __typename?: 'project_interview_livestock_milk_min_fields';
  days_milked?: Maybe<Scalars['numeric']['output']>;
  exchanged_cereal?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  livestock_off_peak_id?: Maybe<Scalars['uuid']['output']>;
  livestock_off_peak_secondary_id?: Maybe<Scalars['uuid']['output']>;
  livestock_peak_id?: Maybe<Scalars['uuid']['output']>;
  livestock_peak_secondary_id?: Maybe<Scalars['uuid']['output']>;
  measure_unit?: Maybe<Scalars['numeric']['output']>;
  measure_unit_id?: Maybe<Scalars['uuid']['output']>;
  milk_per_animal?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  price_per_litre?: Maybe<Scalars['numeric']['output']>;
  quantity_consumed_day?: Maybe<Scalars['numeric']['output']>;
  quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  sold_per_day?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Min_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livestock_off_peak_id?: InputMaybe<Order_By>;
  livestock_off_peak_secondary_id?: InputMaybe<Order_By>;
  livestock_peak_id?: InputMaybe<Order_By>;
  livestock_peak_secondary_id?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  measure_unit_id?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Mutation_Response = {
  __typename?: 'project_interview_livestock_milk_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Livestock_Milk>;
};

/** input type for inserting object relation for remote table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Obj_Rel_Insert_Input = {
  data: Project_Interview_Livestock_Milk_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Livestock_Milk_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_On_Conflict = {
  constraint: Project_Interview_Livestock_Milk_Constraint;
  update_columns?: Array<Project_Interview_Livestock_Milk_Update_Column>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_livestock_milk". */
export type Project_Interview_Livestock_Milk_Order_By = {
  consumes_skim?: InputMaybe<Order_By>;
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livestock_off_peak?: InputMaybe<Project_Interview_Livestock_Order_By>;
  livestock_off_peak_id?: InputMaybe<Order_By>;
  livestock_off_peak_secondary?: InputMaybe<Project_Interview_Livestock_Order_By>;
  livestock_off_peak_secondary_id?: InputMaybe<Order_By>;
  livestock_peak?: InputMaybe<Project_Interview_Livestock_Order_By>;
  livestock_peak_id?: InputMaybe<Order_By>;
  livestock_peak_secondary?: InputMaybe<Project_Interview_Livestock_Order_By>;
  livestock_peak_secondary_id?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  measure_unit_id?: InputMaybe<Order_By>;
  measure_unit_rel?: InputMaybe<Measure_Unit_Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  month?: InputMaybe<Month_Order_By>;
  peak_milk_month?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_livestock_milk */
export type Project_Interview_Livestock_Milk_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_livestock_milk" */
export enum Project_Interview_Livestock_Milk_Select_Column {
  /** column name */
  ConsumesSkim = 'consumes_skim',
  /** column name */
  DaysMilked = 'days_milked',
  /** column name */
  ExchangedCereal = 'exchanged_cereal',
  /** column name */
  Id = 'id',
  /** column name */
  LivestockOffPeakId = 'livestock_off_peak_id',
  /** column name */
  LivestockOffPeakSecondaryId = 'livestock_off_peak_secondary_id',
  /** column name */
  LivestockPeakId = 'livestock_peak_id',
  /** column name */
  LivestockPeakSecondaryId = 'livestock_peak_secondary_id',
  /** column name */
  MeasureUnit = 'measure_unit',
  /** column name */
  MeasureUnitId = 'measure_unit_id',
  /** column name */
  MilkPerAnimal = 'milk_per_animal',
  /** column name */
  MilkedFemale = 'milked_female',
  /** column name */
  PeakMilkMonth = 'peak_milk_month',
  /** column name */
  PricePerLitre = 'price_per_litre',
  /** column name */
  QuantityConsumedDay = 'quantity_consumed_day',
  /** column name */
  QuantityGivenAway = 'quantity_given_away',
  /** column name */
  SoldPerDay = 'sold_per_day',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalConsumed = 'total_consumed',
  /** column name */
  TotalExchangedKcal = 'total_exchanged_kcal',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalProduced = 'total_produced'
}

/** select "project_interview_livestock_milk_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_interview_livestock_milk" */
export enum Project_Interview_Livestock_Milk_Select_Column_Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ConsumesSkim = 'consumes_skim'
}

/** select "project_interview_livestock_milk_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_interview_livestock_milk" */
export enum Project_Interview_Livestock_Milk_Select_Column_Project_Interview_Livestock_Milk_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ConsumesSkim = 'consumes_skim'
}

/** input type for updating data in table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Set_Input = {
  consumes_skim?: InputMaybe<Scalars['Boolean']['input']>;
  days_milked?: InputMaybe<Scalars['numeric']['input']>;
  exchanged_cereal?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_off_peak_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_off_peak_secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_peak_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_peak_secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  measure_unit?: InputMaybe<Scalars['numeric']['input']>;
  measure_unit_id?: InputMaybe<Scalars['uuid']['input']>;
  milk_per_animal?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  peak_milk_month?: InputMaybe<Month_Enum>;
  price_per_litre?: InputMaybe<Scalars['numeric']['input']>;
  quantity_consumed_day?: InputMaybe<Scalars['numeric']['input']>;
  quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  sold_per_day?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Livestock_Milk_Stddev_Fields = {
  __typename?: 'project_interview_livestock_milk_stddev_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Stddev_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Livestock_Milk_Stddev_Pop_Fields = {
  __typename?: 'project_interview_livestock_milk_stddev_pop_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Stddev_Pop_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Livestock_Milk_Stddev_Samp_Fields = {
  __typename?: 'project_interview_livestock_milk_stddev_samp_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Stddev_Samp_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Livestock_Milk_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Livestock_Milk_Stream_Cursor_Value_Input = {
  consumes_skim?: InputMaybe<Scalars['Boolean']['input']>;
  days_milked?: InputMaybe<Scalars['numeric']['input']>;
  exchanged_cereal?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_off_peak_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_off_peak_secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_peak_id?: InputMaybe<Scalars['uuid']['input']>;
  livestock_peak_secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  measure_unit?: InputMaybe<Scalars['numeric']['input']>;
  measure_unit_id?: InputMaybe<Scalars['uuid']['input']>;
  milk_per_animal?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  peak_milk_month?: InputMaybe<Month_Enum>;
  price_per_litre?: InputMaybe<Scalars['numeric']['input']>;
  quantity_consumed_day?: InputMaybe<Scalars['numeric']['input']>;
  quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  sold_per_day?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal?: InputMaybe<Scalars['numeric']['input']>;
  total_produced?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Livestock_Milk_Sum_Fields = {
  __typename?: 'project_interview_livestock_milk_sum_fields';
  days_milked?: Maybe<Scalars['numeric']['output']>;
  exchanged_cereal?: Maybe<Scalars['numeric']['output']>;
  measure_unit?: Maybe<Scalars['numeric']['output']>;
  milk_per_animal?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  price_per_litre?: Maybe<Scalars['numeric']['output']>;
  quantity_consumed_day?: Maybe<Scalars['numeric']['output']>;
  quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  sold_per_day?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_consumed?: Maybe<Scalars['numeric']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['numeric']['output']>;
  total_kcal?: Maybe<Scalars['numeric']['output']>;
  total_produced?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Sum_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** update columns of table "project_interview_livestock_milk" */
export enum Project_Interview_Livestock_Milk_Update_Column {
  /** column name */
  ConsumesSkim = 'consumes_skim',
  /** column name */
  DaysMilked = 'days_milked',
  /** column name */
  ExchangedCereal = 'exchanged_cereal',
  /** column name */
  Id = 'id',
  /** column name */
  LivestockOffPeakId = 'livestock_off_peak_id',
  /** column name */
  LivestockOffPeakSecondaryId = 'livestock_off_peak_secondary_id',
  /** column name */
  LivestockPeakId = 'livestock_peak_id',
  /** column name */
  LivestockPeakSecondaryId = 'livestock_peak_secondary_id',
  /** column name */
  MeasureUnit = 'measure_unit',
  /** column name */
  MeasureUnitId = 'measure_unit_id',
  /** column name */
  MilkPerAnimal = 'milk_per_animal',
  /** column name */
  MilkedFemale = 'milked_female',
  /** column name */
  PeakMilkMonth = 'peak_milk_month',
  /** column name */
  PricePerLitre = 'price_per_litre',
  /** column name */
  QuantityConsumedDay = 'quantity_consumed_day',
  /** column name */
  QuantityGivenAway = 'quantity_given_away',
  /** column name */
  SoldPerDay = 'sold_per_day',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalConsumed = 'total_consumed',
  /** column name */
  TotalExchangedKcal = 'total_exchanged_kcal',
  /** column name */
  TotalKcal = 'total_kcal',
  /** column name */
  TotalProduced = 'total_produced'
}

export type Project_Interview_Livestock_Milk_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Livestock_Milk_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Livestock_Milk_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Livestock_Milk_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Livestock_Milk_Var_Pop_Fields = {
  __typename?: 'project_interview_livestock_milk_var_pop_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Var_Pop_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Livestock_Milk_Var_Samp_Fields = {
  __typename?: 'project_interview_livestock_milk_var_samp_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Var_Samp_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Livestock_Milk_Variance_Fields = {
  __typename?: 'project_interview_livestock_milk_variance_fields';
  days_milked?: Maybe<Scalars['Float']['output']>;
  exchanged_cereal?: Maybe<Scalars['Float']['output']>;
  measure_unit?: Maybe<Scalars['Float']['output']>;
  milk_per_animal?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  price_per_litre?: Maybe<Scalars['Float']['output']>;
  quantity_consumed_day?: Maybe<Scalars['Float']['output']>;
  quantity_given_away?: Maybe<Scalars['Float']['output']>;
  sold_per_day?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_consumed?: Maybe<Scalars['Float']['output']>;
  total_exchanged_kcal?: Maybe<Scalars['Float']['output']>;
  total_kcal?: Maybe<Scalars['Float']['output']>;
  total_produced?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_livestock_milk" */
export type Project_Interview_Livestock_Milk_Variance_Order_By = {
  days_milked?: InputMaybe<Order_By>;
  exchanged_cereal?: InputMaybe<Order_By>;
  measure_unit?: InputMaybe<Order_By>;
  milk_per_animal?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  price_per_litre?: InputMaybe<Order_By>;
  quantity_consumed_day?: InputMaybe<Order_By>;
  quantity_given_away?: InputMaybe<Order_By>;
  sold_per_day?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_consumed?: InputMaybe<Order_By>;
  total_exchanged_kcal?: InputMaybe<Order_By>;
  total_kcal?: InputMaybe<Order_By>;
  total_produced?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Livestock_Min_Fields = {
  __typename?: 'project_interview_livestock_min_fields';
  animals_other?: Maybe<Scalars['numeric']['output']>;
  balance_consumed?: Maybe<Scalars['numeric']['output']>;
  breeding_female?: Maybe<Scalars['numeric']['output']>;
  given_away_reason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  losses_death?: Maybe<Scalars['numeric']['output']>;
  losses_reason?: Maybe<Scalars['String']['output']>;
  meat_per_carcass?: Maybe<Scalars['numeric']['output']>;
  meat_price_per_kg?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_sold?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  new_birth?: Maybe<Scalars['numeric']['output']>;
  new_birth_secondary?: Maybe<Scalars['numeric']['output']>;
  slaughtered?: Maybe<Scalars['numeric']['output']>;
  total_bartered_calories?: Maybe<Scalars['numeric']['output']>;
  total_calories?: Maybe<Scalars['numeric']['output']>;
  total_cash_expenses?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_cash_income_milk?: Maybe<Scalars['numeric']['output']>;
  total_eggs_consumed?: Maybe<Scalars['numeric']['output']>;
  total_end?: Maybe<Scalars['numeric']['output']>;
  total_exchanged?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_purchases?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
  total_start?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Min_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  given_away_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  losses_reason?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_livestock" */
export type Project_Interview_Livestock_Mutation_Response = {
  __typename?: 'project_interview_livestock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Livestock>;
};

/** input type for inserting object relation for remote table "project_interview_livestock" */
export type Project_Interview_Livestock_Obj_Rel_Insert_Input = {
  data: Project_Interview_Livestock_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Livestock_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_livestock" */
export type Project_Interview_Livestock_On_Conflict = {
  constraint: Project_Interview_Livestock_Constraint;
  update_columns?: Array<Project_Interview_Livestock_Update_Column>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_livestock". */
export type Project_Interview_Livestock_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  given_away_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  is_exchanged_resold?: InputMaybe<Order_By>;
  livestock_type?: InputMaybe<Livestock_Type_Order_By>;
  losses_death?: InputMaybe<Order_By>;
  losses_reason?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  off_peak_milk?: InputMaybe<Project_Interview_Livestock_Milk_Order_By>;
  off_peak_milk_secondary?: InputMaybe<Project_Interview_Livestock_Milk_Order_By>;
  peak_milk?: InputMaybe<Project_Interview_Livestock_Milk_Order_By>;
  peak_milk_secondary?: InputMaybe<Project_Interview_Livestock_Milk_Order_By>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Order_By>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_livestock */
export type Project_Interview_Livestock_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_livestock" */
export enum Project_Interview_Livestock_Select_Column {
  /** column name */
  AnimalsOther = 'animals_other',
  /** column name */
  BalanceConsumed = 'balance_consumed',
  /** column name */
  BreedingFemale = 'breeding_female',
  /** column name */
  GivenAwayReason = 'given_away_reason',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  IsExchangedResold = 'is_exchanged_resold',
  /** column name */
  LossesDeath = 'losses_death',
  /** column name */
  LossesReason = 'losses_reason',
  /** column name */
  MeatPerCarcass = 'meat_per_carcass',
  /** column name */
  MeatPricePerKg = 'meat_price_per_kg',
  /** column name */
  MeatQuantityGivenAway = 'meat_quantity_given_away',
  /** column name */
  MeatQuantitySold = 'meat_quantity_sold',
  /** column name */
  MilkedFemale = 'milked_female',
  /** column name */
  NewBirth = 'new_birth',
  /** column name */
  NewBirthSecondary = 'new_birth_secondary',
  /** column name */
  Slaughtered = 'slaughtered',
  /** column name */
  TotalBarteredCalories = 'total_bartered_calories',
  /** column name */
  TotalCalories = 'total_calories',
  /** column name */
  TotalCashExpenses = 'total_cash_expenses',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalCashIncomeMilk = 'total_cash_income_milk',
  /** column name */
  TotalEggsConsumed = 'total_eggs_consumed',
  /** column name */
  TotalEnd = 'total_end',
  /** column name */
  TotalExchanged = 'total_exchanged',
  /** column name */
  TotalGivenAway = 'total_given_away',
  /** column name */
  TotalKcalCaloriesConsumedEggs = 'total_kcal_calories_consumed_eggs',
  /** column name */
  TotalOffPeakMilkCalories = 'total_off_peak_milk_calories',
  /** column name */
  TotalOffPeakMilkExchangedCalories = 'total_off_peak_milk_exchanged_calories',
  /** column name */
  TotalPeakMilkCalories = 'total_peak_milk_calories',
  /** column name */
  TotalPeakMilkExchangedCalories = 'total_peak_milk_exchanged_calories',
  /** column name */
  TotalPurchases = 'total_purchases',
  /** column name */
  TotalSold = 'total_sold',
  /** column name */
  TotalStart = 'total_start',
  /** column name */
  Type = 'type'
}

/** select "project_interview_livestock_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_interview_livestock" */
export enum Project_Interview_Livestock_Select_Column_Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsExchangedResold = 'is_exchanged_resold'
}

/** select "project_interview_livestock_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_interview_livestock" */
export enum Project_Interview_Livestock_Select_Column_Project_Interview_Livestock_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsExchangedResold = 'is_exchanged_resold'
}

/** input type for updating data in table "project_interview_livestock" */
export type Project_Interview_Livestock_Set_Input = {
  animals_other?: InputMaybe<Scalars['numeric']['input']>;
  balance_consumed?: InputMaybe<Scalars['numeric']['input']>;
  breeding_female?: InputMaybe<Scalars['numeric']['input']>;
  given_away_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  is_exchanged_resold?: InputMaybe<Scalars['Boolean']['input']>;
  losses_death?: InputMaybe<Scalars['numeric']['input']>;
  losses_reason?: InputMaybe<Scalars['String']['input']>;
  meat_per_carcass?: InputMaybe<Scalars['numeric']['input']>;
  meat_price_per_kg?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_sold?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  new_birth?: InputMaybe<Scalars['numeric']['input']>;
  new_birth_secondary?: InputMaybe<Scalars['numeric']['input']>;
  slaughtered?: InputMaybe<Scalars['numeric']['input']>;
  total_bartered_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income_milk?: InputMaybe<Scalars['numeric']['input']>;
  total_eggs_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_end?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_purchases?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  total_start?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Livestock_Type_Enum>;
};

/** aggregate stddev on columns */
export type Project_Interview_Livestock_Stddev_Fields = {
  __typename?: 'project_interview_livestock_stddev_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Stddev_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Livestock_Stddev_Pop_Fields = {
  __typename?: 'project_interview_livestock_stddev_pop_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Stddev_Pop_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Livestock_Stddev_Samp_Fields = {
  __typename?: 'project_interview_livestock_stddev_samp_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Stddev_Samp_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_livestock" */
export type Project_Interview_Livestock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Livestock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Livestock_Stream_Cursor_Value_Input = {
  animals_other?: InputMaybe<Scalars['numeric']['input']>;
  balance_consumed?: InputMaybe<Scalars['numeric']['input']>;
  breeding_female?: InputMaybe<Scalars['numeric']['input']>;
  given_away_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  is_exchanged_resold?: InputMaybe<Scalars['Boolean']['input']>;
  losses_death?: InputMaybe<Scalars['numeric']['input']>;
  losses_reason?: InputMaybe<Scalars['String']['input']>;
  meat_per_carcass?: InputMaybe<Scalars['numeric']['input']>;
  meat_price_per_kg?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_given_away?: InputMaybe<Scalars['numeric']['input']>;
  meat_quantity_sold?: InputMaybe<Scalars['numeric']['input']>;
  milked_female?: InputMaybe<Scalars['numeric']['input']>;
  new_birth?: InputMaybe<Scalars['numeric']['input']>;
  new_birth_secondary?: InputMaybe<Scalars['numeric']['input']>;
  slaughtered?: InputMaybe<Scalars['numeric']['input']>;
  total_bartered_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_expenses?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income?: InputMaybe<Scalars['numeric']['input']>;
  total_cash_income_milk?: InputMaybe<Scalars['numeric']['input']>;
  total_eggs_consumed?: InputMaybe<Scalars['numeric']['input']>;
  total_end?: InputMaybe<Scalars['numeric']['input']>;
  total_exchanged?: InputMaybe<Scalars['numeric']['input']>;
  total_given_away?: InputMaybe<Scalars['numeric']['input']>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_peak_milk_exchanged_calories?: InputMaybe<Scalars['numeric']['input']>;
  total_purchases?: InputMaybe<Scalars['numeric']['input']>;
  total_sold?: InputMaybe<Scalars['numeric']['input']>;
  total_start?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Livestock_Type_Enum>;
};

/** aggregate sum on columns */
export type Project_Interview_Livestock_Sum_Fields = {
  __typename?: 'project_interview_livestock_sum_fields';
  animals_other?: Maybe<Scalars['numeric']['output']>;
  balance_consumed?: Maybe<Scalars['numeric']['output']>;
  breeding_female?: Maybe<Scalars['numeric']['output']>;
  losses_death?: Maybe<Scalars['numeric']['output']>;
  meat_per_carcass?: Maybe<Scalars['numeric']['output']>;
  meat_price_per_kg?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['numeric']['output']>;
  meat_quantity_sold?: Maybe<Scalars['numeric']['output']>;
  milked_female?: Maybe<Scalars['numeric']['output']>;
  new_birth?: Maybe<Scalars['numeric']['output']>;
  new_birth_secondary?: Maybe<Scalars['numeric']['output']>;
  slaughtered?: Maybe<Scalars['numeric']['output']>;
  total_bartered_calories?: Maybe<Scalars['numeric']['output']>;
  total_calories?: Maybe<Scalars['numeric']['output']>;
  total_cash_expenses?: Maybe<Scalars['numeric']['output']>;
  total_cash_income?: Maybe<Scalars['numeric']['output']>;
  total_cash_income_milk?: Maybe<Scalars['numeric']['output']>;
  total_eggs_consumed?: Maybe<Scalars['numeric']['output']>;
  total_end?: Maybe<Scalars['numeric']['output']>;
  total_exchanged?: Maybe<Scalars['numeric']['output']>;
  total_given_away?: Maybe<Scalars['numeric']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['numeric']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['numeric']['output']>;
  total_purchases?: Maybe<Scalars['numeric']['output']>;
  total_sold?: Maybe<Scalars['numeric']['output']>;
  total_start?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Sum_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** update columns of table "project_interview_livestock" */
export enum Project_Interview_Livestock_Update_Column {
  /** column name */
  AnimalsOther = 'animals_other',
  /** column name */
  BalanceConsumed = 'balance_consumed',
  /** column name */
  BreedingFemale = 'breeding_female',
  /** column name */
  GivenAwayReason = 'given_away_reason',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  IsExchangedResold = 'is_exchanged_resold',
  /** column name */
  LossesDeath = 'losses_death',
  /** column name */
  LossesReason = 'losses_reason',
  /** column name */
  MeatPerCarcass = 'meat_per_carcass',
  /** column name */
  MeatPricePerKg = 'meat_price_per_kg',
  /** column name */
  MeatQuantityGivenAway = 'meat_quantity_given_away',
  /** column name */
  MeatQuantitySold = 'meat_quantity_sold',
  /** column name */
  MilkedFemale = 'milked_female',
  /** column name */
  NewBirth = 'new_birth',
  /** column name */
  NewBirthSecondary = 'new_birth_secondary',
  /** column name */
  Slaughtered = 'slaughtered',
  /** column name */
  TotalBarteredCalories = 'total_bartered_calories',
  /** column name */
  TotalCalories = 'total_calories',
  /** column name */
  TotalCashExpenses = 'total_cash_expenses',
  /** column name */
  TotalCashIncome = 'total_cash_income',
  /** column name */
  TotalCashIncomeMilk = 'total_cash_income_milk',
  /** column name */
  TotalEggsConsumed = 'total_eggs_consumed',
  /** column name */
  TotalEnd = 'total_end',
  /** column name */
  TotalExchanged = 'total_exchanged',
  /** column name */
  TotalGivenAway = 'total_given_away',
  /** column name */
  TotalKcalCaloriesConsumedEggs = 'total_kcal_calories_consumed_eggs',
  /** column name */
  TotalOffPeakMilkCalories = 'total_off_peak_milk_calories',
  /** column name */
  TotalOffPeakMilkExchangedCalories = 'total_off_peak_milk_exchanged_calories',
  /** column name */
  TotalPeakMilkCalories = 'total_peak_milk_calories',
  /** column name */
  TotalPeakMilkExchangedCalories = 'total_peak_milk_exchanged_calories',
  /** column name */
  TotalPurchases = 'total_purchases',
  /** column name */
  TotalSold = 'total_sold',
  /** column name */
  TotalStart = 'total_start',
  /** column name */
  Type = 'type'
}

export type Project_Interview_Livestock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Livestock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Livestock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Livestock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Livestock_Var_Pop_Fields = {
  __typename?: 'project_interview_livestock_var_pop_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Var_Pop_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Livestock_Var_Samp_Fields = {
  __typename?: 'project_interview_livestock_var_samp_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Var_Samp_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Livestock_Variance_Fields = {
  __typename?: 'project_interview_livestock_variance_fields';
  animals_other?: Maybe<Scalars['Float']['output']>;
  balance_consumed?: Maybe<Scalars['Float']['output']>;
  breeding_female?: Maybe<Scalars['Float']['output']>;
  losses_death?: Maybe<Scalars['Float']['output']>;
  meat_per_carcass?: Maybe<Scalars['Float']['output']>;
  meat_price_per_kg?: Maybe<Scalars['Float']['output']>;
  meat_quantity_given_away?: Maybe<Scalars['Float']['output']>;
  meat_quantity_sold?: Maybe<Scalars['Float']['output']>;
  milked_female?: Maybe<Scalars['Float']['output']>;
  new_birth?: Maybe<Scalars['Float']['output']>;
  new_birth_secondary?: Maybe<Scalars['Float']['output']>;
  slaughtered?: Maybe<Scalars['Float']['output']>;
  total_bartered_calories?: Maybe<Scalars['Float']['output']>;
  total_calories?: Maybe<Scalars['Float']['output']>;
  total_cash_expenses?: Maybe<Scalars['Float']['output']>;
  total_cash_income?: Maybe<Scalars['Float']['output']>;
  total_cash_income_milk?: Maybe<Scalars['Float']['output']>;
  total_eggs_consumed?: Maybe<Scalars['Float']['output']>;
  total_end?: Maybe<Scalars['Float']['output']>;
  total_exchanged?: Maybe<Scalars['Float']['output']>;
  total_given_away?: Maybe<Scalars['Float']['output']>;
  total_kcal_calories_consumed_eggs?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_off_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_calories?: Maybe<Scalars['Float']['output']>;
  total_peak_milk_exchanged_calories?: Maybe<Scalars['Float']['output']>;
  total_purchases?: Maybe<Scalars['Float']['output']>;
  total_sold?: Maybe<Scalars['Float']['output']>;
  total_start?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_livestock" */
export type Project_Interview_Livestock_Variance_Order_By = {
  animals_other?: InputMaybe<Order_By>;
  balance_consumed?: InputMaybe<Order_By>;
  breeding_female?: InputMaybe<Order_By>;
  losses_death?: InputMaybe<Order_By>;
  meat_per_carcass?: InputMaybe<Order_By>;
  meat_price_per_kg?: InputMaybe<Order_By>;
  meat_quantity_given_away?: InputMaybe<Order_By>;
  meat_quantity_sold?: InputMaybe<Order_By>;
  milked_female?: InputMaybe<Order_By>;
  new_birth?: InputMaybe<Order_By>;
  new_birth_secondary?: InputMaybe<Order_By>;
  slaughtered?: InputMaybe<Order_By>;
  total_bartered_calories?: InputMaybe<Order_By>;
  total_calories?: InputMaybe<Order_By>;
  total_cash_expenses?: InputMaybe<Order_By>;
  total_cash_income?: InputMaybe<Order_By>;
  total_cash_income_milk?: InputMaybe<Order_By>;
  total_eggs_consumed?: InputMaybe<Order_By>;
  total_end?: InputMaybe<Order_By>;
  total_exchanged?: InputMaybe<Order_By>;
  total_given_away?: InputMaybe<Order_By>;
  total_kcal_calories_consumed_eggs?: InputMaybe<Order_By>;
  total_off_peak_milk_calories?: InputMaybe<Order_By>;
  total_off_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_peak_milk_calories?: InputMaybe<Order_By>;
  total_peak_milk_exchanged_calories?: InputMaybe<Order_By>;
  total_purchases?: InputMaybe<Order_By>;
  total_sold?: InputMaybe<Order_By>;
  total_start?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Project_Interview_Max_Fields = {
  __typename?: 'project_interview_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wealth_group_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_interview" */
export type Project_Interview_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wealth_group_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Min_Fields = {
  __typename?: 'project_interview_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wealth_group_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_interview" */
export type Project_Interview_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wealth_group_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview" */
export type Project_Interview_Mutation_Response = {
  __typename?: 'project_interview_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview>;
};

/** columns and relationships of "project_interview_note" */
export type Project_Interview_Note = {
  __typename?: 'project_interview_note';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_done?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  /** An object relationship */
  project_interview: Project_Interview;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "project_interview_note" */
export type Project_Interview_Note_Aggregate = {
  __typename?: 'project_interview_note_aggregate';
  aggregate?: Maybe<Project_Interview_Note_Aggregate_Fields>;
  nodes: Array<Project_Interview_Note>;
};

export type Project_Interview_Note_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Interview_Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Interview_Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Interview_Note_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Interview_Note_Select_Column_Project_Interview_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Interview_Note_Select_Column_Project_Interview_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Interview_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_note" */
export type Project_Interview_Note_Aggregate_Fields = {
  __typename?: 'project_interview_note_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Note_Max_Fields>;
  min?: Maybe<Project_Interview_Note_Min_Fields>;
};


/** aggregate fields of "project_interview_note" */
export type Project_Interview_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_note" */
export type Project_Interview_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Note_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_note" */
export type Project_Interview_Note_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_interview_note". All fields are combined with a logical 'AND'. */
export type Project_Interview_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Note_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Note_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_done?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  project_interview?: InputMaybe<Project_Interview_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_note" */
export enum Project_Interview_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewNotePkey = 'project_interview_note_pkey'
}

/** input type for inserting data into table "project_interview_note" */
export type Project_Interview_Note_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  project_interview?: InputMaybe<Project_Interview_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Note_Max_Fields = {
  __typename?: 'project_interview_note_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_interview_note" */
export type Project_Interview_Note_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Note_Min_Fields = {
  __typename?: 'project_interview_note_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_interview_note" */
export type Project_Interview_Note_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_note" */
export type Project_Interview_Note_Mutation_Response = {
  __typename?: 'project_interview_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Note>;
};

/** on_conflict condition type for table "project_interview_note" */
export type Project_Interview_Note_On_Conflict = {
  constraint: Project_Interview_Note_Constraint;
  update_columns?: Array<Project_Interview_Note_Update_Column>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_note". */
export type Project_Interview_Note_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_done?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_interview?: InputMaybe<Project_Interview_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_note */
export type Project_Interview_Note_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_note" */
export enum Project_Interview_Note_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "project_interview_note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_interview_note" */
export enum Project_Interview_Note_Select_Column_Project_Interview_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done'
}

/** select "project_interview_note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_interview_note" */
export enum Project_Interview_Note_Select_Column_Project_Interview_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done'
}

/** input type for updating data in table "project_interview_note" */
export type Project_Interview_Note_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_interview_note" */
export type Project_Interview_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Note_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_done?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_interview_note" */
export enum Project_Interview_Note_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDone = 'is_done',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Project_Interview_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Note_Bool_Exp;
};

/** input type for inserting object relation for remote table "project_interview" */
export type Project_Interview_Obj_Rel_Insert_Input = {
  data: Project_Interview_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_On_Conflict>;
};

/** on_conflict condition type for table "project_interview" */
export type Project_Interview_On_Conflict = {
  constraint: Project_Interview_Constraint;
  update_columns?: Array<Project_Interview_Update_Column>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview". */
export type Project_Interview_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_interview_backups_aggregate?: InputMaybe<Project_Interview_Backup_Aggregate_Order_By>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Order_By>;
  project_interview_files_aggregate?: InputMaybe<Project_Interview_File_Aggregate_Order_By>;
  project_interview_notes_aggregate?: InputMaybe<Project_Interview_Note_Aggregate_Order_By>;
  project_interview_researcher_mns_aggregate?: InputMaybe<Project_Interview_Researcher_Mn_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  statusByStatus?: InputMaybe<Status_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wealth_group?: InputMaybe<Wealth_Group_Order_By>;
  wealth_group_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview */
export type Project_Interview_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset = {
  __typename?: 'project_interview_productive_asset';
  amount?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  interview_base_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_interview_base: Project_Interview_Base;
  /** An object relationship */
  term: Term;
  term_id: Scalars['uuid']['output'];
};

/** aggregated selection of "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Aggregate = {
  __typename?: 'project_interview_productive_asset_aggregate';
  aggregate?: Maybe<Project_Interview_Productive_Asset_Aggregate_Fields>;
  nodes: Array<Project_Interview_Productive_Asset>;
};

export type Project_Interview_Productive_Asset_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_Productive_Asset_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Productive_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Aggregate_Fields = {
  __typename?: 'project_interview_productive_asset_aggregate_fields';
  avg?: Maybe<Project_Interview_Productive_Asset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Productive_Asset_Max_Fields>;
  min?: Maybe<Project_Interview_Productive_Asset_Min_Fields>;
  stddev?: Maybe<Project_Interview_Productive_Asset_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Productive_Asset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Productive_Asset_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Productive_Asset_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Productive_Asset_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Productive_Asset_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Productive_Asset_Variance_Fields>;
};


/** aggregate fields of "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Interview_Productive_Asset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Productive_Asset_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Productive_Asset_Min_Order_By>;
  stddev?: InputMaybe<Project_Interview_Productive_Asset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Interview_Productive_Asset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Interview_Productive_Asset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Interview_Productive_Asset_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Interview_Productive_Asset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Interview_Productive_Asset_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Interview_Productive_Asset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Productive_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Productive_Asset_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Interview_Productive_Asset_Avg_Fields = {
  __typename?: 'project_interview_productive_asset_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_interview_productive_asset". All fields are combined with a logical 'AND'. */
export type Project_Interview_Productive_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Productive_Asset_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Productive_Asset_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_base_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_productive_asset" */
export enum Project_Interview_Productive_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewProductiveAssetPkey = 'project_interview_productive_asset_pkey'
}

/** input type for incrementing numeric columns in table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_base_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Obj_Rel_Insert_Input>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Productive_Asset_Max_Fields = {
  __typename?: 'project_interview_productive_asset_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_base_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_base_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Productive_Asset_Min_Fields = {
  __typename?: 'project_interview_productive_asset_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_base_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_base_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Mutation_Response = {
  __typename?: 'project_interview_productive_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Productive_Asset>;
};

/** on_conflict condition type for table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_On_Conflict = {
  constraint: Project_Interview_Productive_Asset_Constraint;
  update_columns?: Array<Project_Interview_Productive_Asset_Update_Column>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_productive_asset". */
export type Project_Interview_Productive_Asset_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_base_id?: InputMaybe<Order_By>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_productive_asset */
export type Project_Interview_Productive_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_productive_asset" */
export enum Project_Interview_Productive_Asset_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewBaseId = 'interview_base_id',
  /** column name */
  TermId = 'term_id'
}

/** input type for updating data in table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_base_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Productive_Asset_Stddev_Fields = {
  __typename?: 'project_interview_productive_asset_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Productive_Asset_Stddev_Pop_Fields = {
  __typename?: 'project_interview_productive_asset_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Productive_Asset_Stddev_Samp_Fields = {
  __typename?: 'project_interview_productive_asset_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Productive_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Productive_Asset_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_base_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Productive_Asset_Sum_Fields = {
  __typename?: 'project_interview_productive_asset_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "project_interview_productive_asset" */
export enum Project_Interview_Productive_Asset_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewBaseId = 'interview_base_id',
  /** column name */
  TermId = 'term_id'
}

export type Project_Interview_Productive_Asset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Productive_Asset_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Productive_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Productive_Asset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Productive_Asset_Var_Pop_Fields = {
  __typename?: 'project_interview_productive_asset_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Productive_Asset_Var_Samp_Fields = {
  __typename?: 'project_interview_productive_asset_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Interview_Productive_Asset_Variance_Fields = {
  __typename?: 'project_interview_productive_asset_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_interview_productive_asset" */
export type Project_Interview_Productive_Asset_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn = {
  __typename?: 'project_interview_researcher_mn';
  /** An object relationship */
  project_interview: Project_Interview;
  project_interview_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Aggregate = {
  __typename?: 'project_interview_researcher_mn_aggregate';
  aggregate?: Maybe<Project_Interview_Researcher_Mn_Aggregate_Fields>;
  nodes: Array<Project_Interview_Researcher_Mn>;
};

export type Project_Interview_Researcher_Mn_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Interview_Researcher_Mn_Aggregate_Bool_Exp_Count>;
};

export type Project_Interview_Researcher_Mn_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Aggregate_Fields = {
  __typename?: 'project_interview_researcher_mn_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Researcher_Mn_Max_Fields>;
  min?: Maybe<Project_Interview_Researcher_Mn_Min_Fields>;
};


/** aggregate fields of "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Interview_Researcher_Mn_Max_Order_By>;
  min?: InputMaybe<Project_Interview_Researcher_Mn_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Arr_Rel_Insert_Input = {
  data: Array<Project_Interview_Researcher_Mn_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Researcher_Mn_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_interview_researcher_mn". All fields are combined with a logical 'AND'. */
export type Project_Interview_Researcher_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Researcher_Mn_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Researcher_Mn_Bool_Exp>>;
  project_interview?: InputMaybe<Project_Interview_Bool_Exp>;
  project_interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_interview_researcher_mn" */
export enum Project_Interview_Researcher_Mn_Constraint {
  /** unique or primary key constraint on columns "user_id", "project_interview_id" */
  ProjectInterviewResearcherMUserIdProjectInterviewIdKey = 'project_interview_researcher_m_user_id_project_interview_id_key',
  /** unique or primary key constraint on columns "user_id", "project_interview_id" */
  ProjectInterviewResearcherMnPkey = 'project_interview_researcher_mn_pkey'
}

/** input type for inserting data into table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Insert_Input = {
  project_interview?: InputMaybe<Project_Interview_Obj_Rel_Insert_Input>;
  project_interview_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Project_Interview_Researcher_Mn_Max_Fields = {
  __typename?: 'project_interview_researcher_mn_max_fields';
  project_interview_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Max_Order_By = {
  project_interview_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Interview_Researcher_Mn_Min_Fields = {
  __typename?: 'project_interview_researcher_mn_min_fields';
  project_interview_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Min_Order_By = {
  project_interview_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Mutation_Response = {
  __typename?: 'project_interview_researcher_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Researcher_Mn>;
};

/** on_conflict condition type for table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_On_Conflict = {
  constraint: Project_Interview_Researcher_Mn_Constraint;
  update_columns?: Array<Project_Interview_Researcher_Mn_Update_Column>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_researcher_mn". */
export type Project_Interview_Researcher_Mn_Order_By = {
  project_interview?: InputMaybe<Project_Interview_Order_By>;
  project_interview_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_interview_researcher_mn */
export type Project_Interview_Researcher_Mn_Pk_Columns_Input = {
  project_interview_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_researcher_mn" */
export enum Project_Interview_Researcher_Mn_Select_Column {
  /** column name */
  ProjectInterviewId = 'project_interview_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Set_Input = {
  project_interview_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_interview_researcher_mn" */
export type Project_Interview_Researcher_Mn_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Researcher_Mn_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Researcher_Mn_Stream_Cursor_Value_Input = {
  project_interview_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project_interview_researcher_mn" */
export enum Project_Interview_Researcher_Mn_Update_Column {
  /** column name */
  ProjectInterviewId = 'project_interview_id',
  /** column name */
  UserId = 'user_id'
}

export type Project_Interview_Researcher_Mn_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Researcher_Mn_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Researcher_Mn_Bool_Exp;
};

/** select columns of table "project_interview" */
export enum Project_Interview_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WealthGroupId = 'wealth_group_id'
}

/** input type for updating data in table "project_interview" */
export type Project_Interview_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wealth_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project_interview" */
export type Project_Interview_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wealth_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "project_interview_totals" */
export type Project_Interview_Totals = {
  __typename?: 'project_interview_totals';
  calories_crops?: Maybe<Scalars['numeric']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  calories_food_aid?: Maybe<Scalars['numeric']['output']>;
  calories_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  calories_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  calories_livestock?: Maybe<Scalars['numeric']['output']>;
  calories_migration?: Maybe<Scalars['numeric']['output']>;
  calories_purchases?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_crops?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_crops?: Maybe<Scalars['numeric']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  cash_income_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_income_migration?: Maybe<Scalars['numeric']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_income_self_employment?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  interview_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_interview_base: Project_Interview_Base;
};

/** aggregated selection of "project_interview_totals" */
export type Project_Interview_Totals_Aggregate = {
  __typename?: 'project_interview_totals_aggregate';
  aggregate?: Maybe<Project_Interview_Totals_Aggregate_Fields>;
  nodes: Array<Project_Interview_Totals>;
};

/** aggregate fields of "project_interview_totals" */
export type Project_Interview_Totals_Aggregate_Fields = {
  __typename?: 'project_interview_totals_aggregate_fields';
  avg?: Maybe<Project_Interview_Totals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Interview_Totals_Max_Fields>;
  min?: Maybe<Project_Interview_Totals_Min_Fields>;
  stddev?: Maybe<Project_Interview_Totals_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Interview_Totals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Interview_Totals_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Interview_Totals_Sum_Fields>;
  var_pop?: Maybe<Project_Interview_Totals_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Interview_Totals_Var_Samp_Fields>;
  variance?: Maybe<Project_Interview_Totals_Variance_Fields>;
};


/** aggregate fields of "project_interview_totals" */
export type Project_Interview_Totals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Interview_Totals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Project_Interview_Totals_Avg_Fields = {
  __typename?: 'project_interview_totals_avg_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_interview_totals". All fields are combined with a logical 'AND'. */
export type Project_Interview_Totals_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Interview_Totals_Bool_Exp>>;
  _not?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Interview_Totals_Bool_Exp>>;
  calories_crops?: InputMaybe<Numeric_Comparison_Exp>;
  calories_fishing_wild_food?: InputMaybe<Numeric_Comparison_Exp>;
  calories_food_aid?: InputMaybe<Numeric_Comparison_Exp>;
  calories_labour_exchange?: InputMaybe<Numeric_Comparison_Exp>;
  calories_labour_jobs?: InputMaybe<Numeric_Comparison_Exp>;
  calories_livestock?: InputMaybe<Numeric_Comparison_Exp>;
  calories_migration?: InputMaybe<Numeric_Comparison_Exp>;
  calories_purchases?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_crops?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_food_aid?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_livestock?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_purchases_food?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_purchases_non_food?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_remittance_credit?: InputMaybe<Numeric_Comparison_Exp>;
  cash_expenses_wild_food?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_crops?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_fishing_wild_food?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_food_aid?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_labour_exchange?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_labour_jobs?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_livestock?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_migration?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_remittance_credit?: InputMaybe<Numeric_Comparison_Exp>;
  cash_income_self_employment?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interview_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};

/** unique or primary key constraints on table "project_interview_totals" */
export enum Project_Interview_Totals_Constraint {
  /** unique or primary key constraint on columns "interview_id" */
  ProjectInterviewTotalsInterviewIdKey = 'project_interview_totals_interview_id_key',
  /** unique or primary key constraint on columns "id" */
  ProjectInterviewTotalsPkey = 'project_interview_totals_pkey'
}

/** input type for incrementing numeric columns in table "project_interview_totals" */
export type Project_Interview_Totals_Inc_Input = {
  calories_crops?: InputMaybe<Scalars['numeric']['input']>;
  calories_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  calories_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  calories_livestock?: InputMaybe<Scalars['numeric']['input']>;
  calories_migration?: InputMaybe<Scalars['numeric']['input']>;
  calories_purchases?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_non_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_migration?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_self_employment?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_interview_totals" */
export type Project_Interview_Totals_Insert_Input = {
  calories_crops?: InputMaybe<Scalars['numeric']['input']>;
  calories_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  calories_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  calories_livestock?: InputMaybe<Scalars['numeric']['input']>;
  calories_migration?: InputMaybe<Scalars['numeric']['input']>;
  calories_purchases?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_non_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_migration?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_self_employment?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Interview_Totals_Max_Fields = {
  __typename?: 'project_interview_totals_max_fields';
  calories_crops?: Maybe<Scalars['numeric']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  calories_food_aid?: Maybe<Scalars['numeric']['output']>;
  calories_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  calories_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  calories_livestock?: Maybe<Scalars['numeric']['output']>;
  calories_migration?: Maybe<Scalars['numeric']['output']>;
  calories_purchases?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_crops?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_crops?: Maybe<Scalars['numeric']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  cash_income_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_income_migration?: Maybe<Scalars['numeric']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_income_self_employment?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Project_Interview_Totals_Min_Fields = {
  __typename?: 'project_interview_totals_min_fields';
  calories_crops?: Maybe<Scalars['numeric']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  calories_food_aid?: Maybe<Scalars['numeric']['output']>;
  calories_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  calories_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  calories_livestock?: Maybe<Scalars['numeric']['output']>;
  calories_migration?: Maybe<Scalars['numeric']['output']>;
  calories_purchases?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_crops?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_crops?: Maybe<Scalars['numeric']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  cash_income_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_income_migration?: Maybe<Scalars['numeric']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_income_self_employment?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interview_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project_interview_totals" */
export type Project_Interview_Totals_Mutation_Response = {
  __typename?: 'project_interview_totals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Interview_Totals>;
};

/** input type for inserting object relation for remote table "project_interview_totals" */
export type Project_Interview_Totals_Obj_Rel_Insert_Input = {
  data: Project_Interview_Totals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Interview_Totals_On_Conflict>;
};

/** on_conflict condition type for table "project_interview_totals" */
export type Project_Interview_Totals_On_Conflict = {
  constraint: Project_Interview_Totals_Constraint;
  update_columns?: Array<Project_Interview_Totals_Update_Column>;
  where?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
};

/** Ordering options when selecting data from "project_interview_totals". */
export type Project_Interview_Totals_Order_By = {
  calories_crops?: InputMaybe<Order_By>;
  calories_fishing_wild_food?: InputMaybe<Order_By>;
  calories_food_aid?: InputMaybe<Order_By>;
  calories_labour_exchange?: InputMaybe<Order_By>;
  calories_labour_jobs?: InputMaybe<Order_By>;
  calories_livestock?: InputMaybe<Order_By>;
  calories_migration?: InputMaybe<Order_By>;
  calories_purchases?: InputMaybe<Order_By>;
  cash_expenses_crops?: InputMaybe<Order_By>;
  cash_expenses_food_aid?: InputMaybe<Order_By>;
  cash_expenses_livestock?: InputMaybe<Order_By>;
  cash_expenses_purchases_food?: InputMaybe<Order_By>;
  cash_expenses_purchases_non_food?: InputMaybe<Order_By>;
  cash_expenses_remittance_credit?: InputMaybe<Order_By>;
  cash_expenses_wild_food?: InputMaybe<Order_By>;
  cash_income_crops?: InputMaybe<Order_By>;
  cash_income_fishing_wild_food?: InputMaybe<Order_By>;
  cash_income_food_aid?: InputMaybe<Order_By>;
  cash_income_labour_exchange?: InputMaybe<Order_By>;
  cash_income_labour_jobs?: InputMaybe<Order_By>;
  cash_income_livestock?: InputMaybe<Order_By>;
  cash_income_migration?: InputMaybe<Order_By>;
  cash_income_remittance_credit?: InputMaybe<Order_By>;
  cash_income_self_employment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_id?: InputMaybe<Order_By>;
  project_interview_base?: InputMaybe<Project_Interview_Base_Order_By>;
};

/** primary key columns input for table: project_interview_totals */
export type Project_Interview_Totals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_interview_totals" */
export enum Project_Interview_Totals_Select_Column {
  /** column name */
  CaloriesCrops = 'calories_crops',
  /** column name */
  CaloriesFishingWildFood = 'calories_fishing_wild_food',
  /** column name */
  CaloriesFoodAid = 'calories_food_aid',
  /** column name */
  CaloriesLabourExchange = 'calories_labour_exchange',
  /** column name */
  CaloriesLabourJobs = 'calories_labour_jobs',
  /** column name */
  CaloriesLivestock = 'calories_livestock',
  /** column name */
  CaloriesMigration = 'calories_migration',
  /** column name */
  CaloriesPurchases = 'calories_purchases',
  /** column name */
  CashExpensesCrops = 'cash_expenses_crops',
  /** column name */
  CashExpensesFoodAid = 'cash_expenses_food_aid',
  /** column name */
  CashExpensesLivestock = 'cash_expenses_livestock',
  /** column name */
  CashExpensesPurchasesFood = 'cash_expenses_purchases_food',
  /** column name */
  CashExpensesPurchasesNonFood = 'cash_expenses_purchases_non_food',
  /** column name */
  CashExpensesRemittanceCredit = 'cash_expenses_remittance_credit',
  /** column name */
  CashExpensesWildFood = 'cash_expenses_wild_food',
  /** column name */
  CashIncomeCrops = 'cash_income_crops',
  /** column name */
  CashIncomeFishingWildFood = 'cash_income_fishing_wild_food',
  /** column name */
  CashIncomeFoodAid = 'cash_income_food_aid',
  /** column name */
  CashIncomeLabourExchange = 'cash_income_labour_exchange',
  /** column name */
  CashIncomeLabourJobs = 'cash_income_labour_jobs',
  /** column name */
  CashIncomeLivestock = 'cash_income_livestock',
  /** column name */
  CashIncomeMigration = 'cash_income_migration',
  /** column name */
  CashIncomeRemittanceCredit = 'cash_income_remittance_credit',
  /** column name */
  CashIncomeSelfEmployment = 'cash_income_self_employment',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id'
}

/** input type for updating data in table "project_interview_totals" */
export type Project_Interview_Totals_Set_Input = {
  calories_crops?: InputMaybe<Scalars['numeric']['input']>;
  calories_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  calories_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  calories_livestock?: InputMaybe<Scalars['numeric']['input']>;
  calories_migration?: InputMaybe<Scalars['numeric']['input']>;
  calories_purchases?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_non_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_migration?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_self_employment?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Project_Interview_Totals_Stddev_Fields = {
  __typename?: 'project_interview_totals_stddev_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Interview_Totals_Stddev_Pop_Fields = {
  __typename?: 'project_interview_totals_stddev_pop_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Interview_Totals_Stddev_Samp_Fields = {
  __typename?: 'project_interview_totals_stddev_samp_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project_interview_totals" */
export type Project_Interview_Totals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Interview_Totals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Interview_Totals_Stream_Cursor_Value_Input = {
  calories_crops?: InputMaybe<Scalars['numeric']['input']>;
  calories_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  calories_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  calories_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  calories_livestock?: InputMaybe<Scalars['numeric']['input']>;
  calories_migration?: InputMaybe<Scalars['numeric']['input']>;
  calories_purchases?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_purchases_non_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_expenses_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_crops?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_fishing_wild_food?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_food_aid?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_exchange?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_labour_jobs?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_livestock?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_migration?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_remittance_credit?: InputMaybe<Scalars['numeric']['input']>;
  cash_income_self_employment?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interview_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Project_Interview_Totals_Sum_Fields = {
  __typename?: 'project_interview_totals_sum_fields';
  calories_crops?: Maybe<Scalars['numeric']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  calories_food_aid?: Maybe<Scalars['numeric']['output']>;
  calories_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  calories_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  calories_livestock?: Maybe<Scalars['numeric']['output']>;
  calories_migration?: Maybe<Scalars['numeric']['output']>;
  calories_purchases?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_crops?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_crops?: Maybe<Scalars['numeric']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['numeric']['output']>;
  cash_income_food_aid?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['numeric']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['numeric']['output']>;
  cash_income_livestock?: Maybe<Scalars['numeric']['output']>;
  cash_income_migration?: Maybe<Scalars['numeric']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['numeric']['output']>;
  cash_income_self_employment?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "project_interview_totals" */
export enum Project_Interview_Totals_Update_Column {
  /** column name */
  CaloriesCrops = 'calories_crops',
  /** column name */
  CaloriesFishingWildFood = 'calories_fishing_wild_food',
  /** column name */
  CaloriesFoodAid = 'calories_food_aid',
  /** column name */
  CaloriesLabourExchange = 'calories_labour_exchange',
  /** column name */
  CaloriesLabourJobs = 'calories_labour_jobs',
  /** column name */
  CaloriesLivestock = 'calories_livestock',
  /** column name */
  CaloriesMigration = 'calories_migration',
  /** column name */
  CaloriesPurchases = 'calories_purchases',
  /** column name */
  CashExpensesCrops = 'cash_expenses_crops',
  /** column name */
  CashExpensesFoodAid = 'cash_expenses_food_aid',
  /** column name */
  CashExpensesLivestock = 'cash_expenses_livestock',
  /** column name */
  CashExpensesPurchasesFood = 'cash_expenses_purchases_food',
  /** column name */
  CashExpensesPurchasesNonFood = 'cash_expenses_purchases_non_food',
  /** column name */
  CashExpensesRemittanceCredit = 'cash_expenses_remittance_credit',
  /** column name */
  CashExpensesWildFood = 'cash_expenses_wild_food',
  /** column name */
  CashIncomeCrops = 'cash_income_crops',
  /** column name */
  CashIncomeFishingWildFood = 'cash_income_fishing_wild_food',
  /** column name */
  CashIncomeFoodAid = 'cash_income_food_aid',
  /** column name */
  CashIncomeLabourExchange = 'cash_income_labour_exchange',
  /** column name */
  CashIncomeLabourJobs = 'cash_income_labour_jobs',
  /** column name */
  CashIncomeLivestock = 'cash_income_livestock',
  /** column name */
  CashIncomeMigration = 'cash_income_migration',
  /** column name */
  CashIncomeRemittanceCredit = 'cash_income_remittance_credit',
  /** column name */
  CashIncomeSelfEmployment = 'cash_income_self_employment',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewId = 'interview_id'
}

export type Project_Interview_Totals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Interview_Totals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Totals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Totals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Interview_Totals_Var_Pop_Fields = {
  __typename?: 'project_interview_totals_var_pop_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Interview_Totals_Var_Samp_Fields = {
  __typename?: 'project_interview_totals_var_samp_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Interview_Totals_Variance_Fields = {
  __typename?: 'project_interview_totals_variance_fields';
  calories_crops?: Maybe<Scalars['Float']['output']>;
  calories_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  calories_food_aid?: Maybe<Scalars['Float']['output']>;
  calories_labour_exchange?: Maybe<Scalars['Float']['output']>;
  calories_labour_jobs?: Maybe<Scalars['Float']['output']>;
  calories_livestock?: Maybe<Scalars['Float']['output']>;
  calories_migration?: Maybe<Scalars['Float']['output']>;
  calories_purchases?: Maybe<Scalars['Float']['output']>;
  cash_expenses_crops?: Maybe<Scalars['Float']['output']>;
  cash_expenses_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_expenses_livestock?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_purchases_non_food?: Maybe<Scalars['Float']['output']>;
  cash_expenses_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_expenses_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_crops?: Maybe<Scalars['Float']['output']>;
  cash_income_fishing_wild_food?: Maybe<Scalars['Float']['output']>;
  cash_income_food_aid?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_exchange?: Maybe<Scalars['Float']['output']>;
  cash_income_labour_jobs?: Maybe<Scalars['Float']['output']>;
  cash_income_livestock?: Maybe<Scalars['Float']['output']>;
  cash_income_migration?: Maybe<Scalars['Float']['output']>;
  cash_income_remittance_credit?: Maybe<Scalars['Float']['output']>;
  cash_income_self_employment?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "project_interview" */
export enum Project_Interview_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WealthGroupId = 'wealth_group_id'
}

export type Project_Interview_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Interview_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Interview_Bool_Exp;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currency_exchange_usd?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kcal_pppd?: Maybe<Scalars['numeric']['output']>;
  main_staple_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  reference_period_description?: Maybe<Scalars['String']['output']>;
  reference_period_duration?: Maybe<Scalars['Int']['output']>;
  reference_period_end?: Maybe<Scalars['date']['output']>;
  reference_period_start?: Maybe<Scalars['date']['output']>;
  school_food_kcal?: Maybe<Scalars['numeric']['output']>;
  schooldays_year?: Maybe<Scalars['Int']['output']>;
  supervisor_user_id?: Maybe<Scalars['uuid']['output']>;
  teamleader_user_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "project" */
export type Project_Max_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  main_staple_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  reference_period_description?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  reference_period_end?: InputMaybe<Order_By>;
  reference_period_start?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
  supervisor_user_id?: InputMaybe<Order_By>;
  teamleader_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currency_exchange_usd?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kcal_pppd?: Maybe<Scalars['numeric']['output']>;
  main_staple_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  reference_period_description?: Maybe<Scalars['String']['output']>;
  reference_period_duration?: Maybe<Scalars['Int']['output']>;
  reference_period_end?: Maybe<Scalars['date']['output']>;
  reference_period_start?: Maybe<Scalars['date']['output']>;
  school_food_kcal?: Maybe<Scalars['numeric']['output']>;
  schooldays_year?: Maybe<Scalars['Int']['output']>;
  supervisor_user_id?: Maybe<Scalars['uuid']['output']>;
  teamleader_user_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "project" */
export type Project_Min_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  main_staple_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  reference_period_description?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  reference_period_end?: InputMaybe<Order_By>;
  reference_period_start?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
  supervisor_user_id?: InputMaybe<Order_By>;
  teamleader_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  finished?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  main_staple_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
  project_bss_data_backups_aggregate?: InputMaybe<Project_Bss_Data_Backup_Aggregate_Order_By>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Order_By>;
  project_files_aggregate?: InputMaybe<Project_File_Aggregate_Order_By>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Order_By>;
  reference_period_description?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  reference_period_end?: InputMaybe<Order_By>;
  reference_period_start?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
  supervisor_user_id?: InputMaybe<Order_By>;
  teamleader_user_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userTeamleader?: InputMaybe<Users_Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project" */
export enum Project_Select_Column {
  /** column name */
  AvgPriceMainStapleKg = 'avg_price_main_staple_kg',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CurrencyExchangeUsd = 'currency_exchange_usd',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Finished = 'finished',
  /** column name */
  Id = 'id',
  /** column name */
  KcalPppd = 'kcal_pppd',
  /** column name */
  MainStapleId = 'main_staple_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  ReferencePeriodDescription = 'reference_period_description',
  /** column name */
  ReferencePeriodDuration = 'reference_period_duration',
  /** column name */
  ReferencePeriodEnd = 'reference_period_end',
  /** column name */
  ReferencePeriodStart = 'reference_period_start',
  /** column name */
  SchoolFoodKcal = 'school_food_kcal',
  /** column name */
  SchooldaysYear = 'schooldays_year',
  /** column name */
  SupervisorUserId = 'supervisor_user_id',
  /** column name */
  TeamleaderUserId = 'teamleader_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "project_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Finished = 'finished'
}

/** select "project_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Finished = 'finished'
}

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  avg_price_main_staple_kg?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_exchange_usd?: InputMaybe<Scalars['numeric']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcal_pppd?: InputMaybe<Scalars['numeric']['input']>;
  main_staple_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  reference_period_description?: InputMaybe<Scalars['String']['input']>;
  reference_period_duration?: InputMaybe<Scalars['Int']['input']>;
  reference_period_end?: InputMaybe<Scalars['date']['input']>;
  reference_period_start?: InputMaybe<Scalars['date']['input']>;
  school_food_kcal?: InputMaybe<Scalars['numeric']['input']>;
  schooldays_year?: InputMaybe<Scalars['Int']['input']>;
  supervisor_user_id?: InputMaybe<Scalars['uuid']['input']>;
  teamleader_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Project_Stddev_Fields = {
  __typename?: 'project_stddev_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project" */
export type Project_Stddev_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Stddev_Pop_Fields = {
  __typename?: 'project_stddev_pop_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project" */
export type Project_Stddev_Pop_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Stddev_Samp_Fields = {
  __typename?: 'project_stddev_samp_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project" */
export type Project_Stddev_Samp_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  avg_price_main_staple_kg?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_exchange_usd?: InputMaybe<Scalars['numeric']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcal_pppd?: InputMaybe<Scalars['numeric']['input']>;
  main_staple_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  reference_period_description?: InputMaybe<Scalars['String']['input']>;
  reference_period_duration?: InputMaybe<Scalars['Int']['input']>;
  reference_period_end?: InputMaybe<Scalars['date']['input']>;
  reference_period_start?: InputMaybe<Scalars['date']['input']>;
  school_food_kcal?: InputMaybe<Scalars['numeric']['input']>;
  schooldays_year?: InputMaybe<Scalars['Int']['input']>;
  supervisor_user_id?: InputMaybe<Scalars['uuid']['input']>;
  teamleader_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Project_Sum_Fields = {
  __typename?: 'project_sum_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['numeric']['output']>;
  currency_exchange_usd?: Maybe<Scalars['numeric']['output']>;
  kcal_pppd?: Maybe<Scalars['numeric']['output']>;
  reference_period_duration?: Maybe<Scalars['Int']['output']>;
  school_food_kcal?: Maybe<Scalars['numeric']['output']>;
  schooldays_year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project" */
export type Project_Sum_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** update columns of table "project" */
export enum Project_Update_Column {
  /** column name */
  AvgPriceMainStapleKg = 'avg_price_main_staple_kg',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CurrencyExchangeUsd = 'currency_exchange_usd',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Finished = 'finished',
  /** column name */
  Id = 'id',
  /** column name */
  KcalPppd = 'kcal_pppd',
  /** column name */
  MainStapleId = 'main_staple_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  ReferencePeriodDescription = 'reference_period_description',
  /** column name */
  ReferencePeriodDuration = 'reference_period_duration',
  /** column name */
  ReferencePeriodEnd = 'reference_period_end',
  /** column name */
  ReferencePeriodStart = 'reference_period_start',
  /** column name */
  SchoolFoodKcal = 'school_food_kcal',
  /** column name */
  SchooldaysYear = 'schooldays_year',
  /** column name */
  SupervisorUserId = 'supervisor_user_id',
  /** column name */
  TeamleaderUserId = 'teamleader_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Var_Pop_Fields = {
  __typename?: 'project_var_pop_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project" */
export type Project_Var_Pop_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Var_Samp_Fields = {
  __typename?: 'project_var_samp_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project" */
export type Project_Var_Samp_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Variance_Fields = {
  __typename?: 'project_variance_fields';
  avg_price_main_staple_kg?: Maybe<Scalars['Float']['output']>;
  currency_exchange_usd?: Maybe<Scalars['Float']['output']>;
  kcal_pppd?: Maybe<Scalars['Float']['output']>;
  reference_period_duration?: Maybe<Scalars['Float']['output']>;
  school_food_kcal?: Maybe<Scalars['Float']['output']>;
  schooldays_year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project" */
export type Project_Variance_Order_By = {
  avg_price_main_staple_kg?: InputMaybe<Order_By>;
  currency_exchange_usd?: InputMaybe<Order_By>;
  kcal_pppd?: InputMaybe<Order_By>;
  reference_period_duration?: InputMaybe<Order_By>;
  school_food_kcal?: InputMaybe<Order_By>;
  schooldays_year?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table: "bss_baseline_view" */
  bss_baseline_view: Array<Bss_Baseline_View>;
  /** fetch aggregated fields from the table: "bss_baseline_view" */
  bss_baseline_view_aggregate: Bss_Baseline_View_Aggregate;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_region" */
  country_region: Array<Country_Region>;
  /** fetch aggregated fields from the table: "country_region" */
  country_region_aggregate: Country_Region_Aggregate;
  /** fetch data from the table: "country_region" using primary key columns */
  country_region_by_pk?: Maybe<Country_Region>;
  /** fetch data from the table: "crop_season" */
  crop_season: Array<Crop_Season>;
  /** fetch aggregated fields from the table: "crop_season" */
  crop_season_aggregate: Crop_Season_Aggregate;
  /** fetch data from the table: "crop_season" using primary key columns */
  crop_season_by_pk?: Maybe<Crop_Season>;
  /** fetch data from the table: "crop_season_month_mn" */
  crop_season_month_mn: Array<Crop_Season_Month_Mn>;
  /** fetch aggregated fields from the table: "crop_season_month_mn" */
  crop_season_month_mn_aggregate: Crop_Season_Month_Mn_Aggregate;
  /** fetch data from the table: "crop_season_month_mn" using primary key columns */
  crop_season_month_mn_by_pk?: Maybe<Crop_Season_Month_Mn>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table: "livestock_milking_season" */
  livestock_milking_season: Array<Livestock_Milking_Season>;
  /** fetch aggregated fields from the table: "livestock_milking_season" */
  livestock_milking_season_aggregate: Livestock_Milking_Season_Aggregate;
  /** fetch data from the table: "livestock_milking_season" using primary key columns */
  livestock_milking_season_by_pk?: Maybe<Livestock_Milking_Season>;
  /** fetch data from the table: "livestock_type" */
  livestock_type: Array<Livestock_Type>;
  /** fetch aggregated fields from the table: "livestock_type" */
  livestock_type_aggregate: Livestock_Type_Aggregate;
  /** fetch data from the table: "livestock_type" using primary key columns */
  livestock_type_by_pk?: Maybe<Livestock_Type>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table: "measure_unit" */
  measure_unit: Array<Measure_Unit>;
  /** fetch aggregated fields from the table: "measure_unit" */
  measure_unit_aggregate: Measure_Unit_Aggregate;
  /** fetch data from the table: "measure_unit" using primary key columns */
  measure_unit_by_pk?: Maybe<Measure_Unit>;
  /** fetch data from the table: "measure_unit_type" */
  measure_unit_type: Array<Measure_Unit_Type>;
  /** fetch aggregated fields from the table: "measure_unit_type" */
  measure_unit_type_aggregate: Measure_Unit_Type_Aggregate;
  /** fetch data from the table: "measure_unit_type" using primary key columns */
  measure_unit_type_by_pk?: Maybe<Measure_Unit_Type>;
  /** fetch data from the table: "month" */
  month: Array<Month>;
  /** fetch aggregated fields from the table: "month" */
  month_aggregate: Month_Aggregate;
  /** fetch data from the table: "month" using primary key columns */
  month_by_pk?: Maybe<Month>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** fetch data from the table: "project_bss_data_backup" */
  project_bss_data_backup: Array<Project_Bss_Data_Backup>;
  /** fetch aggregated fields from the table: "project_bss_data_backup" */
  project_bss_data_backup_aggregate: Project_Bss_Data_Backup_Aggregate;
  /** fetch data from the table: "project_bss_data_backup" using primary key columns */
  project_bss_data_backup_by_pk?: Maybe<Project_Bss_Data_Backup>;
  /** fetch data from the table: "project_bss_data" using primary key columns */
  project_bss_data_by_pk?: Maybe<Project_Bss_Data>;
  /** fetch data from the table: "project_bss_data_type" */
  project_bss_data_type: Array<Project_Bss_Data_Type>;
  /** fetch aggregated fields from the table: "project_bss_data_type" */
  project_bss_data_type_aggregate: Project_Bss_Data_Type_Aggregate;
  /** fetch data from the table: "project_bss_data_type" using primary key columns */
  project_bss_data_type_by_pk?: Maybe<Project_Bss_Data_Type>;
  /** fetch data from the table: "project_bss_note" */
  project_bss_note: Array<Project_Bss_Note>;
  /** fetch aggregated fields from the table: "project_bss_note" */
  project_bss_note_aggregate: Project_Bss_Note_Aggregate;
  /** fetch data from the table: "project_bss_note" using primary key columns */
  project_bss_note_by_pk?: Maybe<Project_Bss_Note>;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_file" */
  project_file: Array<Project_File>;
  /** fetch aggregated fields from the table: "project_file" */
  project_file_aggregate: Project_File_Aggregate;
  /** fetch data from the table: "project_file" using primary key columns */
  project_file_by_pk?: Maybe<Project_File>;
  /** fetch data from the table: "project_interview" */
  project_interview: Array<Project_Interview>;
  /** fetch aggregated fields from the table: "project_interview" */
  project_interview_aggregate: Project_Interview_Aggregate;
  /** fetch data from the table: "project_interview_backup" */
  project_interview_backup: Array<Project_Interview_Backup>;
  /** fetch aggregated fields from the table: "project_interview_backup" */
  project_interview_backup_aggregate: Project_Interview_Backup_Aggregate;
  /** fetch data from the table: "project_interview_backup" using primary key columns */
  project_interview_backup_by_pk?: Maybe<Project_Interview_Backup>;
  /** fetch data from the table: "project_interview_base" */
  project_interview_base: Array<Project_Interview_Base>;
  /** fetch aggregated fields from the table: "project_interview_base" */
  project_interview_base_aggregate: Project_Interview_Base_Aggregate;
  /** fetch data from the table: "project_interview_base" using primary key columns */
  project_interview_base_by_pk?: Maybe<Project_Interview_Base>;
  /** fetch data from the table: "project_interview" using primary key columns */
  project_interview_by_pk?: Maybe<Project_Interview>;
  /** An array relationship */
  project_interview_crops: Array<Project_Interview_Crops>;
  /** An aggregate relationship */
  project_interview_crops_aggregate: Project_Interview_Crops_Aggregate;
  /** fetch data from the table: "project_interview_crops" using primary key columns */
  project_interview_crops_by_pk?: Maybe<Project_Interview_Crops>;
  /** fetch data from the table: "project_interview_crops_green_root" */
  project_interview_crops_green_root: Array<Project_Interview_Crops_Green_Root>;
  /** fetch aggregated fields from the table: "project_interview_crops_green_root" */
  project_interview_crops_green_root_aggregate: Project_Interview_Crops_Green_Root_Aggregate;
  /** fetch data from the table: "project_interview_crops_green_root" using primary key columns */
  project_interview_crops_green_root_by_pk?: Maybe<Project_Interview_Crops_Green_Root>;
  /** fetch data from the table: "project_interview_crops_season" */
  project_interview_crops_season: Array<Project_Interview_Crops_Season>;
  /** fetch aggregated fields from the table: "project_interview_crops_season" */
  project_interview_crops_season_aggregate: Project_Interview_Crops_Season_Aggregate;
  /** fetch data from the table: "project_interview_crops_season" using primary key columns */
  project_interview_crops_season_by_pk?: Maybe<Project_Interview_Crops_Season>;
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
  /** fetch data from the table: "project_interview_data" using primary key columns */
  project_interview_data_by_pk?: Maybe<Project_Interview_Data>;
  /** fetch data from the table: "project_interview_data_type" */
  project_interview_data_type: Array<Project_Interview_Data_Type>;
  /** fetch aggregated fields from the table: "project_interview_data_type" */
  project_interview_data_type_aggregate: Project_Interview_Data_Type_Aggregate;
  /** fetch data from the table: "project_interview_data_type" using primary key columns */
  project_interview_data_type_by_pk?: Maybe<Project_Interview_Data_Type>;
  /** fetch data from the table: "project_interview_file" */
  project_interview_file: Array<Project_Interview_File>;
  /** fetch aggregated fields from the table: "project_interview_file" */
  project_interview_file_aggregate: Project_Interview_File_Aggregate;
  /** fetch data from the table: "project_interview_file" using primary key columns */
  project_interview_file_by_pk?: Maybe<Project_Interview_File>;
  /** fetch data from the table: "project_interview_livestock" */
  project_interview_livestock: Array<Project_Interview_Livestock>;
  /** fetch aggregated fields from the table: "project_interview_livestock" */
  project_interview_livestock_aggregate: Project_Interview_Livestock_Aggregate;
  /** fetch data from the table: "project_interview_livestock" using primary key columns */
  project_interview_livestock_by_pk?: Maybe<Project_Interview_Livestock>;
  /** fetch data from the table: "project_interview_livestock_milk" */
  project_interview_livestock_milk: Array<Project_Interview_Livestock_Milk>;
  /** fetch aggregated fields from the table: "project_interview_livestock_milk" */
  project_interview_livestock_milk_aggregate: Project_Interview_Livestock_Milk_Aggregate;
  /** fetch data from the table: "project_interview_livestock_milk" using primary key columns */
  project_interview_livestock_milk_by_pk?: Maybe<Project_Interview_Livestock_Milk>;
  /** fetch data from the table: "project_interview_note" */
  project_interview_note: Array<Project_Interview_Note>;
  /** fetch aggregated fields from the table: "project_interview_note" */
  project_interview_note_aggregate: Project_Interview_Note_Aggregate;
  /** fetch data from the table: "project_interview_note" using primary key columns */
  project_interview_note_by_pk?: Maybe<Project_Interview_Note>;
  /** fetch data from the table: "project_interview_productive_asset" */
  project_interview_productive_asset: Array<Project_Interview_Productive_Asset>;
  /** fetch aggregated fields from the table: "project_interview_productive_asset" */
  project_interview_productive_asset_aggregate: Project_Interview_Productive_Asset_Aggregate;
  /** fetch data from the table: "project_interview_productive_asset" using primary key columns */
  project_interview_productive_asset_by_pk?: Maybe<Project_Interview_Productive_Asset>;
  /** fetch data from the table: "project_interview_researcher_mn" */
  project_interview_researcher_mn: Array<Project_Interview_Researcher_Mn>;
  /** fetch aggregated fields from the table: "project_interview_researcher_mn" */
  project_interview_researcher_mn_aggregate: Project_Interview_Researcher_Mn_Aggregate;
  /** fetch data from the table: "project_interview_researcher_mn" using primary key columns */
  project_interview_researcher_mn_by_pk?: Maybe<Project_Interview_Researcher_Mn>;
  /** fetch data from the table: "project_interview_totals" */
  project_interview_totals: Array<Project_Interview_Totals>;
  /** fetch aggregated fields from the table: "project_interview_totals" */
  project_interview_totals_aggregate: Project_Interview_Totals_Aggregate;
  /** fetch data from the table: "project_interview_totals" using primary key columns */
  project_interview_totals_by_pk?: Maybe<Project_Interview_Totals>;
  /** fetch data from the table: "sale_purchase_type" */
  sale_purchase_type: Array<Sale_Purchase_Type>;
  /** fetch aggregated fields from the table: "sale_purchase_type" */
  sale_purchase_type_aggregate: Sale_Purchase_Type_Aggregate;
  /** fetch data from the table: "sale_purchase_type" using primary key columns */
  sale_purchase_type_by_pk?: Maybe<Sale_Purchase_Type>;
  /** fetch data from the table: "status" */
  status: Array<Status>;
  /** fetch aggregated fields from the table: "status" */
  status_aggregate: Status_Aggregate;
  /** fetch data from the table: "status" using primary key columns */
  status_by_pk?: Maybe<Status>;
  /** fetch data from the table: "term" */
  term: Array<Term>;
  /** fetch aggregated fields from the table: "term" */
  term_aggregate: Term_Aggregate;
  /** fetch data from the table: "term" using primary key columns */
  term_by_pk?: Maybe<Term>;
  /** fetch data from the table: "term_category" */
  term_category: Array<Term_Category>;
  /** fetch aggregated fields from the table: "term_category" */
  term_category_aggregate: Term_Category_Aggregate;
  /** fetch data from the table: "term_category" using primary key columns */
  term_category_by_pk?: Maybe<Term_Category>;
  /** fetch data from the table: "term_category_mn" */
  term_category_mn: Array<Term_Category_Mn>;
  /** fetch aggregated fields from the table: "term_category_mn" */
  term_category_mn_aggregate: Term_Category_Mn_Aggregate;
  /** fetch data from the table: "term_category_mn" using primary key columns */
  term_category_mn_by_pk?: Maybe<Term_Category_Mn>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "user_permission" */
  user_permission: Array<User_Permission>;
  /** fetch aggregated fields from the table: "user_permission" */
  user_permission_aggregate: User_Permission_Aggregate;
  /** fetch data from the table: "user_permission" using primary key columns */
  user_permission_by_pk?: Maybe<User_Permission>;
  /** fetch data from the table: "user_permission_role" */
  user_permission_role: Array<User_Permission_Role>;
  /** fetch aggregated fields from the table: "user_permission_role" */
  user_permission_role_aggregate: User_Permission_Role_Aggregate;
  /** fetch data from the table: "user_permission_role" using primary key columns */
  user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** fetch data from the table: "user_profile" */
  user_profile: Array<User_Profile>;
  /** fetch aggregated fields from the table: "user_profile" */
  user_profile_aggregate: User_Profile_Aggregate;
  /** fetch data from the table: "user_profile" using primary key columns */
  user_profile_by_pk?: Maybe<User_Profile>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "wealth_group" */
  wealth_group: Array<Wealth_Group>;
  /** fetch aggregated fields from the table: "wealth_group" */
  wealth_group_aggregate: Wealth_Group_Aggregate;
  /** fetch data from the table: "wealth_group" using primary key columns */
  wealth_group_by_pk?: Maybe<Wealth_Group>;
  /** fetch data from the table: "zone" */
  zone: Array<Zone>;
  /** fetch aggregated fields from the table: "zone" */
  zone_aggregate: Zone_Aggregate;
  /** fetch data from the table: "zone" using primary key columns */
  zone_by_pk?: Maybe<Zone>;
};


export type Query_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootBss_Baseline_ViewArgs = {
  distinct_on?: InputMaybe<Array<Bss_Baseline_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bss_Baseline_View_Order_By>>;
  where?: InputMaybe<Bss_Baseline_View_Bool_Exp>;
};


export type Query_RootBss_Baseline_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bss_Baseline_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bss_Baseline_View_Order_By>>;
  where?: InputMaybe<Bss_Baseline_View_Bool_Exp>;
};


export type Query_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCountry_RegionArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Query_RootCountry_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Query_RootCountry_Region_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCrop_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Order_By>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


export type Query_RootCrop_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Order_By>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


export type Query_RootCrop_Season_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCrop_Season_Month_MnArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


export type Query_RootCrop_Season_Month_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


export type Query_RootCrop_Season_Month_Mn_By_PkArgs = {
  crop_season_id: Scalars['uuid']['input'];
  month: Month_Enum;
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootLivestock_Milking_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Milking_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Milking_Season_Order_By>>;
  where?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
};


export type Query_RootLivestock_Milking_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Milking_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Milking_Season_Order_By>>;
  where?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
};


export type Query_RootLivestock_Milking_Season_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootLivestock_TypeArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Type_Order_By>>;
  where?: InputMaybe<Livestock_Type_Bool_Exp>;
};


export type Query_RootLivestock_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Type_Order_By>>;
  where?: InputMaybe<Livestock_Type_Bool_Exp>;
};


export type Query_RootLivestock_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMeasure_UnitArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


export type Query_RootMeasure_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


export type Query_RootMeasure_Unit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMeasure_Unit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Type_Order_By>>;
  where?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
};


export type Query_RootMeasure_Unit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Type_Order_By>>;
  where?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
};


export type Query_RootMeasure_Unit_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootMonthArgs = {
  distinct_on?: InputMaybe<Array<Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Month_Order_By>>;
  where?: InputMaybe<Month_Bool_Exp>;
};


export type Query_RootMonth_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Month_Order_By>>;
  where?: InputMaybe<Month_Bool_Exp>;
};


export type Query_RootMonth_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


export type Query_RootProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


export type Query_RootProject_Bss_Data_BackupArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


export type Query_RootProject_Bss_Data_Backup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


export type Query_RootProject_Bss_Data_Backup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Bss_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Bss_Data_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
};


export type Query_RootProject_Bss_Data_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
};


export type Query_RootProject_Bss_Data_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootProject_Bss_NoteArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


export type Query_RootProject_Bss_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


export type Query_RootProject_Bss_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_FileArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


export type Query_RootProject_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


export type Query_RootProject_File_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  project_id: Scalars['uuid']['input'];
};


export type Query_RootProject_InterviewArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


export type Query_RootProject_Interview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


export type Query_RootProject_Interview_BackupArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


export type Query_RootProject_Interview_Backup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


export type Query_RootProject_Interview_Backup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_BaseArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


export type Query_RootProject_Interview_Base_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


export type Query_RootProject_Interview_Base_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_CropsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


export type Query_RootProject_Interview_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


export type Query_RootProject_Interview_Crops_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_Crops_Green_RootArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
};


export type Query_RootProject_Interview_Crops_Green_Root_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
};


export type Query_RootProject_Interview_Crops_Green_Root_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_Crops_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


export type Query_RootProject_Interview_Crops_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


export type Query_RootProject_Interview_Crops_Season_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


export type Query_RootProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


export type Query_RootProject_Interview_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_Data_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
};


export type Query_RootProject_Interview_Data_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
};


export type Query_RootProject_Interview_Data_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootProject_Interview_FileArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


export type Query_RootProject_Interview_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


export type Query_RootProject_Interview_File_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  interview_id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_LivestockArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


export type Query_RootProject_Interview_Livestock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


export type Query_RootProject_Interview_Livestock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_Livestock_MilkArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


export type Query_RootProject_Interview_Livestock_Milk_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


export type Query_RootProject_Interview_Livestock_Milk_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_NoteArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


export type Query_RootProject_Interview_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


export type Query_RootProject_Interview_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_Productive_AssetArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


export type Query_RootProject_Interview_Productive_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


export type Query_RootProject_Interview_Productive_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_Researcher_MnArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


export type Query_RootProject_Interview_Researcher_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


export type Query_RootProject_Interview_Researcher_Mn_By_PkArgs = {
  project_interview_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootProject_Interview_TotalsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Totals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Totals_Order_By>>;
  where?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
};


export type Query_RootProject_Interview_Totals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Totals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Totals_Order_By>>;
  where?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
};


export type Query_RootProject_Interview_Totals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSale_Purchase_TypeArgs = {
  distinct_on?: InputMaybe<Array<Sale_Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Purchase_Type_Order_By>>;
  where?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
};


export type Query_RootSale_Purchase_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Purchase_Type_Order_By>>;
  where?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
};


export type Query_RootSale_Purchase_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootStatusArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Query_RootStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Query_RootStatus_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootTermArgs = {
  distinct_on?: InputMaybe<Array<Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Order_By>>;
  where?: InputMaybe<Term_Bool_Exp>;
};


export type Query_RootTerm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Order_By>>;
  where?: InputMaybe<Term_Bool_Exp>;
};


export type Query_RootTerm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTerm_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Order_By>>;
  where?: InputMaybe<Term_Category_Bool_Exp>;
};


export type Query_RootTerm_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Order_By>>;
  where?: InputMaybe<Term_Category_Bool_Exp>;
};


export type Query_RootTerm_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTerm_Category_MnArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


export type Query_RootTerm_Category_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


export type Query_RootTerm_Category_Mn_By_PkArgs = {
  category_id: Scalars['uuid']['input'];
  term_id: Scalars['uuid']['input'];
};


export type Query_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Query_RootUser_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Query_RootUser_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Permission_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Query_RootUser_Permission_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Query_RootUser_Permission_Role_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootUser_ProfileArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Query_RootUser_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Query_RootUser_Profile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootWealth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Wealth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wealth_Group_Order_By>>;
  where?: InputMaybe<Wealth_Group_Bool_Exp>;
};


export type Query_RootWealth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wealth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wealth_Group_Order_By>>;
  where?: InputMaybe<Wealth_Group_Bool_Exp>;
};


export type Query_RootWealth_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootZoneArgs = {
  distinct_on?: InputMaybe<Array<Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Order_By>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};


export type Query_RootZone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Order_By>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};


export type Query_RootZone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "sale_purchase_type" */
export type Sale_Purchase_Type = {
  __typename?: 'sale_purchase_type';
  name: Scalars['String']['output'];
};

/** aggregated selection of "sale_purchase_type" */
export type Sale_Purchase_Type_Aggregate = {
  __typename?: 'sale_purchase_type_aggregate';
  aggregate?: Maybe<Sale_Purchase_Type_Aggregate_Fields>;
  nodes: Array<Sale_Purchase_Type>;
};

/** aggregate fields of "sale_purchase_type" */
export type Sale_Purchase_Type_Aggregate_Fields = {
  __typename?: 'sale_purchase_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sale_Purchase_Type_Max_Fields>;
  min?: Maybe<Sale_Purchase_Type_Min_Fields>;
};


/** aggregate fields of "sale_purchase_type" */
export type Sale_Purchase_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sale_Purchase_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sale_purchase_type". All fields are combined with a logical 'AND'. */
export type Sale_Purchase_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Sale_Purchase_Type_Bool_Exp>>;
  _not?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Sale_Purchase_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sale_purchase_type" */
export enum Sale_Purchase_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  SalePurchaseTypePkey = 'sale_purchase_type_pkey'
}

/** input type for inserting data into table "sale_purchase_type" */
export type Sale_Purchase_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sale_Purchase_Type_Max_Fields = {
  __typename?: 'sale_purchase_type_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Sale_Purchase_Type_Min_Fields = {
  __typename?: 'sale_purchase_type_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sale_purchase_type" */
export type Sale_Purchase_Type_Mutation_Response = {
  __typename?: 'sale_purchase_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sale_Purchase_Type>;
};

/** on_conflict condition type for table "sale_purchase_type" */
export type Sale_Purchase_Type_On_Conflict = {
  constraint: Sale_Purchase_Type_Constraint;
  update_columns?: Array<Sale_Purchase_Type_Update_Column>;
  where?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "sale_purchase_type". */
export type Sale_Purchase_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sale_purchase_type */
export type Sale_Purchase_Type_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "sale_purchase_type" */
export enum Sale_Purchase_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "sale_purchase_type" */
export type Sale_Purchase_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "sale_purchase_type" */
export type Sale_Purchase_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sale_Purchase_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sale_Purchase_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "sale_purchase_type" */
export enum Sale_Purchase_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Sale_Purchase_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sale_Purchase_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sale_Purchase_Type_Bool_Exp;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "status" */
export type Status = {
  __typename?: 'status';
  name: Scalars['String']['output'];
  /** An array relationship */
  project_interviews: Array<Project_Interview>;
  /** An aggregate relationship */
  project_interviews_aggregate: Project_Interview_Aggregate;
};


/** columns and relationships of "status" */
export type StatusProject_InterviewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


/** columns and relationships of "status" */
export type StatusProject_Interviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};

/** aggregated selection of "status" */
export type Status_Aggregate = {
  __typename?: 'status_aggregate';
  aggregate?: Maybe<Status_Aggregate_Fields>;
  nodes: Array<Status>;
};

/** aggregate fields of "status" */
export type Status_Aggregate_Fields = {
  __typename?: 'status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Status_Max_Fields>;
  min?: Maybe<Status_Min_Fields>;
};


/** aggregate fields of "status" */
export type Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "status". All fields are combined with a logical 'AND'. */
export type Status_Bool_Exp = {
  _and?: InputMaybe<Array<Status_Bool_Exp>>;
  _not?: InputMaybe<Status_Bool_Exp>;
  _or?: InputMaybe<Array<Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_interviews?: InputMaybe<Project_Interview_Bool_Exp>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "status" */
export enum Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  StatusPkey = 'status_pkey'
}

export enum Status_Enum {
  Archived = 'ARCHIVED',
  Done = 'DONE',
  Final = 'FINAL',
  Locked = 'LOCKED'
}

/** Boolean expression to compare columns of type "status_enum". All fields are combined with logical 'AND'. */
export type Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Status_Enum>;
  _in?: InputMaybe<Array<Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Status_Enum>;
  _nin?: InputMaybe<Array<Status_Enum>>;
};

/** input type for inserting data into table "status" */
export type Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  project_interviews?: InputMaybe<Project_Interview_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Status_Max_Fields = {
  __typename?: 'status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Status_Min_Fields = {
  __typename?: 'status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "status" */
export type Status_Mutation_Response = {
  __typename?: 'status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Status>;
};

/** input type for inserting object relation for remote table "status" */
export type Status_Obj_Rel_Insert_Input = {
  data: Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Status_On_Conflict>;
};

/** on_conflict condition type for table "status" */
export type Status_On_Conflict = {
  constraint: Status_Constraint;
  update_columns?: Array<Status_Update_Column>;
  where?: InputMaybe<Status_Bool_Exp>;
};

/** Ordering options when selecting data from "status". */
export type Status_Order_By = {
  name?: InputMaybe<Order_By>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Order_By>;
};

/** primary key columns input for table: status */
export type Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "status" */
export enum Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "status" */
export type Status_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "status" */
export type Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "status" */
export enum Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Status_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>;
  /** fetch data from the table: "bss_baseline_view" */
  bss_baseline_view: Array<Bss_Baseline_View>;
  /** fetch aggregated fields from the table: "bss_baseline_view" */
  bss_baseline_view_aggregate: Bss_Baseline_View_Aggregate;
  /** fetch data from the table in a streaming manner: "bss_baseline_view" */
  bss_baseline_view_stream: Array<Bss_Baseline_View>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_region" */
  country_region: Array<Country_Region>;
  /** fetch aggregated fields from the table: "country_region" */
  country_region_aggregate: Country_Region_Aggregate;
  /** fetch data from the table: "country_region" using primary key columns */
  country_region_by_pk?: Maybe<Country_Region>;
  /** fetch data from the table in a streaming manner: "country_region" */
  country_region_stream: Array<Country_Region>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "crop_season" */
  crop_season: Array<Crop_Season>;
  /** fetch aggregated fields from the table: "crop_season" */
  crop_season_aggregate: Crop_Season_Aggregate;
  /** fetch data from the table: "crop_season" using primary key columns */
  crop_season_by_pk?: Maybe<Crop_Season>;
  /** fetch data from the table: "crop_season_month_mn" */
  crop_season_month_mn: Array<Crop_Season_Month_Mn>;
  /** fetch aggregated fields from the table: "crop_season_month_mn" */
  crop_season_month_mn_aggregate: Crop_Season_Month_Mn_Aggregate;
  /** fetch data from the table: "crop_season_month_mn" using primary key columns */
  crop_season_month_mn_by_pk?: Maybe<Crop_Season_Month_Mn>;
  /** fetch data from the table in a streaming manner: "crop_season_month_mn" */
  crop_season_month_mn_stream: Array<Crop_Season_Month_Mn>;
  /** fetch data from the table in a streaming manner: "crop_season" */
  crop_season_stream: Array<Crop_Season>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "livestock_milking_season" */
  livestock_milking_season: Array<Livestock_Milking_Season>;
  /** fetch aggregated fields from the table: "livestock_milking_season" */
  livestock_milking_season_aggregate: Livestock_Milking_Season_Aggregate;
  /** fetch data from the table: "livestock_milking_season" using primary key columns */
  livestock_milking_season_by_pk?: Maybe<Livestock_Milking_Season>;
  /** fetch data from the table in a streaming manner: "livestock_milking_season" */
  livestock_milking_season_stream: Array<Livestock_Milking_Season>;
  /** fetch data from the table: "livestock_type" */
  livestock_type: Array<Livestock_Type>;
  /** fetch aggregated fields from the table: "livestock_type" */
  livestock_type_aggregate: Livestock_Type_Aggregate;
  /** fetch data from the table: "livestock_type" using primary key columns */
  livestock_type_by_pk?: Maybe<Livestock_Type>;
  /** fetch data from the table in a streaming manner: "livestock_type" */
  livestock_type_stream: Array<Livestock_Type>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table in a streaming manner: "location" */
  location_stream: Array<Location>;
  /** fetch data from the table: "measure_unit" */
  measure_unit: Array<Measure_Unit>;
  /** fetch aggregated fields from the table: "measure_unit" */
  measure_unit_aggregate: Measure_Unit_Aggregate;
  /** fetch data from the table: "measure_unit" using primary key columns */
  measure_unit_by_pk?: Maybe<Measure_Unit>;
  /** fetch data from the table in a streaming manner: "measure_unit" */
  measure_unit_stream: Array<Measure_Unit>;
  /** fetch data from the table: "measure_unit_type" */
  measure_unit_type: Array<Measure_Unit_Type>;
  /** fetch aggregated fields from the table: "measure_unit_type" */
  measure_unit_type_aggregate: Measure_Unit_Type_Aggregate;
  /** fetch data from the table: "measure_unit_type" using primary key columns */
  measure_unit_type_by_pk?: Maybe<Measure_Unit_Type>;
  /** fetch data from the table in a streaming manner: "measure_unit_type" */
  measure_unit_type_stream: Array<Measure_Unit_Type>;
  /** fetch data from the table: "month" */
  month: Array<Month>;
  /** fetch aggregated fields from the table: "month" */
  month_aggregate: Month_Aggregate;
  /** fetch data from the table: "month" using primary key columns */
  month_by_pk?: Maybe<Month>;
  /** fetch data from the table in a streaming manner: "month" */
  month_stream: Array<Month>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** fetch data from the table: "project_bss_data_backup" */
  project_bss_data_backup: Array<Project_Bss_Data_Backup>;
  /** fetch aggregated fields from the table: "project_bss_data_backup" */
  project_bss_data_backup_aggregate: Project_Bss_Data_Backup_Aggregate;
  /** fetch data from the table: "project_bss_data_backup" using primary key columns */
  project_bss_data_backup_by_pk?: Maybe<Project_Bss_Data_Backup>;
  /** fetch data from the table in a streaming manner: "project_bss_data_backup" */
  project_bss_data_backup_stream: Array<Project_Bss_Data_Backup>;
  /** fetch data from the table: "project_bss_data" using primary key columns */
  project_bss_data_by_pk?: Maybe<Project_Bss_Data>;
  /** fetch data from the table in a streaming manner: "project_bss_data" */
  project_bss_data_stream: Array<Project_Bss_Data>;
  /** fetch data from the table: "project_bss_data_type" */
  project_bss_data_type: Array<Project_Bss_Data_Type>;
  /** fetch aggregated fields from the table: "project_bss_data_type" */
  project_bss_data_type_aggregate: Project_Bss_Data_Type_Aggregate;
  /** fetch data from the table: "project_bss_data_type" using primary key columns */
  project_bss_data_type_by_pk?: Maybe<Project_Bss_Data_Type>;
  /** fetch data from the table in a streaming manner: "project_bss_data_type" */
  project_bss_data_type_stream: Array<Project_Bss_Data_Type>;
  /** fetch data from the table: "project_bss_note" */
  project_bss_note: Array<Project_Bss_Note>;
  /** fetch aggregated fields from the table: "project_bss_note" */
  project_bss_note_aggregate: Project_Bss_Note_Aggregate;
  /** fetch data from the table: "project_bss_note" using primary key columns */
  project_bss_note_by_pk?: Maybe<Project_Bss_Note>;
  /** fetch data from the table in a streaming manner: "project_bss_note" */
  project_bss_note_stream: Array<Project_Bss_Note>;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_file" */
  project_file: Array<Project_File>;
  /** fetch aggregated fields from the table: "project_file" */
  project_file_aggregate: Project_File_Aggregate;
  /** fetch data from the table: "project_file" using primary key columns */
  project_file_by_pk?: Maybe<Project_File>;
  /** fetch data from the table in a streaming manner: "project_file" */
  project_file_stream: Array<Project_File>;
  /** fetch data from the table: "project_interview" */
  project_interview: Array<Project_Interview>;
  /** fetch aggregated fields from the table: "project_interview" */
  project_interview_aggregate: Project_Interview_Aggregate;
  /** fetch data from the table: "project_interview_backup" */
  project_interview_backup: Array<Project_Interview_Backup>;
  /** fetch aggregated fields from the table: "project_interview_backup" */
  project_interview_backup_aggregate: Project_Interview_Backup_Aggregate;
  /** fetch data from the table: "project_interview_backup" using primary key columns */
  project_interview_backup_by_pk?: Maybe<Project_Interview_Backup>;
  /** fetch data from the table in a streaming manner: "project_interview_backup" */
  project_interview_backup_stream: Array<Project_Interview_Backup>;
  /** fetch data from the table: "project_interview_base" */
  project_interview_base: Array<Project_Interview_Base>;
  /** fetch aggregated fields from the table: "project_interview_base" */
  project_interview_base_aggregate: Project_Interview_Base_Aggregate;
  /** fetch data from the table: "project_interview_base" using primary key columns */
  project_interview_base_by_pk?: Maybe<Project_Interview_Base>;
  /** fetch data from the table in a streaming manner: "project_interview_base" */
  project_interview_base_stream: Array<Project_Interview_Base>;
  /** fetch data from the table: "project_interview" using primary key columns */
  project_interview_by_pk?: Maybe<Project_Interview>;
  /** An array relationship */
  project_interview_crops: Array<Project_Interview_Crops>;
  /** An aggregate relationship */
  project_interview_crops_aggregate: Project_Interview_Crops_Aggregate;
  /** fetch data from the table: "project_interview_crops" using primary key columns */
  project_interview_crops_by_pk?: Maybe<Project_Interview_Crops>;
  /** fetch data from the table: "project_interview_crops_green_root" */
  project_interview_crops_green_root: Array<Project_Interview_Crops_Green_Root>;
  /** fetch aggregated fields from the table: "project_interview_crops_green_root" */
  project_interview_crops_green_root_aggregate: Project_Interview_Crops_Green_Root_Aggregate;
  /** fetch data from the table: "project_interview_crops_green_root" using primary key columns */
  project_interview_crops_green_root_by_pk?: Maybe<Project_Interview_Crops_Green_Root>;
  /** fetch data from the table in a streaming manner: "project_interview_crops_green_root" */
  project_interview_crops_green_root_stream: Array<Project_Interview_Crops_Green_Root>;
  /** fetch data from the table: "project_interview_crops_season" */
  project_interview_crops_season: Array<Project_Interview_Crops_Season>;
  /** fetch aggregated fields from the table: "project_interview_crops_season" */
  project_interview_crops_season_aggregate: Project_Interview_Crops_Season_Aggregate;
  /** fetch data from the table: "project_interview_crops_season" using primary key columns */
  project_interview_crops_season_by_pk?: Maybe<Project_Interview_Crops_Season>;
  /** fetch data from the table in a streaming manner: "project_interview_crops_season" */
  project_interview_crops_season_stream: Array<Project_Interview_Crops_Season>;
  /** fetch data from the table in a streaming manner: "project_interview_crops" */
  project_interview_crops_stream: Array<Project_Interview_Crops>;
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
  /** fetch data from the table: "project_interview_data" using primary key columns */
  project_interview_data_by_pk?: Maybe<Project_Interview_Data>;
  /** fetch data from the table in a streaming manner: "project_interview_data" */
  project_interview_data_stream: Array<Project_Interview_Data>;
  /** fetch data from the table: "project_interview_data_type" */
  project_interview_data_type: Array<Project_Interview_Data_Type>;
  /** fetch aggregated fields from the table: "project_interview_data_type" */
  project_interview_data_type_aggregate: Project_Interview_Data_Type_Aggregate;
  /** fetch data from the table: "project_interview_data_type" using primary key columns */
  project_interview_data_type_by_pk?: Maybe<Project_Interview_Data_Type>;
  /** fetch data from the table in a streaming manner: "project_interview_data_type" */
  project_interview_data_type_stream: Array<Project_Interview_Data_Type>;
  /** fetch data from the table: "project_interview_file" */
  project_interview_file: Array<Project_Interview_File>;
  /** fetch aggregated fields from the table: "project_interview_file" */
  project_interview_file_aggregate: Project_Interview_File_Aggregate;
  /** fetch data from the table: "project_interview_file" using primary key columns */
  project_interview_file_by_pk?: Maybe<Project_Interview_File>;
  /** fetch data from the table in a streaming manner: "project_interview_file" */
  project_interview_file_stream: Array<Project_Interview_File>;
  /** fetch data from the table: "project_interview_livestock" */
  project_interview_livestock: Array<Project_Interview_Livestock>;
  /** fetch aggregated fields from the table: "project_interview_livestock" */
  project_interview_livestock_aggregate: Project_Interview_Livestock_Aggregate;
  /** fetch data from the table: "project_interview_livestock" using primary key columns */
  project_interview_livestock_by_pk?: Maybe<Project_Interview_Livestock>;
  /** fetch data from the table: "project_interview_livestock_milk" */
  project_interview_livestock_milk: Array<Project_Interview_Livestock_Milk>;
  /** fetch aggregated fields from the table: "project_interview_livestock_milk" */
  project_interview_livestock_milk_aggregate: Project_Interview_Livestock_Milk_Aggregate;
  /** fetch data from the table: "project_interview_livestock_milk" using primary key columns */
  project_interview_livestock_milk_by_pk?: Maybe<Project_Interview_Livestock_Milk>;
  /** fetch data from the table in a streaming manner: "project_interview_livestock_milk" */
  project_interview_livestock_milk_stream: Array<Project_Interview_Livestock_Milk>;
  /** fetch data from the table in a streaming manner: "project_interview_livestock" */
  project_interview_livestock_stream: Array<Project_Interview_Livestock>;
  /** fetch data from the table: "project_interview_note" */
  project_interview_note: Array<Project_Interview_Note>;
  /** fetch aggregated fields from the table: "project_interview_note" */
  project_interview_note_aggregate: Project_Interview_Note_Aggregate;
  /** fetch data from the table: "project_interview_note" using primary key columns */
  project_interview_note_by_pk?: Maybe<Project_Interview_Note>;
  /** fetch data from the table in a streaming manner: "project_interview_note" */
  project_interview_note_stream: Array<Project_Interview_Note>;
  /** fetch data from the table: "project_interview_productive_asset" */
  project_interview_productive_asset: Array<Project_Interview_Productive_Asset>;
  /** fetch aggregated fields from the table: "project_interview_productive_asset" */
  project_interview_productive_asset_aggregate: Project_Interview_Productive_Asset_Aggregate;
  /** fetch data from the table: "project_interview_productive_asset" using primary key columns */
  project_interview_productive_asset_by_pk?: Maybe<Project_Interview_Productive_Asset>;
  /** fetch data from the table in a streaming manner: "project_interview_productive_asset" */
  project_interview_productive_asset_stream: Array<Project_Interview_Productive_Asset>;
  /** fetch data from the table: "project_interview_researcher_mn" */
  project_interview_researcher_mn: Array<Project_Interview_Researcher_Mn>;
  /** fetch aggregated fields from the table: "project_interview_researcher_mn" */
  project_interview_researcher_mn_aggregate: Project_Interview_Researcher_Mn_Aggregate;
  /** fetch data from the table: "project_interview_researcher_mn" using primary key columns */
  project_interview_researcher_mn_by_pk?: Maybe<Project_Interview_Researcher_Mn>;
  /** fetch data from the table in a streaming manner: "project_interview_researcher_mn" */
  project_interview_researcher_mn_stream: Array<Project_Interview_Researcher_Mn>;
  /** fetch data from the table in a streaming manner: "project_interview" */
  project_interview_stream: Array<Project_Interview>;
  /** fetch data from the table: "project_interview_totals" */
  project_interview_totals: Array<Project_Interview_Totals>;
  /** fetch aggregated fields from the table: "project_interview_totals" */
  project_interview_totals_aggregate: Project_Interview_Totals_Aggregate;
  /** fetch data from the table: "project_interview_totals" using primary key columns */
  project_interview_totals_by_pk?: Maybe<Project_Interview_Totals>;
  /** fetch data from the table in a streaming manner: "project_interview_totals" */
  project_interview_totals_stream: Array<Project_Interview_Totals>;
  /** fetch data from the table in a streaming manner: "project" */
  project_stream: Array<Project>;
  /** fetch data from the table: "sale_purchase_type" */
  sale_purchase_type: Array<Sale_Purchase_Type>;
  /** fetch aggregated fields from the table: "sale_purchase_type" */
  sale_purchase_type_aggregate: Sale_Purchase_Type_Aggregate;
  /** fetch data from the table: "sale_purchase_type" using primary key columns */
  sale_purchase_type_by_pk?: Maybe<Sale_Purchase_Type>;
  /** fetch data from the table in a streaming manner: "sale_purchase_type" */
  sale_purchase_type_stream: Array<Sale_Purchase_Type>;
  /** fetch data from the table: "status" */
  status: Array<Status>;
  /** fetch aggregated fields from the table: "status" */
  status_aggregate: Status_Aggregate;
  /** fetch data from the table: "status" using primary key columns */
  status_by_pk?: Maybe<Status>;
  /** fetch data from the table in a streaming manner: "status" */
  status_stream: Array<Status>;
  /** fetch data from the table: "term" */
  term: Array<Term>;
  /** fetch aggregated fields from the table: "term" */
  term_aggregate: Term_Aggregate;
  /** fetch data from the table: "term" using primary key columns */
  term_by_pk?: Maybe<Term>;
  /** fetch data from the table: "term_category" */
  term_category: Array<Term_Category>;
  /** fetch aggregated fields from the table: "term_category" */
  term_category_aggregate: Term_Category_Aggregate;
  /** fetch data from the table: "term_category" using primary key columns */
  term_category_by_pk?: Maybe<Term_Category>;
  /** fetch data from the table: "term_category_mn" */
  term_category_mn: Array<Term_Category_Mn>;
  /** fetch aggregated fields from the table: "term_category_mn" */
  term_category_mn_aggregate: Term_Category_Mn_Aggregate;
  /** fetch data from the table: "term_category_mn" using primary key columns */
  term_category_mn_by_pk?: Maybe<Term_Category_Mn>;
  /** fetch data from the table in a streaming manner: "term_category_mn" */
  term_category_mn_stream: Array<Term_Category_Mn>;
  /** fetch data from the table in a streaming manner: "term_category" */
  term_category_stream: Array<Term_Category>;
  /** fetch data from the table in a streaming manner: "term" */
  term_stream: Array<Term>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "user_permission" */
  user_permission: Array<User_Permission>;
  /** fetch aggregated fields from the table: "user_permission" */
  user_permission_aggregate: User_Permission_Aggregate;
  /** fetch data from the table: "user_permission" using primary key columns */
  user_permission_by_pk?: Maybe<User_Permission>;
  /** fetch data from the table: "user_permission_role" */
  user_permission_role: Array<User_Permission_Role>;
  /** fetch aggregated fields from the table: "user_permission_role" */
  user_permission_role_aggregate: User_Permission_Role_Aggregate;
  /** fetch data from the table: "user_permission_role" using primary key columns */
  user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** fetch data from the table in a streaming manner: "user_permission_role" */
  user_permission_role_stream: Array<User_Permission_Role>;
  /** fetch data from the table in a streaming manner: "user_permission" */
  user_permission_stream: Array<User_Permission>;
  /** fetch data from the table: "user_profile" */
  user_profile: Array<User_Profile>;
  /** fetch aggregated fields from the table: "user_profile" */
  user_profile_aggregate: User_Profile_Aggregate;
  /** fetch data from the table: "user_profile" using primary key columns */
  user_profile_by_pk?: Maybe<User_Profile>;
  /** fetch data from the table in a streaming manner: "user_profile" */
  user_profile_stream: Array<User_Profile>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "wealth_group" */
  wealth_group: Array<Wealth_Group>;
  /** fetch aggregated fields from the table: "wealth_group" */
  wealth_group_aggregate: Wealth_Group_Aggregate;
  /** fetch data from the table: "wealth_group" using primary key columns */
  wealth_group_by_pk?: Maybe<Wealth_Group>;
  /** fetch data from the table in a streaming manner: "wealth_group" */
  wealth_group_stream: Array<Wealth_Group>;
  /** fetch data from the table: "zone" */
  zone: Array<Zone>;
  /** fetch aggregated fields from the table: "zone" */
  zone_aggregate: Zone_Aggregate;
  /** fetch data from the table: "zone" using primary key columns */
  zone_by_pk?: Maybe<Zone>;
  /** fetch data from the table in a streaming manner: "zone" */
  zone_stream: Array<Zone>;
};


export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootBss_Baseline_ViewArgs = {
  distinct_on?: InputMaybe<Array<Bss_Baseline_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bss_Baseline_View_Order_By>>;
  where?: InputMaybe<Bss_Baseline_View_Bool_Exp>;
};


export type Subscription_RootBss_Baseline_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bss_Baseline_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bss_Baseline_View_Order_By>>;
  where?: InputMaybe<Bss_Baseline_View_Bool_Exp>;
};


export type Subscription_RootBss_Baseline_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bss_Baseline_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Bss_Baseline_View_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCountry_RegionArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Subscription_RootCountry_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Subscription_RootCountry_Region_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCountry_Region_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCrop_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Order_By>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


export type Subscription_RootCrop_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Order_By>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


export type Subscription_RootCrop_Season_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCrop_Season_Month_MnArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


export type Subscription_RootCrop_Season_Month_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Season_Month_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crop_Season_Month_Mn_Order_By>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


export type Subscription_RootCrop_Season_Month_Mn_By_PkArgs = {
  crop_season_id: Scalars['uuid']['input'];
  month: Month_Enum;
};


export type Subscription_RootCrop_Season_Month_Mn_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crop_Season_Month_Mn_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Season_Month_Mn_Bool_Exp>;
};


export type Subscription_RootCrop_Season_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crop_Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Season_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootLivestock_Milking_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Milking_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Milking_Season_Order_By>>;
  where?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
};


export type Subscription_RootLivestock_Milking_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Milking_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Milking_Season_Order_By>>;
  where?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
};


export type Subscription_RootLivestock_Milking_Season_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootLivestock_Milking_Season_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Livestock_Milking_Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Livestock_Milking_Season_Bool_Exp>;
};


export type Subscription_RootLivestock_TypeArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Type_Order_By>>;
  where?: InputMaybe<Livestock_Type_Bool_Exp>;
};


export type Subscription_RootLivestock_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Livestock_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Livestock_Type_Order_By>>;
  where?: InputMaybe<Livestock_Type_Bool_Exp>;
};


export type Subscription_RootLivestock_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootLivestock_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Livestock_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Livestock_Type_Bool_Exp>;
};


export type Subscription_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLocation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootMeasure_UnitArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


export type Subscription_RootMeasure_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Order_By>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


export type Subscription_RootMeasure_Unit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMeasure_Unit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Measure_Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
};


export type Subscription_RootMeasure_Unit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Type_Order_By>>;
  where?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
};


export type Subscription_RootMeasure_Unit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Measure_Unit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Measure_Unit_Type_Order_By>>;
  where?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
};


export type Subscription_RootMeasure_Unit_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootMeasure_Unit_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Measure_Unit_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Measure_Unit_Type_Bool_Exp>;
};


export type Subscription_RootMonthArgs = {
  distinct_on?: InputMaybe<Array<Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Month_Order_By>>;
  where?: InputMaybe<Month_Bool_Exp>;
};


export type Subscription_RootMonth_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Month_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Month_Order_By>>;
  where?: InputMaybe<Month_Bool_Exp>;
};


export type Subscription_RootMonth_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootMonth_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Month_Stream_Cursor_Input>>;
  where?: InputMaybe<Month_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_BackupArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_Backup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_Backup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Bss_Data_Backup_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Bss_Data_Backup_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Bss_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Bss_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Data_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootProject_Bss_Data_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Bss_Data_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bss_Data_Type_Bool_Exp>;
};


export type Subscription_RootProject_Bss_NoteArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


export type Subscription_RootProject_Bss_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Bss_Note_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Bss_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_FileArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


export type Subscription_RootProject_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_File_Order_By>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


export type Subscription_RootProject_File_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  project_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_File_Bool_Exp>;
};


export type Subscription_RootProject_InterviewArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


export type Subscription_RootProject_Interview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


export type Subscription_RootProject_Interview_BackupArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Backup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Backup_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Backup_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Backup_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


export type Subscription_RootProject_Interview_BaseArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Base_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Base_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Base_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Base_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


export type Subscription_RootProject_Interview_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_CropsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Crops_Green_RootArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_Green_Root_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Green_Root_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_Green_Root_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Crops_Green_Root_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Crops_Green_Root_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Crops_Green_Root_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Season_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_Season_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Crops_Season_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Crops_Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Crops_Season_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Crops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Crops_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


export type Subscription_RootProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Data_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Data_TypeArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Data_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Type_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Data_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootProject_Interview_Data_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Data_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Data_Type_Bool_Exp>;
};


export type Subscription_RootProject_Interview_FileArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


export type Subscription_RootProject_Interview_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_File_Order_By>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


export type Subscription_RootProject_Interview_File_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  interview_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_File_Bool_Exp>;
};


export type Subscription_RootProject_Interview_LivestockArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Livestock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Livestock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Livestock_MilkArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Livestock_Milk_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Livestock_Milk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Livestock_Milk_Order_By>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Livestock_Milk_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Livestock_Milk_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Livestock_Milk_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Livestock_Milk_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Livestock_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Livestock_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Livestock_Bool_Exp>;
};


export type Subscription_RootProject_Interview_NoteArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Note_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Productive_AssetArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Productive_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Productive_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Productive_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Productive_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Researcher_MnArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Researcher_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Researcher_Mn_By_PkArgs = {
  project_interview_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Researcher_Mn_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Researcher_Mn_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


export type Subscription_RootProject_Interview_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


export type Subscription_RootProject_Interview_TotalsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Totals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Totals_Order_By>>;
  where?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Totals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Totals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Totals_Order_By>>;
  where?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
};


export type Subscription_RootProject_Interview_Totals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Interview_Totals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Interview_Totals_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Interview_Totals_Bool_Exp>;
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootSale_Purchase_TypeArgs = {
  distinct_on?: InputMaybe<Array<Sale_Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Purchase_Type_Order_By>>;
  where?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
};


export type Subscription_RootSale_Purchase_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sale_Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sale_Purchase_Type_Order_By>>;
  where?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
};


export type Subscription_RootSale_Purchase_Type_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootSale_Purchase_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sale_Purchase_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Sale_Purchase_Type_Bool_Exp>;
};


export type Subscription_RootStatusArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStatus_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootTermArgs = {
  distinct_on?: InputMaybe<Array<Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Order_By>>;
  where?: InputMaybe<Term_Bool_Exp>;
};


export type Subscription_RootTerm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Order_By>>;
  where?: InputMaybe<Term_Bool_Exp>;
};


export type Subscription_RootTerm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTerm_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Order_By>>;
  where?: InputMaybe<Term_Category_Bool_Exp>;
};


export type Subscription_RootTerm_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Order_By>>;
  where?: InputMaybe<Term_Category_Bool_Exp>;
};


export type Subscription_RootTerm_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTerm_Category_MnArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


export type Subscription_RootTerm_Category_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


export type Subscription_RootTerm_Category_Mn_By_PkArgs = {
  category_id: Scalars['uuid']['input'];
  term_id: Scalars['uuid']['input'];
};


export type Subscription_RootTerm_Category_Mn_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Term_Category_Mn_Stream_Cursor_Input>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


export type Subscription_RootTerm_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Term_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Term_Category_Bool_Exp>;
};


export type Subscription_RootTerm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Term_Stream_Cursor_Input>>;
  where?: InputMaybe<Term_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Subscription_RootUser_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Subscription_RootUser_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Permission_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Subscription_RootUser_Permission_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Subscription_RootUser_Permission_Role_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootUser_Permission_Role_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Permission_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Subscription_RootUser_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Subscription_RootUser_ProfileArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Profile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Profile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootWealth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Wealth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wealth_Group_Order_By>>;
  where?: InputMaybe<Wealth_Group_Bool_Exp>;
};


export type Subscription_RootWealth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wealth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wealth_Group_Order_By>>;
  where?: InputMaybe<Wealth_Group_Bool_Exp>;
};


export type Subscription_RootWealth_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWealth_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wealth_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Wealth_Group_Bool_Exp>;
};


export type Subscription_RootZoneArgs = {
  distinct_on?: InputMaybe<Array<Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Order_By>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};


export type Subscription_RootZone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zone_Order_By>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};


export type Subscription_RootZone_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootZone_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Zone_Stream_Cursor_Input>>;
  where?: InputMaybe<Zone_Bool_Exp>;
};

/** columns and relationships of "term" */
export type Term = {
  __typename?: 'term';
  am?: Maybe<Scalars['String']['output']>;
  en: Scalars['String']['output'];
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  kcal?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  projectInterviewDataByTermId: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  projectInterviewDataByTermId_aggregate: Project_Interview_Data_Aggregate;
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** An array relationship */
  project_bss_notes: Array<Project_Bss_Note>;
  /** An aggregate relationship */
  project_bss_notes_aggregate: Project_Bss_Note_Aggregate;
  /** An array relationship */
  project_interview_bases: Array<Project_Interview_Base>;
  /** An aggregate relationship */
  project_interview_bases_aggregate: Project_Interview_Base_Aggregate;
  /** An array relationship */
  project_interview_crops: Array<Project_Interview_Crops>;
  /** An aggregate relationship */
  project_interview_crops_aggregate: Project_Interview_Crops_Aggregate;
  /** An array relationship */
  project_interview_data: Array<Project_Interview_Data>;
  /** An aggregate relationship */
  project_interview_data_aggregate: Project_Interview_Data_Aggregate;
  /** An array relationship */
  project_interview_productive_assets: Array<Project_Interview_Productive_Asset>;
  /** An aggregate relationship */
  project_interview_productive_assets_aggregate: Project_Interview_Productive_Asset_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  term_category_mns: Array<Term_Category_Mn>;
  /** An aggregate relationship */
  term_category_mns_aggregate: Term_Category_Mn_Aggregate;
};


/** columns and relationships of "term" */
export type TermProjectInterviewDataByTermIdArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProjectInterviewDataByTermId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Bss_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Bss_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_BasesArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_Bases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Base_Order_By>>;
  where?: InputMaybe<Project_Interview_Base_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_CropsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Crops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Crops_Order_By>>;
  where?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Data_Order_By>>;
  where?: InputMaybe<Project_Interview_Data_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_Productive_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProject_Interview_Productive_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Productive_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Productive_Asset_Order_By>>;
  where?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermTerm_Category_MnsArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


/** columns and relationships of "term" */
export type TermTerm_Category_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};

/** aggregated selection of "term" */
export type Term_Aggregate = {
  __typename?: 'term_aggregate';
  aggregate?: Maybe<Term_Aggregate_Fields>;
  nodes: Array<Term>;
};

/** aggregate fields of "term" */
export type Term_Aggregate_Fields = {
  __typename?: 'term_aggregate_fields';
  avg?: Maybe<Term_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Term_Max_Fields>;
  min?: Maybe<Term_Min_Fields>;
  stddev?: Maybe<Term_Stddev_Fields>;
  stddev_pop?: Maybe<Term_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Term_Stddev_Samp_Fields>;
  sum?: Maybe<Term_Sum_Fields>;
  var_pop?: Maybe<Term_Var_Pop_Fields>;
  var_samp?: Maybe<Term_Var_Samp_Fields>;
  variance?: Maybe<Term_Variance_Fields>;
};


/** aggregate fields of "term" */
export type Term_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Term_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Term_Avg_Fields = {
  __typename?: 'term_avg_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "term". All fields are combined with a logical 'AND'. */
export type Term_Bool_Exp = {
  _and?: InputMaybe<Array<Term_Bool_Exp>>;
  _not?: InputMaybe<Term_Bool_Exp>;
  _or?: InputMaybe<Array<Term_Bool_Exp>>;
  am?: InputMaybe<String_Comparison_Exp>;
  en?: InputMaybe<String_Comparison_Exp>;
  es?: InputMaybe<String_Comparison_Exp>;
  fr?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kcal?: InputMaybe<Int_Comparison_Exp>;
  projectInterviewDataByTermId?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  projectInterviewDataByTermId_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp>;
  project_interview_bases?: InputMaybe<Project_Interview_Base_Bool_Exp>;
  project_interview_bases_aggregate?: InputMaybe<Project_Interview_Base_Aggregate_Bool_Exp>;
  project_interview_crops?: InputMaybe<Project_Interview_Crops_Bool_Exp>;
  project_interview_crops_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Bool_Exp>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Bool_Exp>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Bool_Exp>;
  project_interview_productive_assets?: InputMaybe<Project_Interview_Productive_Asset_Bool_Exp>;
  project_interview_productive_assets_aggregate?: InputMaybe<Project_Interview_Productive_Asset_Aggregate_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  pt?: InputMaybe<String_Comparison_Exp>;
  term_category_mns?: InputMaybe<Term_Category_Mn_Bool_Exp>;
  term_category_mns_aggregate?: InputMaybe<Term_Category_Mn_Aggregate_Bool_Exp>;
};

/** columns and relationships of "term_category" */
export type Term_Category = {
  __typename?: 'term_category';
  am?: Maybe<Scalars['String']['output']>;
  en: Scalars['String']['output'];
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  term_category_mns: Array<Term_Category_Mn>;
  /** An aggregate relationship */
  term_category_mns_aggregate: Term_Category_Mn_Aggregate;
};


/** columns and relationships of "term_category" */
export type Term_CategoryTerm_Category_MnsArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};


/** columns and relationships of "term_category" */
export type Term_CategoryTerm_Category_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Term_Category_Mn_Order_By>>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};

/** aggregated selection of "term_category" */
export type Term_Category_Aggregate = {
  __typename?: 'term_category_aggregate';
  aggregate?: Maybe<Term_Category_Aggregate_Fields>;
  nodes: Array<Term_Category>;
};

/** aggregate fields of "term_category" */
export type Term_Category_Aggregate_Fields = {
  __typename?: 'term_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Term_Category_Max_Fields>;
  min?: Maybe<Term_Category_Min_Fields>;
};


/** aggregate fields of "term_category" */
export type Term_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Term_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "term_category". All fields are combined with a logical 'AND'. */
export type Term_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Term_Category_Bool_Exp>>;
  _not?: InputMaybe<Term_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Term_Category_Bool_Exp>>;
  am?: InputMaybe<String_Comparison_Exp>;
  en?: InputMaybe<String_Comparison_Exp>;
  es?: InputMaybe<String_Comparison_Exp>;
  fr?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pt?: InputMaybe<String_Comparison_Exp>;
  term_category_mns?: InputMaybe<Term_Category_Mn_Bool_Exp>;
  term_category_mns_aggregate?: InputMaybe<Term_Category_Mn_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "term_category" */
export enum Term_Category_Constraint {
  /** unique or primary key constraint on columns "en" */
  TermCategoryEnKey = 'term_category_en_key',
  /** unique or primary key constraint on columns "id" */
  TermCategoryPkey = 'term_category_pkey'
}

/** input type for inserting data into table "term_category" */
export type Term_Category_Insert_Input = {
  am?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  term_category_mns?: InputMaybe<Term_Category_Mn_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Term_Category_Max_Fields = {
  __typename?: 'term_category_max_fields';
  am?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Term_Category_Min_Fields = {
  __typename?: 'term_category_min_fields';
  am?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "term_category_mn" */
export type Term_Category_Mn = {
  __typename?: 'term_category_mn';
  category_id: Scalars['uuid']['output'];
  /** An object relationship */
  term: Term;
  /** An object relationship */
  term_category: Term_Category;
  term_id: Scalars['uuid']['output'];
};

/** aggregated selection of "term_category_mn" */
export type Term_Category_Mn_Aggregate = {
  __typename?: 'term_category_mn_aggregate';
  aggregate?: Maybe<Term_Category_Mn_Aggregate_Fields>;
  nodes: Array<Term_Category_Mn>;
};

export type Term_Category_Mn_Aggregate_Bool_Exp = {
  count?: InputMaybe<Term_Category_Mn_Aggregate_Bool_Exp_Count>;
};

export type Term_Category_Mn_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Term_Category_Mn_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "term_category_mn" */
export type Term_Category_Mn_Aggregate_Fields = {
  __typename?: 'term_category_mn_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Term_Category_Mn_Max_Fields>;
  min?: Maybe<Term_Category_Mn_Min_Fields>;
};


/** aggregate fields of "term_category_mn" */
export type Term_Category_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Term_Category_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "term_category_mn" */
export type Term_Category_Mn_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Term_Category_Mn_Max_Order_By>;
  min?: InputMaybe<Term_Category_Mn_Min_Order_By>;
};

/** input type for inserting array relation for remote table "term_category_mn" */
export type Term_Category_Mn_Arr_Rel_Insert_Input = {
  data: Array<Term_Category_Mn_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Term_Category_Mn_On_Conflict>;
};

/** Boolean expression to filter rows from the table "term_category_mn". All fields are combined with a logical 'AND'. */
export type Term_Category_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Term_Category_Mn_Bool_Exp>>;
  _not?: InputMaybe<Term_Category_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Term_Category_Mn_Bool_Exp>>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  term?: InputMaybe<Term_Bool_Exp>;
  term_category?: InputMaybe<Term_Category_Bool_Exp>;
  term_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "term_category_mn" */
export enum Term_Category_Mn_Constraint {
  /** unique or primary key constraint on columns "category_id", "term_id" */
  TermCategoryMnPkey = 'term_category_mn_pkey'
}

/** input type for inserting data into table "term_category_mn" */
export type Term_Category_Mn_Insert_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  term?: InputMaybe<Term_Obj_Rel_Insert_Input>;
  term_category?: InputMaybe<Term_Category_Obj_Rel_Insert_Input>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Term_Category_Mn_Max_Fields = {
  __typename?: 'term_category_mn_max_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "term_category_mn" */
export type Term_Category_Mn_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Term_Category_Mn_Min_Fields = {
  __typename?: 'term_category_mn_min_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  term_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "term_category_mn" */
export type Term_Category_Mn_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  term_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "term_category_mn" */
export type Term_Category_Mn_Mutation_Response = {
  __typename?: 'term_category_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Term_Category_Mn>;
};

/** on_conflict condition type for table "term_category_mn" */
export type Term_Category_Mn_On_Conflict = {
  constraint: Term_Category_Mn_Constraint;
  update_columns?: Array<Term_Category_Mn_Update_Column>;
  where?: InputMaybe<Term_Category_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "term_category_mn". */
export type Term_Category_Mn_Order_By = {
  category_id?: InputMaybe<Order_By>;
  term?: InputMaybe<Term_Order_By>;
  term_category?: InputMaybe<Term_Category_Order_By>;
  term_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: term_category_mn */
export type Term_Category_Mn_Pk_Columns_Input = {
  category_id: Scalars['uuid']['input'];
  term_id: Scalars['uuid']['input'];
};

/** select columns of table "term_category_mn" */
export enum Term_Category_Mn_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  TermId = 'term_id'
}

/** input type for updating data in table "term_category_mn" */
export type Term_Category_Mn_Set_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "term_category_mn" */
export type Term_Category_Mn_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Term_Category_Mn_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Term_Category_Mn_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  term_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "term_category_mn" */
export enum Term_Category_Mn_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  TermId = 'term_id'
}

export type Term_Category_Mn_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Term_Category_Mn_Set_Input>;
  /** filter the rows which have to be updated */
  where: Term_Category_Mn_Bool_Exp;
};

/** response of any mutation on the table "term_category" */
export type Term_Category_Mutation_Response = {
  __typename?: 'term_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Term_Category>;
};

/** input type for inserting object relation for remote table "term_category" */
export type Term_Category_Obj_Rel_Insert_Input = {
  data: Term_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Term_Category_On_Conflict>;
};

/** on_conflict condition type for table "term_category" */
export type Term_Category_On_Conflict = {
  constraint: Term_Category_Constraint;
  update_columns?: Array<Term_Category_Update_Column>;
  where?: InputMaybe<Term_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "term_category". */
export type Term_Category_Order_By = {
  am?: InputMaybe<Order_By>;
  en?: InputMaybe<Order_By>;
  es?: InputMaybe<Order_By>;
  fr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pt?: InputMaybe<Order_By>;
  term_category_mns_aggregate?: InputMaybe<Term_Category_Mn_Aggregate_Order_By>;
};

/** primary key columns input for table: term_category */
export type Term_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "term_category" */
export enum Term_Category_Select_Column {
  /** column name */
  Am = 'am',
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Pt = 'pt'
}

/** input type for updating data in table "term_category" */
export type Term_Category_Set_Input = {
  am?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "term_category" */
export type Term_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Term_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Term_Category_Stream_Cursor_Value_Input = {
  am?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "term_category" */
export enum Term_Category_Update_Column {
  /** column name */
  Am = 'am',
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Pt = 'pt'
}

export type Term_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Term_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Term_Category_Bool_Exp;
};

/** unique or primary key constraints on table "term" */
export enum Term_Constraint {
  /** unique or primary key constraint on columns "id" */
  TermPkey = 'term_pkey'
}

/** input type for incrementing numeric columns in table "term" */
export type Term_Inc_Input = {
  kcal?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "term" */
export type Term_Insert_Input = {
  am?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcal?: InputMaybe<Scalars['Int']['input']>;
  projectInterviewDataByTermId?: InputMaybe<Project_Interview_Data_Arr_Rel_Insert_Input>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Arr_Rel_Insert_Input>;
  project_interview_bases?: InputMaybe<Project_Interview_Base_Arr_Rel_Insert_Input>;
  project_interview_crops?: InputMaybe<Project_Interview_Crops_Arr_Rel_Insert_Input>;
  project_interview_data?: InputMaybe<Project_Interview_Data_Arr_Rel_Insert_Input>;
  project_interview_productive_assets?: InputMaybe<Project_Interview_Productive_Asset_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  pt?: InputMaybe<Scalars['String']['input']>;
  term_category_mns?: InputMaybe<Term_Category_Mn_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Term_Max_Fields = {
  __typename?: 'term_max_fields';
  am?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kcal?: Maybe<Scalars['Int']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Term_Min_Fields = {
  __typename?: 'term_min_fields';
  am?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kcal?: Maybe<Scalars['Int']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "term" */
export type Term_Mutation_Response = {
  __typename?: 'term_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Term>;
};

/** input type for inserting object relation for remote table "term" */
export type Term_Obj_Rel_Insert_Input = {
  data: Term_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Term_On_Conflict>;
};

/** on_conflict condition type for table "term" */
export type Term_On_Conflict = {
  constraint: Term_Constraint;
  update_columns?: Array<Term_Update_Column>;
  where?: InputMaybe<Term_Bool_Exp>;
};

/** Ordering options when selecting data from "term". */
export type Term_Order_By = {
  am?: InputMaybe<Order_By>;
  en?: InputMaybe<Order_By>;
  es?: InputMaybe<Order_By>;
  fr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kcal?: InputMaybe<Order_By>;
  projectInterviewDataByTermId_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Order_By>;
  project_interview_bases_aggregate?: InputMaybe<Project_Interview_Base_Aggregate_Order_By>;
  project_interview_crops_aggregate?: InputMaybe<Project_Interview_Crops_Aggregate_Order_By>;
  project_interview_data_aggregate?: InputMaybe<Project_Interview_Data_Aggregate_Order_By>;
  project_interview_productive_assets_aggregate?: InputMaybe<Project_Interview_Productive_Asset_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  pt?: InputMaybe<Order_By>;
  term_category_mns_aggregate?: InputMaybe<Term_Category_Mn_Aggregate_Order_By>;
};

/** primary key columns input for table: term */
export type Term_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "term" */
export enum Term_Select_Column {
  /** column name */
  Am = 'am',
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Kcal = 'kcal',
  /** column name */
  Pt = 'pt'
}

/** input type for updating data in table "term" */
export type Term_Set_Input = {
  am?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcal?: InputMaybe<Scalars['Int']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Term_Stddev_Fields = {
  __typename?: 'term_stddev_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Term_Stddev_Pop_Fields = {
  __typename?: 'term_stddev_pop_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Term_Stddev_Samp_Fields = {
  __typename?: 'term_stddev_samp_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "term" */
export type Term_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Term_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Term_Stream_Cursor_Value_Input = {
  am?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kcal?: InputMaybe<Scalars['Int']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Term_Sum_Fields = {
  __typename?: 'term_sum_fields';
  kcal?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "term" */
export enum Term_Update_Column {
  /** column name */
  Am = 'am',
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Kcal = 'kcal',
  /** column name */
  Pt = 'pt'
}

export type Term_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Term_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Term_Set_Input>;
  /** filter the rows which have to be updated */
  where: Term_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Term_Var_Pop_Fields = {
  __typename?: 'term_var_pop_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Term_Var_Samp_Fields = {
  __typename?: 'term_var_samp_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Term_Variance_Fields = {
  __typename?: 'term_variance_fields';
  kcal?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "user_permission" */
export type User_Permission = {
  __typename?: 'user_permission';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<User_Permission_Role_Enum>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user_permission_role?: Maybe<User_Permission_Role>;
};

/** aggregated selection of "user_permission" */
export type User_Permission_Aggregate = {
  __typename?: 'user_permission_aggregate';
  aggregate?: Maybe<User_Permission_Aggregate_Fields>;
  nodes: Array<User_Permission>;
};

export type User_Permission_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Permission_Aggregate_Bool_Exp_Count>;
};

export type User_Permission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Permission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_permission" */
export type User_Permission_Aggregate_Fields = {
  __typename?: 'user_permission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Permission_Max_Fields>;
  min?: Maybe<User_Permission_Min_Fields>;
};


/** aggregate fields of "user_permission" */
export type User_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_permission" */
export type User_Permission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Permission_Max_Order_By>;
  min?: InputMaybe<User_Permission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_permission" */
export type User_Permission_Arr_Rel_Insert_Input = {
  data: Array<User_Permission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Permission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_permission". All fields are combined with a logical 'AND'. */
export type User_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<User_Permission_Bool_Exp>>;
  _not?: InputMaybe<User_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<User_Permission_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<User_Permission_Role_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_permission_role?: InputMaybe<User_Permission_Role_Bool_Exp>;
};

/** unique or primary key constraints on table "user_permission" */
export enum User_Permission_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPermissionPkey = 'user_permission_pkey'
}

/** input type for inserting data into table "user_permission" */
export type User_Permission_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<User_Permission_Role_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_permission_role?: InputMaybe<User_Permission_Role_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Permission_Max_Fields = {
  __typename?: 'user_permission_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_permission" */
export type User_Permission_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Permission_Min_Fields = {
  __typename?: 'user_permission_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_permission" */
export type User_Permission_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_permission" */
export type User_Permission_Mutation_Response = {
  __typename?: 'user_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Permission>;
};

/** on_conflict condition type for table "user_permission" */
export type User_Permission_On_Conflict = {
  constraint: User_Permission_Constraint;
  update_columns?: Array<User_Permission_Update_Column>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "user_permission". */
export type User_Permission_Order_By = {
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_permission_role?: InputMaybe<User_Permission_Role_Order_By>;
};

/** primary key columns input for table: user_permission */
export type User_Permission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "user_permission_role" */
export type User_Permission_Role = {
  __typename?: 'user_permission_role';
  name: Scalars['String']['output'];
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
};


/** columns and relationships of "user_permission_role" */
export type User_Permission_RoleUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** columns and relationships of "user_permission_role" */
export type User_Permission_RoleUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "user_permission_role" */
export type User_Permission_Role_Aggregate = {
  __typename?: 'user_permission_role_aggregate';
  aggregate?: Maybe<User_Permission_Role_Aggregate_Fields>;
  nodes: Array<User_Permission_Role>;
};

/** aggregate fields of "user_permission_role" */
export type User_Permission_Role_Aggregate_Fields = {
  __typename?: 'user_permission_role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Permission_Role_Max_Fields>;
  min?: Maybe<User_Permission_Role_Min_Fields>;
};


/** aggregate fields of "user_permission_role" */
export type User_Permission_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_permission_role". All fields are combined with a logical 'AND'. */
export type User_Permission_Role_Bool_Exp = {
  _and?: InputMaybe<Array<User_Permission_Role_Bool_Exp>>;
  _not?: InputMaybe<User_Permission_Role_Bool_Exp>;
  _or?: InputMaybe<Array<User_Permission_Role_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_permission_role" */
export enum User_Permission_Role_Constraint {
  /** unique or primary key constraint on columns "name" */
  UserPermissionRolePkey = 'user_permission_role_pkey'
}

export enum User_Permission_Role_Enum {
  Admin = 'ADMIN',
  Researcher = 'RESEARCHER'
}

/** Boolean expression to compare columns of type "user_permission_role_enum". All fields are combined with logical 'AND'. */
export type User_Permission_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Permission_Role_Enum>;
  _in?: InputMaybe<Array<User_Permission_Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Permission_Role_Enum>;
  _nin?: InputMaybe<Array<User_Permission_Role_Enum>>;
};

/** input type for inserting data into table "user_permission_role" */
export type User_Permission_Role_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Permission_Role_Max_Fields = {
  __typename?: 'user_permission_role_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Permission_Role_Min_Fields = {
  __typename?: 'user_permission_role_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_permission_role" */
export type User_Permission_Role_Mutation_Response = {
  __typename?: 'user_permission_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Permission_Role>;
};

/** input type for inserting object relation for remote table "user_permission_role" */
export type User_Permission_Role_Obj_Rel_Insert_Input = {
  data: User_Permission_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Permission_Role_On_Conflict>;
};

/** on_conflict condition type for table "user_permission_role" */
export type User_Permission_Role_On_Conflict = {
  constraint: User_Permission_Role_Constraint;
  update_columns?: Array<User_Permission_Role_Update_Column>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "user_permission_role". */
export type User_Permission_Role_Order_By = {
  name?: InputMaybe<Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: user_permission_role */
export type User_Permission_Role_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "user_permission_role" */
export enum User_Permission_Role_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "user_permission_role" */
export type User_Permission_Role_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_permission_role" */
export type User_Permission_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Permission_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Permission_Role_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_permission_role" */
export enum User_Permission_Role_Update_Column {
  /** column name */
  Name = 'name'
}

export type User_Permission_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Permission_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Permission_Role_Bool_Exp;
};

/** select columns of table "user_permission" */
export enum User_Permission_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_permission" */
export type User_Permission_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<User_Permission_Role_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_permission" */
export type User_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Permission_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<User_Permission_Role_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_permission" */
export enum User_Permission_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

export type User_Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Permission_Bool_Exp;
};

/** columns and relationships of "user_profile" */
export type User_Profile = {
  __typename?: 'user_profile';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_profile" */
export type User_Profile_Aggregate = {
  __typename?: 'user_profile_aggregate';
  aggregate?: Maybe<User_Profile_Aggregate_Fields>;
  nodes: Array<User_Profile>;
};

/** aggregate fields of "user_profile" */
export type User_Profile_Aggregate_Fields = {
  __typename?: 'user_profile_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Profile_Max_Fields>;
  min?: Maybe<User_Profile_Min_Fields>;
};


/** aggregate fields of "user_profile" */
export type User_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_profile". All fields are combined with a logical 'AND'. */
export type User_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profile_Bool_Exp>>;
  _not?: InputMaybe<User_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profile_Bool_Exp>>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profile" */
export enum User_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilePkey = 'user_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserProfileUserIdKey = 'user_profile_user_id_key'
}

/** input type for inserting data into table "user_profile" */
export type User_Profile_Insert_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Profile_Max_Fields = {
  __typename?: 'user_profile_max_fields';
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Profile_Min_Fields = {
  __typename?: 'user_profile_min_fields';
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_profile" */
export type User_Profile_Mutation_Response = {
  __typename?: 'user_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profile>;
};

/** input type for inserting object relation for remote table "user_profile" */
export type User_Profile_Obj_Rel_Insert_Input = {
  data: User_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};

/** on_conflict condition type for table "user_profile" */
export type User_Profile_On_Conflict = {
  constraint: User_Profile_Constraint;
  update_columns?: Array<User_Profile_Update_Column>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profile". */
export type User_Profile_Order_By = {
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profile */
export type User_Profile_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_profile" */
export enum User_Profile_Select_Column {
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_profile" */
export type User_Profile_Set_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_profile" */
export type User_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profile_Stream_Cursor_Value_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_profile" */
export enum User_Profile_Update_Column {
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UserId = 'user_id'
}

export type User_Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profile_Bool_Exp;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole: Scalars['String']['output'];
  /** An object relationship */
  defaultRoleByRole: AuthRoles;
  disabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale: Scalars['String']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt: Scalars['timestamptz']['output'];
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** An array relationship */
  project_bss_data_backups: Array<Project_Bss_Data_Backup>;
  /** An aggregate relationship */
  project_bss_data_backups_aggregate: Project_Bss_Data_Backup_Aggregate;
  /** An array relationship */
  project_bss_notes: Array<Project_Bss_Note>;
  /** An aggregate relationship */
  project_bss_notes_aggregate: Project_Bss_Note_Aggregate;
  /** An array relationship */
  project_interview_backups: Array<Project_Interview_Backup>;
  /** An aggregate relationship */
  project_interview_backups_aggregate: Project_Interview_Backup_Aggregate;
  /** An array relationship */
  project_interview_notes: Array<Project_Interview_Note>;
  /** An aggregate relationship */
  project_interview_notes_aggregate: Project_Interview_Note_Aggregate;
  /** An array relationship */
  project_interview_researcher_mns: Array<Project_Interview_Researcher_Mn>;
  /** An aggregate relationship */
  project_interview_researcher_mns_aggregate: Project_Interview_Researcher_Mn_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An array relationship */
  projectsByTeamleaderUserId: Array<Project>;
  /** An aggregate relationship */
  projectsByTeamleaderUserId_aggregate: Project_Aggregate;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  /** An array relationship */
  roles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt: Scalars['timestamptz']['output'];
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
  /** An object relationship */
  user_profile?: Maybe<User_Profile>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Bss_Data_BackupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Bss_Data_Backups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Backup_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Bss_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Bss_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Note_Order_By>>;
  where?: InputMaybe<Project_Bss_Note_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Interview_BackupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Interview_Backups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Backup_Order_By>>;
  where?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Interview_NotesArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Interview_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Note_Order_By>>;
  where?: InputMaybe<Project_Interview_Note_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Interview_Researcher_MnsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProject_Interview_Researcher_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Researcher_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Researcher_Mn_Order_By>>;
  where?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProjectsByTeamleaderUserIdArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProjectsByTeamleaderUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp>;
  avatarUrl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentChallenge?: InputMaybe<String_Comparison_Exp>;
  defaultRole?: InputMaybe<String_Comparison_Exp>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  newEmail?: InputMaybe<Citext_Comparison_Exp>;
  otpHash?: InputMaybe<String_Comparison_Exp>;
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp>;
  passwordHash?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
  project_bss_data_backups?: InputMaybe<Project_Bss_Data_Backup_Bool_Exp>;
  project_bss_data_backups_aggregate?: InputMaybe<Project_Bss_Data_Backup_Aggregate_Bool_Exp>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Bool_Exp>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Bool_Exp>;
  project_interview_backups?: InputMaybe<Project_Interview_Backup_Bool_Exp>;
  project_interview_backups_aggregate?: InputMaybe<Project_Interview_Backup_Aggregate_Bool_Exp>;
  project_interview_notes?: InputMaybe<Project_Interview_Note_Bool_Exp>;
  project_interview_notes_aggregate?: InputMaybe<Project_Interview_Note_Aggregate_Bool_Exp>;
  project_interview_researcher_mns?: InputMaybe<Project_Interview_Researcher_Mn_Bool_Exp>;
  project_interview_researcher_mns_aggregate?: InputMaybe<Project_Interview_Researcher_Mn_Aggregate_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projectsByTeamleaderUserId?: InputMaybe<Project_Bool_Exp>;
  projectsByTeamleaderUserId_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  roles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>;
  ticket?: InputMaybe<String_Comparison_Exp>;
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  totpSecret?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Bool_Exp>;
  user_profile?: InputMaybe<User_Profile_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
  project_bss_data_backups?: InputMaybe<Project_Bss_Data_Backup_Arr_Rel_Insert_Input>;
  project_bss_notes?: InputMaybe<Project_Bss_Note_Arr_Rel_Insert_Input>;
  project_interview_backups?: InputMaybe<Project_Interview_Backup_Arr_Rel_Insert_Input>;
  project_interview_notes?: InputMaybe<Project_Interview_Note_Arr_Rel_Insert_Input>;
  project_interview_researcher_mns?: InputMaybe<Project_Interview_Researcher_Mn_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  projectsByTeamleaderUserId?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
  user_profile?: InputMaybe<User_Profile_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By>;
  disabled?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAnonymous?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  phoneNumberVerified?: InputMaybe<Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
  project_bss_data_backups_aggregate?: InputMaybe<Project_Bss_Data_Backup_Aggregate_Order_By>;
  project_bss_notes_aggregate?: InputMaybe<Project_Bss_Note_Aggregate_Order_By>;
  project_interview_backups_aggregate?: InputMaybe<Project_Interview_Backup_Aggregate_Order_By>;
  project_interview_notes_aggregate?: InputMaybe<Project_Interview_Note_Aggregate_Order_By>;
  project_interview_researcher_mns_aggregate?: InputMaybe<Project_Interview_Researcher_Mn_Aggregate_Order_By>;
  projectsByTeamleaderUserId_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
  user_profile?: InputMaybe<User_Profile_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

/** columns and relationships of "wealth_group" */
export type Wealth_Group = {
  __typename?: 'wealth_group';
  en: Scalars['String']['output'];
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  project_bss_data: Array<Project_Bss_Data>;
  /** An aggregate relationship */
  project_bss_data_aggregate: Project_Bss_Data_Aggregate;
  /** An array relationship */
  project_interviews: Array<Project_Interview>;
  /** An aggregate relationship */
  project_interviews_aggregate: Project_Interview_Aggregate;
  pt?: Maybe<Scalars['String']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "wealth_group" */
export type Wealth_GroupProject_Bss_DataArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "wealth_group" */
export type Wealth_GroupProject_Bss_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Bss_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Bss_Data_Order_By>>;
  where?: InputMaybe<Project_Bss_Data_Bool_Exp>;
};


/** columns and relationships of "wealth_group" */
export type Wealth_GroupProject_InterviewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};


/** columns and relationships of "wealth_group" */
export type Wealth_GroupProject_Interviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Interview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Interview_Order_By>>;
  where?: InputMaybe<Project_Interview_Bool_Exp>;
};

/** aggregated selection of "wealth_group" */
export type Wealth_Group_Aggregate = {
  __typename?: 'wealth_group_aggregate';
  aggregate?: Maybe<Wealth_Group_Aggregate_Fields>;
  nodes: Array<Wealth_Group>;
};

/** aggregate fields of "wealth_group" */
export type Wealth_Group_Aggregate_Fields = {
  __typename?: 'wealth_group_aggregate_fields';
  avg?: Maybe<Wealth_Group_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wealth_Group_Max_Fields>;
  min?: Maybe<Wealth_Group_Min_Fields>;
  stddev?: Maybe<Wealth_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Wealth_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wealth_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Wealth_Group_Sum_Fields>;
  var_pop?: Maybe<Wealth_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Wealth_Group_Var_Samp_Fields>;
  variance?: Maybe<Wealth_Group_Variance_Fields>;
};


/** aggregate fields of "wealth_group" */
export type Wealth_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wealth_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Wealth_Group_Avg_Fields = {
  __typename?: 'wealth_group_avg_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "wealth_group". All fields are combined with a logical 'AND'. */
export type Wealth_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Wealth_Group_Bool_Exp>>;
  _not?: InputMaybe<Wealth_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Wealth_Group_Bool_Exp>>;
  en?: InputMaybe<String_Comparison_Exp>;
  es?: InputMaybe<String_Comparison_Exp>;
  fr?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Bool_Exp>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Bool_Exp>;
  project_interviews?: InputMaybe<Project_Interview_Bool_Exp>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Bool_Exp>;
  pt?: InputMaybe<String_Comparison_Exp>;
  sorting?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "wealth_group" */
export enum Wealth_Group_Constraint {
  /** unique or primary key constraint on columns "en" */
  WealthGroupEnKey = 'wealth_group_en_key',
  /** unique or primary key constraint on columns "id" */
  WealthGroupIdKey = 'wealth_group_id_key',
  /** unique or primary key constraint on columns "id" */
  WealthGroupPkey = 'wealth_group_pkey',
  /** unique or primary key constraint on columns "sorting" */
  WealthGroupSortingKey = 'wealth_group_sorting_key'
}

/** input type for incrementing numeric columns in table "wealth_group" */
export type Wealth_Group_Inc_Input = {
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "wealth_group" */
export type Wealth_Group_Insert_Input = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_bss_data?: InputMaybe<Project_Bss_Data_Arr_Rel_Insert_Input>;
  project_interviews?: InputMaybe<Project_Interview_Arr_Rel_Insert_Input>;
  pt?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Wealth_Group_Max_Fields = {
  __typename?: 'wealth_group_max_fields';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Wealth_Group_Min_Fields = {
  __typename?: 'wealth_group_min_fields';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "wealth_group" */
export type Wealth_Group_Mutation_Response = {
  __typename?: 'wealth_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wealth_Group>;
};

/** input type for inserting object relation for remote table "wealth_group" */
export type Wealth_Group_Obj_Rel_Insert_Input = {
  data: Wealth_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wealth_Group_On_Conflict>;
};

/** on_conflict condition type for table "wealth_group" */
export type Wealth_Group_On_Conflict = {
  constraint: Wealth_Group_Constraint;
  update_columns?: Array<Wealth_Group_Update_Column>;
  where?: InputMaybe<Wealth_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "wealth_group". */
export type Wealth_Group_Order_By = {
  en?: InputMaybe<Order_By>;
  es?: InputMaybe<Order_By>;
  fr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_bss_data_aggregate?: InputMaybe<Project_Bss_Data_Aggregate_Order_By>;
  project_interviews_aggregate?: InputMaybe<Project_Interview_Aggregate_Order_By>;
  pt?: InputMaybe<Order_By>;
  sorting?: InputMaybe<Order_By>;
};

/** primary key columns input for table: wealth_group */
export type Wealth_Group_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "wealth_group" */
export enum Wealth_Group_Select_Column {
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Pt = 'pt',
  /** column name */
  Sorting = 'sorting'
}

/** input type for updating data in table "wealth_group" */
export type Wealth_Group_Set_Input = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Wealth_Group_Stddev_Fields = {
  __typename?: 'wealth_group_stddev_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Wealth_Group_Stddev_Pop_Fields = {
  __typename?: 'wealth_group_stddev_pop_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Wealth_Group_Stddev_Samp_Fields = {
  __typename?: 'wealth_group_stddev_samp_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "wealth_group" */
export type Wealth_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wealth_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wealth_Group_Stream_Cursor_Value_Input = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Wealth_Group_Sum_Fields = {
  __typename?: 'wealth_group_sum_fields';
  sorting?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "wealth_group" */
export enum Wealth_Group_Update_Column {
  /** column name */
  En = 'en',
  /** column name */
  Es = 'es',
  /** column name */
  Fr = 'fr',
  /** column name */
  Id = 'id',
  /** column name */
  Pt = 'pt',
  /** column name */
  Sorting = 'sorting'
}

export type Wealth_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wealth_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wealth_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wealth_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wealth_Group_Var_Pop_Fields = {
  __typename?: 'wealth_group_var_pop_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Wealth_Group_Var_Samp_Fields = {
  __typename?: 'wealth_group_var_samp_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Wealth_Group_Variance_Fields = {
  __typename?: 'wealth_group_variance_fields';
  sorting?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "zone" */
export type Zone = {
  __typename?: 'zone';
  /** An object relationship */
  country: Country;
  country_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  locations: Array<Location>;
  /** An aggregate relationship */
  locations_aggregate: Location_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "zone" */
export type ZoneLocationsArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "zone" */
export type ZoneLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** aggregated selection of "zone" */
export type Zone_Aggregate = {
  __typename?: 'zone_aggregate';
  aggregate?: Maybe<Zone_Aggregate_Fields>;
  nodes: Array<Zone>;
};

export type Zone_Aggregate_Bool_Exp = {
  count?: InputMaybe<Zone_Aggregate_Bool_Exp_Count>;
};

export type Zone_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Zone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Zone_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "zone" */
export type Zone_Aggregate_Fields = {
  __typename?: 'zone_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Zone_Max_Fields>;
  min?: Maybe<Zone_Min_Fields>;
};


/** aggregate fields of "zone" */
export type Zone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Zone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "zone" */
export type Zone_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Zone_Max_Order_By>;
  min?: InputMaybe<Zone_Min_Order_By>;
};

/** input type for inserting array relation for remote table "zone" */
export type Zone_Arr_Rel_Insert_Input = {
  data: Array<Zone_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Zone_On_Conflict>;
};

/** Boolean expression to filter rows from the table "zone". All fields are combined with a logical 'AND'. */
export type Zone_Bool_Exp = {
  _and?: InputMaybe<Array<Zone_Bool_Exp>>;
  _not?: InputMaybe<Zone_Bool_Exp>;
  _or?: InputMaybe<Array<Zone_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locations?: InputMaybe<Location_Bool_Exp>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "zone" */
export enum Zone_Constraint {
  /** unique or primary key constraint on columns "name" */
  ZoneNameKey = 'zone_name_key',
  /** unique or primary key constraint on columns "id" */
  ZonePkey = 'zone_pkey'
}

/** input type for inserting data into table "zone" */
export type Zone_Insert_Input = {
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locations?: InputMaybe<Location_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Zone_Max_Fields = {
  __typename?: 'zone_max_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "zone" */
export type Zone_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Zone_Min_Fields = {
  __typename?: 'zone_min_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "zone" */
export type Zone_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "zone" */
export type Zone_Mutation_Response = {
  __typename?: 'zone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Zone>;
};

/** input type for inserting object relation for remote table "zone" */
export type Zone_Obj_Rel_Insert_Input = {
  data: Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Zone_On_Conflict>;
};

/** on_conflict condition type for table "zone" */
export type Zone_On_Conflict = {
  constraint: Zone_Constraint;
  update_columns?: Array<Zone_Update_Column>;
  where?: InputMaybe<Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "zone". */
export type Zone_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: zone */
export type Zone_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "zone" */
export enum Zone_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "zone" */
export type Zone_Set_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "zone" */
export type Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Zone_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "zone" */
export enum Zone_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Zone_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Zone_Bool_Exp;
};

export type CountryFragment = { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string };

export type CountryListQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryListQuery = { __typename?: 'query_root', country: Array<{ __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }> };

export type DeleteCountryMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteCountryMutation = { __typename?: 'mutation_root', delete_country?: { __typename?: 'country_mutation_response', affected_rows: number } | null };

export type UpsertCountryMutationVariables = Exact<{
  object: Country_Insert_Input;
}>;


export type UpsertCountryMutation = { __typename?: 'mutation_root', insert_country_one?: { __typename?: 'country', en: string, es?: string | null, fr?: string | null, id: any, key: string, pt?: string | null } | null };

export type CountryRegionFragmentFragment = { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> };

export type CountryRegionQueryVariables = Exact<{
  where?: InputMaybe<Country_Region_Bool_Exp>;
}>;


export type CountryRegionQuery = { __typename?: 'query_root', country_region: Array<{ __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }> };

export type DeleteCountryRegionMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteCountryRegionMutation = { __typename?: 'mutation_root', delete_country_region?: { __typename?: 'country_region_mutation_response', affected_rows: number } | null };

export type UpsertCountryRegionMutationVariables = Exact<{
  objects: Array<Country_Region_Insert_Input> | Country_Region_Insert_Input;
}>;


export type UpsertCountryRegionMutation = { __typename?: 'mutation_root', insert_country_region?: { __typename?: 'country_region_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }> } | null };

export type CropSeasonFragment = { __typename?: 'crop_season', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, crop_season_month_mns: Array<{ __typename?: 'crop_season_month_mn', crop_season_id: any, month: Month_Enum }> };

export type CropSeasonListQueryVariables = Exact<{
  where?: InputMaybe<Crop_Season_Bool_Exp>;
}>;


export type CropSeasonListQuery = { __typename?: 'query_root', crop_season: Array<{ __typename?: 'crop_season', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, crop_season_month_mns: Array<{ __typename?: 'crop_season_month_mn', crop_season_id: any, month: Month_Enum }> }> };

export type DeleteCropSeasonMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteCropSeasonMutation = { __typename?: 'mutation_root', delete_crop_season?: { __typename?: 'crop_season_mutation_response', affected_rows: number } | null };

export type UpsertCropSeasonMutationVariables = Exact<{
  object: Crop_Season_Insert_Input;
  mnObjects: Array<Crop_Season_Month_Mn_Insert_Input> | Crop_Season_Month_Mn_Insert_Input;
  seasonId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpsertCropSeasonMutation = { __typename?: 'mutation_root', insert_crop_season_one?: { __typename?: 'crop_season', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, crop_season_month_mns: Array<{ __typename?: 'crop_season_month_mn', crop_season_id: any, month: Month_Enum }> } | null, delete_crop_season_month_mn?: { __typename?: 'crop_season_month_mn_mutation_response', affected_rows: number } | null, insert_crop_season_month_mn?: { __typename?: 'crop_season_month_mn_mutation_response', affected_rows: number } | null };

export type DeleteLocationMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteLocationMutation = { __typename?: 'mutation_root', delete_location?: { __typename?: 'location_mutation_response', affected_rows: number } | null };

export type LocationFragmentFragment = { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } };

export type LocationQueryVariables = Exact<{
  where?: InputMaybe<Location_Bool_Exp>;
}>;


export type LocationQuery = { __typename?: 'query_root', location: Array<{ __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }> };

export type UpsertLocationMutationVariables = Exact<{
  objects: Array<Location_Insert_Input> | Location_Insert_Input;
}>;


export type UpsertLocationMutation = { __typename?: 'mutation_root', insert_location?: { __typename?: 'location_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }> } | null };

export type DeleteMeasureUnitMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteMeasureUnitMutation = { __typename?: 'mutation_root', delete_measure_unit?: { __typename?: 'measure_unit_mutation_response', affected_rows: number } | null };

export type MeasureUnitFragment = { __typename?: 'measure_unit', id: any, type: Measure_Unit_Type_Enum, multiplier: any, name: string, country_id?: any | null, country?: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } | null };

export type MeasureListQueryVariables = Exact<{
  where?: InputMaybe<Measure_Unit_Bool_Exp>;
}>;


export type MeasureListQuery = { __typename?: 'query_root', measure_unit: Array<{ __typename?: 'measure_unit', id: any, type: Measure_Unit_Type_Enum, multiplier: any, name: string, country_id?: any | null, country?: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } | null }> };

export type UpsertMeasureMutationVariables = Exact<{
  object: Measure_Unit_Insert_Input;
}>;


export type UpsertMeasureMutation = { __typename?: 'mutation_root', insert_measure_unit_one?: { __typename?: 'measure_unit', id: any, type: Measure_Unit_Type_Enum, multiplier: any, name: string, country_id?: any | null, country?: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } | null } | null };

export type DeleteTermMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteTermMutation = { __typename?: 'mutation_root', delete_term?: { __typename?: 'term_mutation_response', affected_rows: number } | null };

export type TermFragment = { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> };

export type TermListQueryVariables = Exact<{
  where?: InputMaybe<Term_Bool_Exp>;
  orderBy?: InputMaybe<Array<Term_Order_By> | Term_Order_By>;
}>;


export type TermListQuery = { __typename?: 'query_root', term: Array<{ __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> }> };

export type TermSimpleFragment = { __typename?: 'term', id: any, en: string, am?: string | null, pt?: string | null, es?: string | null, fr?: string | null, kcal?: number | null };

export type UpsertTermMutationVariables = Exact<{
  object: Term_Insert_Input;
  termId?: InputMaybe<Scalars['uuid']['input']>;
  mnObjects: Array<Term_Category_Mn_Insert_Input> | Term_Category_Mn_Insert_Input;
}>;


export type UpsertTermMutation = { __typename?: 'mutation_root', insert_term_one?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, delete_term_category_mn?: { __typename?: 'term_category_mn_mutation_response', affected_rows: number } | null, insert_term_category_mn?: { __typename?: 'term_category_mn_mutation_response', affected_rows: number } | null };

export type DeleteTermCategoryMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteTermCategoryMutation = { __typename?: 'mutation_root', delete_term_category?: { __typename?: 'term_category_mutation_response', affected_rows: number } | null };

export type TermCategoryFragment = { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null };

export type TermCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type TermCategoryListQuery = { __typename?: 'query_root', term_category: Array<{ __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null }> };

export type UpsertTermCategoryMutationVariables = Exact<{
  object: Term_Category_Insert_Input;
}>;


export type UpsertTermCategoryMutation = { __typename?: 'mutation_root', insert_term_category_one?: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } | null };

export type DeleteWealthGroupMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteWealthGroupMutation = { __typename?: 'mutation_root', delete_wealth_group?: { __typename?: 'wealth_group_mutation_response', affected_rows: number } | null };

export type UpsertWealthGroupMutationVariables = Exact<{
  object: Wealth_Group_Insert_Input;
}>;


export type UpsertWealthGroupMutation = { __typename?: 'mutation_root', insert_wealth_group_one?: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null } | null };

export type WealthGroupFragment = { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null };

export type WealthGroupListQueryVariables = Exact<{ [key: string]: never; }>;


export type WealthGroupListQuery = { __typename?: 'query_root', wealth_group: Array<{ __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }> };

export type DeleteZoneMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteZoneMutation = { __typename?: 'mutation_root', delete_zone?: { __typename?: 'zone_mutation_response', affected_rows: number } | null };

export type UpsertZoneMutationVariables = Exact<{
  objects: Array<Zone_Insert_Input> | Zone_Insert_Input;
}>;


export type UpsertZoneMutation = { __typename?: 'mutation_root', insert_zone?: { __typename?: 'zone_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }> } | null };

export type ZoneFragment = { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } };

export type ZoneListQueryVariables = Exact<{ [key: string]: never; }>;


export type ZoneListQuery = { __typename?: 'query_root', zone: Array<{ __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }> };

export type DeleteInterviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteInterviewMutation = { __typename?: 'mutation_root', delete_project_interview_by_pk?: { __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> } | null };

export type InsertInterviewsMutationVariables = Exact<{
  objects: Array<Project_Interview_Insert_Input> | Project_Interview_Insert_Input;
}>;


export type InsertInterviewsMutation = { __typename?: 'mutation_root', insert_project_interview?: { __typename?: 'project_interview_mutation_response', affected_rows: number } | null };

export type InterviewByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InterviewByPkQuery = { __typename?: 'query_root', project_interview_by_pk?: { __typename?: 'project_interview', project_id: any, location_id: any, id: any, status?: Status_Enum | null, created_at: any, updated_at: any, date?: any | null, project: { __typename?: 'project', id: any, name: string }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, project_interview_base?: { __typename?: 'project_interview_base', id: any, is_done?: boolean | null, created_at?: any | null } | null, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, displayName: string } }> } | null };

export type InterviewDetailFragment = { __typename?: 'project_interview', id: any, status?: Status_Enum | null, created_at: any, updated_at: any, date?: any | null };

export type InterviewBasicFragment = { __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> };

export type UpdateProjectInterviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Project_Interview_Set_Input;
  researchData: Array<Project_Interview_Researcher_Mn_Insert_Input> | Project_Interview_Researcher_Mn_Insert_Input;
}>;


export type UpdateProjectInterviewMutation = { __typename?: 'mutation_root', update_project_interview_by_pk?: { __typename?: 'project_interview', id: any, status?: Status_Enum | null, created_at: any, updated_at: any, date?: any | null } | null, delete_project_interview_researcher_mn?: { __typename?: 'project_interview_researcher_mn_mutation_response', affected_rows: number } | null, insert_project_interview_researcher_mn?: { __typename?: 'project_interview_researcher_mn_mutation_response', affected_rows: number } | null };

export type UpdateProjectInterviewSimpleMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Project_Interview_Set_Input;
}>;


export type UpdateProjectInterviewSimpleMutation = { __typename?: 'mutation_root', update_project_interview_by_pk?: { __typename?: 'project_interview', id: any, status?: Status_Enum | null, created_at: any, updated_at: any, date?: any | null } | null };

export type DeleteProjectMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteProjectMutation = { __typename?: 'mutation_root', delete_project?: { __typename?: 'project_mutation_response', affected_rows: number } | null };

export type InsertProjectMutationVariables = Exact<{
  object: Project_Insert_Input;
}>;


export type InsertProjectMutation = { __typename?: 'mutation_root', insert_project_one?: { __typename?: 'project', id: any, name: string } | null };

export type ProjectByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProjectByPkQuery = { __typename?: 'query_root', project_by_pk?: { __typename?: 'project', id: any, name: string, created_at: any, updated_at: any, finished?: boolean | null, supervisor_user_id?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, deleted?: boolean | null, main_staple_id?: any | null, avg_price_main_staple_kg?: any | null, schooldays_year?: number | null, teamleader_user_id?: any | null, school_food_kcal?: any | null, reference_period_duration?: number | null, reference_period_description?: string | null, password?: string | null, kcal_pppd?: any | null, currency?: string | null, currency_exchange_usd?: any | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, user?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, project_interview_base?: { __typename?: 'project_interview_base', id: any, is_done?: boolean | null, created_at?: any | null } | null, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> }> } | null };

export type ProjectDetailFragment = { __typename?: 'project', id: any, name: string, created_at: any, updated_at: any, finished?: boolean | null, supervisor_user_id?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, deleted?: boolean | null, main_staple_id?: any | null, avg_price_main_staple_kg?: any | null, schooldays_year?: number | null, teamleader_user_id?: any | null, school_food_kcal?: any | null, reference_period_duration?: number | null, reference_period_description?: string | null, password?: string | null, kcal_pppd?: any | null, currency?: string | null, currency_exchange_usd?: any | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, user?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, project_interview_base?: { __typename?: 'project_interview_base', id: any, is_done?: boolean | null, created_at?: any | null } | null, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> }> };

export type ProjectFragment = { __typename?: 'project', id: any, name: string, created_at: any, updated_at: any, finished?: boolean | null, supervisor_user_id?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, deleted?: boolean | null, main_staple_id?: any | null, user?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, project_interview_base?: { __typename?: 'project_interview_base', id: any, is_done?: boolean | null, created_at?: any | null } | null, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> }>, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null };

export type ProjectListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectListQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, created_at: any, updated_at: any, finished?: boolean | null, supervisor_user_id?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, deleted?: boolean | null, main_staple_id?: any | null, user?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, project_interview_base?: { __typename?: 'project_interview_base', id: any, is_done?: boolean | null, created_at?: any | null } | null, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> }>, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null }> };

export type ProjectScalarFragment = { __typename?: 'project', avg_price_main_staple_kg?: any | null, schooldays_year?: number | null, teamleader_user_id?: any | null, supervisor_user_id?: any | null, school_food_kcal?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, reference_period_duration?: number | null, reference_period_description?: string | null, password?: string | null, name: string, main_staple_id?: any | null, kcal_pppd?: any | null, finished?: boolean | null, currency?: string | null, currency_exchange_usd?: any | null };

export type UpdateProjectMutationVariables = Exact<{
  set: Project_Set_Input;
  id: Scalars['uuid']['input'];
}>;


export type UpdateProjectMutation = { __typename?: 'mutation_root', update_project_by_pk?: { __typename?: 'project', id: any, name: string, created_at: any, updated_at: any, finished?: boolean | null, supervisor_user_id?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, deleted?: boolean | null, main_staple_id?: any | null, avg_price_main_staple_kg?: any | null, schooldays_year?: number | null, teamleader_user_id?: any | null, school_food_kcal?: any | null, reference_period_duration?: number | null, reference_period_description?: string | null, password?: string | null, kcal_pppd?: any | null, currency?: string | null, currency_exchange_usd?: any | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, user?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, date?: any | null, status?: Status_Enum | null, wealth_group_id: any, location_id: any, project_interview_base?: { __typename?: 'project_interview_base', id: any, is_done?: boolean | null, created_at?: any | null } | null, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> }> } | null };

export type DeleteUsersMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteUsersMutation = { __typename?: 'mutation_root', deleteUsers?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type MeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MeQuery = { __typename?: 'query_root', user?: { __typename?: 'users', email?: any | null, metadata?: any | null, user_permissions: Array<{ __typename?: 'user_permission', id: any, project_id?: any | null, role?: User_Permission_Role_Enum | null }>, project_bss_data: Array<{ __typename?: 'project_bss_data', project_id: any, id: any, is_resolved?: boolean | null }>, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', project_interview_id: any }> } | null };

export type UpsertUserProfileMutationVariables = Exact<{
  object: User_Profile_Insert_Input;
}>;


export type UpsertUserProfileMutation = { __typename?: 'mutation_root', insert_user_profile_one?: { __typename?: 'user_profile', first_name?: string | null, last_name?: string | null, id: any, user_id: any } | null };

export type UpsertUserMutationVariables = Exact<{
  object: Users_Insert_Input;
}>;


export type UpsertUserMutation = { __typename?: 'mutation_root', insertUser?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null };

export type UserFragment = { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
}>;


export type UsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null }> };

export type BssBaselineDetailQueryVariables = Exact<{
  baselineId: Scalars['uuid']['input'];
}>;


export type BssBaselineDetailQuery = { __typename?: 'query_root', project_by_pk?: { __typename?: 'project', avg_price_main_staple_kg?: any | null, schooldays_year?: number | null, teamleader_user_id?: any | null, supervisor_user_id?: any | null, school_food_kcal?: any | null, reference_period_start?: any | null, reference_period_end?: any | null, reference_period_duration?: number | null, reference_period_description?: string | null, password?: string | null, name: string, main_staple_id?: any | null, kcal_pppd?: any | null, finished?: boolean | null, currency?: string | null, currency_exchange_usd?: any | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null } | null, project_interview_base: Array<{ __typename?: 'project_interview_base', people_in_household?: any | null, children_primary_school?: any | null, children_secondary_school?: any | null, interviewees_female?: any | null, interviewees_male?: any | null, land_cultivated_cash?: any | null, land_cultivated_food?: any | null, land_outsourced?: any | null, land_owned?: any | null, land_unit_conversion?: any | null, land_unit_conversion_id?: any | null, other_productive_assets?: any | null, comments?: string | null, leftover_cereal_amount?: any | null, leftover_cereal_term_id?: any | null, leftover_cereal_total_calories?: any | null, leftover_cereal_months?: any | null, date?: any | null, created_at?: any | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, project_interview_productive_assets: Array<{ __typename?: 'project_interview_productive_asset', amount?: any | null, term_id: any, term: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } }>, project_interview: { __typename?: 'project_interview', project_id: any, location_id: any, wealth_group_id: any, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null } } }>, project_interview_livestock: Array<{ __typename?: 'project_interview_livestock', total_start?: any | null, total_sold?: any | null, total_purchases?: any | null, total_given_away?: any | null, total_exchanged?: any | null, total_end?: any | null, total_eggs_consumed?: any | null, total_cash_expenses?: any | null, total_calories?: any | null, slaughtered?: any | null, new_birth?: any | null, new_birth_secondary?: any | null, milked_female?: any | null, meat_quantity_sold?: any | null, meat_quantity_given_away?: any | null, meat_price_per_kg?: any | null, meat_per_carcass?: any | null, losses_reason?: string | null, losses_death?: any | null, is_exchanged_resold?: boolean | null, given_away_reason?: string | null, breeding_female?: any | null, balance_consumed?: any | null, animals_other?: any | null, total_cash_income?: any | null, type: Livestock_Type_Enum, total_kcal_calories_consumed_eggs?: any | null, total_off_peak_milk_exchanged_calories?: any | null, total_peak_milk_exchanged_calories?: any | null, total_peak_milk_calories?: any | null, total_off_peak_milk_calories?: any | null, total_bartered_calories?: any | null, project_interview_data: Array<{ __typename?: 'project_interview_data', price?: any | null, amount?: any | null, term_id?: any | null, quantity?: any | null, months?: any | null, is_resold?: boolean | null, quantity_unit_id?: any | null, quantity_unit?: any | null, description?: string | null, total_kcal?: any | null, total_expenses?: any | null, total_cash_income?: any | null, type: Project_Interview_Data_Type_Enum, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null }>, off_peak_milk?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, peak_milk?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, peak_milk_secondary?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, off_peak_milk_secondary?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, project_interview_base: { __typename?: 'project_interview_base', project_interview: { __typename?: 'project_interview', project_id: any, id: any, location_id: any, wealth_group_id: any } } }>, project_interview_totals: Array<{ __typename?: 'project_interview_totals', cash_income_self_employment?: any | null, cash_income_remittance_credit?: any | null, cash_income_migration?: any | null, cash_income_livestock?: any | null, cash_income_labour_jobs?: any | null, cash_income_labour_exchange?: any | null, cash_income_food_aid?: any | null, cash_income_fishing_wild_food?: any | null, cash_income_crops?: any | null, cash_expenses_wild_food?: any | null, cash_expenses_remittance_credit?: any | null, cash_expenses_purchases_non_food?: any | null, cash_expenses_purchases_food?: any | null, cash_expenses_livestock?: any | null, cash_expenses_food_aid?: any | null, cash_expenses_crops?: any | null, calories_purchases?: any | null, calories_migration?: any | null, calories_livestock?: any | null, calories_labour_jobs?: any | null, calories_labour_exchange?: any | null, calories_food_aid?: any | null, calories_fishing_wild_food?: any | null, calories_crops?: any | null, project_interview_base: { __typename?: 'project_interview_base', project_interview: { __typename?: 'project_interview', id: any, location_id: any, wealth_group_id: any } } }>, interviews: Array<{ __typename?: 'project_interview', id: any, project_id: any, location_id: any, date?: any | null, location: { __typename?: 'location', id: any, name: string }, project_interview_base?: { __typename?: 'project_interview_base', date?: any | null } | null }>, wealth_groups: Array<{ __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null, project_interviews_aggregate: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'project_interview', id: any, location_id: any }> } }>, bss_baseline_view: Array<{ __typename?: 'bss_baseline_view', type?: string | null, project_id?: any | null, term_id?: any | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, data: Array<{ __typename?: 'project_interview_data', total_cash_income?: any | null, total_expenses?: any | null, type: Project_Interview_Data_Type_Enum, term_id?: any | null, activity?: string | null, amount?: any | null, total_quantity?: any | null, total_kcal?: any | null, times_money_sent?: any | null, sold_unit?: any | null, sold_quantity?: any | null, quantity?: any | null, quantity_unit_id?: any | null, project_interview_id?: any | null, profit_per_unit?: any | null, profit_by_person?: any | null, price?: any | null, people?: any | null, payment_nr_times?: any | null, other_uses?: any | null, number_children?: any | null, months?: any | null, meals_included?: boolean | null, location?: string | null, livestock_id?: any | null, is_school?: boolean | null, is_resold?: boolean | null, is_payment_person?: boolean | null, is_food?: boolean | null, is_expenditure?: boolean | null, is_area_based?: boolean | null, food_term_id?: any | null, food_amount?: any | null, duration?: any | null, description?: string | null, crop_id?: any | null, quantity_unit?: any | null, payment?: any | null, food_term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, project_interview_base?: { __typename?: 'project_interview_base', project_interview: { __typename?: 'project_interview', project_id: any, id: any, location_id: any, wealth_group_id: any } } | null }> }>, schoolfeeding_data: Array<{ __typename?: 'project_interview_data', type: Project_Interview_Data_Type_Enum, number_children?: any | null, total_kcal?: any | null, project_interview_base?: { __typename?: 'project_interview_base', project_interview: { __typename?: 'project_interview', project_id: any, id: any, location_id: any, wealth_group_id: any } } | null }>, migration_data: Array<{ __typename?: 'project_interview_data', type: Project_Interview_Data_Type_Enum, activity?: string | null, location?: string | null, people?: any | null, months?: any | null, times_money_sent?: any | null, amount?: any | null, total_cash_income?: any | null, total_kcal?: any | null, project_interview_base?: { __typename?: 'project_interview_base', project_interview: { __typename?: 'project_interview', project_id: any, id: any, location_id: any, wealth_group_id: any } } | null }>, project_interview_crops_season: Array<{ __typename?: 'project_interview_crops_season', id: any, interview_id: any, crop_season_id?: any | null, total_kcal_consumed?: any | null, total_expenses?: any | null, total_consumed?: any | null, total_kcal?: any | null, total_cash_income?: any | null, harvested_crops?: string | null, green_crops?: { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null } | null, root_crops?: { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null } | null, project_interview_crops: Array<{ __typename?: 'project_interview_crops', when_sold?: any | null, total_produced?: any | null, sold_unit_measure?: any | null, sold_price_per_unit?: any | null, produced_unit_measure?: any | null, produced_quantity?: any | null, months_consumption?: any | null, losses?: any | null, total_kcal_consumed?: any | null, total_consumed?: any | null, sold_quantity?: any | null, other_uses?: any | null, total_sold?: any | null, total_given_away?: any | null, total_cash_income?: any | null, produced_unit_measure_id?: any | null, total_kcal?: any | null, sold_unit_measure_id?: any | null, term_id?: any | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null }>, season?: { __typename?: 'crop_season', name: string, crop_season_month_mns: Array<{ __typename?: 'crop_season_month_mn', month: Month_Enum }> } | null, project_interview_data: Array<{ __typename?: 'project_interview_data', price?: any | null, quantity?: any | null, total_cash_income?: any | null, total_expenses?: any | null, term_id?: any | null, months?: any | null, is_resold?: boolean | null, total_kcal?: any | null, amount?: any | null, description?: string | null, quantity_unit?: any | null, quantity_unit_id?: any | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null }>, project_interview_base: { __typename?: 'project_interview_base', project_interview: { __typename?: 'project_interview', project_id: any, wealth_group_id: any, location_id: any, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', name: string } } } }> };

export type BssDataFragment = { __typename?: 'project_bss_data', id: any, project_id: any, wealth_group_id: any, kcal?: any | null, type: Project_Bss_Data_Type_Enum, term_id?: any | null, season_id?: any | null, livestock_type?: Livestock_Type_Enum | null, created_at: any, total_kcal?: any | null, total_expenses?: any | null, total_cash_income?: any | null, non_significant?: boolean | null, is_resolved?: boolean | null, data?: any | null };

export type BssDataQueryVariables = Exact<{
  baselineId: Scalars['uuid']['input'];
}>;


export type BssDataQuery = { __typename?: 'query_root', project_bss_data: Array<{ __typename?: 'project_bss_data', id: any, project_id: any, wealth_group_id: any, kcal?: any | null, type: Project_Bss_Data_Type_Enum, term_id?: any | null, season_id?: any | null, livestock_type?: Livestock_Type_Enum | null, created_at: any, total_kcal?: any | null, total_expenses?: any | null, total_cash_income?: any | null, non_significant?: boolean | null, is_resolved?: boolean | null, data?: any | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, user?: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } | null }>, project_bss_note: Array<{ __typename?: 'project_bss_note', id: any, project_id: any, type?: string | null, message?: string | null, term_id?: any | null, created_at: any, user_id: any, livestock_type?: Livestock_Type_Enum | null, season_id?: any | null, updated_at?: any | null, is_done?: boolean | null, is_deleted?: boolean | null, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> };

export type BssNoteFragment = { __typename?: 'project_bss_note', id: any, project_id: any, type?: string | null, message?: string | null, term_id?: any | null, created_at: any, user_id: any, livestock_type?: Livestock_Type_Enum | null, season_id?: any | null, updated_at?: any | null, is_done?: boolean | null, is_deleted?: boolean | null };

export type UploadBssDataMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  objects: Array<Project_Bss_Data_Insert_Input> | Project_Bss_Data_Insert_Input;
  noteObjects: Array<Project_Bss_Note_Insert_Input> | Project_Bss_Note_Insert_Input;
  backupObject: Project_Bss_Data_Backup_Insert_Input;
}>;


export type UploadBssDataMutation = { __typename?: 'mutation_root', delete_project_bss_data?: { __typename?: 'project_bss_data_mutation_response', affected_rows: number } | null, insert_project_bss_data?: { __typename?: 'project_bss_data_mutation_response', affected_rows: number } | null, insert_project_bss_data_backup_one?: { __typename?: 'project_bss_data_backup', id: any } | null, insert_project_bss_note?: { __typename?: 'project_bss_note_mutation_response', affected_rows: number } | null };

export type BssProjectListQueryVariables = Exact<{ [key: string]: never; }>;


export type BssProjectListQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, user?: { __typename?: 'users', id: any, email?: any | null, user_profile?: { __typename?: 'user_profile', first_name?: string | null, last_name?: string | null } | null } | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, user_profile?: { __typename?: 'user_profile', first_name?: string | null, last_name?: string | null } | null } | null, interviewZone: Array<{ __typename?: 'project_interview', location: { __typename?: 'location', country_region: { __typename?: 'country_region', country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }, zone: { __typename?: 'zone', name: string } } }>, locationTotal: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, interviewsTotal: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, interviewsDone: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, interviewsLocked: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, project_interviews: Array<{ __typename?: 'project_interview', project_interview_base?: { __typename?: 'project_interview_base', interviewees_female?: any | null, interviewees_male?: any | null } | null }> }> };

export type BssProjectListFragment = { __typename?: 'project', id: any, name: string, user?: { __typename?: 'users', id: any, email?: any | null, user_profile?: { __typename?: 'user_profile', first_name?: string | null, last_name?: string | null } | null } | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, user_profile?: { __typename?: 'user_profile', first_name?: string | null, last_name?: string | null } | null } | null, interviewZone: Array<{ __typename?: 'project_interview', location: { __typename?: 'location', country_region: { __typename?: 'country_region', country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }, zone: { __typename?: 'zone', name: string } } }>, locationTotal: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, interviewsTotal: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, interviewsDone: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, interviewsLocked: { __typename?: 'project_interview_aggregate', aggregate?: { __typename?: 'project_interview_aggregate_fields', count: number } | null }, project_interviews: Array<{ __typename?: 'project_interview', project_interview_base?: { __typename?: 'project_interview_base', interviewees_female?: any | null, interviewees_male?: any | null } | null }> };

export type AllBssVariablesQueryVariables = Exact<{
  where: Term_Bool_Exp;
  termOrderBy?: InputMaybe<Array<Term_Order_By> | Term_Order_By>;
}>;


export type AllBssVariablesQuery = { __typename?: 'query_root', term: Array<{ __typename?: 'term', am?: string | null, en: string, es?: string | null, fr?: string | null, id: any, kcal?: number | null, pt?: string | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', am?: string | null, en: string, es?: string | null, fr?: string | null, id: any, pt?: string | null } }> }> };

export type AllVariablesQueryVariables = Exact<{
  termOrderBy?: InputMaybe<Array<Term_Order_By> | Term_Order_By>;
  measureUnitOrderBy?: InputMaybe<Array<Measure_Unit_Order_By> | Measure_Unit_Order_By>;
  cropSeasonOrderBy?: InputMaybe<Array<Crop_Season_Order_By> | Crop_Season_Order_By>;
}>;


export type AllVariablesQuery = { __typename?: 'query_root', term: Array<{ __typename?: 'term', am?: string | null, en: string, es?: string | null, fr?: string | null, id: any, kcal?: number | null, pt?: string | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', am?: string | null, en: string, es?: string | null, fr?: string | null, id: any, pt?: string | null } }> }>, measure_unit: Array<{ __typename?: 'measure_unit', id: any, name: string, country_id?: any | null, type: Measure_Unit_Type_Enum, multiplier: any }>, crop_season: Array<{ __typename?: 'crop_season', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, crop_season_month_mns: Array<{ __typename?: 'crop_season_month_mn', crop_season_id: any, month: Month_Enum }> }> };

export type GetAllOnlineDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOnlineDataQuery = { __typename?: 'query_root', country: Array<{ __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }>, term_category: Array<{ __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null }>, term: Array<{ __typename?: 'term', id: any, en: string, am?: string | null, pt?: string | null, es?: string | null, fr?: string | null, kcal?: number | null }>, term_category_mn: Array<{ __typename?: 'term_category_mn', term_id: any, category_id: any }>, crop_season: Array<{ __typename?: 'crop_season', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, crop_season_month_mns: Array<{ __typename?: 'crop_season_month_mn', crop_season_id: any, month: Month_Enum }> }>, crop_season_month_mn: Array<{ __typename?: 'crop_season_month_mn', month: Month_Enum, crop_season_id: any }>, measure_unit: Array<{ __typename?: 'measure_unit', id: any, type: Measure_Unit_Type_Enum, multiplier: any, name: string, country_id?: any | null, country?: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } | null }> };

export type ProjectListTssQueryVariables = Exact<{
  where: Project_Bool_Exp;
}>;


export type ProjectListTssQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: any, name: string, school_food_kcal?: any | null, schooldays_year?: number | null, currency?: string | null, currency_exchange_usd?: any | null, avg_price_main_staple_kg?: any | null, deleted?: boolean | null, finished?: boolean | null, reference_period_end?: any | null, reference_period_start?: any | null, reference_period_duration?: number | null, kcal_pppd?: any | null, main_staple_id?: any | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, displayName: string } | null, user?: { __typename?: 'users', id: any, email?: any | null, displayName: string } | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, project_id: any, date?: any | null, status?: Status_Enum | null, created_at: any, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region: { __typename?: 'country_region', id: any, name: string, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }, zone: { __typename?: 'zone', id: any, name: string } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user: { __typename?: 'users', id: any, email?: any | null, displayName: string } }>, project_interview_base?: { __typename?: 'project_interview_base', id: any, created_at?: any | null, is_done?: boolean | null } | null, project_interview_notes_aggregate: { __typename?: 'project_interview_note_aggregate', aggregate?: { __typename?: 'project_interview_note_aggregate_fields', count: number } | null } }> }> };

export type ProjectTssQueryFragment = { __typename?: 'project', id: any, name: string, school_food_kcal?: any | null, schooldays_year?: number | null, currency?: string | null, currency_exchange_usd?: any | null, avg_price_main_staple_kg?: any | null, deleted?: boolean | null, finished?: boolean | null, reference_period_end?: any | null, reference_period_start?: any | null, reference_period_duration?: number | null, kcal_pppd?: any | null, main_staple_id?: any | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, displayName: string } | null, user?: { __typename?: 'users', id: any, email?: any | null, displayName: string } | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, project_id: any, date?: any | null, status?: Status_Enum | null, created_at: any, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region: { __typename?: 'country_region', id: any, name: string, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }, zone: { __typename?: 'zone', id: any, name: string } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user: { __typename?: 'users', id: any, email?: any | null, displayName: string } }>, project_interview_base?: { __typename?: 'project_interview_base', id: any, created_at?: any | null, is_done?: boolean | null } | null, project_interview_notes_aggregate: { __typename?: 'project_interview_note_aggregate', aggregate?: { __typename?: 'project_interview_note_aggregate_fields', count: number } | null } }> };

export type TssInterviewUpdateStateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  done: Scalars['Boolean']['input'];
}>;


export type TssInterviewUpdateStateMutation = { __typename?: 'mutation_root', update_project_interview_base_by_pk?: { __typename?: 'project_interview_base', id: any } | null };

export type TssProjectOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TssProjectOneQuery = { __typename?: 'query_root', project_by_pk?: { __typename?: 'project', id: any, name: string, school_food_kcal?: any | null, schooldays_year?: number | null, currency?: string | null, currency_exchange_usd?: any | null, avg_price_main_staple_kg?: any | null, deleted?: boolean | null, finished?: boolean | null, reference_period_end?: any | null, reference_period_start?: any | null, reference_period_duration?: number | null, kcal_pppd?: any | null, main_staple_id?: any | null, userTeamleader?: { __typename?: 'users', id: any, email?: any | null, displayName: string } | null, user?: { __typename?: 'users', id: any, email?: any | null, displayName: string } | null, term?: { __typename?: 'term', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null, kcal?: number | null, term_category_mns: Array<{ __typename?: 'term_category_mn', category_id: any, term_category: { __typename?: 'term_category', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, am?: string | null } }> } | null, project_interviews: Array<{ __typename?: 'project_interview', id: any, project_id: any, date?: any | null, status?: Status_Enum | null, created_at: any, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, location: { __typename?: 'location', id: any, name: string, country_region: { __typename?: 'country_region', id: any, name: string, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } }, zone: { __typename?: 'zone', id: any, name: string } }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user: { __typename?: 'users', id: any, email?: any | null, displayName: string } }>, project_interview_base?: { __typename?: 'project_interview_base', id: any, created_at?: any | null, is_done?: boolean | null } | null, project_interview_notes_aggregate: { __typename?: 'project_interview_note_aggregate', aggregate?: { __typename?: 'project_interview_note_aggregate_fields', count: number } | null } }> } | null };

export type UpdateInterviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Project_Interview_Set_Input;
}>;


export type UpdateInterviewMutation = { __typename?: 'mutation_root', update_project_interview_by_pk?: { __typename?: 'project_interview', id: any, status?: Status_Enum | null, created_at: any, updated_at: any, date?: any | null } | null };

export type FileFragment = { __typename?: 'files', id: any, name?: string | null, size?: number | null, mimeType?: string | null, bucketId: string };

export type InsertProjectInterviewFileMutationVariables = Exact<{
  objects: Array<Project_Interview_File_Insert_Input> | Project_Interview_File_Insert_Input;
}>;


export type InsertProjectInterviewFileMutation = { __typename?: 'mutation_root', insert_project_interview_file?: { __typename?: 'project_interview_file_mutation_response', affected_rows: number } | null };

export type InsertProjectFilesMutationVariables = Exact<{
  objects: Array<Project_File_Insert_Input> | Project_File_Insert_Input;
}>;


export type InsertProjectFilesMutation = { __typename?: 'mutation_root', insert_project_file?: { __typename?: 'project_file_mutation_response', affected_rows: number } | null };

export type InterviewFilesQueryVariables = Exact<{
  interviewId: Scalars['uuid']['input'];
}>;


export type InterviewFilesQuery = { __typename?: 'query_root', project_interview_file: Array<{ __typename?: 'project_interview_file', file: { __typename?: 'files', id: any, name?: string | null, size?: number | null, mimeType?: string | null, bucketId: string } }> };

export type ProjectFilesQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectFilesQuery = { __typename?: 'query_root', project_file: Array<{ __typename?: 'project_file', project_id: any, location_id?: any | null, file: { __typename?: 'files', id: any, name?: string | null, size?: number | null, mimeType?: string | null, bucketId: string }, location?: { __typename?: 'location', id: any, name: string } | null }> };

export type InterviewsTssQueryVariables = Exact<{
  where?: InputMaybe<Project_Interview_Bool_Exp>;
}>;


export type InterviewsTssQuery = { __typename?: 'query_root', project_interview: Array<{ __typename?: 'project_interview', id: any, status?: Status_Enum | null, date?: any | null, location_id: any, wealth_group_id: any, location: { __typename?: 'location', id: any, name: string, country_region_id: any, zone_id: any, country_region: { __typename?: 'country_region', id: any, name: string, country_id: any, parent_id?: any | null, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string }, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null, country_region?: { __typename?: 'country_region', id: any, name: string, parent_id?: any | null } | null } | null } | null } | null, country_regions: Array<{ __typename?: 'country_region', id: any, name: string }> }, zone: { __typename?: 'zone', id: any, name: string, country_id: any, country: { __typename?: 'country', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, key: string } } }, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null } }> };

export type TssNoteFragment = { __typename?: 'project_interview_note', id: any, is_deleted?: boolean | null, is_done?: boolean | null, message: string, created_at: any, updated_at?: any | null, user_id: any, interview_id: any };

export type TssNotesQueryVariables = Exact<{
  interviewId: Scalars['uuid']['input'];
}>;


export type TssNotesQuery = { __typename?: 'query_root', project_interview_note: Array<{ __typename?: 'project_interview_note', id: any, is_deleted?: boolean | null, is_done?: boolean | null, message: string, created_at: any, updated_at?: any | null, user_id: any, interview_id: any, user: { __typename?: 'users', id: any, email?: any | null, emailVerified: boolean, createdAt: any, updatedAt: any, disabled: boolean, lastSeen?: any | null, displayName: string, user_profile?: { __typename?: 'user_profile', id: any, first_name?: string | null, last_name?: string | null } | null } }> };

export type TssNotesUpdateMutationVariables = Exact<{
  objects: Array<Project_Interview_Note_Insert_Input> | Project_Interview_Note_Insert_Input;
}>;


export type TssNotesUpdateMutation = { __typename?: 'mutation_root', insert_project_interview_note?: { __typename?: 'project_interview_note_mutation_response', affected_rows: number } | null };

export type InterviewBaseFragment = { __typename?: 'project_interview_base', people_in_household?: any | null, children_primary_school?: any | null, children_secondary_school?: any | null, interviewees_female?: any | null, interviewees_male?: any | null, land_cultivated_cash?: any | null, land_cultivated_food?: any | null, land_outsourced?: any | null, land_owned?: any | null, land_unit_conversion?: any | null, land_unit_conversion_id?: any | null, other_productive_assets?: any | null, comments?: string | null, leftover_cereal_amount?: any | null, leftover_cereal_term_id?: any | null, leftover_cereal_total_calories?: any | null, leftover_cereal_months?: any | null, date?: any | null, created_at?: any | null };

export type CropProductionFragment = { __typename?: 'project_interview_crops', when_sold?: any | null, total_produced?: any | null, sold_unit_measure?: any | null, sold_price_per_unit?: any | null, produced_unit_measure?: any | null, produced_quantity?: any | null, months_consumption?: any | null, losses?: any | null, total_kcal_consumed?: any | null, total_consumed?: any | null, sold_quantity?: any | null, other_uses?: any | null, total_sold?: any | null, total_given_away?: any | null, total_cash_income?: any | null, produced_unit_measure_id?: any | null, total_kcal?: any | null, sold_unit_measure_id?: any | null, term_id?: any | null };

export type InterviewCropsDataFragment = { __typename?: 'project_interview_data', price?: any | null, quantity?: any | null, total_cash_income?: any | null, total_expenses?: any | null, term_id?: any | null, months?: any | null, is_resold?: boolean | null, total_kcal?: any | null, amount?: any | null, description?: string | null, quantity_unit?: any | null, quantity_unit_id?: any | null };

export type GreenRootCropsFragment = { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null };

export type InterviewCropsSeasonBaseFragment = { __typename?: 'project_interview_crops_season', id: any, interview_id: any, crop_season_id?: any | null, total_kcal_consumed?: any | null, total_expenses?: any | null, total_consumed?: any | null, total_kcal?: any | null, total_cash_income?: any | null, harvested_crops?: string | null };

export type InterviewCropsSeasonsFragment = { __typename?: 'project_interview_crops_season', id: any, interview_id: any, crop_season_id?: any | null, total_kcal_consumed?: any | null, total_expenses?: any | null, total_consumed?: any | null, total_kcal?: any | null, total_cash_income?: any | null, harvested_crops?: string | null, green_crops?: { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null } | null, root_crops?: { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null } | null, project_interview_crops: Array<{ __typename?: 'project_interview_crops', when_sold?: any | null, total_produced?: any | null, sold_unit_measure?: any | null, sold_price_per_unit?: any | null, produced_unit_measure?: any | null, produced_quantity?: any | null, months_consumption?: any | null, losses?: any | null, total_kcal_consumed?: any | null, total_consumed?: any | null, sold_quantity?: any | null, other_uses?: any | null, total_sold?: any | null, total_given_away?: any | null, total_cash_income?: any | null, produced_unit_measure_id?: any | null, total_kcal?: any | null, sold_unit_measure_id?: any | null, term_id?: any | null }> };

export type InterviewDataFragment = { __typename?: 'project_interview_data', total_cash_income?: any | null, total_expenses?: any | null, type: Project_Interview_Data_Type_Enum, term_id?: any | null, activity?: string | null, amount?: any | null, total_quantity?: any | null, total_kcal?: any | null, times_money_sent?: any | null, sold_unit?: any | null, sold_quantity?: any | null, quantity?: any | null, quantity_unit_id?: any | null, project_interview_id?: any | null, profit_per_unit?: any | null, profit_by_person?: any | null, price?: any | null, people?: any | null, payment_nr_times?: any | null, other_uses?: any | null, number_children?: any | null, months?: any | null, meals_included?: boolean | null, location?: string | null, livestock_id?: any | null, is_school?: boolean | null, is_resold?: boolean | null, is_payment_person?: boolean | null, is_food?: boolean | null, is_expenditure?: boolean | null, is_area_based?: boolean | null, food_term_id?: any | null, food_amount?: any | null, duration?: any | null, description?: string | null, crop_id?: any | null, quantity_unit?: any | null, payment?: any | null };

export type TssInterviewDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TssInterviewDetailQuery = { __typename?: 'query_root', project_interview_by_pk?: { __typename?: 'project_interview', id: any, status?: Status_Enum | null, created_at: any, updated_at: any, date?: any | null, location: { __typename?: 'location', id: any, name: string }, project_interview_researcher_mns: Array<{ __typename?: 'project_interview_researcher_mn', user: { __typename?: 'users', id: any } }>, wealth_group: { __typename?: 'wealth_group', id: any, en: string, es?: string | null, fr?: string | null, pt?: string | null, sorting?: number | null }, project_interview_base?: { __typename?: 'project_interview_base', people_in_household?: any | null, children_primary_school?: any | null, children_secondary_school?: any | null, interviewees_female?: any | null, interviewees_male?: any | null, land_cultivated_cash?: any | null, land_cultivated_food?: any | null, land_outsourced?: any | null, land_owned?: any | null, land_unit_conversion?: any | null, land_unit_conversion_id?: any | null, other_productive_assets?: any | null, comments?: string | null, leftover_cereal_amount?: any | null, leftover_cereal_term_id?: any | null, leftover_cereal_total_calories?: any | null, leftover_cereal_months?: any | null, date?: any | null, created_at?: any | null, project_interview_productive_assets: Array<{ __typename?: 'project_interview_productive_asset', term_id: any, amount?: any | null }>, project_interview_crops_seasons: Array<{ __typename?: 'project_interview_crops_season', id: any, interview_id: any, crop_season_id?: any | null, total_kcal_consumed?: any | null, total_expenses?: any | null, total_consumed?: any | null, total_kcal?: any | null, total_cash_income?: any | null, harvested_crops?: string | null, project_interview_data: Array<{ __typename?: 'project_interview_data', price?: any | null, quantity?: any | null, total_cash_income?: any | null, total_expenses?: any | null, term_id?: any | null, months?: any | null, is_resold?: boolean | null, total_kcal?: any | null, amount?: any | null, description?: string | null, quantity_unit?: any | null, quantity_unit_id?: any | null }>, green_crops?: { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null } | null, root_crops?: { __typename?: 'project_interview_crops_green_root', weeks?: any | null, meals_day?: any | null, is_snack?: boolean | null, people?: any | null, months?: any | null, total_kcal?: any | null, days_per_week?: any | null } | null, project_interview_crops: Array<{ __typename?: 'project_interview_crops', when_sold?: any | null, total_produced?: any | null, sold_unit_measure?: any | null, sold_price_per_unit?: any | null, produced_unit_measure?: any | null, produced_quantity?: any | null, months_consumption?: any | null, losses?: any | null, total_kcal_consumed?: any | null, total_consumed?: any | null, sold_quantity?: any | null, other_uses?: any | null, total_sold?: any | null, total_given_away?: any | null, total_cash_income?: any | null, produced_unit_measure_id?: any | null, total_kcal?: any | null, sold_unit_measure_id?: any | null, term_id?: any | null }> }>, project_interview_livestocks: Array<{ __typename?: 'project_interview_livestock', total_start?: any | null, total_sold?: any | null, total_purchases?: any | null, total_given_away?: any | null, total_exchanged?: any | null, total_end?: any | null, total_eggs_consumed?: any | null, total_cash_expenses?: any | null, total_calories?: any | null, slaughtered?: any | null, new_birth?: any | null, new_birth_secondary?: any | null, milked_female?: any | null, meat_quantity_sold?: any | null, meat_quantity_given_away?: any | null, meat_price_per_kg?: any | null, meat_per_carcass?: any | null, losses_reason?: string | null, losses_death?: any | null, is_exchanged_resold?: boolean | null, given_away_reason?: string | null, breeding_female?: any | null, balance_consumed?: any | null, animals_other?: any | null, total_cash_income?: any | null, type: Livestock_Type_Enum, total_kcal_calories_consumed_eggs?: any | null, total_off_peak_milk_exchanged_calories?: any | null, total_peak_milk_exchanged_calories?: any | null, total_peak_milk_calories?: any | null, total_off_peak_milk_calories?: any | null, total_bartered_calories?: any | null, project_interview_data: Array<{ __typename?: 'project_interview_data', price?: any | null, amount?: any | null, term_id?: any | null, quantity?: any | null, months?: any | null, is_resold?: boolean | null, quantity_unit_id?: any | null, quantity_unit?: any | null, description?: string | null, total_kcal?: any | null, total_expenses?: any | null, total_cash_income?: any | null, type: Project_Interview_Data_Type_Enum }>, off_peak_milk?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, peak_milk?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, off_peak_milk_secondary?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, peak_milk_secondary?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null }>, project_interview_total?: { __typename?: 'project_interview_totals', cash_income_self_employment?: any | null, cash_income_remittance_credit?: any | null, cash_income_migration?: any | null, cash_income_livestock?: any | null, cash_income_labour_jobs?: any | null, cash_income_labour_exchange?: any | null, cash_income_food_aid?: any | null, cash_income_fishing_wild_food?: any | null, cash_income_crops?: any | null, cash_expenses_wild_food?: any | null, cash_expenses_remittance_credit?: any | null, cash_expenses_purchases_non_food?: any | null, cash_expenses_purchases_food?: any | null, cash_expenses_livestock?: any | null, cash_expenses_food_aid?: any | null, cash_expenses_crops?: any | null, calories_purchases?: any | null, calories_migration?: any | null, calories_livestock?: any | null, calories_labour_jobs?: any | null, calories_labour_exchange?: any | null, calories_food_aid?: any | null, calories_fishing_wild_food?: any | null, calories_crops?: any | null } | null, project_interview_data: Array<{ __typename?: 'project_interview_data', total_cash_income?: any | null, total_expenses?: any | null, type: Project_Interview_Data_Type_Enum, term_id?: any | null, activity?: string | null, amount?: any | null, total_quantity?: any | null, total_kcal?: any | null, times_money_sent?: any | null, sold_unit?: any | null, sold_quantity?: any | null, quantity?: any | null, quantity_unit_id?: any | null, project_interview_id?: any | null, profit_per_unit?: any | null, profit_by_person?: any | null, price?: any | null, people?: any | null, payment_nr_times?: any | null, other_uses?: any | null, number_children?: any | null, months?: any | null, meals_included?: boolean | null, location?: string | null, livestock_id?: any | null, is_school?: boolean | null, is_resold?: boolean | null, is_payment_person?: boolean | null, is_food?: boolean | null, is_expenditure?: boolean | null, is_area_based?: boolean | null, food_term_id?: any | null, food_amount?: any | null, duration?: any | null, description?: string | null, crop_id?: any | null, quantity_unit?: any | null, payment?: any | null }> } | null } | null };

export type TssInterviewDetailUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Project_Interview_Base_Insert_Input;
  backup: Project_Interview_Backup_Insert_Input;
}>;


export type TssInterviewDetailUpdateMutation = { __typename?: 'mutation_root', delete_project_interview_base?: { __typename?: 'project_interview_base_mutation_response', affected_rows: number } | null, insert_project_interview_base_one?: { __typename?: 'project_interview_base', people_in_household?: any | null, children_primary_school?: any | null, children_secondary_school?: any | null, interviewees_female?: any | null, interviewees_male?: any | null, land_cultivated_cash?: any | null, land_cultivated_food?: any | null, land_outsourced?: any | null, land_owned?: any | null, land_unit_conversion?: any | null, land_unit_conversion_id?: any | null, other_productive_assets?: any | null, comments?: string | null, leftover_cereal_amount?: any | null, leftover_cereal_term_id?: any | null, leftover_cereal_total_calories?: any | null, leftover_cereal_months?: any | null, date?: any | null, created_at?: any | null } | null, insert_project_interview_backup_one?: { __typename?: 'project_interview_backup', id: any } | null };

export type InterviewLivestockBaseFragment = { __typename?: 'project_interview_livestock', total_start?: any | null, total_sold?: any | null, total_purchases?: any | null, total_given_away?: any | null, total_exchanged?: any | null, total_end?: any | null, total_eggs_consumed?: any | null, total_cash_expenses?: any | null, total_calories?: any | null, slaughtered?: any | null, new_birth?: any | null, new_birth_secondary?: any | null, milked_female?: any | null, meat_quantity_sold?: any | null, meat_quantity_given_away?: any | null, meat_price_per_kg?: any | null, meat_per_carcass?: any | null, losses_reason?: string | null, losses_death?: any | null, is_exchanged_resold?: boolean | null, given_away_reason?: string | null, breeding_female?: any | null, balance_consumed?: any | null, animals_other?: any | null, total_cash_income?: any | null, type: Livestock_Type_Enum, total_kcal_calories_consumed_eggs?: any | null, total_off_peak_milk_exchanged_calories?: any | null, total_peak_milk_exchanged_calories?: any | null, total_peak_milk_calories?: any | null, total_off_peak_milk_calories?: any | null, total_bartered_calories?: any | null };

export type InterviewLivestockDataFragment = { __typename?: 'project_interview_data', price?: any | null, amount?: any | null, term_id?: any | null, quantity?: any | null, months?: any | null, is_resold?: boolean | null, quantity_unit_id?: any | null, quantity_unit?: any | null, description?: string | null, total_kcal?: any | null, total_expenses?: any | null, total_cash_income?: any | null, type: Project_Interview_Data_Type_Enum };

export type InterviewLivestockFragment = { __typename?: 'project_interview_livestock', total_start?: any | null, total_sold?: any | null, total_purchases?: any | null, total_given_away?: any | null, total_exchanged?: any | null, total_end?: any | null, total_eggs_consumed?: any | null, total_cash_expenses?: any | null, total_calories?: any | null, slaughtered?: any | null, new_birth?: any | null, new_birth_secondary?: any | null, milked_female?: any | null, meat_quantity_sold?: any | null, meat_quantity_given_away?: any | null, meat_price_per_kg?: any | null, meat_per_carcass?: any | null, losses_reason?: string | null, losses_death?: any | null, is_exchanged_resold?: boolean | null, given_away_reason?: string | null, breeding_female?: any | null, balance_consumed?: any | null, animals_other?: any | null, total_cash_income?: any | null, type: Livestock_Type_Enum, total_kcal_calories_consumed_eggs?: any | null, total_off_peak_milk_exchanged_calories?: any | null, total_peak_milk_exchanged_calories?: any | null, total_peak_milk_calories?: any | null, total_off_peak_milk_calories?: any | null, total_bartered_calories?: any | null, project_interview_data: Array<{ __typename?: 'project_interview_data', price?: any | null, amount?: any | null, term_id?: any | null, quantity?: any | null, months?: any | null, is_resold?: boolean | null, quantity_unit_id?: any | null, quantity_unit?: any | null, description?: string | null, total_kcal?: any | null, total_expenses?: any | null, total_cash_income?: any | null, type: Project_Interview_Data_Type_Enum }>, off_peak_milk?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, peak_milk?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, off_peak_milk_secondary?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null, peak_milk_secondary?: { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null } | null };

export type InterviewLivestockMilkFragment = { __typename?: 'project_interview_livestock_milk', sold_per_day?: any | null, quantity_given_away?: any | null, quantity_consumed_day?: any | null, price_per_litre?: any | null, peak_milk_month?: Month_Enum | null, milk_per_animal?: any | null, exchanged_cereal?: any | null, days_milked?: any | null, consumes_skim?: boolean | null, measure_unit?: any | null, measure_unit_id?: any | null, milked_female?: any | null, total_cash_income?: any | null, total_kcal?: any | null, total_consumed?: any | null, total_produced?: any | null, total_exchanged_kcal?: any | null };

export type InterviewTotalsFragment = { __typename?: 'project_interview_totals', cash_income_self_employment?: any | null, cash_income_remittance_credit?: any | null, cash_income_migration?: any | null, cash_income_livestock?: any | null, cash_income_labour_jobs?: any | null, cash_income_labour_exchange?: any | null, cash_income_food_aid?: any | null, cash_income_fishing_wild_food?: any | null, cash_income_crops?: any | null, cash_expenses_wild_food?: any | null, cash_expenses_remittance_credit?: any | null, cash_expenses_purchases_non_food?: any | null, cash_expenses_purchases_food?: any | null, cash_expenses_livestock?: any | null, cash_expenses_food_aid?: any | null, cash_expenses_crops?: any | null, calories_purchases?: any | null, calories_migration?: any | null, calories_livestock?: any | null, calories_labour_jobs?: any | null, calories_labour_exchange?: any | null, calories_food_aid?: any | null, calories_fishing_wild_food?: any | null, calories_crops?: any | null };


export const CountryFragmentDoc = `
    fragment country on country {
  id
  en
  es
  fr
  pt
  key
}
    `;
export const CropSeasonFragmentDoc = `
    fragment cropSeason on crop_season {
  id
  name
  country_id
  country {
    ...country
  }
  crop_season_month_mns {
    crop_season_id
    month
  }
}
    `;
export const MeasureUnitFragmentDoc = `
    fragment measureUnit on measure_unit {
  id
  type
  multiplier
  name
  country_id
  country {
    ...country
  }
}
    `;
export const TermSimpleFragmentDoc = `
    fragment termSimple on term {
  id
  en
  am
  pt
  es
  fr
  kcal
}
    `;
export const InterviewDetailFragmentDoc = `
    fragment interviewDetail on project_interview {
  id
  status
  created_at
  updated_at
  date
}
    `;
export const UserFragmentDoc = `
    fragment user on users {
  id
  email
  emailVerified
  createdAt
  updatedAt
  disabled
  lastSeen
  displayName
  user_profile {
    id
    first_name
    last_name
  }
}
    `;
export const WealthGroupFragmentDoc = `
    fragment wealthGroup on wealth_group {
  id
  en
  es
  fr
  pt
  sorting
}
    `;
export const CountryRegionFragmentFragmentDoc = `
    fragment countryRegionFragment on country_region {
  id
  name
  country_id
  country {
    ...country
  }
  parent_id
  country_region {
    id
    name
    parent_id
    country_region {
      id
      name
      parent_id
      country_region {
        id
        name
        parent_id
        country_region {
          id
          name
          parent_id
        }
      }
    }
  }
  country_regions(order_by: [{name: asc}]) {
    id
    name
  }
}
    `;
export const ZoneFragmentDoc = `
    fragment zone on zone {
  id
  name
  country_id
  country {
    ...country
  }
}
    `;
export const LocationFragmentFragmentDoc = `
    fragment locationFragment on location {
  id
  name
  country_region_id
  zone_id
  country_region {
    ...countryRegionFragment
  }
  zone {
    ...zone
  }
}
    `;
export const InterviewBasicFragmentDoc = `
    fragment interviewBasic on project_interview {
  id
  date
  status
  wealth_group_id
  wealth_group {
    ...wealthGroup
  }
  location_id
  location {
    ...locationFragment
  }
  project_interview_researcher_mns {
    user_id
    user {
      ...user
    }
  }
}
    `;
export const TermCategoryFragmentDoc = `
    fragment termCategory on term_category {
  id
  en
  es
  fr
  pt
  am
}
    `;
export const TermFragmentDoc = `
    fragment term on term {
  id
  en
  es
  fr
  pt
  am
  kcal
  term_category_mns {
    category_id
    term_category {
      ...termCategory
    }
  }
}
    `;
export const ProjectFragmentDoc = `
    fragment project on project {
  id
  name
  created_at
  updated_at
  finished
  supervisor_user_id
  reference_period_start
  reference_period_end
  deleted
  main_staple_id
  user {
    ...user
  }
  project_interviews {
    ...interviewBasic
    project_interview_base {
      id
      is_done
      created_at
    }
  }
  term {
    ...term
  }
}
    `;
export const ProjectScalarFragmentDoc = `
    fragment projectScalar on project {
  avg_price_main_staple_kg
  schooldays_year
  teamleader_user_id
  supervisor_user_id
  school_food_kcal
  reference_period_start
  reference_period_end
  reference_period_duration
  reference_period_description
  password
  name
  main_staple_id
  kcal_pppd
  finished
  currency
  currency_exchange_usd
}
    `;
export const ProjectDetailFragmentDoc = `
    fragment projectDetail on project {
  ...project
  ...projectScalar
  userTeamleader {
    ...user
  }
  term {
    ...term
  }
}
    `;
export const BssDataFragmentDoc = `
    fragment bssData on project_bss_data {
  id
  project_id
  wealth_group_id
  kcal
  type
  term_id
  season_id
  livestock_type
  created_at
  total_kcal
  total_expenses
  total_cash_income
  non_significant
  is_resolved
  data
}
    `;
export const BssNoteFragmentDoc = `
    fragment bssNote on project_bss_note {
  id
  project_id
  type
  message
  term_id
  created_at
  user_id
  livestock_type
  season_id
  updated_at
  is_done
  is_deleted
}
    `;
export const BssProjectListFragmentDoc = `
    fragment bssProjectList on project {
  id
  name
  user {
    id
    email
    user_profile {
      first_name
      last_name
    }
  }
  userTeamleader {
    id
    email
    user_profile {
      first_name
      last_name
    }
  }
  interviewZone: project_interviews(limit: 1, order_by: {created_at: asc}) {
    location {
      country_region {
        country {
          ...country
        }
      }
      zone {
        name
      }
    }
  }
  locationTotal: project_interviews_aggregate {
    aggregate {
      count(distinct: true, columns: [location_id])
    }
  }
  interviewsTotal: project_interviews_aggregate {
    aggregate {
      count
    }
  }
  interviewsDone: project_interviews_aggregate(
    where: {status: {_is_null: true}, project_interview_base: {is_done: {_eq: true}}}
  ) {
    aggregate {
      count
    }
  }
  interviewsLocked: project_interviews_aggregate(where: {status: {_eq: LOCKED}}) {
    aggregate {
      count
    }
  }
  project_interviews(where: {project_interview_base: {id: {_is_null: false}}}) {
    project_interview_base {
      interviewees_female
      interviewees_male
    }
  }
}
    `;
export const ProjectTssQueryFragmentDoc = `
    fragment projectTssQuery on project {
  id
  name
  userTeamleader {
    id
    email
    displayName
  }
  user {
    id
    email
    displayName
  }
  school_food_kcal
  schooldays_year
  currency
  currency_exchange_usd
  avg_price_main_staple_kg
  deleted
  finished
  reference_period_end
  reference_period_start
  reference_period_duration
  kcal_pppd
  main_staple_id
  term {
    ...term
  }
  project_interviews(
    order_by: [{date: asc_nulls_last}, {wealth_group: {sorting: asc_nulls_last}}]
  ) {
    id
    project_id
    wealth_group {
      ...wealthGroup
    }
    date
    status
    created_at
    location {
      id
      name
      country_region {
        id
        name
        country {
          ...country
        }
      }
      zone {
        id
        name
      }
    }
    project_interview_researcher_mns {
      user {
        id
        email
        displayName
      }
    }
    project_interview_base {
      id
      created_at
      is_done
    }
    project_interview_notes_aggregate(
      where: {is_deleted: {_eq: false}, is_done: {_eq: false}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;
export const FileFragmentDoc = `
    fragment file on files {
  id
  name
  size
  mimeType
  bucketId
}
    `;
export const TssNoteFragmentDoc = `
    fragment tssNote on project_interview_note {
  id
  is_deleted
  is_done
  message
  created_at
  updated_at
  user_id
  interview_id
}
    `;
export const InterviewBaseFragmentDoc = `
    fragment interviewBase on project_interview_base {
  people_in_household
  children_primary_school
  children_secondary_school
  interviewees_female
  interviewees_male
  land_cultivated_cash
  land_cultivated_food
  land_outsourced
  land_owned
  land_unit_conversion
  land_unit_conversion_id
  other_productive_assets
  comments
  leftover_cereal_amount
  leftover_cereal_term_id
  leftover_cereal_total_calories
  leftover_cereal_months
  date
  created_at
}
    `;
export const InterviewCropsDataFragmentDoc = `
    fragment interviewCropsData on project_interview_data {
  price
  quantity
  total_cash_income
  total_expenses
  term_id
  months
  is_resold
  total_kcal
  amount
  description
  quantity_unit
  quantity_unit_id
}
    `;
export const InterviewCropsSeasonBaseFragmentDoc = `
    fragment interviewCropsSeasonBase on project_interview_crops_season {
  id
  interview_id
  crop_season_id
  total_kcal_consumed
  total_expenses
  total_consumed
  total_kcal
  total_cash_income
  harvested_crops
}
    `;
export const GreenRootCropsFragmentDoc = `
    fragment greenRootCrops on project_interview_crops_green_root {
  weeks
  meals_day
  is_snack
  people
  months
  total_kcal
  days_per_week
}
    `;
export const CropProductionFragmentDoc = `
    fragment cropProduction on project_interview_crops {
  when_sold
  total_produced
  sold_unit_measure
  sold_price_per_unit
  produced_unit_measure
  produced_quantity
  months_consumption
  losses
  total_kcal_consumed
  total_consumed
  sold_quantity
  other_uses
  total_sold
  total_given_away
  total_cash_income
  produced_unit_measure_id
  total_kcal
  sold_unit_measure_id
  term_id
}
    `;
export const InterviewCropsSeasonsFragmentDoc = `
    fragment interviewCropsSeasons on project_interview_crops_season {
  ...interviewCropsSeasonBase
  green_crops {
    ...greenRootCrops
  }
  root_crops {
    ...greenRootCrops
  }
  project_interview_crops {
    ...cropProduction
  }
}
    `;
export const InterviewDataFragmentDoc = `
    fragment interviewData on project_interview_data {
  total_cash_income
  total_expenses
  type
  term_id
  activity
  amount
  total_quantity
  total_kcal
  times_money_sent
  sold_unit
  sold_quantity
  quantity
  quantity_unit_id
  project_interview_id
  profit_per_unit
  profit_by_person
  price
  people
  payment_nr_times
  other_uses
  number_children
  months
  meals_included
  location
  livestock_id
  is_school
  is_resold
  is_payment_person
  is_food
  is_expenditure
  is_area_based
  food_term_id
  food_amount
  duration
  description
  crop_id
  quantity_unit
  payment
}
    `;
export const InterviewLivestockBaseFragmentDoc = `
    fragment interviewLivestockBase on project_interview_livestock {
  total_start
  total_sold
  total_purchases
  total_given_away
  total_exchanged
  total_end
  total_eggs_consumed
  total_cash_expenses
  total_calories
  slaughtered
  new_birth
  new_birth_secondary
  milked_female
  meat_quantity_sold
  meat_quantity_given_away
  meat_price_per_kg
  meat_per_carcass
  losses_reason
  losses_death
  is_exchanged_resold
  given_away_reason
  breeding_female
  balance_consumed
  animals_other
  total_cash_income
  type
  total_kcal_calories_consumed_eggs
  total_off_peak_milk_exchanged_calories
  total_peak_milk_exchanged_calories
  total_peak_milk_calories
  total_off_peak_milk_calories
  total_bartered_calories
}
    `;
export const InterviewLivestockDataFragmentDoc = `
    fragment interviewLivestockData on project_interview_data {
  price
  amount
  term_id
  quantity
  months
  is_resold
  quantity_unit_id
  quantity_unit
  description
  total_kcal
  total_expenses
  total_cash_income
  type
}
    `;
export const InterviewLivestockMilkFragmentDoc = `
    fragment interviewLivestockMilk on project_interview_livestock_milk {
  sold_per_day
  quantity_given_away
  quantity_consumed_day
  price_per_litre
  peak_milk_month
  milk_per_animal
  exchanged_cereal
  days_milked
  consumes_skim
  measure_unit
  measure_unit_id
  milked_female
  total_cash_income
  total_kcal
  total_consumed
  total_produced
  total_exchanged_kcal
}
    `;
export const InterviewLivestockFragmentDoc = `
    fragment interviewLivestock on project_interview_livestock {
  ...interviewLivestockBase
  project_interview_data {
    ...interviewLivestockData
  }
  off_peak_milk {
    ...interviewLivestockMilk
  }
  peak_milk {
    ...interviewLivestockMilk
  }
  off_peak_milk_secondary {
    ...interviewLivestockMilk
  }
  peak_milk_secondary {
    ...interviewLivestockMilk
  }
}
    `;
export const InterviewTotalsFragmentDoc = `
    fragment interviewTotals on project_interview_totals {
  cash_income_self_employment
  cash_income_remittance_credit
  cash_income_migration
  cash_income_livestock
  cash_income_labour_jobs
  cash_income_labour_exchange
  cash_income_food_aid
  cash_income_fishing_wild_food
  cash_income_crops
  cash_expenses_wild_food
  cash_expenses_remittance_credit
  cash_expenses_purchases_non_food
  cash_expenses_purchases_food
  cash_expenses_livestock
  cash_expenses_food_aid
  cash_expenses_crops
  calories_purchases
  calories_migration
  calories_livestock
  calories_labour_jobs
  calories_labour_exchange
  calories_food_aid
  calories_fishing_wild_food
  calories_crops
}
    `;
export const CountryListDocument = `
    query countryList {
  country {
    ...country
  }
}
    ${CountryFragmentDoc}`;

export const useCountryListQuery = <
      TData = CountryListQuery,
      TError = unknown
    >(
      variables?: CountryListQueryVariables,
      options?: Omit<UseQueryOptions<CountryListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CountryListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CountryListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['countryList'] : ['countryList', variables],
    queryFn: fetchData<CountryListQuery, CountryListQueryVariables>(CountryListDocument, variables),
    ...options
  }
    )};

useCountryListQuery.getKey = (variables?: CountryListQueryVariables) => variables === undefined ? ['countryList'] : ['countryList', variables];


useCountryListQuery.fetcher = (variables?: CountryListQueryVariables, options?: RequestInit['headers']) => fetchData<CountryListQuery, CountryListQueryVariables>(CountryListDocument, variables, options);

export const DeleteCountryDocument = `
    mutation deleteCountry($ids: [uuid!]) {
  delete_country(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteCountryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCountryMutation, TError, DeleteCountryMutationVariables, TContext>) => {
    
    return useMutation<DeleteCountryMutation, TError, DeleteCountryMutationVariables, TContext>(
      {
    mutationKey: ['deleteCountry'],
    mutationFn: (variables?: DeleteCountryMutationVariables) => fetchData<DeleteCountryMutation, DeleteCountryMutationVariables>(DeleteCountryDocument, variables)(),
    ...options
  }
    )};


useDeleteCountryMutation.fetcher = (variables?: DeleteCountryMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteCountryMutation, DeleteCountryMutationVariables>(DeleteCountryDocument, variables, options);

export const UpsertCountryDocument = `
    mutation upsertCountry($object: country_insert_input!) {
  insert_country_one(
    object: $object
    on_conflict: {constraint: country_pkey, update_columns: [key, pt, fr, es, en]}
  ) {
    en
    es
    fr
    id
    key
    pt
  }
}
    `;

export const useUpsertCountryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCountryMutation, TError, UpsertCountryMutationVariables, TContext>) => {
    
    return useMutation<UpsertCountryMutation, TError, UpsertCountryMutationVariables, TContext>(
      {
    mutationKey: ['upsertCountry'],
    mutationFn: (variables?: UpsertCountryMutationVariables) => fetchData<UpsertCountryMutation, UpsertCountryMutationVariables>(UpsertCountryDocument, variables)(),
    ...options
  }
    )};


useUpsertCountryMutation.fetcher = (variables: UpsertCountryMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertCountryMutation, UpsertCountryMutationVariables>(UpsertCountryDocument, variables, options);

export const CountryRegionDocument = `
    query countryRegion($where: country_region_bool_exp) {
  country_region(where: $where, order_by: [{name: asc}]) {
    ...countryRegionFragment
  }
}
    ${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}`;

export const useCountryRegionQuery = <
      TData = CountryRegionQuery,
      TError = unknown
    >(
      variables?: CountryRegionQueryVariables,
      options?: Omit<UseQueryOptions<CountryRegionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CountryRegionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CountryRegionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['countryRegion'] : ['countryRegion', variables],
    queryFn: fetchData<CountryRegionQuery, CountryRegionQueryVariables>(CountryRegionDocument, variables),
    ...options
  }
    )};

useCountryRegionQuery.getKey = (variables?: CountryRegionQueryVariables) => variables === undefined ? ['countryRegion'] : ['countryRegion', variables];


useCountryRegionQuery.fetcher = (variables?: CountryRegionQueryVariables, options?: RequestInit['headers']) => fetchData<CountryRegionQuery, CountryRegionQueryVariables>(CountryRegionDocument, variables, options);

export const DeleteCountryRegionDocument = `
    mutation deleteCountryRegion($ids: [uuid!]) {
  delete_country_region(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteCountryRegionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCountryRegionMutation, TError, DeleteCountryRegionMutationVariables, TContext>) => {
    
    return useMutation<DeleteCountryRegionMutation, TError, DeleteCountryRegionMutationVariables, TContext>(
      {
    mutationKey: ['deleteCountryRegion'],
    mutationFn: (variables?: DeleteCountryRegionMutationVariables) => fetchData<DeleteCountryRegionMutation, DeleteCountryRegionMutationVariables>(DeleteCountryRegionDocument, variables)(),
    ...options
  }
    )};


useDeleteCountryRegionMutation.fetcher = (variables?: DeleteCountryRegionMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteCountryRegionMutation, DeleteCountryRegionMutationVariables>(DeleteCountryRegionDocument, variables, options);

export const UpsertCountryRegionDocument = `
    mutation upsertCountryRegion($objects: [country_region_insert_input!]!) {
  insert_country_region(
    objects: $objects
    on_conflict: {constraint: country_district_level_pkey, update_columns: [name, country_id, parent_id]}
  ) {
    affected_rows
    returning {
      ...countryRegionFragment
    }
  }
}
    ${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}`;

export const useUpsertCountryRegionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCountryRegionMutation, TError, UpsertCountryRegionMutationVariables, TContext>) => {
    
    return useMutation<UpsertCountryRegionMutation, TError, UpsertCountryRegionMutationVariables, TContext>(
      {
    mutationKey: ['upsertCountryRegion'],
    mutationFn: (variables?: UpsertCountryRegionMutationVariables) => fetchData<UpsertCountryRegionMutation, UpsertCountryRegionMutationVariables>(UpsertCountryRegionDocument, variables)(),
    ...options
  }
    )};


useUpsertCountryRegionMutation.fetcher = (variables: UpsertCountryRegionMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertCountryRegionMutation, UpsertCountryRegionMutationVariables>(UpsertCountryRegionDocument, variables, options);

export const CropSeasonListDocument = `
    query cropSeasonList($where: crop_season_bool_exp) {
  crop_season(where: $where) {
    ...cropSeason
  }
}
    ${CropSeasonFragmentDoc}
${CountryFragmentDoc}`;

export const useCropSeasonListQuery = <
      TData = CropSeasonListQuery,
      TError = unknown
    >(
      variables?: CropSeasonListQueryVariables,
      options?: Omit<UseQueryOptions<CropSeasonListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CropSeasonListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CropSeasonListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['cropSeasonList'] : ['cropSeasonList', variables],
    queryFn: fetchData<CropSeasonListQuery, CropSeasonListQueryVariables>(CropSeasonListDocument, variables),
    ...options
  }
    )};

useCropSeasonListQuery.getKey = (variables?: CropSeasonListQueryVariables) => variables === undefined ? ['cropSeasonList'] : ['cropSeasonList', variables];


useCropSeasonListQuery.fetcher = (variables?: CropSeasonListQueryVariables, options?: RequestInit['headers']) => fetchData<CropSeasonListQuery, CropSeasonListQueryVariables>(CropSeasonListDocument, variables, options);

export const DeleteCropSeasonDocument = `
    mutation deleteCropSeason($ids: [uuid!]) {
  delete_crop_season(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteCropSeasonMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCropSeasonMutation, TError, DeleteCropSeasonMutationVariables, TContext>) => {
    
    return useMutation<DeleteCropSeasonMutation, TError, DeleteCropSeasonMutationVariables, TContext>(
      {
    mutationKey: ['deleteCropSeason'],
    mutationFn: (variables?: DeleteCropSeasonMutationVariables) => fetchData<DeleteCropSeasonMutation, DeleteCropSeasonMutationVariables>(DeleteCropSeasonDocument, variables)(),
    ...options
  }
    )};


useDeleteCropSeasonMutation.fetcher = (variables?: DeleteCropSeasonMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteCropSeasonMutation, DeleteCropSeasonMutationVariables>(DeleteCropSeasonDocument, variables, options);

export const UpsertCropSeasonDocument = `
    mutation upsertCropSeason($object: crop_season_insert_input!, $mnObjects: [crop_season_month_mn_insert_input!]!, $seasonId: uuid) {
  insert_crop_season_one(
    object: $object
    on_conflict: {constraint: crop_season_pkey, update_columns: [name, country_id]}
  ) {
    ...cropSeason
  }
  delete_crop_season_month_mn(where: {crop_season_id: {_eq: $seasonId}}) {
    affected_rows
  }
  insert_crop_season_month_mn(objects: $mnObjects) {
    affected_rows
  }
}
    ${CropSeasonFragmentDoc}
${CountryFragmentDoc}`;

export const useUpsertCropSeasonMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCropSeasonMutation, TError, UpsertCropSeasonMutationVariables, TContext>) => {
    
    return useMutation<UpsertCropSeasonMutation, TError, UpsertCropSeasonMutationVariables, TContext>(
      {
    mutationKey: ['upsertCropSeason'],
    mutationFn: (variables?: UpsertCropSeasonMutationVariables) => fetchData<UpsertCropSeasonMutation, UpsertCropSeasonMutationVariables>(UpsertCropSeasonDocument, variables)(),
    ...options
  }
    )};


useUpsertCropSeasonMutation.fetcher = (variables: UpsertCropSeasonMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertCropSeasonMutation, UpsertCropSeasonMutationVariables>(UpsertCropSeasonDocument, variables, options);

export const DeleteLocationDocument = `
    mutation deleteLocation($ids: [uuid!]) {
  delete_location(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteLocationMutation, TError, DeleteLocationMutationVariables, TContext>) => {
    
    return useMutation<DeleteLocationMutation, TError, DeleteLocationMutationVariables, TContext>(
      {
    mutationKey: ['deleteLocation'],
    mutationFn: (variables?: DeleteLocationMutationVariables) => fetchData<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, variables)(),
    ...options
  }
    )};


useDeleteLocationMutation.fetcher = (variables?: DeleteLocationMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, variables, options);

export const LocationDocument = `
    query location($where: location_bool_exp) {
  location(where: $where, order_by: [{name: asc}]) {
    ...locationFragment
  }
}
    ${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}`;

export const useLocationQuery = <
      TData = LocationQuery,
      TError = unknown
    >(
      variables?: LocationQueryVariables,
      options?: Omit<UseQueryOptions<LocationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LocationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LocationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['location'] : ['location', variables],
    queryFn: fetchData<LocationQuery, LocationQueryVariables>(LocationDocument, variables),
    ...options
  }
    )};

useLocationQuery.getKey = (variables?: LocationQueryVariables) => variables === undefined ? ['location'] : ['location', variables];


useLocationQuery.fetcher = (variables?: LocationQueryVariables, options?: RequestInit['headers']) => fetchData<LocationQuery, LocationQueryVariables>(LocationDocument, variables, options);

export const UpsertLocationDocument = `
    mutation upsertLocation($objects: [location_insert_input!]!) {
  insert_location(
    objects: $objects
    on_conflict: {constraint: location_pkey, update_columns: [name, country_region_id, zone_id]}
  ) {
    affected_rows
    returning {
      ...locationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}`;

export const useUpsertLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertLocationMutation, TError, UpsertLocationMutationVariables, TContext>) => {
    
    return useMutation<UpsertLocationMutation, TError, UpsertLocationMutationVariables, TContext>(
      {
    mutationKey: ['upsertLocation'],
    mutationFn: (variables?: UpsertLocationMutationVariables) => fetchData<UpsertLocationMutation, UpsertLocationMutationVariables>(UpsertLocationDocument, variables)(),
    ...options
  }
    )};


useUpsertLocationMutation.fetcher = (variables: UpsertLocationMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertLocationMutation, UpsertLocationMutationVariables>(UpsertLocationDocument, variables, options);

export const DeleteMeasureUnitDocument = `
    mutation deleteMeasureUnit($ids: [uuid!]) {
  delete_measure_unit(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteMeasureUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMeasureUnitMutation, TError, DeleteMeasureUnitMutationVariables, TContext>) => {
    
    return useMutation<DeleteMeasureUnitMutation, TError, DeleteMeasureUnitMutationVariables, TContext>(
      {
    mutationKey: ['deleteMeasureUnit'],
    mutationFn: (variables?: DeleteMeasureUnitMutationVariables) => fetchData<DeleteMeasureUnitMutation, DeleteMeasureUnitMutationVariables>(DeleteMeasureUnitDocument, variables)(),
    ...options
  }
    )};


useDeleteMeasureUnitMutation.fetcher = (variables?: DeleteMeasureUnitMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteMeasureUnitMutation, DeleteMeasureUnitMutationVariables>(DeleteMeasureUnitDocument, variables, options);

export const MeasureListDocument = `
    query measureList($where: measure_unit_bool_exp) {
  measure_unit(where: $where) {
    ...measureUnit
  }
}
    ${MeasureUnitFragmentDoc}
${CountryFragmentDoc}`;

export const useMeasureListQuery = <
      TData = MeasureListQuery,
      TError = unknown
    >(
      variables?: MeasureListQueryVariables,
      options?: Omit<UseQueryOptions<MeasureListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeasureListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeasureListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['measureList'] : ['measureList', variables],
    queryFn: fetchData<MeasureListQuery, MeasureListQueryVariables>(MeasureListDocument, variables),
    ...options
  }
    )};

useMeasureListQuery.getKey = (variables?: MeasureListQueryVariables) => variables === undefined ? ['measureList'] : ['measureList', variables];


useMeasureListQuery.fetcher = (variables?: MeasureListQueryVariables, options?: RequestInit['headers']) => fetchData<MeasureListQuery, MeasureListQueryVariables>(MeasureListDocument, variables, options);

export const UpsertMeasureDocument = `
    mutation upsertMeasure($object: measure_unit_insert_input!) {
  insert_measure_unit_one(
    object: $object
    on_conflict: {constraint: measure_unit_pkey, update_columns: [name, multiplier, type, country_id]}
  ) {
    ...measureUnit
  }
}
    ${MeasureUnitFragmentDoc}
${CountryFragmentDoc}`;

export const useUpsertMeasureMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertMeasureMutation, TError, UpsertMeasureMutationVariables, TContext>) => {
    
    return useMutation<UpsertMeasureMutation, TError, UpsertMeasureMutationVariables, TContext>(
      {
    mutationKey: ['upsertMeasure'],
    mutationFn: (variables?: UpsertMeasureMutationVariables) => fetchData<UpsertMeasureMutation, UpsertMeasureMutationVariables>(UpsertMeasureDocument, variables)(),
    ...options
  }
    )};


useUpsertMeasureMutation.fetcher = (variables: UpsertMeasureMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertMeasureMutation, UpsertMeasureMutationVariables>(UpsertMeasureDocument, variables, options);

export const DeleteTermDocument = `
    mutation deleteTerm($ids: [uuid!]) {
  delete_term(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteTermMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTermMutation, TError, DeleteTermMutationVariables, TContext>) => {
    
    return useMutation<DeleteTermMutation, TError, DeleteTermMutationVariables, TContext>(
      {
    mutationKey: ['deleteTerm'],
    mutationFn: (variables?: DeleteTermMutationVariables) => fetchData<DeleteTermMutation, DeleteTermMutationVariables>(DeleteTermDocument, variables)(),
    ...options
  }
    )};


useDeleteTermMutation.fetcher = (variables?: DeleteTermMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteTermMutation, DeleteTermMutationVariables>(DeleteTermDocument, variables, options);

export const TermListDocument = `
    query termList($where: term_bool_exp, $orderBy: [term_order_by!]) {
  term(where: $where, order_by: $orderBy) {
    ...term
  }
}
    ${TermFragmentDoc}
${TermCategoryFragmentDoc}`;

export const useTermListQuery = <
      TData = TermListQuery,
      TError = unknown
    >(
      variables?: TermListQueryVariables,
      options?: Omit<UseQueryOptions<TermListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TermListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TermListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['termList'] : ['termList', variables],
    queryFn: fetchData<TermListQuery, TermListQueryVariables>(TermListDocument, variables),
    ...options
  }
    )};

useTermListQuery.getKey = (variables?: TermListQueryVariables) => variables === undefined ? ['termList'] : ['termList', variables];


useTermListQuery.fetcher = (variables?: TermListQueryVariables, options?: RequestInit['headers']) => fetchData<TermListQuery, TermListQueryVariables>(TermListDocument, variables, options);

export const UpsertTermDocument = `
    mutation upsertTerm($object: term_insert_input!, $termId: uuid, $mnObjects: [term_category_mn_insert_input!]!) {
  insert_term_one(
    object: $object
    on_conflict: {constraint: term_pkey, update_columns: [pt, fr, en, es, kcal, am]}
  ) {
    ...term
  }
  delete_term_category_mn(where: {term_id: {_eq: $termId}}) {
    affected_rows
  }
  insert_term_category_mn(objects: $mnObjects) {
    affected_rows
  }
}
    ${TermFragmentDoc}
${TermCategoryFragmentDoc}`;

export const useUpsertTermMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertTermMutation, TError, UpsertTermMutationVariables, TContext>) => {
    
    return useMutation<UpsertTermMutation, TError, UpsertTermMutationVariables, TContext>(
      {
    mutationKey: ['upsertTerm'],
    mutationFn: (variables?: UpsertTermMutationVariables) => fetchData<UpsertTermMutation, UpsertTermMutationVariables>(UpsertTermDocument, variables)(),
    ...options
  }
    )};


useUpsertTermMutation.fetcher = (variables: UpsertTermMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertTermMutation, UpsertTermMutationVariables>(UpsertTermDocument, variables, options);

export const DeleteTermCategoryDocument = `
    mutation deleteTermCategory($ids: [uuid!]) {
  delete_term_category(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteTermCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTermCategoryMutation, TError, DeleteTermCategoryMutationVariables, TContext>) => {
    
    return useMutation<DeleteTermCategoryMutation, TError, DeleteTermCategoryMutationVariables, TContext>(
      {
    mutationKey: ['deleteTermCategory'],
    mutationFn: (variables?: DeleteTermCategoryMutationVariables) => fetchData<DeleteTermCategoryMutation, DeleteTermCategoryMutationVariables>(DeleteTermCategoryDocument, variables)(),
    ...options
  }
    )};


useDeleteTermCategoryMutation.fetcher = (variables?: DeleteTermCategoryMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteTermCategoryMutation, DeleteTermCategoryMutationVariables>(DeleteTermCategoryDocument, variables, options);

export const TermCategoryListDocument = `
    query termCategoryList {
  term_category {
    ...termCategory
  }
}
    ${TermCategoryFragmentDoc}`;

export const useTermCategoryListQuery = <
      TData = TermCategoryListQuery,
      TError = unknown
    >(
      variables?: TermCategoryListQueryVariables,
      options?: Omit<UseQueryOptions<TermCategoryListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TermCategoryListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TermCategoryListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['termCategoryList'] : ['termCategoryList', variables],
    queryFn: fetchData<TermCategoryListQuery, TermCategoryListQueryVariables>(TermCategoryListDocument, variables),
    ...options
  }
    )};

useTermCategoryListQuery.getKey = (variables?: TermCategoryListQueryVariables) => variables === undefined ? ['termCategoryList'] : ['termCategoryList', variables];


useTermCategoryListQuery.fetcher = (variables?: TermCategoryListQueryVariables, options?: RequestInit['headers']) => fetchData<TermCategoryListQuery, TermCategoryListQueryVariables>(TermCategoryListDocument, variables, options);

export const UpsertTermCategoryDocument = `
    mutation upsertTermCategory($object: term_category_insert_input!) {
  insert_term_category_one(
    object: $object
    on_conflict: {constraint: term_category_pkey, update_columns: [pt, fr, en, es, am]}
  ) {
    ...termCategory
  }
}
    ${TermCategoryFragmentDoc}`;

export const useUpsertTermCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertTermCategoryMutation, TError, UpsertTermCategoryMutationVariables, TContext>) => {
    
    return useMutation<UpsertTermCategoryMutation, TError, UpsertTermCategoryMutationVariables, TContext>(
      {
    mutationKey: ['upsertTermCategory'],
    mutationFn: (variables?: UpsertTermCategoryMutationVariables) => fetchData<UpsertTermCategoryMutation, UpsertTermCategoryMutationVariables>(UpsertTermCategoryDocument, variables)(),
    ...options
  }
    )};


useUpsertTermCategoryMutation.fetcher = (variables: UpsertTermCategoryMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertTermCategoryMutation, UpsertTermCategoryMutationVariables>(UpsertTermCategoryDocument, variables, options);

export const DeleteWealthGroupDocument = `
    mutation deleteWealthGroup($ids: [uuid!]) {
  delete_wealth_group(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteWealthGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWealthGroupMutation, TError, DeleteWealthGroupMutationVariables, TContext>) => {
    
    return useMutation<DeleteWealthGroupMutation, TError, DeleteWealthGroupMutationVariables, TContext>(
      {
    mutationKey: ['deleteWealthGroup'],
    mutationFn: (variables?: DeleteWealthGroupMutationVariables) => fetchData<DeleteWealthGroupMutation, DeleteWealthGroupMutationVariables>(DeleteWealthGroupDocument, variables)(),
    ...options
  }
    )};


useDeleteWealthGroupMutation.fetcher = (variables?: DeleteWealthGroupMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteWealthGroupMutation, DeleteWealthGroupMutationVariables>(DeleteWealthGroupDocument, variables, options);

export const UpsertWealthGroupDocument = `
    mutation upsertWealthGroup($object: wealth_group_insert_input!) {
  insert_wealth_group_one(
    object: $object
    on_conflict: {constraint: wealth_group_pkey, update_columns: [en, fr, es, pt]}
  ) {
    id
    en
    es
    fr
    pt
  }
}
    `;

export const useUpsertWealthGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWealthGroupMutation, TError, UpsertWealthGroupMutationVariables, TContext>) => {
    
    return useMutation<UpsertWealthGroupMutation, TError, UpsertWealthGroupMutationVariables, TContext>(
      {
    mutationKey: ['upsertWealthGroup'],
    mutationFn: (variables?: UpsertWealthGroupMutationVariables) => fetchData<UpsertWealthGroupMutation, UpsertWealthGroupMutationVariables>(UpsertWealthGroupDocument, variables)(),
    ...options
  }
    )};


useUpsertWealthGroupMutation.fetcher = (variables: UpsertWealthGroupMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertWealthGroupMutation, UpsertWealthGroupMutationVariables>(UpsertWealthGroupDocument, variables, options);

export const WealthGroupListDocument = `
    query wealthGroupList {
  wealth_group(order_by: [{sorting: asc}]) {
    ...wealthGroup
  }
}
    ${WealthGroupFragmentDoc}`;

export const useWealthGroupListQuery = <
      TData = WealthGroupListQuery,
      TError = unknown
    >(
      variables?: WealthGroupListQueryVariables,
      options?: Omit<UseQueryOptions<WealthGroupListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WealthGroupListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WealthGroupListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['wealthGroupList'] : ['wealthGroupList', variables],
    queryFn: fetchData<WealthGroupListQuery, WealthGroupListQueryVariables>(WealthGroupListDocument, variables),
    ...options
  }
    )};

useWealthGroupListQuery.getKey = (variables?: WealthGroupListQueryVariables) => variables === undefined ? ['wealthGroupList'] : ['wealthGroupList', variables];


useWealthGroupListQuery.fetcher = (variables?: WealthGroupListQueryVariables, options?: RequestInit['headers']) => fetchData<WealthGroupListQuery, WealthGroupListQueryVariables>(WealthGroupListDocument, variables, options);

export const DeleteZoneDocument = `
    mutation deleteZone($ids: [uuid!]) {
  delete_zone(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteZoneMutation, TError, DeleteZoneMutationVariables, TContext>) => {
    
    return useMutation<DeleteZoneMutation, TError, DeleteZoneMutationVariables, TContext>(
      {
    mutationKey: ['deleteZone'],
    mutationFn: (variables?: DeleteZoneMutationVariables) => fetchData<DeleteZoneMutation, DeleteZoneMutationVariables>(DeleteZoneDocument, variables)(),
    ...options
  }
    )};


useDeleteZoneMutation.fetcher = (variables?: DeleteZoneMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteZoneMutation, DeleteZoneMutationVariables>(DeleteZoneDocument, variables, options);

export const UpsertZoneDocument = `
    mutation upsertZone($objects: [zone_insert_input!]!) {
  insert_zone(
    objects: $objects
    on_conflict: {constraint: zone_pkey, update_columns: [name, country_id]}
  ) {
    affected_rows
    returning {
      ...zone
    }
  }
}
    ${ZoneFragmentDoc}
${CountryFragmentDoc}`;

export const useUpsertZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertZoneMutation, TError, UpsertZoneMutationVariables, TContext>) => {
    
    return useMutation<UpsertZoneMutation, TError, UpsertZoneMutationVariables, TContext>(
      {
    mutationKey: ['upsertZone'],
    mutationFn: (variables?: UpsertZoneMutationVariables) => fetchData<UpsertZoneMutation, UpsertZoneMutationVariables>(UpsertZoneDocument, variables)(),
    ...options
  }
    )};


useUpsertZoneMutation.fetcher = (variables: UpsertZoneMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertZoneMutation, UpsertZoneMutationVariables>(UpsertZoneDocument, variables, options);

export const ZoneListDocument = `
    query zoneList {
  zone {
    ...zone
  }
}
    ${ZoneFragmentDoc}
${CountryFragmentDoc}`;

export const useZoneListQuery = <
      TData = ZoneListQuery,
      TError = unknown
    >(
      variables?: ZoneListQueryVariables,
      options?: Omit<UseQueryOptions<ZoneListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ZoneListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ZoneListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['zoneList'] : ['zoneList', variables],
    queryFn: fetchData<ZoneListQuery, ZoneListQueryVariables>(ZoneListDocument, variables),
    ...options
  }
    )};

useZoneListQuery.getKey = (variables?: ZoneListQueryVariables) => variables === undefined ? ['zoneList'] : ['zoneList', variables];


useZoneListQuery.fetcher = (variables?: ZoneListQueryVariables, options?: RequestInit['headers']) => fetchData<ZoneListQuery, ZoneListQueryVariables>(ZoneListDocument, variables, options);

export const DeleteInterviewDocument = `
    mutation deleteInterview($id: uuid!) {
  delete_project_interview_by_pk(id: $id) {
    ...interviewBasic
  }
}
    ${InterviewBasicFragmentDoc}
${WealthGroupFragmentDoc}
${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${UserFragmentDoc}`;

export const useDeleteInterviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteInterviewMutation, TError, DeleteInterviewMutationVariables, TContext>) => {
    
    return useMutation<DeleteInterviewMutation, TError, DeleteInterviewMutationVariables, TContext>(
      {
    mutationKey: ['deleteInterview'],
    mutationFn: (variables?: DeleteInterviewMutationVariables) => fetchData<DeleteInterviewMutation, DeleteInterviewMutationVariables>(DeleteInterviewDocument, variables)(),
    ...options
  }
    )};


useDeleteInterviewMutation.fetcher = (variables: DeleteInterviewMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteInterviewMutation, DeleteInterviewMutationVariables>(DeleteInterviewDocument, variables, options);

export const InsertInterviewsDocument = `
    mutation insertInterviews($objects: [project_interview_insert_input!]!) {
  insert_project_interview(objects: $objects) {
    affected_rows
  }
}
    `;

export const useInsertInterviewsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertInterviewsMutation, TError, InsertInterviewsMutationVariables, TContext>) => {
    
    return useMutation<InsertInterviewsMutation, TError, InsertInterviewsMutationVariables, TContext>(
      {
    mutationKey: ['insertInterviews'],
    mutationFn: (variables?: InsertInterviewsMutationVariables) => fetchData<InsertInterviewsMutation, InsertInterviewsMutationVariables>(InsertInterviewsDocument, variables)(),
    ...options
  }
    )};


useInsertInterviewsMutation.fetcher = (variables: InsertInterviewsMutationVariables, options?: RequestInit['headers']) => fetchData<InsertInterviewsMutation, InsertInterviewsMutationVariables>(InsertInterviewsDocument, variables, options);

export const InterviewByPkDocument = `
    query interviewByPk($id: uuid!) {
  project_interview_by_pk(id: $id) {
    ...interviewDetail
    project_id
    location_id
    project {
      id
      name
    }
    location {
      ...locationFragment
    }
    wealth_group {
      ...wealthGroup
    }
    project_interview_base {
      id
      is_done
      created_at
    }
    project_interview_researcher_mns {
      user_id
      user {
        id
        email
        displayName
      }
    }
  }
}
    ${InterviewDetailFragmentDoc}
${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${WealthGroupFragmentDoc}`;

export const useInterviewByPkQuery = <
      TData = InterviewByPkQuery,
      TError = unknown
    >(
      variables: InterviewByPkQueryVariables,
      options?: Omit<UseQueryOptions<InterviewByPkQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InterviewByPkQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InterviewByPkQuery, TError, TData>(
      {
    queryKey: ['interviewByPk', variables],
    queryFn: fetchData<InterviewByPkQuery, InterviewByPkQueryVariables>(InterviewByPkDocument, variables),
    ...options
  }
    )};

useInterviewByPkQuery.getKey = (variables: InterviewByPkQueryVariables) => ['interviewByPk', variables];


useInterviewByPkQuery.fetcher = (variables: InterviewByPkQueryVariables, options?: RequestInit['headers']) => fetchData<InterviewByPkQuery, InterviewByPkQueryVariables>(InterviewByPkDocument, variables, options);

export const UpdateProjectInterviewDocument = `
    mutation updateProjectInterview($id: uuid!, $set: project_interview_set_input!, $researchData: [project_interview_researcher_mn_insert_input!]!) {
  update_project_interview_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...interviewDetail
  }
  delete_project_interview_researcher_mn(
    where: {project_interview_id: {_eq: $id}}
  ) {
    affected_rows
  }
  insert_project_interview_researcher_mn(objects: $researchData) {
    affected_rows
  }
}
    ${InterviewDetailFragmentDoc}`;

export const useUpdateProjectInterviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectInterviewMutation, TError, UpdateProjectInterviewMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectInterviewMutation, TError, UpdateProjectInterviewMutationVariables, TContext>(
      {
    mutationKey: ['updateProjectInterview'],
    mutationFn: (variables?: UpdateProjectInterviewMutationVariables) => fetchData<UpdateProjectInterviewMutation, UpdateProjectInterviewMutationVariables>(UpdateProjectInterviewDocument, variables)(),
    ...options
  }
    )};


useUpdateProjectInterviewMutation.fetcher = (variables: UpdateProjectInterviewMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateProjectInterviewMutation, UpdateProjectInterviewMutationVariables>(UpdateProjectInterviewDocument, variables, options);

export const UpdateProjectInterviewSimpleDocument = `
    mutation updateProjectInterviewSimple($id: uuid!, $set: project_interview_set_input!) {
  update_project_interview_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...interviewDetail
  }
}
    ${InterviewDetailFragmentDoc}`;

export const useUpdateProjectInterviewSimpleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectInterviewSimpleMutation, TError, UpdateProjectInterviewSimpleMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectInterviewSimpleMutation, TError, UpdateProjectInterviewSimpleMutationVariables, TContext>(
      {
    mutationKey: ['updateProjectInterviewSimple'],
    mutationFn: (variables?: UpdateProjectInterviewSimpleMutationVariables) => fetchData<UpdateProjectInterviewSimpleMutation, UpdateProjectInterviewSimpleMutationVariables>(UpdateProjectInterviewSimpleDocument, variables)(),
    ...options
  }
    )};


useUpdateProjectInterviewSimpleMutation.fetcher = (variables: UpdateProjectInterviewSimpleMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateProjectInterviewSimpleMutation, UpdateProjectInterviewSimpleMutationVariables>(UpdateProjectInterviewSimpleDocument, variables, options);

export const DeleteProjectDocument = `
    mutation deleteProject($ids: [uuid!]) {
  delete_project(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProjectMutation, TError, DeleteProjectMutationVariables, TContext>) => {
    
    return useMutation<DeleteProjectMutation, TError, DeleteProjectMutationVariables, TContext>(
      {
    mutationKey: ['deleteProject'],
    mutationFn: (variables?: DeleteProjectMutationVariables) => fetchData<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, variables)(),
    ...options
  }
    )};


useDeleteProjectMutation.fetcher = (variables?: DeleteProjectMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, variables, options);

export const InsertProjectDocument = `
    mutation insertProject($object: project_insert_input!) {
  insert_project_one(
    object: $object
    on_conflict: {constraint: project_pkey, update_columns: [updated_at, created_at, supervisor_user_id, teamleader_user_id]}
  ) {
    id
    name
  }
}
    `;

export const useInsertProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertProjectMutation, TError, InsertProjectMutationVariables, TContext>) => {
    
    return useMutation<InsertProjectMutation, TError, InsertProjectMutationVariables, TContext>(
      {
    mutationKey: ['insertProject'],
    mutationFn: (variables?: InsertProjectMutationVariables) => fetchData<InsertProjectMutation, InsertProjectMutationVariables>(InsertProjectDocument, variables)(),
    ...options
  }
    )};


useInsertProjectMutation.fetcher = (variables: InsertProjectMutationVariables, options?: RequestInit['headers']) => fetchData<InsertProjectMutation, InsertProjectMutationVariables>(InsertProjectDocument, variables, options);

export const ProjectByPkDocument = `
    query projectByPk($id: uuid!) {
  project_by_pk(id: $id) {
    ...projectDetail
  }
}
    ${ProjectDetailFragmentDoc}
${ProjectFragmentDoc}
${UserFragmentDoc}
${InterviewBasicFragmentDoc}
${WealthGroupFragmentDoc}
${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}
${ProjectScalarFragmentDoc}`;

export const useProjectByPkQuery = <
      TData = ProjectByPkQuery,
      TError = unknown
    >(
      variables: ProjectByPkQueryVariables,
      options?: Omit<UseQueryOptions<ProjectByPkQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectByPkQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectByPkQuery, TError, TData>(
      {
    queryKey: ['projectByPk', variables],
    queryFn: fetchData<ProjectByPkQuery, ProjectByPkQueryVariables>(ProjectByPkDocument, variables),
    ...options
  }
    )};

useProjectByPkQuery.getKey = (variables: ProjectByPkQueryVariables) => ['projectByPk', variables];


useProjectByPkQuery.fetcher = (variables: ProjectByPkQueryVariables, options?: RequestInit['headers']) => fetchData<ProjectByPkQuery, ProjectByPkQueryVariables>(ProjectByPkDocument, variables, options);

export const ProjectListDocument = `
    query projectList {
  project(where: {_or: [{deleted: {_is_null: true}}, {deleted: {_eq: false}}]}) {
    ...project
  }
}
    ${ProjectFragmentDoc}
${UserFragmentDoc}
${InterviewBasicFragmentDoc}
${WealthGroupFragmentDoc}
${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}`;

export const useProjectListQuery = <
      TData = ProjectListQuery,
      TError = unknown
    >(
      variables?: ProjectListQueryVariables,
      options?: Omit<UseQueryOptions<ProjectListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['projectList'] : ['projectList', variables],
    queryFn: fetchData<ProjectListQuery, ProjectListQueryVariables>(ProjectListDocument, variables),
    ...options
  }
    )};

useProjectListQuery.getKey = (variables?: ProjectListQueryVariables) => variables === undefined ? ['projectList'] : ['projectList', variables];


useProjectListQuery.fetcher = (variables?: ProjectListQueryVariables, options?: RequestInit['headers']) => fetchData<ProjectListQuery, ProjectListQueryVariables>(ProjectListDocument, variables, options);

export const UpdateProjectDocument = `
    mutation updateProject($set: project_set_input!, $id: uuid!) {
  update_project_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...projectDetail
  }
}
    ${ProjectDetailFragmentDoc}
${ProjectFragmentDoc}
${UserFragmentDoc}
${InterviewBasicFragmentDoc}
${WealthGroupFragmentDoc}
${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}
${ProjectScalarFragmentDoc}`;

export const useUpdateProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectMutation, TError, UpdateProjectMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectMutation, TError, UpdateProjectMutationVariables, TContext>(
      {
    mutationKey: ['updateProject'],
    mutationFn: (variables?: UpdateProjectMutationVariables) => fetchData<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, variables)(),
    ...options
  }
    )};


useUpdateProjectMutation.fetcher = (variables: UpdateProjectMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, variables, options);

export const DeleteUsersDocument = `
    mutation deleteUsers($ids: [uuid!]) {
  deleteUsers(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

export const useDeleteUsersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUsersMutation, TError, DeleteUsersMutationVariables, TContext>) => {
    
    return useMutation<DeleteUsersMutation, TError, DeleteUsersMutationVariables, TContext>(
      {
    mutationKey: ['deleteUsers'],
    mutationFn: (variables?: DeleteUsersMutationVariables) => fetchData<DeleteUsersMutation, DeleteUsersMutationVariables>(DeleteUsersDocument, variables)(),
    ...options
  }
    )};


useDeleteUsersMutation.fetcher = (variables?: DeleteUsersMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteUsersMutation, DeleteUsersMutationVariables>(DeleteUsersDocument, variables, options);

export const MeDocument = `
    query me($id: uuid!) {
  user(id: $id) {
    email
    metadata
    user_permissions {
      id
      project_id
      role
    }
    project_bss_data {
      project_id
      id
      is_resolved
    }
    project_interview_researcher_mns {
      project_interview_id
    }
  }
}
    `;

export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables: MeQueryVariables,
      options?: Omit<UseQueryOptions<MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeQuery, TError, TData>(
      {
    queryKey: ['me', variables],
    queryFn: fetchData<MeQuery, MeQueryVariables>(MeDocument, variables),
    ...options
  }
    )};

useMeQuery.getKey = (variables: MeQueryVariables) => ['me', variables];


useMeQuery.fetcher = (variables: MeQueryVariables, options?: RequestInit['headers']) => fetchData<MeQuery, MeQueryVariables>(MeDocument, variables, options);

export const UpsertUserProfileDocument = `
    mutation upsertUserProfile($object: user_profile_insert_input!) {
  insert_user_profile_one(
    object: $object
    on_conflict: {constraint: user_profile_pkey, update_columns: [last_name, first_name]}
  ) {
    first_name
    last_name
    id
    user_id
  }
}
    `;

export const useUpsertUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertUserProfileMutation, TError, UpsertUserProfileMutationVariables, TContext>) => {
    
    return useMutation<UpsertUserProfileMutation, TError, UpsertUserProfileMutationVariables, TContext>(
      {
    mutationKey: ['upsertUserProfile'],
    mutationFn: (variables?: UpsertUserProfileMutationVariables) => fetchData<UpsertUserProfileMutation, UpsertUserProfileMutationVariables>(UpsertUserProfileDocument, variables)(),
    ...options
  }
    )};


useUpsertUserProfileMutation.fetcher = (variables: UpsertUserProfileMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertUserProfileMutation, UpsertUserProfileMutationVariables>(UpsertUserProfileDocument, variables, options);

export const UpsertUserDocument = `
    mutation upsertUser($object: users_insert_input!) {
  insertUser(
    object: $object
    on_conflict: {update_columns: [email, displayName], constraint: users_pkey}
  ) {
    ...user
  }
}
    ${UserFragmentDoc}`;

export const useUpsertUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertUserMutation, TError, UpsertUserMutationVariables, TContext>) => {
    
    return useMutation<UpsertUserMutation, TError, UpsertUserMutationVariables, TContext>(
      {
    mutationKey: ['upsertUser'],
    mutationFn: (variables?: UpsertUserMutationVariables) => fetchData<UpsertUserMutation, UpsertUserMutationVariables>(UpsertUserDocument, variables)(),
    ...options
  }
    )};


useUpsertUserMutation.fetcher = (variables: UpsertUserMutationVariables, options?: RequestInit['headers']) => fetchData<UpsertUserMutation, UpsertUserMutationVariables>(UpsertUserDocument, variables, options);

export const UsersDocument = `
    query users($where: users_bool_exp, $limit: Int, $orderBy: [users_order_by!]) {
  users(where: $where, limit: $limit, order_by: $orderBy) {
    ...user
  }
}
    ${UserFragmentDoc}`;

export const useUsersQuery = <
      TData = UsersQuery,
      TError = unknown
    >(
      variables?: UsersQueryVariables,
      options?: Omit<UseQueryOptions<UsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['users'] : ['users', variables],
    queryFn: fetchData<UsersQuery, UsersQueryVariables>(UsersDocument, variables),
    ...options
  }
    )};

useUsersQuery.getKey = (variables?: UsersQueryVariables) => variables === undefined ? ['users'] : ['users', variables];


useUsersQuery.fetcher = (variables?: UsersQueryVariables, options?: RequestInit['headers']) => fetchData<UsersQuery, UsersQueryVariables>(UsersDocument, variables, options);

export const BssBaselineDetailDocument = `
    query bssBaselineDetail($baselineId: uuid!) {
  project_by_pk(id: $baselineId) {
    ...projectScalar
    term {
      ...term
    }
  }
  project_interview_base(
    where: {project_interview: {project_id: {_eq: $baselineId}}}
  ) {
    ...interviewBase
    term {
      ...term
    }
    project_interview_productive_assets {
      amount
      term_id
      term {
        ...term
      }
    }
    project_interview {
      project_id
      location_id
      wealth_group_id
      location {
        ...locationFragment
      }
      wealth_group {
        ...wealthGroup
      }
    }
  }
  project_interview_livestock(
    where: {project_interview_base: {project_interview: {project_id: {_eq: $baselineId}}}}
  ) {
    ...interviewLivestockBase
    project_interview_data {
      ...interviewLivestockData
      term {
        ...term
      }
    }
    off_peak_milk {
      ...interviewLivestockMilk
    }
    peak_milk {
      ...interviewLivestockMilk
    }
    peak_milk_secondary {
      ...interviewLivestockMilk
    }
    off_peak_milk_secondary {
      ...interviewLivestockMilk
    }
    project_interview_base {
      project_interview {
        project_id
        id
        location_id
        wealth_group_id
      }
    }
  }
  project_interview_totals(
    where: {project_interview_base: {project_interview: {project_id: {_eq: $baselineId}}}}
  ) {
    project_interview_base {
      project_interview {
        id
        location_id
        wealth_group_id
      }
    }
    ...interviewTotals
  }
  interviews: project_interview(
    where: {project_id: {_eq: $baselineId}}
    distinct_on: [location_id]
  ) {
    id
    project_id
    location_id
    location {
      id
      name
    }
    date
    project_interview_base {
      date
    }
  }
  wealth_groups: wealth_group(
    where: {project_interviews: {project_id: {_eq: $baselineId}}}
    order_by: {sorting: asc}
  ) {
    ...wealthGroup
    project_interviews_aggregate(where: {project_id: {_eq: $baselineId}}) {
      aggregate {
        count
      }
      nodes {
        id
        location_id
      }
    }
  }
  bss_baseline_view(where: {project_id: {_eq: $baselineId}}) {
    type
    project_id
    term_id
    term {
      ...term
    }
    data(
      where: {project_interview_base: {project_interview: {project_id: {_eq: $baselineId}}}}
    ) {
      ...interviewData
      food_term {
        ...term
      }
      project_interview_base {
        project_interview {
          project_id
          id
          location_id
          wealth_group_id
        }
      }
    }
  }
  schoolfeeding_data: project_interview_data(
    where: {project_interview_base: {project_interview: {project_id: {_eq: $baselineId}}}, term_id: {_is_null: true}, type: {_eq: FOOD_AID}}
  ) {
    type
    number_children
    total_kcal
    project_interview_base {
      project_interview {
        project_id
        id
        location_id
        wealth_group_id
      }
    }
  }
  migration_data: project_interview_data(
    where: {project_interview_base: {project_interview: {project_id: {_eq: $baselineId}}}, term_id: {_is_null: true}, type: {_eq: MIGRATION}}
  ) {
    type
    activity
    location
    people
    months
    times_money_sent
    amount
    total_cash_income
    total_kcal
    project_interview_base {
      project_interview {
        project_id
        id
        location_id
        wealth_group_id
      }
    }
  }
  project_interview_crops_season(
    where: {project_interview_base: {project_interview: {project_id: {_eq: $baselineId}}}}
  ) {
    ...interviewCropsSeasonBase
    green_crops {
      ...greenRootCrops
    }
    root_crops {
      ...greenRootCrops
    }
    project_interview_crops {
      ...cropProduction
      term {
        ...term
      }
    }
    season {
      name
      crop_season_month_mns {
        month
      }
    }
    project_interview_data {
      ...interviewCropsData
      term {
        ...term
      }
    }
    project_interview_base {
      project_interview {
        project_id
        wealth_group_id
        wealth_group {
          ...wealthGroup
        }
        location_id
        location {
          name
        }
      }
    }
  }
}
    ${ProjectScalarFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}
${InterviewBaseFragmentDoc}
${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${WealthGroupFragmentDoc}
${InterviewLivestockBaseFragmentDoc}
${InterviewLivestockDataFragmentDoc}
${InterviewLivestockMilkFragmentDoc}
${InterviewTotalsFragmentDoc}
${InterviewDataFragmentDoc}
${InterviewCropsSeasonBaseFragmentDoc}
${GreenRootCropsFragmentDoc}
${CropProductionFragmentDoc}
${InterviewCropsDataFragmentDoc}`;

export const useBssBaselineDetailQuery = <
      TData = BssBaselineDetailQuery,
      TError = unknown
    >(
      variables: BssBaselineDetailQueryVariables,
      options?: Omit<UseQueryOptions<BssBaselineDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BssBaselineDetailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BssBaselineDetailQuery, TError, TData>(
      {
    queryKey: ['bssBaselineDetail', variables],
    queryFn: fetchData<BssBaselineDetailQuery, BssBaselineDetailQueryVariables>(BssBaselineDetailDocument, variables),
    ...options
  }
    )};

useBssBaselineDetailQuery.getKey = (variables: BssBaselineDetailQueryVariables) => ['bssBaselineDetail', variables];


useBssBaselineDetailQuery.fetcher = (variables: BssBaselineDetailQueryVariables, options?: RequestInit['headers']) => fetchData<BssBaselineDetailQuery, BssBaselineDetailQueryVariables>(BssBaselineDetailDocument, variables, options);

export const BssDataDocument = `
    query bssData($baselineId: uuid!) {
  project_bss_data(where: {project_id: {_eq: $baselineId}}) {
    ...bssData
    term {
      ...term
    }
    user {
      ...user
    }
  }
  project_bss_note(
    where: {project_id: {_eq: $baselineId}, is_deleted: {_neq: true}}
    order_by: [{created_at: desc}]
  ) {
    ...bssNote
    user {
      ...user
    }
  }
}
    ${BssDataFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}
${UserFragmentDoc}
${BssNoteFragmentDoc}`;

export const useBssDataQuery = <
      TData = BssDataQuery,
      TError = unknown
    >(
      variables: BssDataQueryVariables,
      options?: Omit<UseQueryOptions<BssDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BssDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BssDataQuery, TError, TData>(
      {
    queryKey: ['bssData', variables],
    queryFn: fetchData<BssDataQuery, BssDataQueryVariables>(BssDataDocument, variables),
    ...options
  }
    )};

useBssDataQuery.getKey = (variables: BssDataQueryVariables) => ['bssData', variables];


useBssDataQuery.fetcher = (variables: BssDataQueryVariables, options?: RequestInit['headers']) => fetchData<BssDataQuery, BssDataQueryVariables>(BssDataDocument, variables, options);

export const UploadBssDataDocument = `
    mutation uploadBssData($projectId: uuid!, $objects: [project_bss_data_insert_input!]!, $noteObjects: [project_bss_note_insert_input!]!, $backupObject: project_bss_data_backup_insert_input!) {
  delete_project_bss_data(where: {project_id: {_eq: $projectId}}) {
    affected_rows
  }
  insert_project_bss_data(objects: $objects) {
    affected_rows
  }
  insert_project_bss_data_backup_one(object: $backupObject) {
    id
  }
  insert_project_bss_note(
    objects: $noteObjects
    on_conflict: {constraint: project_bss_note_pkey, update_columns: [is_done, is_deleted, id, updated_at, created_at, livestock_type, season_id, project_id, message, type, term_id]}
  ) {
    affected_rows
  }
}
    `;

export const useUploadBssDataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadBssDataMutation, TError, UploadBssDataMutationVariables, TContext>) => {
    
    return useMutation<UploadBssDataMutation, TError, UploadBssDataMutationVariables, TContext>(
      {
    mutationKey: ['uploadBssData'],
    mutationFn: (variables?: UploadBssDataMutationVariables) => fetchData<UploadBssDataMutation, UploadBssDataMutationVariables>(UploadBssDataDocument, variables)(),
    ...options
  }
    )};


useUploadBssDataMutation.fetcher = (variables: UploadBssDataMutationVariables, options?: RequestInit['headers']) => fetchData<UploadBssDataMutation, UploadBssDataMutationVariables>(UploadBssDataDocument, variables, options);

export const BssProjectListDocument = `
    query bssProjectList {
  project {
    ...bssProjectList
  }
}
    ${BssProjectListFragmentDoc}
${CountryFragmentDoc}`;

export const useBssProjectListQuery = <
      TData = BssProjectListQuery,
      TError = unknown
    >(
      variables?: BssProjectListQueryVariables,
      options?: Omit<UseQueryOptions<BssProjectListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BssProjectListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BssProjectListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['bssProjectList'] : ['bssProjectList', variables],
    queryFn: fetchData<BssProjectListQuery, BssProjectListQueryVariables>(BssProjectListDocument, variables),
    ...options
  }
    )};

useBssProjectListQuery.getKey = (variables?: BssProjectListQueryVariables) => variables === undefined ? ['bssProjectList'] : ['bssProjectList', variables];


useBssProjectListQuery.fetcher = (variables?: BssProjectListQueryVariables, options?: RequestInit['headers']) => fetchData<BssProjectListQuery, BssProjectListQueryVariables>(BssProjectListDocument, variables, options);

export const AllBssVariablesDocument = `
    query allBssVariables($where: term_bool_exp!, $termOrderBy: [term_order_by!]) {
  term(order_by: $termOrderBy, where: $where) {
    am
    en
    es
    fr
    id
    kcal
    pt
    term_category_mns {
      category_id
      term_category {
        am
        en
        es
        fr
        id
        pt
      }
    }
  }
}
    `;

export const useAllBssVariablesQuery = <
      TData = AllBssVariablesQuery,
      TError = unknown
    >(
      variables: AllBssVariablesQueryVariables,
      options?: Omit<UseQueryOptions<AllBssVariablesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllBssVariablesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AllBssVariablesQuery, TError, TData>(
      {
    queryKey: ['allBssVariables', variables],
    queryFn: fetchData<AllBssVariablesQuery, AllBssVariablesQueryVariables>(AllBssVariablesDocument, variables),
    ...options
  }
    )};

useAllBssVariablesQuery.getKey = (variables: AllBssVariablesQueryVariables) => ['allBssVariables', variables];


useAllBssVariablesQuery.fetcher = (variables: AllBssVariablesQueryVariables, options?: RequestInit['headers']) => fetchData<AllBssVariablesQuery, AllBssVariablesQueryVariables>(AllBssVariablesDocument, variables, options);

export const AllVariablesDocument = `
    query allVariables($termOrderBy: [term_order_by!], $measureUnitOrderBy: [measure_unit_order_by!], $cropSeasonOrderBy: [crop_season_order_by!]) {
  term(order_by: $termOrderBy) {
    am
    en
    es
    fr
    id
    kcal
    pt
    term_category_mns {
      category_id
      term_category {
        am
        en
        es
        fr
        id
        pt
      }
    }
  }
  measure_unit(order_by: $measureUnitOrderBy) {
    id
    name
    country_id
    type
    multiplier
  }
  crop_season(order_by: $cropSeasonOrderBy) {
    ...cropSeason
  }
}
    ${CropSeasonFragmentDoc}
${CountryFragmentDoc}`;

export const useAllVariablesQuery = <
      TData = AllVariablesQuery,
      TError = unknown
    >(
      variables?: AllVariablesQueryVariables,
      options?: Omit<UseQueryOptions<AllVariablesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllVariablesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AllVariablesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allVariables'] : ['allVariables', variables],
    queryFn: fetchData<AllVariablesQuery, AllVariablesQueryVariables>(AllVariablesDocument, variables),
    ...options
  }
    )};

useAllVariablesQuery.getKey = (variables?: AllVariablesQueryVariables) => variables === undefined ? ['allVariables'] : ['allVariables', variables];


useAllVariablesQuery.fetcher = (variables?: AllVariablesQueryVariables, options?: RequestInit['headers']) => fetchData<AllVariablesQuery, AllVariablesQueryVariables>(AllVariablesDocument, variables, options);

export const GetAllOnlineDataDocument = `
    query getAllOnlineData {
  country {
    ...country
  }
  term_category {
    ...termCategory
  }
  term {
    ...termSimple
  }
  term_category_mn {
    term_id
    category_id
  }
  crop_season {
    ...cropSeason
  }
  crop_season_month_mn {
    month
    crop_season_id
  }
  measure_unit {
    ...measureUnit
  }
}
    ${CountryFragmentDoc}
${TermCategoryFragmentDoc}
${TermSimpleFragmentDoc}
${CropSeasonFragmentDoc}
${MeasureUnitFragmentDoc}`;

export const useGetAllOnlineDataQuery = <
      TData = GetAllOnlineDataQuery,
      TError = unknown
    >(
      variables?: GetAllOnlineDataQueryVariables,
      options?: Omit<UseQueryOptions<GetAllOnlineDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllOnlineDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllOnlineDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAllOnlineData'] : ['getAllOnlineData', variables],
    queryFn: fetchData<GetAllOnlineDataQuery, GetAllOnlineDataQueryVariables>(GetAllOnlineDataDocument, variables),
    ...options
  }
    )};

useGetAllOnlineDataQuery.getKey = (variables?: GetAllOnlineDataQueryVariables) => variables === undefined ? ['getAllOnlineData'] : ['getAllOnlineData', variables];


useGetAllOnlineDataQuery.fetcher = (variables?: GetAllOnlineDataQueryVariables, options?: RequestInit['headers']) => fetchData<GetAllOnlineDataQuery, GetAllOnlineDataQueryVariables>(GetAllOnlineDataDocument, variables, options);

export const ProjectListTssDocument = `
    query projectListTss($where: project_bool_exp!) {
  project(where: $where) {
    ...projectTssQuery
  }
}
    ${ProjectTssQueryFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}
${WealthGroupFragmentDoc}
${CountryFragmentDoc}`;

export const useProjectListTssQuery = <
      TData = ProjectListTssQuery,
      TError = unknown
    >(
      variables: ProjectListTssQueryVariables,
      options?: Omit<UseQueryOptions<ProjectListTssQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectListTssQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectListTssQuery, TError, TData>(
      {
    queryKey: ['projectListTss', variables],
    queryFn: fetchData<ProjectListTssQuery, ProjectListTssQueryVariables>(ProjectListTssDocument, variables),
    ...options
  }
    )};

useProjectListTssQuery.getKey = (variables: ProjectListTssQueryVariables) => ['projectListTss', variables];


useProjectListTssQuery.fetcher = (variables: ProjectListTssQueryVariables, options?: RequestInit['headers']) => fetchData<ProjectListTssQuery, ProjectListTssQueryVariables>(ProjectListTssDocument, variables, options);

export const TssInterviewUpdateStateDocument = `
    mutation tssInterviewUpdateState($id: uuid!, $done: Boolean!) {
  update_project_interview_base_by_pk(
    pk_columns: {id: $id}
    _set: {is_done: $done}
  ) {
    id
  }
}
    `;

export const useTssInterviewUpdateStateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TssInterviewUpdateStateMutation, TError, TssInterviewUpdateStateMutationVariables, TContext>) => {
    
    return useMutation<TssInterviewUpdateStateMutation, TError, TssInterviewUpdateStateMutationVariables, TContext>(
      {
    mutationKey: ['tssInterviewUpdateState'],
    mutationFn: (variables?: TssInterviewUpdateStateMutationVariables) => fetchData<TssInterviewUpdateStateMutation, TssInterviewUpdateStateMutationVariables>(TssInterviewUpdateStateDocument, variables)(),
    ...options
  }
    )};


useTssInterviewUpdateStateMutation.fetcher = (variables: TssInterviewUpdateStateMutationVariables, options?: RequestInit['headers']) => fetchData<TssInterviewUpdateStateMutation, TssInterviewUpdateStateMutationVariables>(TssInterviewUpdateStateDocument, variables, options);

export const TssProjectOneDocument = `
    query tssProjectOne($id: uuid!) {
  project_by_pk(id: $id) {
    ...projectTssQuery
  }
}
    ${ProjectTssQueryFragmentDoc}
${TermFragmentDoc}
${TermCategoryFragmentDoc}
${WealthGroupFragmentDoc}
${CountryFragmentDoc}`;

export const useTssProjectOneQuery = <
      TData = TssProjectOneQuery,
      TError = unknown
    >(
      variables: TssProjectOneQueryVariables,
      options?: Omit<UseQueryOptions<TssProjectOneQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TssProjectOneQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TssProjectOneQuery, TError, TData>(
      {
    queryKey: ['tssProjectOne', variables],
    queryFn: fetchData<TssProjectOneQuery, TssProjectOneQueryVariables>(TssProjectOneDocument, variables),
    ...options
  }
    )};

useTssProjectOneQuery.getKey = (variables: TssProjectOneQueryVariables) => ['tssProjectOne', variables];


useTssProjectOneQuery.fetcher = (variables: TssProjectOneQueryVariables, options?: RequestInit['headers']) => fetchData<TssProjectOneQuery, TssProjectOneQueryVariables>(TssProjectOneDocument, variables, options);

export const UpdateInterviewDocument = `
    mutation updateInterview($id: uuid!, $set: project_interview_set_input!) {
  update_project_interview_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...interviewDetail
  }
}
    ${InterviewDetailFragmentDoc}`;

export const useUpdateInterviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInterviewMutation, TError, UpdateInterviewMutationVariables, TContext>) => {
    
    return useMutation<UpdateInterviewMutation, TError, UpdateInterviewMutationVariables, TContext>(
      {
    mutationKey: ['updateInterview'],
    mutationFn: (variables?: UpdateInterviewMutationVariables) => fetchData<UpdateInterviewMutation, UpdateInterviewMutationVariables>(UpdateInterviewDocument, variables)(),
    ...options
  }
    )};


useUpdateInterviewMutation.fetcher = (variables: UpdateInterviewMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateInterviewMutation, UpdateInterviewMutationVariables>(UpdateInterviewDocument, variables, options);

export const InsertProjectInterviewFileDocument = `
    mutation insertProjectInterviewFile($objects: [project_interview_file_insert_input!]!) {
  insert_project_interview_file(objects: $objects) {
    affected_rows
  }
}
    `;

export const useInsertProjectInterviewFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertProjectInterviewFileMutation, TError, InsertProjectInterviewFileMutationVariables, TContext>) => {
    
    return useMutation<InsertProjectInterviewFileMutation, TError, InsertProjectInterviewFileMutationVariables, TContext>(
      {
    mutationKey: ['insertProjectInterviewFile'],
    mutationFn: (variables?: InsertProjectInterviewFileMutationVariables) => fetchData<InsertProjectInterviewFileMutation, InsertProjectInterviewFileMutationVariables>(InsertProjectInterviewFileDocument, variables)(),
    ...options
  }
    )};


useInsertProjectInterviewFileMutation.fetcher = (variables: InsertProjectInterviewFileMutationVariables, options?: RequestInit['headers']) => fetchData<InsertProjectInterviewFileMutation, InsertProjectInterviewFileMutationVariables>(InsertProjectInterviewFileDocument, variables, options);

export const InsertProjectFilesDocument = `
    mutation insertProjectFiles($objects: [project_file_insert_input!]!) {
  insert_project_file(objects: $objects) {
    affected_rows
  }
}
    `;

export const useInsertProjectFilesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertProjectFilesMutation, TError, InsertProjectFilesMutationVariables, TContext>) => {
    
    return useMutation<InsertProjectFilesMutation, TError, InsertProjectFilesMutationVariables, TContext>(
      {
    mutationKey: ['insertProjectFiles'],
    mutationFn: (variables?: InsertProjectFilesMutationVariables) => fetchData<InsertProjectFilesMutation, InsertProjectFilesMutationVariables>(InsertProjectFilesDocument, variables)(),
    ...options
  }
    )};


useInsertProjectFilesMutation.fetcher = (variables: InsertProjectFilesMutationVariables, options?: RequestInit['headers']) => fetchData<InsertProjectFilesMutation, InsertProjectFilesMutationVariables>(InsertProjectFilesDocument, variables, options);

export const InterviewFilesDocument = `
    query interviewFiles($interviewId: uuid!) {
  project_interview_file(
    where: {interview_id: {_eq: $interviewId}}
    order_by: [{file: {createdAt: asc}}]
  ) {
    file {
      ...file
    }
  }
}
    ${FileFragmentDoc}`;

export const useInterviewFilesQuery = <
      TData = InterviewFilesQuery,
      TError = unknown
    >(
      variables: InterviewFilesQueryVariables,
      options?: Omit<UseQueryOptions<InterviewFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InterviewFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InterviewFilesQuery, TError, TData>(
      {
    queryKey: ['interviewFiles', variables],
    queryFn: fetchData<InterviewFilesQuery, InterviewFilesQueryVariables>(InterviewFilesDocument, variables),
    ...options
  }
    )};

useInterviewFilesQuery.getKey = (variables: InterviewFilesQueryVariables) => ['interviewFiles', variables];


useInterviewFilesQuery.fetcher = (variables: InterviewFilesQueryVariables, options?: RequestInit['headers']) => fetchData<InterviewFilesQuery, InterviewFilesQueryVariables>(InterviewFilesDocument, variables, options);

export const ProjectFilesDocument = `
    query projectFiles($projectId: uuid!) {
  project_file(
    where: {project_id: {_eq: $projectId}}
    order_by: {file: {createdAt: asc}}
  ) {
    project_id
    file {
      ...file
    }
    location_id
    location {
      id
      name
    }
  }
}
    ${FileFragmentDoc}`;

export const useProjectFilesQuery = <
      TData = ProjectFilesQuery,
      TError = unknown
    >(
      variables: ProjectFilesQueryVariables,
      options?: Omit<UseQueryOptions<ProjectFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectFilesQuery, TError, TData>(
      {
    queryKey: ['projectFiles', variables],
    queryFn: fetchData<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, variables),
    ...options
  }
    )};

useProjectFilesQuery.getKey = (variables: ProjectFilesQueryVariables) => ['projectFiles', variables];


useProjectFilesQuery.fetcher = (variables: ProjectFilesQueryVariables, options?: RequestInit['headers']) => fetchData<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, variables, options);

export const InterviewsTssDocument = `
    query interviewsTss($where: project_interview_bool_exp) {
  project_interview(where: $where) {
    id
    status
    date
    location_id
    location {
      ...locationFragment
    }
    wealth_group_id
    wealth_group {
      ...wealthGroup
    }
  }
}
    ${LocationFragmentFragmentDoc}
${CountryRegionFragmentFragmentDoc}
${CountryFragmentDoc}
${ZoneFragmentDoc}
${WealthGroupFragmentDoc}`;

export const useInterviewsTssQuery = <
      TData = InterviewsTssQuery,
      TError = unknown
    >(
      variables?: InterviewsTssQueryVariables,
      options?: Omit<UseQueryOptions<InterviewsTssQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InterviewsTssQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InterviewsTssQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['interviewsTss'] : ['interviewsTss', variables],
    queryFn: fetchData<InterviewsTssQuery, InterviewsTssQueryVariables>(InterviewsTssDocument, variables),
    ...options
  }
    )};

useInterviewsTssQuery.getKey = (variables?: InterviewsTssQueryVariables) => variables === undefined ? ['interviewsTss'] : ['interviewsTss', variables];


useInterviewsTssQuery.fetcher = (variables?: InterviewsTssQueryVariables, options?: RequestInit['headers']) => fetchData<InterviewsTssQuery, InterviewsTssQueryVariables>(InterviewsTssDocument, variables, options);

export const TssNotesDocument = `
    query tssNotes($interviewId: uuid!) {
  project_interview_note(
    where: {interview_id: {_eq: $interviewId}}
    order_by: {created_at: asc}
  ) {
    ...tssNote
    user {
      ...user
    }
  }
}
    ${TssNoteFragmentDoc}
${UserFragmentDoc}`;

export const useTssNotesQuery = <
      TData = TssNotesQuery,
      TError = unknown
    >(
      variables: TssNotesQueryVariables,
      options?: Omit<UseQueryOptions<TssNotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TssNotesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TssNotesQuery, TError, TData>(
      {
    queryKey: ['tssNotes', variables],
    queryFn: fetchData<TssNotesQuery, TssNotesQueryVariables>(TssNotesDocument, variables),
    ...options
  }
    )};

useTssNotesQuery.getKey = (variables: TssNotesQueryVariables) => ['tssNotes', variables];


useTssNotesQuery.fetcher = (variables: TssNotesQueryVariables, options?: RequestInit['headers']) => fetchData<TssNotesQuery, TssNotesQueryVariables>(TssNotesDocument, variables, options);

export const TssNotesUpdateDocument = `
    mutation tssNotesUpdate($objects: [project_interview_note_insert_input!]!) {
  insert_project_interview_note(
    objects: $objects
    on_conflict: {constraint: project_interview_note_pkey, update_columns: [message, updated_at, created_at, user_id, is_done, is_deleted]}
  ) {
    affected_rows
  }
}
    `;

export const useTssNotesUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TssNotesUpdateMutation, TError, TssNotesUpdateMutationVariables, TContext>) => {
    
    return useMutation<TssNotesUpdateMutation, TError, TssNotesUpdateMutationVariables, TContext>(
      {
    mutationKey: ['tssNotesUpdate'],
    mutationFn: (variables?: TssNotesUpdateMutationVariables) => fetchData<TssNotesUpdateMutation, TssNotesUpdateMutationVariables>(TssNotesUpdateDocument, variables)(),
    ...options
  }
    )};


useTssNotesUpdateMutation.fetcher = (variables: TssNotesUpdateMutationVariables, options?: RequestInit['headers']) => fetchData<TssNotesUpdateMutation, TssNotesUpdateMutationVariables>(TssNotesUpdateDocument, variables, options);

export const TssInterviewDetailDocument = `
    query tssInterviewDetail($id: uuid!) {
  project_interview_by_pk(id: $id) {
    ...interviewDetail
    location {
      id
      name
    }
    project_interview_researcher_mns {
      user {
        id
      }
    }
    wealth_group {
      ...wealthGroup
    }
    project_interview_base {
      ...interviewBase
      project_interview_productive_assets {
        term_id
        amount
      }
      project_interview_crops_seasons {
        ...interviewCropsSeasons
        project_interview_data {
          ...interviewCropsData
        }
      }
      project_interview_livestocks {
        ...interviewLivestock
        project_interview_data {
          ...interviewLivestockData
        }
      }
      project_interview_total {
        ...interviewTotals
      }
      project_interview_data {
        ...interviewData
      }
    }
  }
}
    ${InterviewDetailFragmentDoc}
${WealthGroupFragmentDoc}
${InterviewBaseFragmentDoc}
${InterviewCropsSeasonsFragmentDoc}
${InterviewCropsSeasonBaseFragmentDoc}
${GreenRootCropsFragmentDoc}
${CropProductionFragmentDoc}
${InterviewCropsDataFragmentDoc}
${InterviewLivestockFragmentDoc}
${InterviewLivestockBaseFragmentDoc}
${InterviewLivestockDataFragmentDoc}
${InterviewLivestockMilkFragmentDoc}
${InterviewTotalsFragmentDoc}
${InterviewDataFragmentDoc}`;

export const useTssInterviewDetailQuery = <
      TData = TssInterviewDetailQuery,
      TError = unknown
    >(
      variables: TssInterviewDetailQueryVariables,
      options?: Omit<UseQueryOptions<TssInterviewDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TssInterviewDetailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TssInterviewDetailQuery, TError, TData>(
      {
    queryKey: ['tssInterviewDetail', variables],
    queryFn: fetchData<TssInterviewDetailQuery, TssInterviewDetailQueryVariables>(TssInterviewDetailDocument, variables),
    ...options
  }
    )};

useTssInterviewDetailQuery.getKey = (variables: TssInterviewDetailQueryVariables) => ['tssInterviewDetail', variables];


useTssInterviewDetailQuery.fetcher = (variables: TssInterviewDetailQueryVariables, options?: RequestInit['headers']) => fetchData<TssInterviewDetailQuery, TssInterviewDetailQueryVariables>(TssInterviewDetailDocument, variables, options);

export const TssInterviewDetailUpdateDocument = `
    mutation tssInterviewDetailUpdate($id: uuid!, $set: project_interview_base_insert_input!, $backup: project_interview_backup_insert_input!) {
  delete_project_interview_base(where: {interview_id: {_eq: $id}}) {
    affected_rows
  }
  insert_project_interview_base_one(object: $set) {
    ...interviewBase
  }
  insert_project_interview_backup_one(object: $backup) {
    id
  }
}
    ${InterviewBaseFragmentDoc}`;

export const useTssInterviewDetailUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TssInterviewDetailUpdateMutation, TError, TssInterviewDetailUpdateMutationVariables, TContext>) => {
    
    return useMutation<TssInterviewDetailUpdateMutation, TError, TssInterviewDetailUpdateMutationVariables, TContext>(
      {
    mutationKey: ['tssInterviewDetailUpdate'],
    mutationFn: (variables?: TssInterviewDetailUpdateMutationVariables) => fetchData<TssInterviewDetailUpdateMutation, TssInterviewDetailUpdateMutationVariables>(TssInterviewDetailUpdateDocument, variables)(),
    ...options
  }
    )};


useTssInterviewDetailUpdateMutation.fetcher = (variables: TssInterviewDetailUpdateMutationVariables, options?: RequestInit['headers']) => fetchData<TssInterviewDetailUpdateMutation, TssInterviewDetailUpdateMutationVariables>(TssInterviewDetailUpdateDocument, variables, options);
